(function (Ge, ie) {
  typeof exports == 'object' && typeof module < 'u'
    ? (module.exports = ie())
    : typeof define == 'function' && define.amd
      ? define(ie)
      : ((Ge = typeof globalThis < 'u' ? globalThis : Ge || self), (Ge.QLFQuizSwApp = ie()));
})(this, function () {
  'use strict';
  window.process = { env: { NODE_ENV: 'production' } };
  /**
   * @vue/shared v3.5.13
   * (c) 2018-present Yuxi (Evan) You and Vue contributors
   * @license MIT
   **/ /*! #__NO_SIDE_EFFECTS__ */ function Ge(e) {
    const t = Object.create(null);
    for (const n of e.split(',')) t[n] = 1;
    return (n) => n in t;
  }
  const ie = Object.freeze({}),
    qn = Object.freeze([]),
    Fe = () => {},
    Fc = () => !1,
    jn = (e) =>
      e.charCodeAt(0) === 111 &&
      e.charCodeAt(1) === 110 &&
      (e.charCodeAt(2) > 122 || e.charCodeAt(2) < 97),
    ks = (e) => e.startsWith('onUpdate:'),
    ye = Object.assign,
    ki = (e, t) => {
      const n = e.indexOf(t);
      n > -1 && e.splice(n, 1);
    },
    Dc = Object.prototype.hasOwnProperty,
    le = (e, t) => Dc.call(e, t),
    K = Array.isArray,
    Yt = (e) => Cs(e) === '[object Map]',
    so = (e) => Cs(e) === '[object Set]',
    G = (e) => typeof e == 'function',
    ve = (e) => typeof e == 'string',
    Ct = (e) => typeof e == 'symbol',
    ue = (e) => e !== null && typeof e == 'object',
    Ci = (e) => (ue(e) || G(e)) && G(e.then) && G(e.catch),
    io = Object.prototype.toString,
    Cs = (e) => io.call(e),
    Ai = (e) => Cs(e).slice(8, -1),
    ro = (e) => Cs(e) === '[object Object]',
    Ti = (e) => ve(e) && e !== 'NaN' && e[0] !== '-' && '' + parseInt(e, 10) === e,
    Ln = Ge(
      ',key,ref,ref_for,ref_key,onVnodeBeforeMount,onVnodeMounted,onVnodeBeforeUpdate,onVnodeUpdated,onVnodeBeforeUnmount,onVnodeUnmounted'
    ),
    zc = Ge('bind,cloak,else-if,else,for,html,if,model,on,once,pre,show,slot,text,memo'),
    As = (e) => {
      const t = Object.create(null);
      return (n) => t[n] || (t[n] = e(n));
    },
    Pc = /-(\w)/g,
    Me = As((e) => e.replace(Pc, (t, n) => (n ? n.toUpperCase() : ''))),
    Mc = /\B([A-Z])/g,
    At = As((e) => e.replace(Mc, '-$1').toLowerCase()),
    Zt = As((e) => e.charAt(0).toUpperCase() + e.slice(1)),
    Jt = As((e) => (e ? `on${Zt(e)}` : '')),
    Pt = (e, t) => !Object.is(e, t),
    vn = (e, ...t) => {
      for (let n = 0; n < e.length; n++) e[n](...t);
    },
    Ts = (e, t, n, s = !1) => {
      Object.defineProperty(e, t, { configurable: !0, enumerable: !1, writable: s, value: n });
    },
    Oi = (e) => {
      const t = parseFloat(e);
      return isNaN(t) ? e : t;
    },
    Rc = (e) => {
      const t = ve(e) ? Number(e) : NaN;
      return isNaN(t) ? e : t;
    };
  let oo;
  const Un = () =>
    oo ||
    (oo =
      typeof globalThis < 'u'
        ? globalThis
        : typeof self < 'u'
          ? self
          : typeof window < 'u'
            ? window
            : typeof global < 'u'
              ? global
              : {});
  function Ye(e) {
    if (K(e)) {
      const t = {};
      for (let n = 0; n < e.length; n++) {
        const s = e[n],
          i = ve(s) ? Lc(s) : Ye(s);
        if (i) for (const r in i) t[r] = i[r];
      }
      return t;
    } else if (ve(e) || ue(e)) return e;
  }
  const Vc = /;(?![^(]*\))/g,
    Nc = /:([^]+)/,
    jc = /\/\*[^]*?\*\//g;
  function Lc(e) {
    const t = {};
    return (
      e
        .replace(jc, '')
        .split(Vc)
        .forEach((n) => {
          if (n) {
            const s = n.split(Nc);
            s.length > 1 && (t[s[0].trim()] = s[1].trim());
          }
        }),
      t
    );
  }
  function Be(e) {
    let t = '';
    if (ve(e)) t = e;
    else if (K(e))
      for (let n = 0; n < e.length; n++) {
        const s = Be(e[n]);
        s && (t += s + ' ');
      }
    else if (ue(e)) for (const n in e) e[n] && (t += n + ' ');
    return t.trim();
  }
  const Uc =
      'html,body,base,head,link,meta,style,title,address,article,aside,footer,header,hgroup,h1,h2,h3,h4,h5,h6,nav,section,div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,ruby,s,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,embed,object,param,source,canvas,script,noscript,del,ins,caption,col,colgroup,table,thead,tbody,td,th,tr,button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,output,progress,select,textarea,details,dialog,menu,summary,template,blockquote,iframe,tfoot',
    Qc =
      'svg,animate,animateMotion,animateTransform,circle,clipPath,color-profile,defs,desc,discard,ellipse,feBlend,feColorMatrix,feComponentTransfer,feComposite,feConvolveMatrix,feDiffuseLighting,feDisplacementMap,feDistantLight,feDropShadow,feFlood,feFuncA,feFuncB,feFuncG,feFuncR,feGaussianBlur,feImage,feMerge,feMergeNode,feMorphology,feOffset,fePointLight,feSpecularLighting,feSpotLight,feTile,feTurbulence,filter,foreignObject,g,hatch,hatchpath,image,line,linearGradient,marker,mask,mesh,meshgradient,meshpatch,meshrow,metadata,mpath,path,pattern,polygon,polyline,radialGradient,rect,set,solidcolor,stop,switch,symbol,text,textPath,title,tspan,unknown,use,view',
    Hc =
      'annotation,annotation-xml,maction,maligngroup,malignmark,math,menclose,merror,mfenced,mfrac,mfraction,mglyph,mi,mlabeledtr,mlongdiv,mmultiscripts,mn,mo,mover,mpadded,mphantom,mprescripts,mroot,mrow,ms,mscarries,mscarry,msgroup,msline,mspace,msqrt,msrow,mstack,mstyle,msub,msubsup,msup,mtable,mtd,mtext,mtr,munder,munderover,none,semantics',
    Kc = Ge(Uc),
    Wc = Ge(Qc),
    Gc = Ge(Hc),
    Yc = Ge('itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly');
  function lo(e) {
    return !!e || e === '';
  }
  const ao = (e) => !!(e && e.__v_isRef === !0),
    me = (e) =>
      ve(e)
        ? e
        : e == null
          ? ''
          : K(e) || (ue(e) && (e.toString === io || !G(e.toString)))
            ? ao(e)
              ? me(e.value)
              : JSON.stringify(e, uo, 2)
            : String(e),
    uo = (e, t) =>
      ao(t)
        ? uo(e, t.value)
        : Yt(t)
          ? {
              [`Map(${t.size})`]: [...t.entries()].reduce(
                (n, [s, i], r) => ((n[Ii(s, r) + ' =>'] = i), n),
                {}
              )
            }
          : so(t)
            ? { [`Set(${t.size})`]: [...t.values()].map((n) => Ii(n)) }
            : Ct(t)
              ? Ii(t)
              : ue(t) && !K(t) && !ro(t)
                ? String(t)
                : t,
    Ii = (e, t = '') => {
      var n;
      return Ct(e) ? `Symbol(${(n = e.description) != null ? n : t})` : e;
    };
  var Zc = { NODE_ENV: '"production"' };
  function tt(e, ...t) {
    console.warn(`[Vue warn] ${e}`, ...t);
  }
  let Re;
  class co {
    constructor(t = !1) {
      ((this.detached = t),
        (this._active = !0),
        (this.effects = []),
        (this.cleanups = []),
        (this._isPaused = !1),
        (this.parent = Re),
        !t && Re && (this.index = (Re.scopes || (Re.scopes = [])).push(this) - 1));
    }
    get active() {
      return this._active;
    }
    pause() {
      if (this._active) {
        this._isPaused = !0;
        let t, n;
        if (this.scopes) for (t = 0, n = this.scopes.length; t < n; t++) this.scopes[t].pause();
        for (t = 0, n = this.effects.length; t < n; t++) this.effects[t].pause();
      }
    }
    resume() {
      if (this._active && this._isPaused) {
        this._isPaused = !1;
        let t, n;
        if (this.scopes) for (t = 0, n = this.scopes.length; t < n; t++) this.scopes[t].resume();
        for (t = 0, n = this.effects.length; t < n; t++) this.effects[t].resume();
      }
    }
    run(t) {
      if (this._active) {
        const n = Re;
        try {
          return ((Re = this), t());
        } finally {
          Re = n;
        }
      } else tt('cannot run an inactive effect scope.');
    }
    on() {
      Re = this;
    }
    off() {
      Re = this.parent;
    }
    stop(t) {
      if (this._active) {
        this._active = !1;
        let n, s;
        for (n = 0, s = this.effects.length; n < s; n++) this.effects[n].stop();
        for (this.effects.length = 0, n = 0, s = this.cleanups.length; n < s; n++)
          this.cleanups[n]();
        if (((this.cleanups.length = 0), this.scopes)) {
          for (n = 0, s = this.scopes.length; n < s; n++) this.scopes[n].stop(!0);
          this.scopes.length = 0;
        }
        if (!this.detached && this.parent && !t) {
          const i = this.parent.scopes.pop();
          i && i !== this && ((this.parent.scopes[this.index] = i), (i.index = this.index));
        }
        this.parent = void 0;
      }
    }
  }
  function fo(e) {
    return new co(e);
  }
  function po() {
    return Re;
  }
  function Jc(e, t = !1) {
    Re
      ? Re.cleanups.push(e)
      : t ||
        tt(
          'onScopeDispose() is called when there is no active effect scope to be associated with.'
        );
  }
  let ce;
  const $i = new WeakSet();
  class ho {
    constructor(t) {
      ((this.fn = t),
        (this.deps = void 0),
        (this.depsTail = void 0),
        (this.flags = 5),
        (this.next = void 0),
        (this.cleanup = void 0),
        (this.scheduler = void 0),
        Re && Re.active && Re.effects.push(this));
    }
    pause() {
      this.flags |= 64;
    }
    resume() {
      this.flags & 64 && ((this.flags &= -65), $i.has(this) && ($i.delete(this), this.trigger()));
    }
    notify() {
      (this.flags & 2 && !(this.flags & 32)) || this.flags & 8 || go(this);
    }
    run() {
      if (!(this.flags & 1)) return this.fn();
      ((this.flags |= 2), bo(this), _o(this));
      const t = ce,
        n = it;
      ((ce = this), (it = !0));
      try {
        return this.fn();
      } finally {
        (ce !== this &&
          tt('Active effect was not restored correctly - this is likely a Vue internal bug.'),
          qo(this),
          (ce = t),
          (it = n),
          (this.flags &= -3));
      }
    }
    stop() {
      if (this.flags & 1) {
        for (let t = this.deps; t; t = t.nextDep) zi(t);
        ((this.deps = this.depsTail = void 0),
          bo(this),
          this.onStop && this.onStop(),
          (this.flags &= -2));
      }
    }
    trigger() {
      this.flags & 64 ? $i.add(this) : this.scheduler ? this.scheduler() : this.runIfDirty();
    }
    runIfDirty() {
      Di(this) && this.run();
    }
    get dirty() {
      return Di(this);
    }
  }
  let mo = 0,
    Qn,
    Hn;
  function go(e, t = !1) {
    if (((e.flags |= 8), t)) {
      ((e.next = Hn), (Hn = e));
      return;
    }
    ((e.next = Qn), (Qn = e));
  }
  function Bi() {
    mo++;
  }
  function Fi() {
    if (--mo > 0) return;
    if (Hn) {
      let t = Hn;
      for (Hn = void 0; t; ) {
        const n = t.next;
        ((t.next = void 0), (t.flags &= -9), (t = n));
      }
    }
    let e;
    for (; Qn; ) {
      let t = Qn;
      for (Qn = void 0; t; ) {
        const n = t.next;
        if (((t.next = void 0), (t.flags &= -9), t.flags & 1))
          try {
            t.trigger();
          } catch (s) {
            e || (e = s);
          }
        t = n;
      }
    }
    if (e) throw e;
  }
  function _o(e) {
    for (let t = e.deps; t; t = t.nextDep)
      ((t.version = -1), (t.prevActiveLink = t.dep.activeLink), (t.dep.activeLink = t));
  }
  function qo(e) {
    let t,
      n = e.depsTail,
      s = n;
    for (; s; ) {
      const i = s.prevDep;
      (s.version === -1 ? (s === n && (n = i), zi(s), Xc(s)) : (t = s),
        (s.dep.activeLink = s.prevActiveLink),
        (s.prevActiveLink = void 0),
        (s = i));
    }
    ((e.deps = t), (e.depsTail = n));
  }
  function Di(e) {
    for (let t = e.deps; t; t = t.nextDep)
      if (
        t.dep.version !== t.version ||
        (t.dep.computed && (vo(t.dep.computed) || t.dep.version !== t.version))
      )
        return !0;
    return !!e._dirty;
  }
  function vo(e) {
    if ((e.flags & 4 && !(e.flags & 16)) || ((e.flags &= -17), e.globalVersion === Kn)) return;
    e.globalVersion = Kn;
    const t = e.dep;
    if (((e.flags |= 2), t.version > 0 && !e.isSSR && e.deps && !Di(e))) {
      e.flags &= -3;
      return;
    }
    const n = ce,
      s = it;
    ((ce = e), (it = !0));
    try {
      _o(e);
      const i = e.fn(e._value);
      (t.version === 0 || Pt(i, e._value)) && ((e._value = i), t.version++);
    } catch (i) {
      throw (t.version++, i);
    } finally {
      ((ce = n), (it = s), qo(e), (e.flags &= -3));
    }
  }
  function zi(e, t = !1) {
    const { dep: n, prevSub: s, nextSub: i } = e;
    if (
      (s && ((s.nextSub = i), (e.prevSub = void 0)),
      i && ((i.prevSub = s), (e.nextSub = void 0)),
      n.subsHead === e && (n.subsHead = i),
      n.subs === e && ((n.subs = s), !s && n.computed))
    ) {
      n.computed.flags &= -5;
      for (let r = n.computed.deps; r; r = r.nextDep) zi(r, !0);
    }
    !t && !--n.sc && n.map && n.map.delete(n.key);
  }
  function Xc(e) {
    const { prevDep: t, nextDep: n } = e;
    (t && ((t.nextDep = n), (e.prevDep = void 0)), n && ((n.prevDep = t), (e.nextDep = void 0)));
  }
  let it = !0;
  const yo = [];
  function Tt() {
    (yo.push(it), (it = !1));
  }
  function Ot() {
    const e = yo.pop();
    it = e === void 0 ? !0 : e;
  }
  function bo(e) {
    const { cleanup: t } = e;
    if (((e.cleanup = void 0), t)) {
      const n = ce;
      ce = void 0;
      try {
        t();
      } finally {
        ce = n;
      }
    }
  }
  let Kn = 0;
  class ef {
    constructor(t, n) {
      ((this.sub = t),
        (this.dep = n),
        (this.version = n.version),
        (this.nextDep = this.prevDep = this.nextSub = this.prevSub = this.prevActiveLink = void 0));
    }
  }
  class Pi {
    constructor(t) {
      ((this.computed = t),
        (this.version = 0),
        (this.activeLink = void 0),
        (this.subs = void 0),
        (this.map = void 0),
        (this.key = void 0),
        (this.sc = 0),
        (this.subsHead = void 0));
    }
    track(t) {
      if (!ce || !it || ce === this.computed) return;
      let n = this.activeLink;
      if (n === void 0 || n.sub !== ce)
        ((n = this.activeLink = new ef(ce, this)),
          ce.deps
            ? ((n.prevDep = ce.depsTail), (ce.depsTail.nextDep = n), (ce.depsTail = n))
            : (ce.deps = ce.depsTail = n),
          wo(n));
      else if (n.version === -1 && ((n.version = this.version), n.nextDep)) {
        const s = n.nextDep;
        ((s.prevDep = n.prevDep),
          n.prevDep && (n.prevDep.nextDep = s),
          (n.prevDep = ce.depsTail),
          (n.nextDep = void 0),
          (ce.depsTail.nextDep = n),
          (ce.depsTail = n),
          ce.deps === n && (ce.deps = s));
      }
      return (ce.onTrack && ce.onTrack(ye({ effect: ce }, t)), n);
    }
    trigger(t) {
      (this.version++, Kn++, this.notify(t));
    }
    notify(t) {
      Bi();
      try {
        if (Zc.NODE_ENV !== 'production')
          for (let n = this.subsHead; n; n = n.nextSub)
            n.sub.onTrigger && !(n.sub.flags & 8) && n.sub.onTrigger(ye({ effect: n.sub }, t));
        for (let n = this.subs; n; n = n.prevSub) n.sub.notify() && n.sub.dep.notify();
      } finally {
        Fi();
      }
    }
  }
  function wo(e) {
    if ((e.dep.sc++, e.sub.flags & 4)) {
      const t = e.dep.computed;
      if (t && !e.dep.subs) {
        t.flags |= 20;
        for (let s = t.deps; s; s = s.nextDep) wo(s);
      }
      const n = e.dep.subs;
      (n !== e && ((e.prevSub = n), n && (n.nextSub = e)),
        e.dep.subsHead === void 0 && (e.dep.subsHead = e),
        (e.dep.subs = e));
    }
  }
  const Os = new WeakMap(),
    Xt = Symbol('Object iterate'),
    Mi = Symbol('Map keys iterate'),
    Wn = Symbol('Array iterate');
  function Oe(e, t, n) {
    if (it && ce) {
      let s = Os.get(e);
      s || Os.set(e, (s = new Map()));
      let i = s.get(n);
      (i || (s.set(n, (i = new Pi())), (i.map = s), (i.key = n)),
        i.track({ target: e, type: t, key: n }));
    }
  }
  function ft(e, t, n, s, i, r) {
    const o = Os.get(e);
    if (!o) {
      Kn++;
      return;
    }
    const l = (a) => {
      a && a.trigger({ target: e, type: t, key: n, newValue: s, oldValue: i, oldTarget: r });
    };
    if ((Bi(), t === 'clear')) o.forEach(l);
    else {
      const a = K(e),
        f = a && Ti(n);
      if (a && n === 'length') {
        const c = Number(s);
        o.forEach((u, d) => {
          (d === 'length' || d === Wn || (!Ct(d) && d >= c)) && l(u);
        });
      } else
        switch (((n !== void 0 || o.has(void 0)) && l(o.get(n)), f && l(o.get(Wn)), t)) {
          case 'add':
            a ? f && l(o.get('length')) : (l(o.get(Xt)), Yt(e) && l(o.get(Mi)));
            break;
          case 'delete':
            a || (l(o.get(Xt)), Yt(e) && l(o.get(Mi)));
            break;
          case 'set':
            Yt(e) && l(o.get(Xt));
            break;
        }
    }
    Fi();
  }
  function tf(e, t) {
    const n = Os.get(e);
    return n && n.get(t);
  }
  function yn(e) {
    const t = J(e);
    return t === e ? t : (Oe(t, 'iterate', Wn), Ve(e) ? t : t.map(De));
  }
  function Is(e) {
    return (Oe((e = J(e)), 'iterate', Wn), e);
  }
  const nf = {
    __proto__: null,
    [Symbol.iterator]() {
      return Ri(this, Symbol.iterator, De);
    },
    concat(...e) {
      return yn(this).concat(...e.map((t) => (K(t) ? yn(t) : t)));
    },
    entries() {
      return Ri(this, 'entries', (e) => ((e[1] = De(e[1])), e));
    },
    every(e, t) {
      return It(this, 'every', e, t, void 0, arguments);
    },
    filter(e, t) {
      return It(this, 'filter', e, t, (n) => n.map(De), arguments);
    },
    find(e, t) {
      return It(this, 'find', e, t, De, arguments);
    },
    findIndex(e, t) {
      return It(this, 'findIndex', e, t, void 0, arguments);
    },
    findLast(e, t) {
      return It(this, 'findLast', e, t, De, arguments);
    },
    findLastIndex(e, t) {
      return It(this, 'findLastIndex', e, t, void 0, arguments);
    },
    forEach(e, t) {
      return It(this, 'forEach', e, t, void 0, arguments);
    },
    includes(...e) {
      return Vi(this, 'includes', e);
    },
    indexOf(...e) {
      return Vi(this, 'indexOf', e);
    },
    join(e) {
      return yn(this).join(e);
    },
    lastIndexOf(...e) {
      return Vi(this, 'lastIndexOf', e);
    },
    map(e, t) {
      return It(this, 'map', e, t, void 0, arguments);
    },
    pop() {
      return Gn(this, 'pop');
    },
    push(...e) {
      return Gn(this, 'push', e);
    },
    reduce(e, ...t) {
      return xo(this, 'reduce', e, t);
    },
    reduceRight(e, ...t) {
      return xo(this, 'reduceRight', e, t);
    },
    shift() {
      return Gn(this, 'shift');
    },
    some(e, t) {
      return It(this, 'some', e, t, void 0, arguments);
    },
    splice(...e) {
      return Gn(this, 'splice', e);
    },
    toReversed() {
      return yn(this).toReversed();
    },
    toSorted(e) {
      return yn(this).toSorted(e);
    },
    toSpliced(...e) {
      return yn(this).toSpliced(...e);
    },
    unshift(...e) {
      return Gn(this, 'unshift', e);
    },
    values() {
      return Ri(this, 'values', De);
    }
  };
  function Ri(e, t, n) {
    const s = Is(e),
      i = s[t]();
    return (
      s !== e &&
        !Ve(e) &&
        ((i._next = i.next),
        (i.next = () => {
          const r = i._next();
          return (r.value && (r.value = n(r.value)), r);
        })),
      i
    );
  }
  const sf = Array.prototype;
  function It(e, t, n, s, i, r) {
    const o = Is(e),
      l = o !== e && !Ve(e),
      a = o[t];
    if (a !== sf[t]) {
      const u = a.apply(e, r);
      return l ? De(u) : u;
    }
    let f = n;
    o !== e &&
      (l
        ? (f = function (u, d) {
            return n.call(this, De(u), d, e);
          })
        : n.length > 2 &&
          (f = function (u, d) {
            return n.call(this, u, d, e);
          }));
    const c = a.call(o, f, s);
    return l && i ? i(c) : c;
  }
  function xo(e, t, n, s) {
    const i = Is(e);
    let r = n;
    return (
      i !== e &&
        (Ve(e)
          ? n.length > 3 &&
            (r = function (o, l, a) {
              return n.call(this, o, l, a, e);
            })
          : (r = function (o, l, a) {
              return n.call(this, o, De(l), a, e);
            })),
      i[t](r, ...s)
    );
  }
  function Vi(e, t, n) {
    const s = J(e);
    Oe(s, 'iterate', Wn);
    const i = s[t](...n);
    return (i === -1 || i === !1) && Yn(n[0]) ? ((n[0] = J(n[0])), s[t](...n)) : i;
  }
  function Gn(e, t, n = []) {
    (Tt(), Bi());
    const s = J(e)[t].apply(e, n);
    return (Fi(), Ot(), s);
  }
  const rf = Ge('__proto__,__v_isRef,__isVue'),
    Eo = new Set(
      Object.getOwnPropertyNames(Symbol)
        .filter((e) => e !== 'arguments' && e !== 'caller')
        .map((e) => Symbol[e])
        .filter(Ct)
    );
  function of(e) {
    Ct(e) || (e = String(e));
    const t = J(this);
    return (Oe(t, 'has', e), t.hasOwnProperty(e));
  }
  class So {
    constructor(t = !1, n = !1) {
      ((this._isReadonly = t), (this._isShallow = n));
    }
    get(t, n, s) {
      if (n === '__v_skip') return t.__v_skip;
      const i = this._isReadonly,
        r = this._isShallow;
      if (n === '__v_isReactive') return !i;
      if (n === '__v_isReadonly') return i;
      if (n === '__v_isShallow') return r;
      if (n === '__v_raw')
        return s === (i ? (r ? $o : Io) : r ? Oo : To).get(t) ||
          Object.getPrototypeOf(t) === Object.getPrototypeOf(s)
          ? t
          : void 0;
      const o = K(t);
      if (!i) {
        let a;
        if (o && (a = nf[n])) return a;
        if (n === 'hasOwnProperty') return of;
      }
      const l = Reflect.get(t, n, ge(t) ? t : s);
      return (Ct(n) ? Eo.has(n) : rf(n)) || (i || Oe(t, 'get', n), r)
        ? l
        : ge(l)
          ? o && Ti(n)
            ? l
            : l.value
          : ue(l)
            ? i
              ? Bo(l)
              : Ds(l)
            : l;
    }
  }
  class ko extends So {
    constructor(t = !1) {
      super(!1, t);
    }
    set(t, n, s, i) {
      let r = t[n];
      if (!this._isShallow) {
        const a = $t(r);
        if ((!Ve(s) && !$t(s) && ((r = J(r)), (s = J(s))), !K(t) && ge(r) && !ge(s)))
          return a ? !1 : ((r.value = s), !0);
      }
      const o = K(t) && Ti(n) ? Number(n) < t.length : le(t, n),
        l = Reflect.set(t, n, s, ge(t) ? t : i);
      return (t === J(i) && (o ? Pt(s, r) && ft(t, 'set', n, s, r) : ft(t, 'add', n, s)), l);
    }
    deleteProperty(t, n) {
      const s = le(t, n),
        i = t[n],
        r = Reflect.deleteProperty(t, n);
      return (r && s && ft(t, 'delete', n, void 0, i), r);
    }
    has(t, n) {
      const s = Reflect.has(t, n);
      return ((!Ct(n) || !Eo.has(n)) && Oe(t, 'has', n), s);
    }
    ownKeys(t) {
      return (Oe(t, 'iterate', K(t) ? 'length' : Xt), Reflect.ownKeys(t));
    }
  }
  class Co extends So {
    constructor(t = !1) {
      super(!0, t);
    }
    set(t, n) {
      return (tt(`Set operation on key "${String(n)}" failed: target is readonly.`, t), !0);
    }
    deleteProperty(t, n) {
      return (tt(`Delete operation on key "${String(n)}" failed: target is readonly.`, t), !0);
    }
  }
  const lf = new ko(),
    af = new Co(),
    uf = new ko(!0),
    cf = new Co(!0),
    Ni = (e) => e,
    $s = (e) => Reflect.getPrototypeOf(e);
  function ff(e, t, n) {
    return function (...s) {
      const i = this.__v_raw,
        r = J(i),
        o = Yt(r),
        l = e === 'entries' || (e === Symbol.iterator && o),
        a = e === 'keys' && o,
        f = i[e](...s),
        c = n ? Ni : t ? ji : De;
      return (
        !t && Oe(r, 'iterate', a ? Mi : Xt),
        {
          next() {
            const { value: u, done: d } = f.next();
            return d ? { value: u, done: d } : { value: l ? [c(u[0]), c(u[1])] : c(u), done: d };
          },
          [Symbol.iterator]() {
            return this;
          }
        }
      );
    };
  }
  function Bs(e) {
    return function (...t) {
      {
        const n = t[0] ? `on key "${t[0]}" ` : '';
        tt(`${Zt(e)} operation ${n}failed: target is readonly.`, J(this));
      }
      return e === 'delete' ? !1 : e === 'clear' ? void 0 : this;
    };
  }
  function df(e, t) {
    const n = {
      get(i) {
        const r = this.__v_raw,
          o = J(r),
          l = J(i);
        e || (Pt(i, l) && Oe(o, 'get', i), Oe(o, 'get', l));
        const { has: a } = $s(o),
          f = t ? Ni : e ? ji : De;
        if (a.call(o, i)) return f(r.get(i));
        if (a.call(o, l)) return f(r.get(l));
        r !== o && r.get(i);
      },
      get size() {
        const i = this.__v_raw;
        return (!e && Oe(J(i), 'iterate', Xt), Reflect.get(i, 'size', i));
      },
      has(i) {
        const r = this.__v_raw,
          o = J(r),
          l = J(i);
        return (
          e || (Pt(i, l) && Oe(o, 'has', i), Oe(o, 'has', l)),
          i === l ? r.has(i) : r.has(i) || r.has(l)
        );
      },
      forEach(i, r) {
        const o = this,
          l = o.__v_raw,
          a = J(l),
          f = t ? Ni : e ? ji : De;
        return (!e && Oe(a, 'iterate', Xt), l.forEach((c, u) => i.call(r, f(c), f(u), o)));
      }
    };
    return (
      ye(
        n,
        e
          ? { add: Bs('add'), set: Bs('set'), delete: Bs('delete'), clear: Bs('clear') }
          : {
              add(i) {
                !t && !Ve(i) && !$t(i) && (i = J(i));
                const r = J(this);
                return ($s(r).has.call(r, i) || (r.add(i), ft(r, 'add', i, i)), this);
              },
              set(i, r) {
                !t && !Ve(r) && !$t(r) && (r = J(r));
                const o = J(this),
                  { has: l, get: a } = $s(o);
                let f = l.call(o, i);
                f ? Ao(o, l, i) : ((i = J(i)), (f = l.call(o, i)));
                const c = a.call(o, i);
                return (
                  o.set(i, r),
                  f ? Pt(r, c) && ft(o, 'set', i, r, c) : ft(o, 'add', i, r),
                  this
                );
              },
              delete(i) {
                const r = J(this),
                  { has: o, get: l } = $s(r);
                let a = o.call(r, i);
                a ? Ao(r, o, i) : ((i = J(i)), (a = o.call(r, i)));
                const f = l ? l.call(r, i) : void 0,
                  c = r.delete(i);
                return (a && ft(r, 'delete', i, void 0, f), c);
              },
              clear() {
                const i = J(this),
                  r = i.size !== 0,
                  o = Yt(i) ? new Map(i) : new Set(i),
                  l = i.clear();
                return (r && ft(i, 'clear', void 0, void 0, o), l);
              }
            }
      ),
      ['keys', 'values', 'entries', Symbol.iterator].forEach((i) => {
        n[i] = ff(i, e, t);
      }),
      n
    );
  }
  function Fs(e, t) {
    const n = df(e, t);
    return (s, i, r) =>
      i === '__v_isReactive'
        ? !e
        : i === '__v_isReadonly'
          ? e
          : i === '__v_raw'
            ? s
            : Reflect.get(le(n, i) && i in s ? n : s, i, r);
  }
  const pf = { get: Fs(!1, !1) },
    hf = { get: Fs(!1, !0) },
    mf = { get: Fs(!0, !1) },
    gf = { get: Fs(!0, !0) };
  function Ao(e, t, n) {
    const s = J(n);
    if (s !== n && t.call(e, s)) {
      const i = Ai(e);
      tt(
        `Reactive ${i} contains both the raw and reactive versions of the same object${i === 'Map' ? ' as keys' : ''}, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`
      );
    }
  }
  const To = new WeakMap(),
    Oo = new WeakMap(),
    Io = new WeakMap(),
    $o = new WeakMap();
  function _f(e) {
    switch (e) {
      case 'Object':
      case 'Array':
        return 1;
      case 'Map':
      case 'Set':
      case 'WeakMap':
      case 'WeakSet':
        return 2;
      default:
        return 0;
    }
  }
  function qf(e) {
    return e.__v_skip || !Object.isExtensible(e) ? 0 : _f(Ai(e));
  }
  function Ds(e) {
    return $t(e) ? e : zs(e, !1, lf, pf, To);
  }
  function vf(e) {
    return zs(e, !1, uf, hf, Oo);
  }
  function Bo(e) {
    return zs(e, !0, af, mf, Io);
  }
  function dt(e) {
    return zs(e, !0, cf, gf, $o);
  }
  function zs(e, t, n, s, i) {
    if (!ue(e)) return (tt(`value cannot be made ${t ? 'readonly' : 'reactive'}: ${String(e)}`), e);
    if (e.__v_raw && !(t && e.__v_isReactive)) return e;
    const r = i.get(e);
    if (r) return r;
    const o = qf(e);
    if (o === 0) return e;
    const l = new Proxy(e, o === 2 ? s : n);
    return (i.set(e, l), l);
  }
  function pt(e) {
    return $t(e) ? pt(e.__v_raw) : !!(e && e.__v_isReactive);
  }
  function $t(e) {
    return !!(e && e.__v_isReadonly);
  }
  function Ve(e) {
    return !!(e && e.__v_isShallow);
  }
  function Yn(e) {
    return e ? !!e.__v_raw : !1;
  }
  function J(e) {
    const t = e && e.__v_raw;
    return t ? J(t) : e;
  }
  function Mt(e) {
    return (!le(e, '__v_skip') && Object.isExtensible(e) && Ts(e, '__v_skip', !0), e);
  }
  const De = (e) => (ue(e) ? Ds(e) : e),
    ji = (e) => (ue(e) ? Bo(e) : e);
  function ge(e) {
    return e ? e.__v_isRef === !0 : !1;
  }
  function Q(e) {
    return yf(e, !1);
  }
  function yf(e, t) {
    return ge(e) ? e : new bf(e, t);
  }
  class bf {
    constructor(t, n) {
      ((this.dep = new Pi()),
        (this.__v_isRef = !0),
        (this.__v_isShallow = !1),
        (this._rawValue = n ? t : J(t)),
        (this._value = n ? t : De(t)),
        (this.__v_isShallow = n));
    }
    get value() {
      return (this.dep.track({ target: this, type: 'get', key: 'value' }), this._value);
    }
    set value(t) {
      const n = this._rawValue,
        s = this.__v_isShallow || Ve(t) || $t(t);
      ((t = s ? t : J(t)),
        Pt(t, n) &&
          ((this._rawValue = t),
          (this._value = s ? t : De(t)),
          this.dep.trigger({ target: this, type: 'set', key: 'value', newValue: t, oldValue: n })));
    }
  }
  function rt(e) {
    return ge(e) ? e.value : e;
  }
  const wf = {
    get: (e, t, n) => (t === '__v_raw' ? e : rt(Reflect.get(e, t, n))),
    set: (e, t, n, s) => {
      const i = e[t];
      return ge(i) && !ge(n) ? ((i.value = n), !0) : Reflect.set(e, t, n, s);
    }
  };
  function Fo(e) {
    return pt(e) ? e : new Proxy(e, wf);
  }
  function Do(e) {
    Yn(e) || tt('toRefs() expects a reactive object but received a plain one.');
    const t = K(e) ? new Array(e.length) : {};
    for (const n in e) t[n] = zo(e, n);
    return t;
  }
  class xf {
    constructor(t, n, s) {
      ((this._object = t),
        (this._key = n),
        (this._defaultValue = s),
        (this.__v_isRef = !0),
        (this._value = void 0));
    }
    get value() {
      const t = this._object[this._key];
      return (this._value = t === void 0 ? this._defaultValue : t);
    }
    set value(t) {
      this._object[this._key] = t;
    }
    get dep() {
      return tf(J(this._object), this._key);
    }
  }
  class Ef {
    constructor(t) {
      ((this._getter = t),
        (this.__v_isRef = !0),
        (this.__v_isReadonly = !0),
        (this._value = void 0));
    }
    get value() {
      return (this._value = this._getter());
    }
  }
  function Li(e, t, n) {
    return ge(e) ? e : G(e) ? new Ef(e) : ue(e) && arguments.length > 1 ? zo(e, t, n) : Q(e);
  }
  function zo(e, t, n) {
    const s = e[t];
    return ge(s) ? s : new xf(e, t, n);
  }
  class Sf {
    constructor(t, n, s) {
      ((this.fn = t),
        (this.setter = n),
        (this._value = void 0),
        (this.dep = new Pi(this)),
        (this.__v_isRef = !0),
        (this.deps = void 0),
        (this.depsTail = void 0),
        (this.flags = 16),
        (this.globalVersion = Kn - 1),
        (this.next = void 0),
        (this.effect = this),
        (this.__v_isReadonly = !n),
        (this.isSSR = s));
    }
    notify() {
      if (((this.flags |= 16), !(this.flags & 8) && ce !== this)) return (go(this, !0), !0);
    }
    get value() {
      const t = this.dep.track({ target: this, type: 'get', key: 'value' });
      return (vo(this), t && (t.version = this.dep.version), this._value);
    }
    set value(t) {
      this.setter ? this.setter(t) : tt('Write operation failed: computed value is readonly');
    }
  }
  function kf(e, t, n = !1) {
    let s, i;
    return (G(e) ? (s = e) : ((s = e.get), (i = e.set)), new Sf(s, i, n));
  }
  const Ps = {},
    Ms = new WeakMap();
  let en;
  function Cf(e, t = !1, n = en) {
    if (n) {
      let s = Ms.get(n);
      (s || Ms.set(n, (s = [])), s.push(e));
    } else
      t || tt('onWatcherCleanup() was called when there was no active watcher to associate with.');
  }
  function Af(e, t, n = ie) {
    const { immediate: s, deep: i, once: r, scheduler: o, augmentJob: l, call: a } = n,
      f = (N) => {
        (n.onWarn || tt)(
          'Invalid watch source: ',
          N,
          'A watch source can only be a getter/effect function, a ref, a reactive object, or an array of these types.'
        );
      },
      c = (N) => (i ? N : Ve(N) || i === !1 || i === 0 ? Bt(N, 1) : Bt(N));
    let u,
      d,
      p,
      h,
      q = !1,
      v = !1;
    if (
      (ge(e)
        ? ((d = () => e.value), (q = Ve(e)))
        : pt(e)
          ? ((d = () => c(e)), (q = !0))
          : K(e)
            ? ((v = !0),
              (q = e.some((N) => pt(N) || Ve(N))),
              (d = () =>
                e.map((N) => {
                  if (ge(N)) return N.value;
                  if (pt(N)) return c(N);
                  if (G(N)) return a ? a(N, 2) : N();
                  f(N);
                })))
            : G(e)
              ? t
                ? (d = a ? () => a(e, 2) : e)
                : (d = () => {
                    if (p) {
                      Tt();
                      try {
                        p();
                      } finally {
                        Ot();
                      }
                    }
                    const N = en;
                    en = u;
                    try {
                      return a ? a(e, 3, [h]) : e(h);
                    } finally {
                      en = N;
                    }
                  })
              : ((d = Fe), f(e)),
      t && i)
    ) {
      const N = d,
        ne = i === !0 ? 1 / 0 : i;
      d = () => Bt(N(), ne);
    }
    const y = po(),
      z = () => {
        (u.stop(), y && y.active && ki(y.effects, u));
      };
    if (r && t) {
      const N = t;
      t = (...ne) => {
        (N(...ne), z());
      };
    }
    let O = v ? new Array(e.length).fill(Ps) : Ps;
    const X = (N) => {
      if (!(!(u.flags & 1) || (!u.dirty && !N)))
        if (t) {
          const ne = u.run();
          if (i || q || (v ? ne.some((H, fe) => Pt(H, O[fe])) : Pt(ne, O))) {
            p && p();
            const H = en;
            en = u;
            try {
              const fe = [ne, O === Ps ? void 0 : v && O[0] === Ps ? [] : O, h];
              (a ? a(t, 3, fe) : t(...fe), (O = ne));
            } finally {
              en = H;
            }
          }
        } else u.run();
    };
    return (
      l && l(X),
      (u = new ho(d)),
      (u.scheduler = o ? () => o(X, !1) : X),
      (h = (N) => Cf(N, !1, u)),
      (p = u.onStop =
        () => {
          const N = Ms.get(u);
          if (N) {
            if (a) a(N, 4);
            else for (const ne of N) ne();
            Ms.delete(u);
          }
        }),
      (u.onTrack = n.onTrack),
      (u.onTrigger = n.onTrigger),
      t ? (s ? X(!0) : (O = u.run())) : o ? o(X.bind(null, !0), !0) : u.run(),
      (z.pause = u.pause.bind(u)),
      (z.resume = u.resume.bind(u)),
      (z.stop = z),
      z
    );
  }
  function Bt(e, t = 1 / 0, n) {
    if (t <= 0 || !ue(e) || e.__v_skip || ((n = n || new Set()), n.has(e))) return e;
    if ((n.add(e), t--, ge(e))) Bt(e.value, t, n);
    else if (K(e)) for (let s = 0; s < e.length; s++) Bt(e[s], t, n);
    else if (so(e) || Yt(e))
      e.forEach((s) => {
        Bt(s, t, n);
      });
    else if (ro(e)) {
      for (const s in e) Bt(e[s], t, n);
      for (const s of Object.getOwnPropertySymbols(e))
        Object.prototype.propertyIsEnumerable.call(e, s) && Bt(e[s], t, n);
    }
    return e;
  }
  var Rt = { NODE_ENV: '"production"' };
  const tn = [];
  function Rs(e) {
    tn.push(e);
  }
  function Vs() {
    tn.pop();
  }
  let Ui = !1;
  function I(e, ...t) {
    if (Ui) return;
    ((Ui = !0), Tt());
    const n = tn.length ? tn[tn.length - 1].component : null,
      s = n && n.appContext.config.warnHandler,
      i = Tf();
    if (s)
      bn(s, n, 11, [
        e +
          t
            .map((r) => {
              var o, l;
              return (l = (o = r.toString) == null ? void 0 : o.call(r)) != null
                ? l
                : JSON.stringify(r);
            })
            .join(''),
        n && n.proxy,
        i.map(({ vnode: r }) => `at <${ii(n, r.type)}>`).join(`
`),
        i
      ]);
    else {
      const r = [`[Vue warn]: ${e}`, ...t];
      (i.length &&
        r.push(
          `
`,
          ...Of(i)
        ),
        console.warn(...r));
    }
    (Ot(), (Ui = !1));
  }
  function Tf() {
    let e = tn[tn.length - 1];
    if (!e) return [];
    const t = [];
    for (; e; ) {
      const n = t[0];
      n && n.vnode === e ? n.recurseCount++ : t.push({ vnode: e, recurseCount: 0 });
      const s = e.component && e.component.parent;
      e = s && s.vnode;
    }
    return t;
  }
  function Of(e) {
    const t = [];
    return (
      e.forEach((n, s) => {
        t.push(
          ...(s === 0
            ? []
            : [
                `
`
              ]),
          ...If(n)
        );
      }),
      t
    );
  }
  function If({ vnode: e, recurseCount: t }) {
    const n = t > 0 ? `... (${t} recursive calls)` : '',
      s = e.component ? e.component.parent == null : !1,
      i = ` at <${ii(e.component, e.type, s)}`,
      r = '>' + n;
    return e.props ? [i, ...$f(e.props), r] : [i + r];
  }
  function $f(e) {
    const t = [],
      n = Object.keys(e);
    return (
      n.slice(0, 3).forEach((s) => {
        t.push(...Po(s, e[s]));
      }),
      n.length > 3 && t.push(' ...'),
      t
    );
  }
  function Po(e, t, n) {
    return ve(t)
      ? ((t = JSON.stringify(t)), n ? t : [`${e}=${t}`])
      : typeof t == 'number' || typeof t == 'boolean' || t == null
        ? n
          ? t
          : [`${e}=${t}`]
        : ge(t)
          ? ((t = Po(e, J(t.value), !0)), n ? t : [`${e}=Ref<`, t, '>'])
          : G(t)
            ? [`${e}=fn${t.name ? `<${t.name}>` : ''}`]
            : ((t = J(t)), n ? t : [`${e}=`, t]);
  }
  function Bf(e, t) {
    e !== void 0 &&
      (typeof e != 'number'
        ? I(`${t} is not a valid number - got ${JSON.stringify(e)}.`)
        : isNaN(e) && I(`${t} is NaN - the duration expression might be incorrect.`));
  }
  const Qi = {
    sp: 'serverPrefetch hook',
    bc: 'beforeCreate hook',
    c: 'created hook',
    bm: 'beforeMount hook',
    m: 'mounted hook',
    bu: 'beforeUpdate hook',
    u: 'updated',
    bum: 'beforeUnmount hook',
    um: 'unmounted hook',
    a: 'activated hook',
    da: 'deactivated hook',
    ec: 'errorCaptured hook',
    rtc: 'renderTracked hook',
    rtg: 'renderTriggered hook',
    0: 'setup function',
    1: 'render function',
    2: 'watcher getter',
    3: 'watcher callback',
    4: 'watcher cleanup function',
    5: 'native event handler',
    6: 'component event handler',
    7: 'vnode hook',
    8: 'directive hook',
    9: 'transition hook',
    10: 'app errorHandler',
    11: 'app warnHandler',
    12: 'ref function',
    13: 'async component loader',
    14: 'scheduler flush',
    15: 'component update',
    16: 'app unmount cleanup function'
  };
  function bn(e, t, n, s) {
    try {
      return s ? e(...s) : e();
    } catch (i) {
      Zn(i, t, n);
    }
  }
  function ot(e, t, n, s) {
    if (G(e)) {
      const i = bn(e, t, n, s);
      return (
        i &&
          Ci(i) &&
          i.catch((r) => {
            Zn(r, t, n);
          }),
        i
      );
    }
    if (K(e)) {
      const i = [];
      for (let r = 0; r < e.length; r++) i.push(ot(e[r], t, n, s));
      return i;
    } else I(`Invalid value type passed to callWithAsyncErrorHandling(): ${typeof e}`);
  }
  function Zn(e, t, n, s = !0) {
    const i = t ? t.vnode : null,
      { errorHandler: r, throwUnhandledErrorInProduction: o } = (t && t.appContext.config) || ie;
    if (t) {
      let l = t.parent;
      const a = t.proxy,
        f = Qi[n];
      for (; l; ) {
        const c = l.ec;
        if (c) {
          for (let u = 0; u < c.length; u++) if (c[u](e, a, f) === !1) return;
        }
        l = l.parent;
      }
      if (r) {
        (Tt(), bn(r, null, 10, [e, a, f]), Ot());
        return;
      }
    }
    Ff(e, n, i, s, o);
  }
  function Ff(e, t, n, s = !0, i = !1) {
    {
      const r = Qi[t];
      if ((n && Rs(n), I(`Unhandled error${r ? ` during execution of ${r}` : ''}`), n && Vs(), s))
        throw e;
      console.error(e);
    }
  }
  const Ne = [];
  let ht = -1;
  const wn = [];
  let Vt = null,
    xn = 0;
  const Mo = Promise.resolve();
  let Ns = null;
  const Df = 100;
  function Hi(e) {
    const t = Ns || Mo;
    return e ? t.then(this ? e.bind(this) : e) : t;
  }
  function zf(e) {
    let t = ht + 1,
      n = Ne.length;
    for (; t < n; ) {
      const s = (t + n) >>> 1,
        i = Ne[s],
        r = Jn(i);
      r < e || (r === e && i.flags & 2) ? (t = s + 1) : (n = s);
    }
    return t;
  }
  function js(e) {
    if (!(e.flags & 1)) {
      const t = Jn(e),
        n = Ne[Ne.length - 1];
      (!n || (!(e.flags & 2) && t >= Jn(n)) ? Ne.push(e) : Ne.splice(zf(t), 0, e),
        (e.flags |= 1),
        Ro());
    }
  }
  function Ro() {
    Ns || (Ns = Mo.then(Lo));
  }
  function Vo(e) {
    (K(e)
      ? wn.push(...e)
      : Vt && e.id === -1
        ? Vt.splice(xn + 1, 0, e)
        : e.flags & 1 || (wn.push(e), (e.flags |= 1)),
      Ro());
  }
  function No(e, t, n = ht + 1) {
    for (t = t || new Map(); n < Ne.length; n++) {
      const s = Ne[n];
      if (s && s.flags & 2) {
        if ((e && s.id !== e.uid) || Ki(t, s)) continue;
        (Ne.splice(n, 1), n--, s.flags & 4 && (s.flags &= -2), s(), s.flags & 4 || (s.flags &= -2));
      }
    }
  }
  function jo(e) {
    if (wn.length) {
      const t = [...new Set(wn)].sort((n, s) => Jn(n) - Jn(s));
      if (((wn.length = 0), Vt)) {
        Vt.push(...t);
        return;
      }
      for (Vt = t, e = e || new Map(), xn = 0; xn < Vt.length; xn++) {
        const n = Vt[xn];
        Ki(e, n) || (n.flags & 4 && (n.flags &= -2), n.flags & 8 || n(), (n.flags &= -2));
      }
      ((Vt = null), (xn = 0));
    }
  }
  const Jn = (e) => (e.id == null ? (e.flags & 2 ? -1 : 1 / 0) : e.id);
  function Lo(e) {
    e = e || new Map();
    const t = (n) => Ki(e, n);
    try {
      for (ht = 0; ht < Ne.length; ht++) {
        const n = Ne[ht];
        if (n && !(n.flags & 8)) {
          if (Rt.NODE_ENV !== 'production' && t(n)) continue;
          (n.flags & 4 && (n.flags &= -2),
            bn(n, n.i, n.i ? 15 : 14),
            n.flags & 4 || (n.flags &= -2));
        }
      }
    } finally {
      for (; ht < Ne.length; ht++) {
        const n = Ne[ht];
        n && (n.flags &= -2);
      }
      ((ht = -1), (Ne.length = 0), jo(e), (Ns = null), (Ne.length || wn.length) && Lo(e));
    }
  }
  function Ki(e, t) {
    const n = e.get(t) || 0;
    if (n > Df) {
      const s = t.i,
        i = s && hr(s.type);
      return (
        Zn(
          `Maximum recursive updates exceeded${i ? ` in component <${i}>` : ''}. This means you have a reactive effect that is mutating its own dependencies and thus recursively triggering itself. Possible sources include component template, render function, updated hook or watcher source function.`,
          null,
          10
        ),
        !0
      );
    }
    return (e.set(t, n + 1), !1);
  }
  let mt = !1;
  const Ls = new Map();
  Un().__VUE_HMR_RUNTIME__ = { createRecord: Wi(Uo), rerender: Wi(Rf), reload: Wi(Vf) };
  const nn = new Map();
  function Pf(e) {
    const t = e.type.__hmrId;
    let n = nn.get(t);
    (n || (Uo(t, e.type), (n = nn.get(t))), n.instances.add(e));
  }
  function Mf(e) {
    nn.get(e.type.__hmrId).instances.delete(e);
  }
  function Uo(e, t) {
    return nn.has(e) ? !1 : (nn.set(e, { initialDef: Us(t), instances: new Set() }), !0);
  }
  function Us(e) {
    return Zl(e) ? e.__vccOpts : e;
  }
  function Rf(e, t) {
    const n = nn.get(e);
    n &&
      ((n.initialDef.render = t),
      [...n.instances].forEach((s) => {
        (t && ((s.render = t), (Us(s.type).render = t)),
          (s.renderCache = []),
          (mt = !0),
          s.update(),
          (mt = !1));
      }));
  }
  function Vf(e, t) {
    const n = nn.get(e);
    if (!n) return;
    ((t = Us(t)), Qo(n.initialDef, t));
    const s = [...n.instances];
    for (let i = 0; i < s.length; i++) {
      const r = s[i],
        o = Us(r.type);
      let l = Ls.get(o);
      (l || (o !== n.initialDef && Qo(o, t), Ls.set(o, (l = new Set()))),
        l.add(r),
        r.appContext.propsCache.delete(r.type),
        r.appContext.emitsCache.delete(r.type),
        r.appContext.optionsCache.delete(r.type),
        r.ceReload
          ? (l.add(r), r.ceReload(t.styles), l.delete(r))
          : r.parent
            ? js(() => {
                ((mt = !0), r.parent.update(), (mt = !1), l.delete(r));
              })
            : r.appContext.reload
              ? r.appContext.reload()
              : typeof window < 'u'
                ? window.location.reload()
                : console.warn(
                    '[HMR] Root or manually mounted instance modified. Full reload required.'
                  ),
        r.root.ce && r !== r.root && r.root.ce._removeChildStyle(o));
    }
    Vo(() => {
      Ls.clear();
    });
  }
  function Qo(e, t) {
    ye(e, t);
    for (const n in e) n !== '__file' && !(n in t) && delete e[n];
  }
  function Wi(e) {
    return (t, n) => {
      try {
        return e(t, n);
      } catch (s) {
        (console.error(s),
          console.warn(
            '[HMR] Something went wrong during Vue component hot-reload. Full reload required.'
          ));
      }
    };
  }
  let gt,
    Xn = [],
    Gi = !1;
  function es(e, ...t) {
    gt ? gt.emit(e, ...t) : Gi || Xn.push({ event: e, args: t });
  }
  function Ho(e, t) {
    var n, s;
    ((gt = e),
      gt
        ? ((gt.enabled = !0), Xn.forEach(({ event: i, args: r }) => gt.emit(i, ...r)), (Xn = []))
        : typeof window < 'u' &&
            window.HTMLElement &&
            !(
              (s = (n = window.navigator) == null ? void 0 : n.userAgent) != null &&
              s.includes('jsdom')
            )
          ? ((t.__VUE_DEVTOOLS_HOOK_REPLAY__ = t.__VUE_DEVTOOLS_HOOK_REPLAY__ || []).push((r) => {
              Ho(r, t);
            }),
            setTimeout(() => {
              gt || ((t.__VUE_DEVTOOLS_HOOK_REPLAY__ = null), (Gi = !0), (Xn = []));
            }, 3e3))
          : ((Gi = !0), (Xn = [])));
  }
  function Nf(e, t) {
    es('app:init', e, t, { Fragment: be, Text: An, Comment: Se, Static: os });
  }
  function jf(e) {
    es('app:unmount', e);
  }
  const Lf = Yi('component:added'),
    Ko = Yi('component:updated'),
    Uf = Yi('component:removed'),
    Qf = (e) => {
      gt && typeof gt.cleanupBuffer == 'function' && !gt.cleanupBuffer(e) && Uf(e);
    };
  /*! #__NO_SIDE_EFFECTS__ */ function Yi(e) {
    return (t) => {
      es(e, t.appContext.app, t.uid, t.parent ? t.parent.uid : void 0, t);
    };
  }
  const Hf = Wo('perf:start'),
    Kf = Wo('perf:end');
  function Wo(e) {
    return (t, n, s) => {
      es(e, t.appContext.app, t.uid, t, n, s);
    };
  }
  function Wf(e, t, n) {
    es('component:emit', e.appContext.app, e, t, n);
  }
  let Ee = null,
    Go = null;
  function Qs(e) {
    const t = Ee;
    return ((Ee = e), (Go = (e && e.type.__scopeId) || null), t);
  }
  function lt(e, t = Ee, n) {
    if (!t || e._n) return e;
    const s = (...i) => {
      s._d && jl(-1);
      const r = Qs(t);
      let o;
      try {
        o = e(...i);
      } finally {
        (Qs(r), s._d && jl(1));
      }
      return (Ko(t), o);
    };
    return ((s._n = !0), (s._c = !0), (s._d = !0), s);
  }
  function Yo(e) {
    zc(e) && I('Do not use built-in directive ids as custom directive id: ' + e);
  }
  function En(e, t) {
    if (Ee === null) return (I('withDirectives can only be used inside render functions.'), e);
    const n = si(Ee),
      s = e.dirs || (e.dirs = []);
    for (let i = 0; i < t.length; i++) {
      let [r, o, l, a = ie] = t[i];
      r &&
        (G(r) && (r = { mounted: r, updated: r }),
        r.deep && Bt(o),
        s.push({ dir: r, instance: n, value: o, oldValue: void 0, arg: l, modifiers: a }));
    }
    return e;
  }
  function sn(e, t, n, s) {
    const i = e.dirs,
      r = t && t.dirs;
    for (let o = 0; o < i.length; o++) {
      const l = i[o];
      r && (l.oldValue = r[o].value);
      let a = l.dir[s];
      a && (Tt(), ot(a, n, 8, [e.el, l, e, t]), Ot());
    }
  }
  const Gf = Symbol('_vte'),
    Zo = (e) => e.__isTeleport,
    Nt = Symbol('_leaveCb'),
    Hs = Symbol('_enterCb');
  function Jo() {
    const e = { isMounted: !1, isLeaving: !1, isUnmounting: !1, leavingVNodes: new Map() };
    return (
      jt(() => {
        e.isMounted = !0;
      }),
      ll(() => {
        e.isUnmounting = !0;
      }),
      e
    );
  }
  const nt = [Function, Array],
    Xo = {
      mode: String,
      appear: Boolean,
      persisted: Boolean,
      onBeforeEnter: nt,
      onEnter: nt,
      onAfterEnter: nt,
      onEnterCancelled: nt,
      onBeforeLeave: nt,
      onLeave: nt,
      onAfterLeave: nt,
      onLeaveCancelled: nt,
      onBeforeAppear: nt,
      onAppear: nt,
      onAfterAppear: nt,
      onAppearCancelled: nt
    },
    el = (e) => {
      const t = e.subTree;
      return t.component ? el(t.component) : t;
    },
    Yf = {
      name: 'BaseTransition',
      props: Xo,
      setup(e, { slots: t }) {
        const n = ti(),
          s = Jo();
        return () => {
          const i = t.default && Ji(t.default(), !0);
          if (!i || !i.length) return;
          const r = tl(i),
            o = J(e),
            { mode: l } = o;
          if (
            (l &&
              l !== 'in-out' &&
              l !== 'out-in' &&
              l !== 'default' &&
              I(`invalid <transition> mode: ${l}`),
            s.isLeaving)
          )
            return Zi(r);
          const a = sl(r);
          if (!a) return Zi(r);
          let f = ts(a, o, s, n, (u) => (f = u));
          a.type !== Se && rn(a, f);
          let c = n.subTree && sl(n.subTree);
          if (c && c.type !== Se && !cn(a, c) && el(n).type !== Se) {
            let u = ts(c, o, s, n);
            if ((rn(c, u), l === 'out-in' && a.type !== Se))
              return (
                (s.isLeaving = !0),
                (u.afterLeave = () => {
                  ((s.isLeaving = !1),
                    n.job.flags & 8 || n.update(),
                    delete u.afterLeave,
                    (c = void 0));
                }),
                Zi(r)
              );
            l === 'in-out' && a.type !== Se
              ? (u.delayLeave = (d, p, h) => {
                  const q = nl(s, c);
                  ((q[String(c.key)] = c),
                    (d[Nt] = () => {
                      (p(), (d[Nt] = void 0), delete f.delayedLeave, (c = void 0));
                    }),
                    (f.delayedLeave = () => {
                      (h(), delete f.delayedLeave, (c = void 0));
                    }));
                })
              : (c = void 0);
          } else c && (c = void 0);
          return r;
        };
      }
    };
  function tl(e) {
    let t = e[0];
    if (e.length > 1) {
      let n = !1;
      for (const s of e)
        if (s.type !== Se) {
          if (n) {
            I(
              '<transition> can only be used on a single element or component. Use <transition-group> for lists.'
            );
            break;
          }
          ((t = s), (n = !0));
        }
    }
    return t;
  }
  const Zf = Yf;
  function nl(e, t) {
    const { leavingVNodes: n } = e;
    let s = n.get(t.type);
    return (s || ((s = Object.create(null)), n.set(t.type, s)), s);
  }
  function ts(e, t, n, s, i) {
    const {
        appear: r,
        mode: o,
        persisted: l = !1,
        onBeforeEnter: a,
        onEnter: f,
        onAfterEnter: c,
        onEnterCancelled: u,
        onBeforeLeave: d,
        onLeave: p,
        onAfterLeave: h,
        onLeaveCancelled: q,
        onBeforeAppear: v,
        onAppear: y,
        onAfterAppear: z,
        onAppearCancelled: O
      } = t,
      X = String(e.key),
      N = nl(n, e),
      ne = (U, w) => {
        U && ot(U, s, 9, w);
      },
      H = (U, w) => {
        const x = w[1];
        (ne(U, w), K(U) ? U.every((E) => E.length <= 1) && x() : U.length <= 1 && x());
      },
      fe = {
        mode: o,
        persisted: l,
        beforeEnter(U) {
          let w = a;
          if (!n.isMounted)
            if (r) w = v || a;
            else return;
          U[Nt] && U[Nt](!0);
          const x = N[X];
          (x && cn(e, x) && x.el[Nt] && x.el[Nt](), ne(w, [U]));
        },
        enter(U) {
          let w = f,
            x = c,
            E = u;
          if (!n.isMounted)
            if (r) ((w = y || f), (x = z || c), (E = O || u));
            else return;
          let Y = !1;
          const de = (U[Hs] = (xe) => {
            Y ||
              ((Y = !0),
              xe ? ne(E, [U]) : ne(x, [U]),
              fe.delayedLeave && fe.delayedLeave(),
              (U[Hs] = void 0));
          });
          w ? H(w, [U, de]) : de();
        },
        leave(U, w) {
          const x = String(e.key);
          if ((U[Hs] && U[Hs](!0), n.isUnmounting)) return w();
          ne(d, [U]);
          let E = !1;
          const Y = (U[Nt] = (de) => {
            E ||
              ((E = !0),
              w(),
              de ? ne(q, [U]) : ne(h, [U]),
              (U[Nt] = void 0),
              N[x] === e && delete N[x]);
          });
          ((N[x] = e), p ? H(p, [U, Y]) : Y());
        },
        clone(U) {
          const w = ts(U, t, n, s, i);
          return (i && i(w), w);
        }
      };
    return fe;
  }
  function Zi(e) {
    if (ns(e)) return ((e = _t(e)), (e.children = null), e);
  }
  function sl(e) {
    if (!ns(e)) return Zo(e.type) && e.children ? tl(e.children) : e;
    if (e.component) return e.component.subTree;
    const { shapeFlag: t, children: n } = e;
    if (n) {
      if (t & 16) return n[0];
      if (t & 32 && G(n.default)) return n.default();
    }
  }
  function rn(e, t) {
    e.shapeFlag & 6 && e.component
      ? ((e.transition = t), rn(e.component.subTree, t))
      : e.shapeFlag & 128
        ? ((e.ssContent.transition = t.clone(e.ssContent)),
          (e.ssFallback.transition = t.clone(e.ssFallback)))
        : (e.transition = t);
  }
  function Ji(e, t = !1, n) {
    let s = [],
      i = 0;
    for (let r = 0; r < e.length; r++) {
      let o = e[r];
      const l = n == null ? o.key : String(n) + String(o.key != null ? o.key : r);
      o.type === be
        ? (o.patchFlag & 128 && i++, (s = s.concat(Ji(o.children, t, l))))
        : (t || o.type !== Se) && s.push(l != null ? _t(o, { key: l }) : o);
    }
    if (i > 1) for (let r = 0; r < s.length; r++) s[r].patchFlag = -2;
    return s;
  }
  /*! #__NO_SIDE_EFFECTS__ */ function se(e, t) {
    return G(e) ? ye({ name: e.name }, t, { setup: e }) : e;
  }
  function il(e) {
    e.ids = [e.ids[0] + e.ids[2]++ + '-', 0, 0];
  }
  const Jf = new WeakSet();
  function Ks(e, t, n, s, i = !1) {
    if (K(e)) {
      e.forEach((h, q) => Ks(h, t && (K(t) ? t[q] : t), n, s, i));
      return;
    }
    if (Sn(s) && !i) {
      s.shapeFlag & 512 &&
        s.type.__asyncResolved &&
        s.component.subTree.component &&
        Ks(e, t, n, s.component.subTree);
      return;
    }
    const r = s.shapeFlag & 4 ? si(s.component) : s.el,
      o = i ? null : r,
      { i: l, r: a } = e;
    if (!l) {
      I(
        'Missing ref owner context. ref cannot be used on hoisted vnodes. A vnode with ref must be created inside the render function.'
      );
      return;
    }
    const f = t && t.r,
      c = l.refs === ie ? (l.refs = {}) : l.refs,
      u = l.setupState,
      d = J(u),
      p =
        u === ie
          ? () => !1
          : (h) => (
              le(d, h) &&
                !ge(d[h]) &&
                I(
                  `Template ref "${h}" used on a non-ref value. It will not work in the production build.`
                ),
              Jf.has(d[h]) ? !1 : le(d, h)
            );
    if (
      (f != null &&
        f !== a &&
        (ve(f) ? ((c[f] = null), p(f) && (u[f] = null)) : ge(f) && (f.value = null)),
      G(a))
    )
      bn(a, l, 12, [o, c]);
    else {
      const h = ve(a),
        q = ge(a);
      if (h || q) {
        const v = () => {
          if (e.f) {
            const y = h ? (p(a) ? u[a] : c[a]) : a.value;
            i
              ? K(y) && ki(y, r)
              : K(y)
                ? y.includes(r) || y.push(r)
                : h
                  ? ((c[a] = [r]), p(a) && (u[a] = c[a]))
                  : ((a.value = [r]), e.k && (c[e.k] = a.value));
          } else
            h
              ? ((c[a] = o), p(a) && (u[a] = o))
              : q
                ? ((a.value = o), e.k && (c[e.k] = o))
                : I('Invalid template ref type:', a, `(${typeof a})`);
        };
        o ? ((v.id = -1), Ze(v, n)) : v();
      } else I('Invalid template ref type:', a, `(${typeof a})`);
    }
  }
  (Un().requestIdleCallback, Un().cancelIdleCallback);
  const Sn = (e) => !!e.type.__asyncLoader,
    ns = (e) => e.type.__isKeepAlive;
  function Xf(e, t) {
    rl(e, 'a', t);
  }
  function ed(e, t) {
    rl(e, 'da', t);
  }
  function rl(e, t, n = Ae) {
    const s =
      e.__wdc ||
      (e.__wdc = () => {
        let i = n;
        for (; i; ) {
          if (i.isDeactivated) return;
          i = i.parent;
        }
        return e();
      });
    if ((Ws(t, s, n), n)) {
      let i = n.parent;
      for (; i && i.parent; ) (ns(i.parent.vnode) && td(s, t, n, i), (i = i.parent));
    }
  }
  function td(e, t, n, s) {
    const i = Ws(t, e, s, !0);
    Gs(() => {
      ki(s[t], i);
    }, n);
  }
  function Ws(e, t, n = Ae, s = !1) {
    if (n) {
      const i = n[e] || (n[e] = []),
        r =
          t.__weh ||
          (t.__weh = (...o) => {
            Tt();
            const l = us(n),
              a = ot(t, n, e, o);
            return (l(), Ot(), a);
          });
      return (s ? i.unshift(r) : i.push(r), r);
    } else {
      const i = Jt(Qi[e].replace(/ hook$/, ''));
      I(
        `${i} is called when there is no active component instance to be associated with. Lifecycle injection APIs can only be used during execution of setup(). If you are using async setup(), make sure to register lifecycle hooks before the first await statement.`
      );
    }
  }
  const Ft =
      (e) =>
      (t, n = Ae) => {
        (!cs || e === 'sp') && Ws(e, (...s) => t(...s), n);
      },
    nd = Ft('bm'),
    jt = Ft('m'),
    sd = Ft('bu'),
    ol = Ft('u'),
    ll = Ft('bum'),
    Gs = Ft('um'),
    id = Ft('sp'),
    rd = Ft('rtg'),
    od = Ft('rtc');
  function ld(e, t = Ae) {
    Ws('ec', e, t);
  }
  const ad = 'components',
    al = Symbol.for('v-ndc');
  function ud(e) {
    return ve(e) ? cd(ad, e, !1) || e : e || al;
  }
  function cd(e, t, n = !0, s = !1) {
    const i = Ee || Ae;
    if (i) {
      const r = i.type;
      {
        const l = hr(r, !1);
        if (l && (l === t || l === Me(t) || l === Zt(Me(t)))) return r;
      }
      const o = ul(i[e] || r[e], t) || ul(i.appContext[e], t);
      return !o && s
        ? r
        : (n &&
            !o &&
            I(`Failed to resolve ${e.slice(0, -1)}: ${t}
If this is a native custom element, make sure to exclude it from component resolution via compilerOptions.isCustomElement.`),
          o);
    } else I(`resolve${Zt(e.slice(0, -1))} can only be used in render() or setup().`);
  }
  function ul(e, t) {
    return e && (e[t] || e[Me(t)] || e[Zt(Me(t))]);
  }
  function Lt(e, t, n, s) {
    let i;
    const r = n,
      o = K(e);
    if (o || ve(e)) {
      const l = o && pt(e);
      let a = !1;
      (l && ((a = !Ve(e)), (e = Is(e))), (i = new Array(e.length)));
      for (let f = 0, c = e.length; f < c; f++) i[f] = t(a ? De(e[f]) : e[f], f, void 0, r);
    } else if (typeof e == 'number') {
      (Number.isInteger(e) || I(`The v-for range expect an integer value but got ${e}.`),
        (i = new Array(e)));
      for (let l = 0; l < e; l++) i[l] = t(l + 1, l, void 0, r);
    } else if (ue(e))
      if (e[Symbol.iterator]) i = Array.from(e, (l, a) => t(l, a, void 0, r));
      else {
        const l = Object.keys(e);
        i = new Array(l.length);
        for (let a = 0, f = l.length; a < f; a++) {
          const c = l[a];
          i[a] = t(e[c], c, a, r);
        }
      }
    else i = [];
    return i;
  }
  function cl(e, t, n = {}, s, i) {
    if (Ee.ce || (Ee.parent && Sn(Ee.parent) && Ee.parent.ce))
      return (F(), at(be, null, [D('slot', n, s && s())], 64));
    let r = e[t];
    (r &&
      r.length > 1 &&
      (I(
        'SSR-optimized slot function detected in a non-SSR-optimized render function. You need to mark this component with $dynamic-slots in the parent template.'
      ),
      (r = () => [])),
      r && r._c && (r._d = !1),
      F());
    const o = r && fl(r(n)),
      l = n.key || (o && o.key),
      a = at(
        be,
        { key: (l && !Ct(l) ? l : `_${t}`) + (!o && s ? '_fb' : '') },
        o || (s ? s() : []),
        o && e._ === 1 ? 64 : -2
      );
    return (a.scopeId && (a.slotScopeIds = [a.scopeId + '-s']), r && r._c && (r._d = !0), a);
  }
  function fl(e) {
    return e.some((t) => (un(t) ? !(t.type === Se || (t.type === be && !fl(t.children))) : !0))
      ? e
      : null;
  }
  const Xi = (e) => (e ? (Wl(e) ? si(e) : Xi(e.parent)) : null),
    on = ye(Object.create(null), {
      $: (e) => e,
      $el: (e) => e.vnode.el,
      $data: (e) => e.data,
      $props: (e) => dt(e.props),
      $attrs: (e) => dt(e.attrs),
      $slots: (e) => dt(e.slots),
      $refs: (e) => dt(e.refs),
      $parent: (e) => Xi(e.parent),
      $root: (e) => Xi(e.root),
      $host: (e) => e.ce,
      $emit: (e) => e.emit,
      $options: (e) => gl(e),
      $forceUpdate: (e) =>
        e.f ||
        (e.f = () => {
          js(e.update);
        }),
      $nextTick: (e) => e.n || (e.n = Hi.bind(e.proxy)),
      $watch: (e) => Ud.bind(e)
    }),
    er = (e) => e === '_' || e === '$',
    tr = (e, t) => e !== ie && !e.__isScriptSetup && le(e, t),
    dl = {
      get({ _: e }, t) {
        if (t === '__v_skip') return !0;
        const {
          ctx: n,
          setupState: s,
          data: i,
          props: r,
          accessCache: o,
          type: l,
          appContext: a
        } = e;
        if (t === '__isVue') return !0;
        let f;
        if (t[0] !== '$') {
          const p = o[t];
          if (p !== void 0)
            switch (p) {
              case 1:
                return s[t];
              case 2:
                return i[t];
              case 4:
                return n[t];
              case 3:
                return r[t];
            }
          else {
            if (tr(s, t)) return ((o[t] = 1), s[t]);
            if (i !== ie && le(i, t)) return ((o[t] = 2), i[t]);
            if ((f = e.propsOptions[0]) && le(f, t)) return ((o[t] = 3), r[t]);
            if (n !== ie && le(n, t)) return ((o[t] = 4), n[t]);
            nr && (o[t] = 0);
          }
        }
        const c = on[t];
        let u, d;
        if (c)
          return (
            t === '$attrs' ? (Oe(e.attrs, 'get', ''), Xs()) : t === '$slots' && Oe(e, 'get', t),
            c(e)
          );
        if ((u = l.__cssModules) && (u = u[t])) return u;
        if (n !== ie && le(n, t)) return ((o[t] = 4), n[t]);
        if (((d = a.config.globalProperties), le(d, t))) return d[t];
        Ee &&
          (!ve(t) || t.indexOf('__v') !== 0) &&
          (i !== ie && er(t[0]) && le(i, t)
            ? I(
                `Property ${JSON.stringify(t)} must be accessed via $data because it starts with a reserved character ("$" or "_") and is not proxied on the render context.`
              )
            : e === Ee &&
              I(
                `Property ${JSON.stringify(t)} was accessed during render but is not defined on instance.`
              ));
      },
      set({ _: e }, t, n) {
        const { data: s, setupState: i, ctx: r } = e;
        return tr(i, t)
          ? ((i[t] = n), !0)
          : i.__isScriptSetup && le(i, t)
            ? (I(`Cannot mutate <script setup> binding "${t}" from Options API.`), !1)
            : s !== ie && le(s, t)
              ? ((s[t] = n), !0)
              : le(e.props, t)
                ? (I(`Attempting to mutate prop "${t}". Props are readonly.`), !1)
                : t[0] === '$' && t.slice(1) in e
                  ? (I(
                      `Attempting to mutate public property "${t}". Properties starting with $ are reserved and readonly.`
                    ),
                    !1)
                  : (t in e.appContext.config.globalProperties
                      ? Object.defineProperty(r, t, { enumerable: !0, configurable: !0, value: n })
                      : (r[t] = n),
                    !0);
      },
      has(
        { _: { data: e, setupState: t, accessCache: n, ctx: s, appContext: i, propsOptions: r } },
        o
      ) {
        let l;
        return (
          !!n[o] ||
          (e !== ie && le(e, o)) ||
          tr(t, o) ||
          ((l = r[0]) && le(l, o)) ||
          le(s, o) ||
          le(on, o) ||
          le(i.config.globalProperties, o)
        );
      },
      defineProperty(e, t, n) {
        return (
          n.get != null
            ? (e._.accessCache[t] = 0)
            : le(n, 'value') && this.set(e, t, n.value, null),
          Reflect.defineProperty(e, t, n)
        );
      }
    };
  dl.ownKeys = (e) => (
    I(
      'Avoid app logic that relies on enumerating keys on a component instance. The keys will be empty in production mode to avoid performance overhead.'
    ),
    Reflect.ownKeys(e)
  );
  function fd(e) {
    const t = {};
    return (
      Object.defineProperty(t, '_', { configurable: !0, enumerable: !1, get: () => e }),
      Object.keys(on).forEach((n) => {
        Object.defineProperty(t, n, {
          configurable: !0,
          enumerable: !1,
          get: () => on[n](e),
          set: Fe
        });
      }),
      t
    );
  }
  function dd(e) {
    const {
      ctx: t,
      propsOptions: [n]
    } = e;
    n &&
      Object.keys(n).forEach((s) => {
        Object.defineProperty(t, s, {
          enumerable: !0,
          configurable: !0,
          get: () => e.props[s],
          set: Fe
        });
      });
  }
  function pd(e) {
    const { ctx: t, setupState: n } = e;
    Object.keys(J(n)).forEach((s) => {
      if (!n.__isScriptSetup) {
        if (er(s[0])) {
          I(
            `setup() return property ${JSON.stringify(s)} should not start with "$" or "_" which are reserved prefixes for Vue internals.`
          );
          return;
        }
        Object.defineProperty(t, s, { enumerable: !0, configurable: !0, get: () => n[s], set: Fe });
      }
    });
  }
  function pl(e) {
    return K(e) ? e.reduce((t, n) => ((t[n] = null), t), {}) : e;
  }
  function hd() {
    const e = Object.create(null);
    return (t, n) => {
      e[n] ? I(`${t} property "${n}" is already defined in ${e[n]}.`) : (e[n] = t);
    };
  }
  let nr = !0;
  function md(e) {
    const t = gl(e),
      n = e.proxy,
      s = e.ctx;
    ((nr = !1), t.beforeCreate && hl(t.beforeCreate, e, 'bc'));
    const {
        data: i,
        computed: r,
        methods: o,
        watch: l,
        provide: a,
        inject: f,
        created: c,
        beforeMount: u,
        mounted: d,
        beforeUpdate: p,
        updated: h,
        activated: q,
        deactivated: v,
        beforeDestroy: y,
        beforeUnmount: z,
        destroyed: O,
        unmounted: X,
        render: N,
        renderTracked: ne,
        renderTriggered: H,
        errorCaptured: fe,
        serverPrefetch: U,
        expose: w,
        inheritAttrs: x,
        components: E,
        directives: Y,
        filters: de
      } = t,
      xe = hd();
    {
      const [V] = e.propsOptions;
      if (V) for (const ee in V) xe('Props', ee);
    }
    if ((f && gd(f, s, xe), o))
      for (const V in o) {
        const ee = o[V];
        G(ee)
          ? (Object.defineProperty(s, V, {
              value: ee.bind(n),
              configurable: !0,
              enumerable: !0,
              writable: !0
            }),
            xe('Methods', V))
          : I(
              `Method "${V}" has type "${typeof ee}" in the component definition. Did you reference the function correctly?`
            );
      }
    if (i) {
      G(i) || I('The data option must be a function. Plain object usage is no longer supported.');
      const V = i.call(n, n);
      if (
        (Ci(V) &&
          I(
            'data() returned a Promise - note data() cannot be async; If you intend to perform data fetching before component renders, use async setup() + <Suspense>.'
          ),
        !ue(V))
      )
        I('data() should return an object.');
      else {
        e.data = Ds(V);
        for (const ee in V)
          (xe('Data', ee),
            er(ee[0]) ||
              Object.defineProperty(s, ee, {
                configurable: !0,
                enumerable: !0,
                get: () => V[ee],
                set: Fe
              }));
      }
    }
    if (((nr = !0), r))
      for (const V in r) {
        const ee = r[V],
          re = G(ee) ? ee.bind(n, n) : G(ee.get) ? ee.get.bind(n, n) : Fe;
        re === Fe && I(`Computed property "${V}" has no getter.`);
        const xt =
            !G(ee) && G(ee.set)
              ? ee.set.bind(n)
              : () => {
                  I(`Write operation failed: computed property "${V}" is readonly.`);
                },
          He = L({ get: re, set: xt });
        (Object.defineProperty(s, V, {
          enumerable: !0,
          configurable: !0,
          get: () => He.value,
          set: ($e) => (He.value = $e)
        }),
          xe('Computed', V));
      }
    if (l) for (const V in l) ml(l[V], s, n, V);
    if (a) {
      const V = G(a) ? a.call(n) : a;
      Reflect.ownKeys(V).forEach((ee) => {
        wd(ee, V[ee]);
      });
    }
    c && hl(c, e, 'c');
    function pe(V, ee) {
      K(ee) ? ee.forEach((re) => V(re.bind(n))) : ee && V(ee.bind(n));
    }
    if (
      (pe(nd, u),
      pe(jt, d),
      pe(sd, p),
      pe(ol, h),
      pe(Xf, q),
      pe(ed, v),
      pe(ld, fe),
      pe(od, ne),
      pe(rd, H),
      pe(ll, z),
      pe(Gs, X),
      pe(id, U),
      K(w))
    )
      if (w.length) {
        const V = e.exposed || (e.exposed = {});
        w.forEach((ee) => {
          Object.defineProperty(V, ee, { get: () => n[ee], set: (re) => (n[ee] = re) });
        });
      } else e.exposed || (e.exposed = {});
    (N && e.render === Fe && (e.render = N),
      x != null && (e.inheritAttrs = x),
      E && (e.components = E),
      Y && (e.directives = Y),
      U && il(e));
  }
  function gd(e, t, n = Fe) {
    K(e) && (e = sr(e));
    for (const s in e) {
      const i = e[s];
      let r;
      (ue(i)
        ? 'default' in i
          ? (r = is(i.from || s, i.default, !0))
          : (r = is(i.from || s))
        : (r = is(i)),
        ge(r)
          ? Object.defineProperty(t, s, {
              enumerable: !0,
              configurable: !0,
              get: () => r.value,
              set: (o) => (r.value = o)
            })
          : (t[s] = r),
        n('Inject', s));
    }
  }
  function hl(e, t, n) {
    ot(K(e) ? e.map((s) => s.bind(t.proxy)) : e.bind(t.proxy), t, n);
  }
  function ml(e, t, n, s) {
    let i = s.includes('.') ? Dl(n, s) : () => n[s];
    if (ve(e)) {
      const r = t[e];
      G(r) ? ze(i, r) : I(`Invalid watch handler specified by key "${e}"`, r);
    } else if (G(e)) ze(i, e.bind(n));
    else if (ue(e))
      if (K(e)) e.forEach((r) => ml(r, t, n, s));
      else {
        const r = G(e.handler) ? e.handler.bind(n) : t[e.handler];
        G(r) ? ze(i, r, e) : I(`Invalid watch handler specified by key "${e.handler}"`, r);
      }
    else I(`Invalid watch option: "${s}"`, e);
  }
  function gl(e) {
    const t = e.type,
      { mixins: n, extends: s } = t,
      {
        mixins: i,
        optionsCache: r,
        config: { optionMergeStrategies: o }
      } = e.appContext,
      l = r.get(t);
    let a;
    return (
      l
        ? (a = l)
        : !i.length && !n && !s
          ? (a = t)
          : ((a = {}), i.length && i.forEach((f) => Ys(a, f, o, !0)), Ys(a, t, o)),
      ue(t) && r.set(t, a),
      a
    );
  }
  function Ys(e, t, n, s = !1) {
    const { mixins: i, extends: r } = t;
    (r && Ys(e, r, n, !0), i && i.forEach((o) => Ys(e, o, n, !0)));
    for (const o in t)
      if (s && o === 'expose')
        I(
          '"expose" option is ignored when declared in mixins or extends. It should only be declared in the base component itself.'
        );
      else {
        const l = _d[o] || (n && n[o]);
        e[o] = l ? l(e[o], t[o]) : t[o];
      }
    return e;
  }
  const _d = {
    data: _l,
    props: ql,
    emits: ql,
    methods: ss,
    computed: ss,
    beforeCreate: je,
    created: je,
    beforeMount: je,
    mounted: je,
    beforeUpdate: je,
    updated: je,
    beforeDestroy: je,
    beforeUnmount: je,
    destroyed: je,
    unmounted: je,
    activated: je,
    deactivated: je,
    errorCaptured: je,
    serverPrefetch: je,
    components: ss,
    directives: ss,
    watch: vd,
    provide: _l,
    inject: qd
  };
  function _l(e, t) {
    return t
      ? e
        ? function () {
            return ye(G(e) ? e.call(this, this) : e, G(t) ? t.call(this, this) : t);
          }
        : t
      : e;
  }
  function qd(e, t) {
    return ss(sr(e), sr(t));
  }
  function sr(e) {
    if (K(e)) {
      const t = {};
      for (let n = 0; n < e.length; n++) t[e[n]] = e[n];
      return t;
    }
    return e;
  }
  function je(e, t) {
    return e ? [...new Set([].concat(e, t))] : t;
  }
  function ss(e, t) {
    return e ? ye(Object.create(null), e, t) : t;
  }
  function ql(e, t) {
    return e
      ? K(e) && K(t)
        ? [...new Set([...e, ...t])]
        : ye(Object.create(null), pl(e), pl(t ?? {}))
      : t;
  }
  function vd(e, t) {
    if (!e) return t;
    if (!t) return e;
    const n = ye(Object.create(null), e);
    for (const s in t) n[s] = je(e[s], t[s]);
    return n;
  }
  function vl() {
    return {
      app: null,
      config: {
        isNativeTag: Fc,
        performance: !1,
        globalProperties: {},
        optionMergeStrategies: {},
        errorHandler: void 0,
        warnHandler: void 0,
        compilerOptions: {}
      },
      mixins: [],
      components: {},
      directives: {},
      provides: Object.create(null),
      optionsCache: new WeakMap(),
      propsCache: new WeakMap(),
      emitsCache: new WeakMap()
    };
  }
  let yd = 0;
  function bd(e, t) {
    return function (s, i = null) {
      (G(s) || (s = ye({}, s)),
        i != null &&
          !ue(i) &&
          (I('root props passed to app.mount() must be an object.'), (i = null)));
      const r = vl(),
        o = new WeakSet(),
        l = [];
      let a = !1;
      const f = (r.app = {
        _uid: yd++,
        _component: s,
        _props: i,
        _container: null,
        _context: r,
        _instance: null,
        version: Jl,
        get config() {
          return r.config;
        },
        set config(c) {
          I('app.config cannot be replaced. Modify individual options instead.');
        },
        use(c, ...u) {
          return (
            o.has(c)
              ? I('Plugin has already been applied to target app.')
              : c && G(c.install)
                ? (o.add(c), c.install(f, ...u))
                : G(c)
                  ? (o.add(c), c(f, ...u))
                  : I(
                      'A plugin must either be a function or an object with an "install" function.'
                    ),
            f
          );
        },
        mixin(c) {
          return (
            r.mixins.includes(c)
              ? I('Mixin has already been applied to target app' + (c.name ? `: ${c.name}` : ''))
              : r.mixins.push(c),
            f
          );
        },
        component(c, u) {
          return (
            pr(c, r.config),
            u
              ? (r.components[c] &&
                  I(`Component "${c}" has already been registered in target app.`),
                (r.components[c] = u),
                f)
              : r.components[c]
          );
        },
        directive(c, u) {
          return (
            Yo(c),
            u
              ? (r.directives[c] &&
                  I(`Directive "${c}" has already been registered in target app.`),
                (r.directives[c] = u),
                f)
              : r.directives[c]
          );
        },
        mount(c, u, d) {
          if (a)
            I(
              'App has already been mounted.\nIf you want to remount the same app, move your app creation logic into a factory function and create fresh app instances for each mount - e.g. `const createMyApp = () => createApp(App)`'
            );
          else {
            c.__vue_app__ &&
              I(
                'There is already an app instance mounted on the host container.\n If you want to mount another app on the same host container, you need to unmount the previous app by calling `app.unmount()` first.'
              );
            const p = f._ceVNode || D(s, i);
            return (
              (p.appContext = r),
              d === !0 ? (d = 'svg') : d === !1 && (d = void 0),
              (r.reload = () => {
                e(_t(p), c, d);
              }),
              e(p, c, d),
              (a = !0),
              (f._container = c),
              (c.__vue_app__ = f),
              (f._instance = p.component),
              Nf(f, Jl),
              si(p.component)
            );
          }
        },
        onUnmount(c) {
          (typeof c != 'function' &&
            I(`Expected function as first argument to app.onUnmount(), but got ${typeof c}`),
            l.push(c));
        },
        unmount() {
          a
            ? (ot(l, f._instance, 16),
              e(null, f._container),
              (f._instance = null),
              jf(f),
              delete f._container.__vue_app__)
            : I('Cannot unmount an app that is not mounted.');
        },
        provide(c, u) {
          return (
            c in r.provides &&
              I(
                `App already provides property with key "${String(c)}". It will be overwritten with the new value.`
              ),
            (r.provides[c] = u),
            f
          );
        },
        runWithContext(c) {
          const u = ln;
          ln = f;
          try {
            return c();
          } finally {
            ln = u;
          }
        }
      });
      return f;
    };
  }
  let ln = null;
  function wd(e, t) {
    if (!Ae) I('provide() can only be used inside setup().');
    else {
      let n = Ae.provides;
      const s = Ae.parent && Ae.parent.provides;
      (s === n && (n = Ae.provides = Object.create(s)), (n[e] = t));
    }
  }
  function is(e, t, n = !1) {
    const s = Ae || Ee;
    if (s || ln) {
      const i = ln
        ? ln._context.provides
        : s
          ? s.parent == null
            ? s.vnode.appContext && s.vnode.appContext.provides
            : s.parent.provides
          : void 0;
      if (i && e in i) return i[e];
      if (arguments.length > 1) return n && G(t) ? t.call(s && s.proxy) : t;
      I(`injection "${String(e)}" not found.`);
    } else I('inject() can only be used inside setup() or functional components.');
  }
  function xd() {
    return !!(Ae || Ee || ln);
  }
  const yl = {},
    bl = () => Object.create(yl),
    wl = (e) => Object.getPrototypeOf(e) === yl;
  function Ed(e, t, n, s = !1) {
    const i = {},
      r = bl();
    ((e.propsDefaults = Object.create(null)), xl(e, t, i, r));
    for (const o in e.propsOptions[0]) o in i || (i[o] = void 0);
    (kl(t || {}, i, e),
      n ? (e.props = s ? i : vf(i)) : e.type.props ? (e.props = i) : (e.props = r),
      (e.attrs = r));
  }
  function Sd(e) {
    for (; e; ) {
      if (e.type.__hmrId) return !0;
      e = e.parent;
    }
  }
  function kd(e, t, n, s) {
    const {
        props: i,
        attrs: r,
        vnode: { patchFlag: o }
      } = e,
      l = J(i),
      [a] = e.propsOptions;
    let f = !1;
    if (!Sd(e) && (s || o > 0) && !(o & 16)) {
      if (o & 8) {
        const c = e.vnode.dynamicProps;
        for (let u = 0; u < c.length; u++) {
          let d = c[u];
          if (Js(e.emitsOptions, d)) continue;
          const p = t[d];
          if (a)
            if (le(r, d)) p !== r[d] && ((r[d] = p), (f = !0));
            else {
              const h = Me(d);
              i[h] = ir(a, l, h, p, e, !1);
            }
          else p !== r[d] && ((r[d] = p), (f = !0));
        }
      }
    } else {
      xl(e, t, i, r) && (f = !0);
      let c;
      for (const u in l)
        (!t || (!le(t, u) && ((c = At(u)) === u || !le(t, c)))) &&
          (a
            ? n && (n[u] !== void 0 || n[c] !== void 0) && (i[u] = ir(a, l, u, void 0, e, !0))
            : delete i[u]);
      if (r !== l) for (const u in r) (!t || !le(t, u)) && (delete r[u], (f = !0));
    }
    (f && ft(e.attrs, 'set', ''), kl(t || {}, i, e));
  }
  function xl(e, t, n, s) {
    const [i, r] = e.propsOptions;
    let o = !1,
      l;
    if (t)
      for (let a in t) {
        if (Ln(a)) continue;
        const f = t[a];
        let c;
        i && le(i, (c = Me(a)))
          ? !r || !r.includes(c)
            ? (n[c] = f)
            : ((l || (l = {}))[c] = f)
          : Js(e.emitsOptions, a) || ((!(a in s) || f !== s[a]) && ((s[a] = f), (o = !0)));
      }
    if (r) {
      const a = J(n),
        f = l || ie;
      for (let c = 0; c < r.length; c++) {
        const u = r[c];
        n[u] = ir(i, a, u, f[u], e, !le(f, u));
      }
    }
    return o;
  }
  function ir(e, t, n, s, i, r) {
    const o = e[n];
    if (o != null) {
      const l = le(o, 'default');
      if (l && s === void 0) {
        const a = o.default;
        if (o.type !== Function && !o.skipFactory && G(a)) {
          const { propsDefaults: f } = i;
          if (n in f) s = f[n];
          else {
            const c = us(i);
            ((s = f[n] = a.call(null, t)), c());
          }
        } else s = a;
        i.ce && i.ce._setProp(n, s);
      }
      o[0] && (r && !l ? (s = !1) : o[1] && (s === '' || s === At(n)) && (s = !0));
    }
    return s;
  }
  const Cd = new WeakMap();
  function El(e, t, n = !1) {
    const s = n ? Cd : t.propsCache,
      i = s.get(e);
    if (i) return i;
    const r = e.props,
      o = {},
      l = [];
    let a = !1;
    if (!G(e)) {
      const c = (u) => {
        a = !0;
        const [d, p] = El(u, t, !0);
        (ye(o, d), p && l.push(...p));
      };
      (!n && t.mixins.length && t.mixins.forEach(c),
        e.extends && c(e.extends),
        e.mixins && e.mixins.forEach(c));
    }
    if (!r && !a) return (ue(e) && s.set(e, qn), qn);
    if (K(r))
      for (let c = 0; c < r.length; c++) {
        ve(r[c]) || I('props must be strings when using array syntax.', r[c]);
        const u = Me(r[c]);
        Sl(u) && (o[u] = ie);
      }
    else if (r) {
      ue(r) || I('invalid props options', r);
      for (const c in r) {
        const u = Me(c);
        if (Sl(u)) {
          const d = r[c],
            p = (o[u] = K(d) || G(d) ? { type: d } : ye({}, d)),
            h = p.type;
          let q = !1,
            v = !0;
          if (K(h))
            for (let y = 0; y < h.length; ++y) {
              const z = h[y],
                O = G(z) && z.name;
              if (O === 'Boolean') {
                q = !0;
                break;
              } else O === 'String' && (v = !1);
            }
          else q = G(h) && h.name === 'Boolean';
          ((p[0] = q), (p[1] = v), (q || le(p, 'default')) && l.push(u));
        }
      }
    }
    const f = [o, l];
    return (ue(e) && s.set(e, f), f);
  }
  function Sl(e) {
    return e[0] !== '$' && !Ln(e)
      ? !0
      : (I(`Invalid prop name: "${e}" is a reserved property.`), !1);
  }
  function Ad(e) {
    return e === null
      ? 'null'
      : typeof e == 'function'
        ? e.name || ''
        : (typeof e == 'object' && e.constructor && e.constructor.name) || '';
  }
  function kl(e, t, n) {
    const s = J(t),
      i = n.propsOptions[0],
      r = Object.keys(e).map((o) => Me(o));
    for (const o in i) {
      let l = i[o];
      l != null && Td(o, s[o], l, dt(s), !r.includes(o));
    }
  }
  function Td(e, t, n, s, i) {
    const { type: r, required: o, validator: l, skipCheck: a } = n;
    if (o && i) {
      I('Missing required prop: "' + e + '"');
      return;
    }
    if (!(t == null && !o)) {
      if (r != null && r !== !0 && !a) {
        let f = !1;
        const c = K(r) ? r : [r],
          u = [];
        for (let d = 0; d < c.length && !f; d++) {
          const { valid: p, expectedType: h } = Id(t, c[d]);
          (u.push(h || ''), (f = p));
        }
        if (!f) {
          I($d(e, t, u));
          return;
        }
      }
      l && !l(t, s) && I('Invalid prop: custom validator check failed for prop "' + e + '".');
    }
  }
  const Od = Ge('String,Number,Boolean,Function,Symbol,BigInt');
  function Id(e, t) {
    let n;
    const s = Ad(t);
    if (s === 'null') n = e === null;
    else if (Od(s)) {
      const i = typeof e;
      ((n = i === s.toLowerCase()), !n && i === 'object' && (n = e instanceof t));
    } else s === 'Object' ? (n = ue(e)) : s === 'Array' ? (n = K(e)) : (n = e instanceof t);
    return { valid: n, expectedType: s };
  }
  function $d(e, t, n) {
    if (n.length === 0)
      return `Prop type [] for prop "${e}" won't match anything. Did you mean to use type Array instead?`;
    let s = `Invalid prop: type check failed for prop "${e}". Expected ${n.map(Zt).join(' | ')}`;
    const i = n[0],
      r = Ai(t),
      o = Cl(t, i),
      l = Cl(t, r);
    return (
      n.length === 1 && Al(i) && !Bd(i, r) && (s += ` with value ${o}`),
      (s += `, got ${r} `),
      Al(r) && (s += `with value ${l}.`),
      s
    );
  }
  function Cl(e, t) {
    return t === 'String' ? `"${e}"` : t === 'Number' ? `${Number(e)}` : `${e}`;
  }
  function Al(e) {
    return ['string', 'number', 'boolean'].some((n) => e.toLowerCase() === n);
  }
  function Bd(...e) {
    return e.some((t) => t.toLowerCase() === 'boolean');
  }
  const Tl = (e) => e[0] === '_' || e === '$stable',
    rr = (e) => (K(e) ? e.map(ut) : [ut(e)]),
    Fd = (e, t, n) => {
      if (t._n) return t;
      const s = lt(
        (...i) => (
          Rt.NODE_ENV !== 'production' &&
            Ae &&
            (!n || n.root === Ae.root) &&
            I(
              `Slot "${e}" invoked outside of the render function: this will not track dependencies used in the slot. Invoke the slot function inside the render function instead.`
            ),
          rr(t(...i))
        ),
        n
      );
      return ((s._c = !1), s);
    },
    Ol = (e, t, n) => {
      const s = e._ctx;
      for (const i in e) {
        if (Tl(i)) continue;
        const r = e[i];
        if (G(r)) t[i] = Fd(i, r, s);
        else if (r != null) {
          I(
            `Non-function value encountered for slot "${i}". Prefer function slots for better performance.`
          );
          const o = rr(r);
          t[i] = () => o;
        }
      }
    },
    Il = (e, t) => {
      ns(e.vnode) ||
        I(
          'Non-function value encountered for default slot. Prefer function slots for better performance.'
        );
      const n = rr(t);
      e.slots.default = () => n;
    },
    or = (e, t, n) => {
      for (const s in t) (n || s !== '_') && (e[s] = t[s]);
    },
    Dd = (e, t, n) => {
      const s = (e.slots = bl());
      if (e.vnode.shapeFlag & 32) {
        const i = t._;
        i ? (or(s, t, n), n && Ts(s, '_', i, !0)) : Ol(t, s);
      } else t && Il(e, t);
    },
    zd = (e, t, n) => {
      const { vnode: s, slots: i } = e;
      let r = !0,
        o = ie;
      if (s.shapeFlag & 32) {
        const l = t._;
        (l
          ? mt
            ? (or(i, t, n), ft(e, 'set', '$slots'))
            : n && l === 1
              ? (r = !1)
              : or(i, t, n)
          : ((r = !t.$stable), Ol(t, i)),
          (o = t));
      } else t && (Il(e, t), (o = { default: 1 }));
      if (r) for (const l in i) !Tl(l) && o[l] == null && delete i[l];
    };
  let rs, Ut;
  function kn(e, t) {
    (e.appContext.config.performance && Zs() && Ut.mark(`vue-${t}-${e.uid}`),
      Hf(e, t, Zs() ? Ut.now() : Date.now()));
  }
  function Cn(e, t) {
    if (e.appContext.config.performance && Zs()) {
      const n = `vue-${t}-${e.uid}`,
        s = n + ':end';
      (Ut.mark(s), Ut.measure(`<${ii(e, e.type)}> ${t}`, n, s), Ut.clearMarks(n), Ut.clearMarks(s));
    }
    Kf(e, t, Zs() ? Ut.now() : Date.now());
  }
  function Zs() {
    return (
      rs !== void 0 ||
        (typeof window < 'u' && window.performance
          ? ((rs = !0), (Ut = window.performance))
          : (rs = !1)),
      rs
    );
  }
  function Pd() {
    const e = [];
    if (e.length) {
      const t = e.length > 1;
      console.warn(`Feature flag${t ? 's' : ''} ${e.join(', ')} ${t ? 'are' : 'is'} not explicitly defined. You are running the esm-bundler build of Vue, which expects these compile-time feature flags to be globally injected via the bundler config in order to get better tree-shaking in the production bundle.

For more details, see https://link.vuejs.org/feature-flags.`);
    }
  }
  const Ze = Zd;
  function Md(e) {
    return Rd(e);
  }
  function Rd(e, t) {
    Pd();
    const n = Un();
    ((n.__VUE__ = !0), Ho(n.__VUE_DEVTOOLS_GLOBAL_HOOK__, n));
    const {
        insert: s,
        remove: i,
        patchProp: r,
        createElement: o,
        createText: l,
        createComment: a,
        setText: f,
        setElementText: c,
        parentNode: u,
        nextSibling: d,
        setScopeId: p = Fe,
        insertStaticContent: h
      } = e,
      q = (
        m,
        g,
        b,
        A = null,
        k = null,
        C = null,
        P = void 0,
        B = null,
        $ = mt ? !1 : !!g.dynamicChildren
      ) => {
        if (m === g) return;
        (m && !cn(m, g) && ((A = Si(m)), Ke(m, k, C, !0), (m = null)),
          g.patchFlag === -2 && (($ = !1), (g.dynamicChildren = null)));
        const { type: T, ref: Z, shapeFlag: M } = g;
        switch (T) {
          case An:
            v(m, g, b, A);
            break;
          case Se:
            y(m, g, b, A);
            break;
          case os:
            m == null ? z(g, b, A, P) : O(m, g, b, P);
            break;
          case be:
            Y(m, g, b, A, k, C, P, B, $);
            break;
          default:
            M & 1
              ? ne(m, g, b, A, k, C, P, B, $)
              : M & 6
                ? de(m, g, b, A, k, C, P, B, $)
                : M & 64 || M & 128
                  ? T.process(m, g, b, A, k, C, P, B, $, Es)
                  : I('Invalid VNode type:', T, `(${typeof T})`);
        }
        Z != null && k && Ks(Z, m && m.ref, C, g || m, !g);
      },
      v = (m, g, b, A) => {
        if (m == null) s((g.el = l(g.children)), b, A);
        else {
          const k = (g.el = m.el);
          g.children !== m.children && f(k, g.children);
        }
      },
      y = (m, g, b, A) => {
        m == null ? s((g.el = a(g.children || '')), b, A) : (g.el = m.el);
      },
      z = (m, g, b, A) => {
        [m.el, m.anchor] = h(m.children, g, b, A, m.el, m.anchor);
      },
      O = (m, g, b, A) => {
        if (g.children !== m.children) {
          const k = d(m.anchor);
          (N(m), ([g.el, g.anchor] = h(g.children, b, k, A)));
        } else ((g.el = m.el), (g.anchor = m.anchor));
      },
      X = ({ el: m, anchor: g }, b, A) => {
        let k;
        for (; m && m !== g; ) ((k = d(m)), s(m, b, A), (m = k));
        s(g, b, A);
      },
      N = ({ el: m, anchor: g }) => {
        let b;
        for (; m && m !== g; ) ((b = d(m)), i(m), (m = b));
        i(g);
      },
      ne = (m, g, b, A, k, C, P, B, $) => {
        (g.type === 'svg' ? (P = 'svg') : g.type === 'math' && (P = 'mathml'),
          m == null ? H(g, b, A, k, C, P, B, $) : w(m, g, k, C, P, B, $));
      },
      H = (m, g, b, A, k, C, P, B) => {
        let $, T;
        const { props: Z, shapeFlag: M, transition: W, dirs: te } = m;
        if (
          (($ = m.el = o(m.type, C, Z && Z.is, Z)),
          M & 8 ? c($, m.children) : M & 16 && U(m.children, $, null, A, k, lr(m, C), P, B),
          te && sn(m, null, A, 'created'),
          fe($, m, m.scopeId, P, A),
          Z)
        ) {
          for (const _e in Z) _e !== 'value' && !Ln(_e) && r($, _e, null, Z[_e], C, A);
          ('value' in Z && r($, 'value', null, Z.value, C),
            (T = Z.onVnodeBeforeMount) && qt(T, A, m));
        }
        (Ts($, '__vnode', m, !0),
          Ts($, '__vueParentComponent', A, !0),
          te && sn(m, null, A, 'beforeMount'));
        const oe = Vd(k, W);
        (oe && W.beforeEnter($),
          s($, g, b),
          ((T = Z && Z.onVnodeMounted) || oe || te) &&
            Ze(() => {
              (T && qt(T, A, m), oe && W.enter($), te && sn(m, null, A, 'mounted'));
            }, k));
      },
      fe = (m, g, b, A, k) => {
        if ((b && p(m, b), A)) for (let C = 0; C < A.length; C++) p(m, A[C]);
        if (k) {
          let C = k.subTree;
          if (
            (C.patchFlag > 0 && C.patchFlag & 2048 && (C = cr(C.children) || C),
            g === C || (Nl(C.type) && (C.ssContent === g || C.ssFallback === g)))
          ) {
            const P = k.vnode;
            fe(m, P, P.scopeId, P.slotScopeIds, k.parent);
          }
        }
      },
      U = (m, g, b, A, k, C, P, B, $ = 0) => {
        for (let T = $; T < m.length; T++) {
          const Z = (m[T] = B ? Qt(m[T]) : ut(m[T]));
          q(null, Z, g, b, A, k, C, P, B);
        }
      },
      w = (m, g, b, A, k, C, P) => {
        const B = (g.el = m.el);
        B.__vnode = g;
        let { patchFlag: $, dynamicChildren: T, dirs: Z } = g;
        $ |= m.patchFlag & 16;
        const M = m.props || ie,
          W = g.props || ie;
        let te;
        if (
          (b && an(b, !1),
          (te = W.onVnodeBeforeUpdate) && qt(te, b, g, m),
          Z && sn(g, m, b, 'beforeUpdate'),
          b && an(b, !0),
          mt && (($ = 0), (P = !1), (T = null)),
          ((M.innerHTML && W.innerHTML == null) || (M.textContent && W.textContent == null)) &&
            c(B, ''),
          T
            ? (x(m.dynamicChildren, T, B, b, A, lr(g, k), C), ar(m, g))
            : P || re(m, g, B, null, b, A, lr(g, k), C, !1),
          $ > 0)
        ) {
          if ($ & 16) E(B, M, W, b, k);
          else if (
            ($ & 2 && M.class !== W.class && r(B, 'class', null, W.class, k),
            $ & 4 && r(B, 'style', M.style, W.style, k),
            $ & 8)
          ) {
            const oe = g.dynamicProps;
            for (let _e = 0; _e < oe.length; _e++) {
              const he = oe[_e],
                et = M[he],
                We = W[he];
              (We !== et || he === 'value') && r(B, he, et, We, k, b);
            }
          }
          $ & 1 && m.children !== g.children && c(B, g.children);
        } else !P && T == null && E(B, M, W, b, k);
        ((te = W.onVnodeUpdated) || Z) &&
          Ze(() => {
            (te && qt(te, b, g, m), Z && sn(g, m, b, 'updated'));
          }, A);
      },
      x = (m, g, b, A, k, C, P) => {
        for (let B = 0; B < g.length; B++) {
          const $ = m[B],
            T = g[B],
            Z = $.el && ($.type === be || !cn($, T) || $.shapeFlag & 70) ? u($.el) : b;
          q($, T, Z, null, A, k, C, P, !0);
        }
      },
      E = (m, g, b, A, k) => {
        if (g !== b) {
          if (g !== ie) for (const C in g) !Ln(C) && !(C in b) && r(m, C, g[C], null, k, A);
          for (const C in b) {
            if (Ln(C)) continue;
            const P = b[C],
              B = g[C];
            P !== B && C !== 'value' && r(m, C, B, P, k, A);
          }
          'value' in b && r(m, 'value', g.value, b.value, k);
        }
      },
      Y = (m, g, b, A, k, C, P, B, $) => {
        const T = (g.el = m ? m.el : l('')),
          Z = (g.anchor = m ? m.anchor : l(''));
        let { patchFlag: M, dynamicChildren: W, slotScopeIds: te } = g;
        ((mt || M & 2048) && ((M = 0), ($ = !1), (W = null)),
          te && (B = B ? B.concat(te) : te),
          m == null
            ? (s(T, b, A), s(Z, b, A), U(g.children || [], b, Z, k, C, P, B, $))
            : M > 0 && M & 64 && W && m.dynamicChildren
              ? (x(m.dynamicChildren, W, b, k, C, P, B), ar(m, g))
              : re(m, g, b, Z, k, C, P, B, $));
      },
      de = (m, g, b, A, k, C, P, B, $) => {
        ((g.slotScopeIds = B),
          m == null
            ? g.shapeFlag & 512
              ? k.ctx.activate(g, b, A, P, $)
              : xe(g, b, A, k, C, P, $)
            : pe(m, g, $));
      },
      xe = (m, g, b, A, k, C, P) => {
        const B = (m.component = rp(m, A, k));
        if (
          (B.type.__hmrId && Pf(B),
          Rs(m),
          kn(B, 'mount'),
          ns(m) && (B.ctx.renderer = Es),
          kn(B, 'init'),
          lp(B, !1, P),
          Cn(B, 'init'),
          B.asyncDep)
        ) {
          if ((mt && (m.el = null), k && k.registerDep(B, V, P), !m.el)) {
            const $ = (B.subTree = D(Se));
            y(null, $, g, b);
          }
        } else V(B, m, g, b, k, C, P);
        (Vs(), Cn(B, 'mount'));
      },
      pe = (m, g, b) => {
        const A = (g.component = m.component);
        if (Gd(m, g, b))
          if (A.asyncDep && !A.asyncResolved) {
            (Rs(g), ee(A, g, b), Vs());
            return;
          } else ((A.next = g), A.update());
        else ((g.el = m.el), (A.vnode = g));
      },
      V = (m, g, b, A, k, C, P) => {
        const B = () => {
          if (m.isMounted) {
            let { next: M, bu: W, u: te, parent: oe, vnode: _e } = m;
            {
              const St = $l(m);
              if (St) {
                (M && ((M.el = _e.el), ee(m, M, P)),
                  St.asyncDep.then(() => {
                    m.isUnmounted || B();
                  }));
                return;
              }
            }
            let he = M,
              et;
            (Rs(M || m.vnode),
              an(m, !1),
              M ? ((M.el = _e.el), ee(m, M, P)) : (M = _e),
              W && vn(W),
              (et = M.props && M.props.onVnodeBeforeUpdate) && qt(et, oe, M, _e),
              an(m, !0),
              kn(m, 'render'));
            const We = Pl(m);
            Cn(m, 'render');
            const Et = m.subTree;
            ((m.subTree = We),
              kn(m, 'patch'),
              q(Et, We, u(Et.el), Si(Et), m, k, C),
              Cn(m, 'patch'),
              (M.el = We.el),
              he === null && Yd(m, We.el),
              te && Ze(te, k),
              (et = M.props && M.props.onVnodeUpdated) && Ze(() => qt(et, oe, M, _e), k),
              Ko(m),
              Vs());
          } else {
            let M;
            const { el: W, props: te } = g,
              { bm: oe, m: _e, parent: he, root: et, type: We } = m,
              Et = Sn(g);
            (an(m, !1),
              oe && vn(oe),
              !Et && (M = te && te.onVnodeBeforeMount) && qt(M, he, g),
              an(m, !0));
            {
              (et.ce && et.ce._injectChildStyle(We), kn(m, 'render'));
              const St = (m.subTree = Pl(m));
              (Cn(m, 'render'),
                kn(m, 'patch'),
                q(null, St, b, A, m, k, C),
                Cn(m, 'patch'),
                (g.el = St.el));
            }
            if ((_e && Ze(_e, k), !Et && (M = te && te.onVnodeMounted))) {
              const St = g;
              Ze(() => qt(M, he, St), k);
            }
            ((g.shapeFlag & 256 || (he && Sn(he.vnode) && he.vnode.shapeFlag & 256)) &&
              m.a &&
              Ze(m.a, k),
              (m.isMounted = !0),
              Lf(m),
              (g = b = A = null));
          }
        };
        m.scope.on();
        const $ = (m.effect = new ho(B));
        m.scope.off();
        const T = (m.update = $.run.bind($)),
          Z = (m.job = $.runIfDirty.bind($));
        ((Z.i = m),
          (Z.id = m.uid),
          ($.scheduler = () => js(Z)),
          an(m, !0),
          ($.onTrack = m.rtc ? (M) => vn(m.rtc, M) : void 0),
          ($.onTrigger = m.rtg ? (M) => vn(m.rtg, M) : void 0),
          T());
      },
      ee = (m, g, b) => {
        g.component = m;
        const A = m.vnode.props;
        ((m.vnode = g),
          (m.next = null),
          kd(m, g.props, A, b),
          zd(m, g.children, b),
          Tt(),
          No(m),
          Ot());
      },
      re = (m, g, b, A, k, C, P, B, $ = !1) => {
        const T = m && m.children,
          Z = m ? m.shapeFlag : 0,
          M = g.children,
          { patchFlag: W, shapeFlag: te } = g;
        if (W > 0) {
          if (W & 128) {
            He(T, M, b, A, k, C, P, B, $);
            return;
          } else if (W & 256) {
            xt(T, M, b, A, k, C, P, B, $);
            return;
          }
        }
        te & 8
          ? (Z & 16 && xs(T, k, C), M !== T && c(b, M))
          : Z & 16
            ? te & 16
              ? He(T, M, b, A, k, C, P, B, $)
              : xs(T, k, C, !0)
            : (Z & 8 && c(b, ''), te & 16 && U(M, b, A, k, C, P, B, $));
      },
      xt = (m, g, b, A, k, C, P, B, $) => {
        ((m = m || qn), (g = g || qn));
        const T = m.length,
          Z = g.length,
          M = Math.min(T, Z);
        let W;
        for (W = 0; W < M; W++) {
          const te = (g[W] = $ ? Qt(g[W]) : ut(g[W]));
          q(m[W], te, b, null, k, C, P, B, $);
        }
        T > Z ? xs(m, k, C, !0, !1, M) : U(g, b, A, k, C, P, B, $, M);
      },
      He = (m, g, b, A, k, C, P, B, $) => {
        let T = 0;
        const Z = g.length;
        let M = m.length - 1,
          W = Z - 1;
        for (; T <= M && T <= W; ) {
          const te = m[T],
            oe = (g[T] = $ ? Qt(g[T]) : ut(g[T]));
          if (cn(te, oe)) q(te, oe, b, null, k, C, P, B, $);
          else break;
          T++;
        }
        for (; T <= M && T <= W; ) {
          const te = m[M],
            oe = (g[W] = $ ? Qt(g[W]) : ut(g[W]));
          if (cn(te, oe)) q(te, oe, b, null, k, C, P, B, $);
          else break;
          (M--, W--);
        }
        if (T > M) {
          if (T <= W) {
            const te = W + 1,
              oe = te < Z ? g[te].el : A;
            for (; T <= W; ) (q(null, (g[T] = $ ? Qt(g[T]) : ut(g[T])), b, oe, k, C, P, B, $), T++);
          }
        } else if (T > W) for (; T <= M; ) (Ke(m[T], k, C, !0), T++);
        else {
          const te = T,
            oe = T,
            _e = new Map();
          for (T = oe; T <= W; T++) {
            const Qe = (g[T] = $ ? Qt(g[T]) : ut(g[T]));
            Qe.key != null &&
              (_e.has(Qe.key) &&
                I(
                  'Duplicate keys found during update:',
                  JSON.stringify(Qe.key),
                  'Make sure keys are unique.'
                ),
              _e.set(Qe.key, T));
          }
          let he,
            et = 0;
          const We = W - oe + 1;
          let Et = !1,
            St = 0;
          const Ss = new Array(We);
          for (T = 0; T < We; T++) Ss[T] = 0;
          for (T = te; T <= M; T++) {
            const Qe = m[T];
            if (et >= We) {
              Ke(Qe, k, C, !0);
              continue;
            }
            let kt;
            if (Qe.key != null) kt = _e.get(Qe.key);
            else
              for (he = oe; he <= W; he++)
                if (Ss[he - oe] === 0 && cn(Qe, g[he])) {
                  kt = he;
                  break;
                }
            kt === void 0
              ? Ke(Qe, k, C, !0)
              : ((Ss[kt - oe] = T + 1),
                kt >= St ? (St = kt) : (Et = !0),
                q(Qe, g[kt], b, null, k, C, P, B, $),
                et++);
          }
          const $c = Et ? Nd(Ss) : qn;
          for (he = $c.length - 1, T = We - 1; T >= 0; T--) {
            const Qe = oe + T,
              kt = g[Qe],
              Bc = Qe + 1 < Z ? g[Qe + 1].el : A;
            Ss[T] === 0
              ? q(null, kt, b, Bc, k, C, P, B, $)
              : Et && (he < 0 || T !== $c[he] ? $e(kt, b, Bc, 2) : he--);
          }
        }
      },
      $e = (m, g, b, A, k = null) => {
        const { el: C, type: P, transition: B, children: $, shapeFlag: T } = m;
        if (T & 6) {
          $e(m.component.subTree, g, b, A);
          return;
        }
        if (T & 128) {
          m.suspense.move(g, b, A);
          return;
        }
        if (T & 64) {
          P.move(m, g, b, Es);
          return;
        }
        if (P === be) {
          s(C, g, b);
          for (let M = 0; M < $.length; M++) $e($[M], g, b, A);
          s(m.anchor, g, b);
          return;
        }
        if (P === os) {
          X(m, g, b);
          return;
        }
        if (A !== 2 && T & 1 && B)
          if (A === 0) (B.beforeEnter(C), s(C, g, b), Ze(() => B.enter(C), k));
          else {
            const { leave: M, delayLeave: W, afterLeave: te } = B,
              oe = () => s(C, g, b),
              _e = () => {
                M(C, () => {
                  (oe(), te && te());
                });
              };
            W ? W(C, oe, _e) : _e();
          }
        else s(C, g, b);
      },
      Ke = (m, g, b, A = !1, k = !1) => {
        const {
          type: C,
          props: P,
          ref: B,
          children: $,
          dynamicChildren: T,
          shapeFlag: Z,
          patchFlag: M,
          dirs: W,
          cacheIndex: te
        } = m;
        if (
          (M === -2 && (k = !1),
          B != null && Ks(B, null, b, m, !0),
          te != null && (g.renderCache[te] = void 0),
          Z & 256)
        ) {
          g.ctx.deactivate(m);
          return;
        }
        const oe = Z & 1 && W,
          _e = !Sn(m);
        let he;
        if ((_e && (he = P && P.onVnodeBeforeUnmount) && qt(he, g, m), Z & 6))
          sq(m.component, b, A);
        else {
          if (Z & 128) {
            m.suspense.unmount(b, A);
            return;
          }
          (oe && sn(m, null, g, 'beforeUnmount'),
            Z & 64
              ? m.type.remove(m, g, b, Es, A)
              : T && !T.hasOnce && (C !== be || (M > 0 && M & 64))
                ? xs(T, g, b, !1, !0)
                : ((C === be && M & 384) || (!k && Z & 16)) && xs($, g, b),
            A && Nn(m));
        }
        ((_e && (he = P && P.onVnodeUnmounted)) || oe) &&
          Ze(() => {
            (he && qt(he, g, m), oe && sn(m, null, g, 'unmounted'));
          }, b);
      },
      Nn = (m) => {
        const { type: g, el: b, anchor: A, transition: k } = m;
        if (g === be) {
          m.patchFlag > 0 && m.patchFlag & 2048 && k && !k.persisted
            ? m.children.forEach((P) => {
                P.type === Se ? i(P.el) : Nn(P);
              })
            : ws(b, A);
          return;
        }
        if (g === os) {
          N(m);
          return;
        }
        const C = () => {
          (i(b), k && !k.persisted && k.afterLeave && k.afterLeave());
        };
        if (m.shapeFlag & 1 && k && !k.persisted) {
          const { leave: P, delayLeave: B } = k,
            $ = () => P(b, C);
          B ? B(m.el, C, $) : $();
        } else C();
      },
      ws = (m, g) => {
        let b;
        for (; m !== g; ) ((b = d(m)), i(m), (m = b));
        i(g);
      },
      sq = (m, g, b) => {
        m.type.__hmrId && Mf(m);
        const { bum: A, scope: k, job: C, subTree: P, um: B, m: $, a: T } = m;
        (Bl($),
          Bl(T),
          A && vn(A),
          k.stop(),
          C && ((C.flags |= 8), Ke(P, m, g, b)),
          B && Ze(B, g),
          Ze(() => {
            m.isUnmounted = !0;
          }, g),
          g &&
            g.pendingBranch &&
            !g.isUnmounted &&
            m.asyncDep &&
            !m.asyncResolved &&
            m.suspenseId === g.pendingId &&
            (g.deps--, g.deps === 0 && g.resolve()),
          Qf(m));
      },
      xs = (m, g, b, A = !1, k = !1, C = 0) => {
        for (let P = C; P < m.length; P++) Ke(m[P], g, b, A, k);
      },
      Si = (m) => {
        if (m.shapeFlag & 6) return Si(m.component.subTree);
        if (m.shapeFlag & 128) return m.suspense.next();
        const g = d(m.anchor || m.el),
          b = g && g[Gf];
        return b ? d(b) : g;
      };
    let no = !1;
    const Ic = (m, g, b) => {
        (m == null
          ? g._vnode && Ke(g._vnode, null, null, !0)
          : q(g._vnode || null, m, g, null, null, null, b),
          (g._vnode = m),
          no || ((no = !0), No(), jo(), (no = !1)));
      },
      Es = { p: q, um: Ke, m: $e, r: Nn, mt: xe, mc: U, pc: re, pbc: x, n: Si, o: e };
    return { render: Ic, hydrate: void 0, createApp: bd(Ic) };
  }
  function lr({ type: e, props: t }, n) {
    return (n === 'svg' && e === 'foreignObject') ||
      (n === 'mathml' && e === 'annotation-xml' && t && t.encoding && t.encoding.includes('html'))
      ? void 0
      : n;
  }
  function an({ effect: e, job: t }, n) {
    n ? ((e.flags |= 32), (t.flags |= 4)) : ((e.flags &= -33), (t.flags &= -5));
  }
  function Vd(e, t) {
    return (!e || (e && !e.pendingBranch)) && t && !t.persisted;
  }
  function ar(e, t, n = !1) {
    const s = e.children,
      i = t.children;
    if (K(s) && K(i))
      for (let r = 0; r < s.length; r++) {
        const o = s[r];
        let l = i[r];
        (l.shapeFlag & 1 &&
          !l.dynamicChildren &&
          ((l.patchFlag <= 0 || l.patchFlag === 32) && ((l = i[r] = Qt(i[r])), (l.el = o.el)),
          !n && l.patchFlag !== -2 && ar(o, l)),
          l.type === An && (l.el = o.el),
          l.type === Se && !l.el && (l.el = o.el));
      }
  }
  function Nd(e) {
    const t = e.slice(),
      n = [0];
    let s, i, r, o, l;
    const a = e.length;
    for (s = 0; s < a; s++) {
      const f = e[s];
      if (f !== 0) {
        if (((i = n[n.length - 1]), e[i] < f)) {
          ((t[s] = i), n.push(s));
          continue;
        }
        for (r = 0, o = n.length - 1; r < o; )
          ((l = (r + o) >> 1), e[n[l]] < f ? (r = l + 1) : (o = l));
        f < e[n[r]] && (r > 0 && (t[s] = n[r - 1]), (n[r] = s));
      }
    }
    for (r = n.length, o = n[r - 1]; r-- > 0; ) ((n[r] = o), (o = t[o]));
    return n;
  }
  function $l(e) {
    const t = e.subTree.component;
    if (t) return t.asyncDep && !t.asyncResolved ? t : $l(t);
  }
  function Bl(e) {
    if (e) for (let t = 0; t < e.length; t++) e[t].flags |= 8;
  }
  const jd = Symbol.for('v-scx'),
    Ld = () => {
      {
        const e = is(jd);
        return (
          e ||
            I(
              'Server rendering context not provided. Make sure to only call useSSRContext() conditionally in the server build.'
            ),
          e
        );
      }
    };
  function ze(e, t, n) {
    return (
      G(t) ||
        I(
          '`watch(fn, options?)` signature has been moved to a separate API. Use `watchEffect(fn, options?)` instead. `watch` now only supports `watch(source, cb, options?) signature.'
        ),
      Fl(e, t, n)
    );
  }
  function Fl(e, t, n = ie) {
    const { immediate: s, deep: i, flush: r, once: o } = n;
    t ||
      (s !== void 0 &&
        I(
          'watch() "immediate" option is only respected when using the watch(source, callback, options?) signature.'
        ),
      i !== void 0 &&
        I(
          'watch() "deep" option is only respected when using the watch(source, callback, options?) signature.'
        ),
      o !== void 0 &&
        I(
          'watch() "once" option is only respected when using the watch(source, callback, options?) signature.'
        ));
    const l = ye({}, n);
    l.onWarn = I;
    const a = (t && s) || (!t && r !== 'post');
    let f;
    if (cs) {
      if (r === 'sync') {
        const p = Ld();
        f = p.__watcherHandles || (p.__watcherHandles = []);
      } else if (!a) {
        const p = () => {};
        return ((p.stop = Fe), (p.resume = Fe), (p.pause = Fe), p);
      }
    }
    const c = Ae;
    l.call = (p, h, q) => ot(p, c, h, q);
    let u = !1;
    (r === 'post'
      ? (l.scheduler = (p) => {
          Ze(p, c && c.suspense);
        })
      : r !== 'sync' &&
        ((u = !0),
        (l.scheduler = (p, h) => {
          h ? p() : js(p);
        })),
      (l.augmentJob = (p) => {
        (t && (p.flags |= 4), u && ((p.flags |= 2), c && ((p.id = c.uid), (p.i = c))));
      }));
    const d = Af(e, t, l);
    return (cs && (f ? f.push(d) : a && d()), d);
  }
  function Ud(e, t, n) {
    const s = this.proxy,
      i = ve(e) ? (e.includes('.') ? Dl(s, e) : () => s[e]) : e.bind(s, s);
    let r;
    G(t) ? (r = t) : ((r = t.handler), (n = t));
    const o = us(this),
      l = Fl(i, r.bind(s), n);
    return (o(), l);
  }
  function Dl(e, t) {
    const n = t.split('.');
    return () => {
      let s = e;
      for (let i = 0; i < n.length && s; i++) s = s[n[i]];
      return s;
    };
  }
  const Qd = (e, t) =>
    t === 'modelValue' || t === 'model-value'
      ? e.modelModifiers
      : e[`${t}Modifiers`] || e[`${Me(t)}Modifiers`] || e[`${At(t)}Modifiers`];
  function Hd(e, t, ...n) {
    if (e.isUnmounted) return;
    const s = e.vnode.props || ie;
    {
      const {
        emitsOptions: c,
        propsOptions: [u]
      } = e;
      if (c)
        if (!(t in c))
          (!u || !(Jt(Me(t)) in u)) &&
            I(
              `Component emitted event "${t}" but it is neither declared in the emits option nor as an "${Jt(Me(t))}" prop.`
            );
        else {
          const d = c[t];
          G(d) &&
            (d(...n) || I(`Invalid event arguments: event validation failed for event "${t}".`));
        }
    }
    let i = n;
    const r = t.startsWith('update:'),
      o = r && Qd(s, t.slice(7));
    (o && (o.trim && (i = n.map((c) => (ve(c) ? c.trim() : c))), o.number && (i = n.map(Oi))),
      Wf(e, t, i));
    {
      const c = t.toLowerCase();
      c !== t &&
        s[Jt(c)] &&
        I(
          `Event "${c}" is emitted in component ${ii(e, e.type)} but the handler is registered for "${t}". Note that HTML attributes are case-insensitive and you cannot use v-on to listen to camelCase events when using in-DOM templates. You should probably use "${At(t)}" instead of "${t}".`
        );
    }
    let l,
      a = s[(l = Jt(t))] || s[(l = Jt(Me(t)))];
    (!a && r && (a = s[(l = Jt(At(t)))]), a && ot(a, e, 6, i));
    const f = s[l + 'Once'];
    if (f) {
      if (!e.emitted) e.emitted = {};
      else if (e.emitted[l]) return;
      ((e.emitted[l] = !0), ot(f, e, 6, i));
    }
  }
  function zl(e, t, n = !1) {
    const s = t.emitsCache,
      i = s.get(e);
    if (i !== void 0) return i;
    const r = e.emits;
    let o = {},
      l = !1;
    if (!G(e)) {
      const a = (f) => {
        const c = zl(f, t, !0);
        c && ((l = !0), ye(o, c));
      };
      (!n && t.mixins.length && t.mixins.forEach(a),
        e.extends && a(e.extends),
        e.mixins && e.mixins.forEach(a));
    }
    return !r && !l
      ? (ue(e) && s.set(e, null), null)
      : (K(r) ? r.forEach((a) => (o[a] = null)) : ye(o, r), ue(e) && s.set(e, o), o);
  }
  function Js(e, t) {
    return !e || !jn(t)
      ? !1
      : ((t = t.slice(2).replace(/Once$/, '')),
        le(e, t[0].toLowerCase() + t.slice(1)) || le(e, At(t)) || le(e, t));
  }
  let ur = !1;
  function Xs() {
    ur = !0;
  }
  function Pl(e) {
    const {
        type: t,
        vnode: n,
        proxy: s,
        withProxy: i,
        propsOptions: [r],
        slots: o,
        attrs: l,
        emit: a,
        render: f,
        renderCache: c,
        props: u,
        data: d,
        setupState: p,
        ctx: h,
        inheritAttrs: q
      } = e,
      v = Qs(e);
    let y, z;
    ur = !1;
    try {
      if (n.shapeFlag & 4) {
        const N = i || s,
          ne =
            Rt.NODE_ENV !== 'production' && p.__isScriptSetup
              ? new Proxy(N, {
                  get(H, fe, U) {
                    return (
                      I(
                        `Property '${String(fe)}' was accessed via 'this'. Avoid using 'this' in templates.`
                      ),
                      Reflect.get(H, fe, U)
                    );
                  }
                })
              : N;
        ((y = ut(f.call(ne, N, c, Rt.NODE_ENV !== 'production' ? dt(u) : u, p, d, h))), (z = l));
      } else {
        const N = t;
        (Rt.NODE_ENV !== 'production' && l === u && Xs(),
          (y = ut(
            N.length > 1
              ? N(
                  Rt.NODE_ENV !== 'production' ? dt(u) : u,
                  Rt.NODE_ENV !== 'production'
                    ? {
                        get attrs() {
                          return (Xs(), dt(l));
                        },
                        slots: o,
                        emit: a
                      }
                    : { attrs: l, slots: o, emit: a }
                )
              : N(Rt.NODE_ENV !== 'production' ? dt(u) : u, null)
          )),
          (z = t.props ? l : Kd(l)));
      }
    } catch (N) {
      ((ls.length = 0), Zn(N, e, 1), (y = D(Se)));
    }
    let O = y,
      X;
    if ((y.patchFlag > 0 && y.patchFlag & 2048 && ([O, X] = Ml(y)), z && q !== !1)) {
      const N = Object.keys(z),
        { shapeFlag: ne } = O;
      if (N.length) {
        if (ne & 7) (r && N.some(ks) && (z = Wd(z, r)), (O = _t(O, z, !1, !0)));
        else if (!ur && O.type !== Se) {
          const H = Object.keys(l),
            fe = [],
            U = [];
          for (let w = 0, x = H.length; w < x; w++) {
            const E = H[w];
            jn(E) ? ks(E) || fe.push(E[2].toLowerCase() + E.slice(3)) : U.push(E);
          }
          (U.length &&
            I(
              `Extraneous non-props attributes (${U.join(', ')}) were passed to component but could not be automatically inherited because component renders fragment or text or teleport root nodes.`
            ),
            fe.length &&
              I(
                `Extraneous non-emits event listeners (${fe.join(', ')}) were passed to component but could not be automatically inherited because component renders fragment or text root nodes. If the listener is intended to be a component custom event listener only, declare it using the "emits" option.`
              ));
        }
      }
    }
    return (
      n.dirs &&
        (Rl(O) ||
          I(
            'Runtime directive used on component with non-element root node. The directives will not function as intended.'
          ),
        (O = _t(O, null, !1, !0)),
        (O.dirs = O.dirs ? O.dirs.concat(n.dirs) : n.dirs)),
      n.transition &&
        (Rl(O) ||
          I('Component inside <Transition> renders non-element root node that cannot be animated.'),
        rn(O, n.transition)),
      X ? X(O) : (y = O),
      Qs(v),
      y
    );
  }
  const Ml = (e) => {
    const t = e.children,
      n = e.dynamicChildren,
      s = cr(t, !1);
    if (s) {
      if (s.patchFlag > 0 && s.patchFlag & 2048) return Ml(s);
    } else return [e, void 0];
    const i = t.indexOf(s),
      r = n ? n.indexOf(s) : -1,
      o = (l) => {
        ((t[i] = l),
          n && (r > -1 ? (n[r] = l) : l.patchFlag > 0 && (e.dynamicChildren = [...n, l])));
      };
    return [ut(s), o];
  };
  function cr(e, t = !0) {
    let n;
    for (let s = 0; s < e.length; s++) {
      const i = e[s];
      if (un(i)) {
        if (i.type !== Se || i.children === 'v-if') {
          if (n) return;
          if (((n = i), t && n.patchFlag > 0 && n.patchFlag & 2048)) return cr(n.children);
        }
      } else return;
    }
    return n;
  }
  const Kd = (e) => {
      let t;
      for (const n in e) (n === 'class' || n === 'style' || jn(n)) && ((t || (t = {}))[n] = e[n]);
      return t;
    },
    Wd = (e, t) => {
      const n = {};
      for (const s in e) (!ks(s) || !(s.slice(9) in t)) && (n[s] = e[s]);
      return n;
    },
    Rl = (e) => e.shapeFlag & 7 || e.type === Se;
  function Gd(e, t, n) {
    const { props: s, children: i, component: r } = e,
      { props: o, children: l, patchFlag: a } = t,
      f = r.emitsOptions;
    if (((i || l) && mt) || t.dirs || t.transition) return !0;
    if (n && a >= 0) {
      if (a & 1024) return !0;
      if (a & 16) return s ? Vl(s, o, f) : !!o;
      if (a & 8) {
        const c = t.dynamicProps;
        for (let u = 0; u < c.length; u++) {
          const d = c[u];
          if (o[d] !== s[d] && !Js(f, d)) return !0;
        }
      }
    } else
      return (i || l) && (!l || !l.$stable) ? !0 : s === o ? !1 : s ? (o ? Vl(s, o, f) : !0) : !!o;
    return !1;
  }
  function Vl(e, t, n) {
    const s = Object.keys(t);
    if (s.length !== Object.keys(e).length) return !0;
    for (let i = 0; i < s.length; i++) {
      const r = s[i];
      if (t[r] !== e[r] && !Js(n, r)) return !0;
    }
    return !1;
  }
  function Yd({ vnode: e, parent: t }, n) {
    for (; t; ) {
      const s = t.subTree;
      if ((s.suspense && s.suspense.activeBranch === e && (s.el = e.el), s === e))
        (((e = t.vnode).el = n), (t = t.parent));
      else break;
    }
  }
  const Nl = (e) => e.__isSuspense;
  function Zd(e, t) {
    t && t.pendingBranch ? (K(e) ? t.effects.push(...e) : t.effects.push(e)) : Vo(e);
  }
  const be = Symbol.for('v-fgt'),
    An = Symbol.for('v-txt'),
    Se = Symbol.for('v-cmt'),
    os = Symbol.for('v-stc'),
    ls = [];
  let Je = null;
  function F(e = !1) {
    ls.push((Je = e ? null : []));
  }
  function Jd() {
    (ls.pop(), (Je = ls[ls.length - 1] || null));
  }
  let as = 1;
  function jl(e, t = !1) {
    ((as += e), e < 0 && Je && t && (Je.hasOnce = !0));
  }
  function Ll(e) {
    return ((e.dynamicChildren = as > 0 ? Je || qn : null), Jd(), as > 0 && Je && Je.push(e), e);
  }
  function R(e, t, n, s, i, r) {
    return Ll(_(e, t, n, s, i, r, !0));
  }
  function at(e, t, n, s, i) {
    return Ll(D(e, t, n, s, i, !0));
  }
  function un(e) {
    return e ? e.__v_isVNode === !0 : !1;
  }
  function cn(e, t) {
    if (t.shapeFlag & 6 && e.component) {
      const n = Ls.get(t.type);
      if (n && n.has(e.component)) return ((e.shapeFlag &= -257), (t.shapeFlag &= -513), !1);
    }
    return e.type === t.type && e.key === t.key;
  }
  const Xd = (...e) => ep(...e),
    Ul = ({ key: e }) => e ?? null,
    ei = ({ ref: e, ref_key: t, ref_for: n }) => (
      typeof e == 'number' && (e = '' + e),
      e != null ? (ve(e) || ge(e) || G(e) ? { i: Ee, r: e, k: t, f: !!n } : e) : null
    );
  function _(e, t = null, n = null, s = 0, i = null, r = e === be ? 0 : 1, o = !1, l = !1) {
    const a = {
      __v_isVNode: !0,
      __v_skip: !0,
      type: e,
      props: t,
      key: t && Ul(t),
      ref: t && ei(t),
      scopeId: Go,
      slotScopeIds: null,
      children: n,
      component: null,
      suspense: null,
      ssContent: null,
      ssFallback: null,
      dirs: null,
      transition: null,
      el: null,
      anchor: null,
      target: null,
      targetStart: null,
      targetAnchor: null,
      staticCount: 0,
      shapeFlag: r,
      patchFlag: s,
      dynamicProps: i,
      dynamicChildren: null,
      appContext: null,
      ctx: Ee
    };
    return (
      l ? (fr(a, n), r & 128 && e.normalize(a)) : n && (a.shapeFlag |= ve(n) ? 8 : 16),
      a.key !== a.key && I('VNode created with invalid key (NaN). VNode type:', a.type),
      as > 0 && !o && Je && (a.patchFlag > 0 || r & 6) && a.patchFlag !== 32 && Je.push(a),
      a
    );
  }
  const D = Xd;
  function ep(e, t = null, n = null, s = 0, i = null, r = !1) {
    if (
      ((!e || e === al) && (e || I(`Invalid vnode type when creating vnode: ${e}.`), (e = Se)),
      un(e))
    ) {
      const l = _t(e, t, !0);
      return (
        n && fr(l, n),
        as > 0 && !r && Je && (l.shapeFlag & 6 ? (Je[Je.indexOf(e)] = l) : Je.push(l)),
        (l.patchFlag = -2),
        l
      );
    }
    if ((Zl(e) && (e = e.__vccOpts), t)) {
      t = tp(t);
      let { class: l, style: a } = t;
      (l && !ve(l) && (t.class = Be(l)),
        ue(a) && (Yn(a) && !K(a) && (a = ye({}, a)), (t.style = Ye(a))));
    }
    const o = ve(e) ? 1 : Nl(e) ? 128 : Zo(e) ? 64 : ue(e) ? 4 : G(e) ? 2 : 0;
    return (
      o & 4 &&
        Yn(e) &&
        ((e = J(e)),
        I(
          'Vue received a Component that was made a reactive object. This can lead to unnecessary performance overhead and should be avoided by marking the component with `markRaw` or using `shallowRef` instead of `ref`.',
          `
Component that was made reactive: `,
          e
        )),
      _(e, t, n, s, i, o, r, !0)
    );
  }
  function tp(e) {
    return e ? (Yn(e) || wl(e) ? ye({}, e) : e) : null;
  }
  function _t(e, t, n = !1, s = !1) {
    const { props: i, ref: r, patchFlag: o, children: l, transition: a } = e,
      f = t ? np(i || {}, t) : i,
      c = {
        __v_isVNode: !0,
        __v_skip: !0,
        type: e.type,
        props: f,
        key: f && Ul(f),
        ref: t && t.ref ? (n && r ? (K(r) ? r.concat(ei(t)) : [r, ei(t)]) : ei(t)) : r,
        scopeId: e.scopeId,
        slotScopeIds: e.slotScopeIds,
        children: o === -1 && K(l) ? l.map(Ql) : l,
        target: e.target,
        targetStart: e.targetStart,
        targetAnchor: e.targetAnchor,
        staticCount: e.staticCount,
        shapeFlag: e.shapeFlag,
        patchFlag: t && e.type !== be ? (o === -1 ? 16 : o | 16) : o,
        dynamicProps: e.dynamicProps,
        dynamicChildren: e.dynamicChildren,
        appContext: e.appContext,
        dirs: e.dirs,
        transition: a,
        component: e.component,
        suspense: e.suspense,
        ssContent: e.ssContent && _t(e.ssContent),
        ssFallback: e.ssFallback && _t(e.ssFallback),
        el: e.el,
        anchor: e.anchor,
        ctx: e.ctx,
        ce: e.ce
      };
    return (a && s && rn(c, a.clone(c)), c);
  }
  function Ql(e) {
    const t = _t(e);
    return (K(e.children) && (t.children = e.children.map(Ql)), t);
  }
  function Tn(e = ' ', t = 0) {
    return D(An, null, e, t);
  }
  function Hl(e, t) {
    const n = D(os, null, e);
    return ((n.staticCount = t), n);
  }
  function we(e = '', t = !1) {
    return t ? (F(), at(Se, null, e)) : D(Se, null, e);
  }
  function ut(e) {
    return e == null || typeof e == 'boolean'
      ? D(Se)
      : K(e)
        ? D(be, null, e.slice())
        : un(e)
          ? Qt(e)
          : D(An, null, String(e));
  }
  function Qt(e) {
    return (e.el === null && e.patchFlag !== -1) || e.memo ? e : _t(e);
  }
  function fr(e, t) {
    let n = 0;
    const { shapeFlag: s } = e;
    if (t == null) t = null;
    else if (K(t)) n = 16;
    else if (typeof t == 'object')
      if (s & 65) {
        const i = t.default;
        i && (i._c && (i._d = !1), fr(e, i()), i._c && (i._d = !0));
        return;
      } else {
        n = 32;
        const i = t._;
        !i && !wl(t)
          ? (t._ctx = Ee)
          : i === 3 && Ee && (Ee.slots._ === 1 ? (t._ = 1) : ((t._ = 2), (e.patchFlag |= 1024)));
      }
    else
      G(t)
        ? ((t = { default: t, _ctx: Ee }), (n = 32))
        : ((t = String(t)), s & 64 ? ((n = 16), (t = [Tn(t)])) : (n = 8));
    ((e.children = t), (e.shapeFlag |= n));
  }
  function np(...e) {
    const t = {};
    for (let n = 0; n < e.length; n++) {
      const s = e[n];
      for (const i in s)
        if (i === 'class') t.class !== s.class && (t.class = Be([t.class, s.class]));
        else if (i === 'style') t.style = Ye([t.style, s.style]);
        else if (jn(i)) {
          const r = t[i],
            o = s[i];
          o && r !== o && !(K(r) && r.includes(o)) && (t[i] = r ? [].concat(r, o) : o);
        } else i !== '' && (t[i] = s[i]);
    }
    return t;
  }
  function qt(e, t, n, s = null) {
    ot(e, t, 7, [n, s]);
  }
  const sp = vl();
  let ip = 0;
  function rp(e, t, n) {
    const s = e.type,
      i = (t ? t.appContext : e.appContext) || sp,
      r = {
        uid: ip++,
        vnode: e,
        type: s,
        parent: t,
        appContext: i,
        root: null,
        next: null,
        subTree: null,
        effect: null,
        update: null,
        job: null,
        scope: new co(!0),
        render: null,
        proxy: null,
        exposed: null,
        exposeProxy: null,
        withProxy: null,
        provides: t ? t.provides : Object.create(i.provides),
        ids: t ? t.ids : ['', 0, 0],
        accessCache: null,
        renderCache: [],
        components: null,
        directives: null,
        propsOptions: El(s, i),
        emitsOptions: zl(s, i),
        emit: null,
        emitted: null,
        propsDefaults: ie,
        inheritAttrs: s.inheritAttrs,
        ctx: ie,
        data: ie,
        props: ie,
        attrs: ie,
        slots: ie,
        refs: ie,
        setupState: ie,
        setupContext: null,
        suspense: n,
        suspenseId: n ? n.pendingId : 0,
        asyncDep: null,
        asyncResolved: !1,
        isMounted: !1,
        isUnmounted: !1,
        isDeactivated: !1,
        bc: null,
        c: null,
        bm: null,
        m: null,
        bu: null,
        u: null,
        um: null,
        bum: null,
        da: null,
        a: null,
        rtg: null,
        rtc: null,
        ec: null,
        sp: null
      };
    return (
      (r.ctx = fd(r)),
      (r.root = t ? t.root : r),
      (r.emit = Hd.bind(null, r)),
      e.ce && e.ce(r),
      r
    );
  }
  let Ae = null;
  const ti = () => Ae || Ee;
  let ni, dr;
  {
    const e = Un(),
      t = (n, s) => {
        let i;
        return (
          (i = e[n]) || (i = e[n] = []),
          i.push(s),
          (r) => {
            i.length > 1 ? i.forEach((o) => o(r)) : i[0](r);
          }
        );
      };
    ((ni = t('__VUE_INSTANCE_SETTERS__', (n) => (Ae = n))),
      (dr = t('__VUE_SSR_SETTERS__', (n) => (cs = n))));
  }
  const us = (e) => {
      const t = Ae;
      return (
        ni(e),
        e.scope.on(),
        () => {
          (e.scope.off(), ni(t));
        }
      );
    },
    Kl = () => {
      (Ae && Ae.scope.off(), ni(null));
    },
    op = Ge('slot,component');
  function pr(e, { isNativeTag: t }) {
    (op(e) || t(e)) && I('Do not use built-in or reserved HTML elements as component id: ' + e);
  }
  function Wl(e) {
    return e.vnode.shapeFlag & 4;
  }
  let cs = !1;
  function lp(e, t = !1, n = !1) {
    t && dr(t);
    const { props: s, children: i } = e.vnode,
      r = Wl(e);
    (Ed(e, s, r, t), Dd(e, i, n));
    const o = r ? ap(e, t) : void 0;
    return (t && dr(!1), o);
  }
  function ap(e, t) {
    var n;
    const s = e.type;
    {
      if ((s.name && pr(s.name, e.appContext.config), s.components)) {
        const r = Object.keys(s.components);
        for (let o = 0; o < r.length; o++) pr(r[o], e.appContext.config);
      }
      if (s.directives) {
        const r = Object.keys(s.directives);
        for (let o = 0; o < r.length; o++) Yo(r[o]);
      }
      s.compilerOptions &&
        up() &&
        I(
          '"compilerOptions" is only supported when using a build of Vue that includes the runtime compiler. Since you are using a runtime-only build, the options should be passed via your build tool config instead.'
        );
    }
    ((e.accessCache = Object.create(null)), (e.proxy = new Proxy(e.ctx, dl)), dd(e));
    const { setup: i } = s;
    if (i) {
      Tt();
      const r = (e.setupContext = i.length > 1 ? dp(e) : null),
        o = us(e),
        l = bn(i, e, 0, [dt(e.props), r]),
        a = Ci(l);
      if ((Ot(), o(), (a || e.sp) && !Sn(e) && il(e), a)) {
        if ((l.then(Kl, Kl), t))
          return l
            .then((f) => {
              Gl(e, f, t);
            })
            .catch((f) => {
              Zn(f, e, 0);
            });
        if (((e.asyncDep = l), !e.suspense)) {
          const f = (n = s.name) != null ? n : 'Anonymous';
          I(
            `Component <${f}>: setup function returned a promise, but no <Suspense> boundary was found in the parent component tree. A component with async setup() must be nested in a <Suspense> in order to be rendered.`
          );
        }
      } else Gl(e, l, t);
    } else Yl(e, t);
  }
  function Gl(e, t, n) {
    (G(t)
      ? e.type.__ssrInlineRender
        ? (e.ssrRender = t)
        : (e.render = t)
      : ue(t)
        ? (un(t) &&
            I('setup() should not return VNodes directly - return a render function instead.'),
          (e.devtoolsRawSetupState = t),
          (e.setupState = Fo(t)),
          pd(e))
        : t !== void 0 &&
          I(`setup() should return an object. Received: ${t === null ? 'null' : typeof t}`),
      Yl(e, n));
  }
  const up = () => !0;
  function Yl(e, t, n) {
    const s = e.type;
    e.render || (e.render = s.render || Fe);
    {
      const i = us(e);
      Tt();
      try {
        md(e);
      } finally {
        (Ot(), i());
      }
    }
    !s.render &&
      e.render === Fe &&
      !t &&
      (s.template
        ? I(
            'Component provided template option but runtime compilation is not supported in this build of Vue. Configure your bundler to alias "vue" to "vue/dist/vue.esm-bundler.js".'
          )
        : I('Component is missing template or render function: ', s));
  }
  const cp = {
    get(e, t) {
      return (Xs(), Oe(e, 'get', ''), e[t]);
    },
    set() {
      return (I('setupContext.attrs is readonly.'), !1);
    },
    deleteProperty() {
      return (I('setupContext.attrs is readonly.'), !1);
    }
  };
  function fp(e) {
    return new Proxy(e.slots, {
      get(t, n) {
        return (Oe(e, 'get', '$slots'), t[n]);
      }
    });
  }
  function dp(e) {
    const t = (n) => {
      if ((e.exposed && I('expose() should be called only once per setup().'), n != null)) {
        let s = typeof n;
        (s === 'object' && (K(n) ? (s = 'array') : ge(n) && (s = 'ref')),
          s !== 'object' && I(`expose() should be passed a plain object, received ${s}.`));
      }
      e.exposed = n || {};
    };
    {
      let n, s;
      return Object.freeze({
        get attrs() {
          return n || (n = new Proxy(e.attrs, cp));
        },
        get slots() {
          return s || (s = fp(e));
        },
        get emit() {
          return (i, ...r) => e.emit(i, ...r);
        },
        expose: t
      });
    }
  }
  function si(e) {
    return e.exposed
      ? e.exposeProxy ||
          (e.exposeProxy = new Proxy(Fo(Mt(e.exposed)), {
            get(t, n) {
              if (n in t) return t[n];
              if (n in on) return on[n](e);
            },
            has(t, n) {
              return n in t || n in on;
            }
          }))
      : e.proxy;
  }
  const pp = /(?:^|[-_])(\w)/g,
    hp = (e) => e.replace(pp, (t) => t.toUpperCase()).replace(/[-_]/g, '');
  function hr(e, t = !0) {
    return G(e) ? e.displayName || e.name : e.name || (t && e.__name);
  }
  function ii(e, t, n = !1) {
    let s = hr(t);
    if (!s && t.__file) {
      const i = t.__file.match(/([^/\\]+)\.\w+$/);
      i && (s = i[1]);
    }
    if (!s && e && e.parent) {
      const i = (r) => {
        for (const o in r) if (r[o] === t) return o;
      };
      s = i(e.components || e.parent.type.components) || i(e.appContext.components);
    }
    return s ? hp(s) : n ? 'App' : 'Anonymous';
  }
  function Zl(e) {
    return G(e) && '__vccOpts' in e;
  }
  const L = (e, t) => {
    const n = kf(e, t, cs);
    {
      const s = ti();
      s && s.appContext.config.warnRecursiveComputed && (n._warnRecursive = !0);
    }
    return n;
  };
  function mp(e, t, n) {
    const s = arguments.length;
    return s === 2
      ? ue(t) && !K(t)
        ? un(t)
          ? D(e, null, [t])
          : D(e, t)
        : D(e, null, t)
      : (s > 3 ? (n = Array.prototype.slice.call(arguments, 2)) : s === 3 && un(n) && (n = [n]),
        D(e, t, n));
  }
  function gp() {
    if (typeof window > 'u') return;
    const e = { style: 'color:#3ba776' },
      t = { style: 'color:#1677ff' },
      n = { style: 'color:#f5222d' },
      s = { style: 'color:#eb2f96' },
      i = {
        __vue_custom_formatter: !0,
        header(u) {
          return ue(u)
            ? u.__isVue
              ? ['div', e, 'VueInstance']
              : ge(u)
                ? ['div', {}, ['span', e, c(u)], '<', l('_value' in u ? u._value : u), '>']
                : pt(u)
                  ? [
                      'div',
                      {},
                      ['span', e, Ve(u) ? 'ShallowReactive' : 'Reactive'],
                      '<',
                      l(u),
                      `>${$t(u) ? ' (readonly)' : ''}`
                    ]
                  : $t(u)
                    ? [
                        'div',
                        {},
                        ['span', e, Ve(u) ? 'ShallowReadonly' : 'Readonly'],
                        '<',
                        l(u),
                        '>'
                      ]
                    : null
            : null;
        },
        hasBody(u) {
          return u && u.__isVue;
        },
        body(u) {
          if (u && u.__isVue) return ['div', {}, ...r(u.$)];
        }
      };
    function r(u) {
      const d = [];
      (u.type.props && u.props && d.push(o('props', J(u.props))),
        u.setupState !== ie && d.push(o('setup', u.setupState)),
        u.data !== ie && d.push(o('data', J(u.data))));
      const p = a(u, 'computed');
      p && d.push(o('computed', p));
      const h = a(u, 'inject');
      return (
        h && d.push(o('injected', h)),
        d.push([
          'div',
          {},
          ['span', { style: s.style + ';opacity:0.66' }, '$ (internal): '],
          ['object', { object: u }]
        ]),
        d
      );
    }
    function o(u, d) {
      return (
        (d = ye({}, d)),
        Object.keys(d).length
          ? [
              'div',
              { style: 'line-height:1.25em;margin-bottom:0.6em' },
              ['div', { style: 'color:#476582' }, u],
              [
                'div',
                { style: 'padding-left:1.25em' },
                ...Object.keys(d).map((p) => ['div', {}, ['span', s, p + ': '], l(d[p], !1)])
              ]
            ]
          : ['span', {}]
      );
    }
    function l(u, d = !0) {
      return typeof u == 'number'
        ? ['span', t, u]
        : typeof u == 'string'
          ? ['span', n, JSON.stringify(u)]
          : typeof u == 'boolean'
            ? ['span', s, u]
            : ue(u)
              ? ['object', { object: d ? J(u) : u }]
              : ['span', n, String(u)];
    }
    function a(u, d) {
      const p = u.type;
      if (G(p)) return;
      const h = {};
      for (const q in u.ctx) f(p, q, d) && (h[q] = u.ctx[q]);
      return h;
    }
    function f(u, d, p) {
      const h = u[p];
      if (
        (K(h) && h.includes(d)) ||
        (ue(h) && d in h) ||
        (u.extends && f(u.extends, d, p)) ||
        (u.mixins && u.mixins.some((q) => f(q, d, p)))
      )
        return !0;
    }
    function c(u) {
      return Ve(u) ? 'ShallowRef' : u.effect ? 'ComputedRef' : 'Ref';
    }
    window.devtoolsFormatters
      ? window.devtoolsFormatters.push(i)
      : (window.devtoolsFormatters = [i]);
  }
  const Jl = '3.5.13',
    vt = I;
  let mr;
  const Xl = typeof window < 'u' && window.trustedTypes;
  if (Xl)
    try {
      mr = Xl.createPolicy('vue', { createHTML: (e) => e });
    } catch (e) {
      vt(`Error creating trusted types policy: ${e}`);
    }
  const ea = mr ? (e) => mr.createHTML(e) : (e) => e,
    _p = 'http://www.w3.org/2000/svg',
    qp = 'http://www.w3.org/1998/Math/MathML',
    Dt = typeof document < 'u' ? document : null,
    ta = Dt && Dt.createElement('template'),
    vp = {
      insert: (e, t, n) => {
        t.insertBefore(e, n || null);
      },
      remove: (e) => {
        const t = e.parentNode;
        t && t.removeChild(e);
      },
      createElement: (e, t, n, s) => {
        const i =
          t === 'svg'
            ? Dt.createElementNS(_p, e)
            : t === 'mathml'
              ? Dt.createElementNS(qp, e)
              : n
                ? Dt.createElement(e, { is: n })
                : Dt.createElement(e);
        return (
          e === 'select' && s && s.multiple != null && i.setAttribute('multiple', s.multiple),
          i
        );
      },
      createText: (e) => Dt.createTextNode(e),
      createComment: (e) => Dt.createComment(e),
      setText: (e, t) => {
        e.nodeValue = t;
      },
      setElementText: (e, t) => {
        e.textContent = t;
      },
      parentNode: (e) => e.parentNode,
      nextSibling: (e) => e.nextSibling,
      querySelector: (e) => Dt.querySelector(e),
      setScopeId(e, t) {
        e.setAttribute(t, '');
      },
      insertStaticContent(e, t, n, s, i, r) {
        const o = n ? n.previousSibling : t.lastChild;
        if (i && (i === r || i.nextSibling))
          for (; t.insertBefore(i.cloneNode(!0), n), !(i === r || !(i = i.nextSibling)); );
        else {
          ta.innerHTML = ea(
            s === 'svg' ? `<svg>${e}</svg>` : s === 'mathml' ? `<math>${e}</math>` : e
          );
          const l = ta.content;
          if (s === 'svg' || s === 'mathml') {
            const a = l.firstChild;
            for (; a.firstChild; ) l.appendChild(a.firstChild);
            l.removeChild(a);
          }
          t.insertBefore(l, n);
        }
        return [o ? o.nextSibling : t.firstChild, n ? n.previousSibling : t.lastChild];
      }
    },
    Ht = 'transition',
    fs = 'animation',
    On = Symbol('_vtc'),
    na = {
      name: String,
      type: String,
      css: { type: Boolean, default: !0 },
      duration: [String, Number, Object],
      enterFromClass: String,
      enterActiveClass: String,
      enterToClass: String,
      appearFromClass: String,
      appearActiveClass: String,
      appearToClass: String,
      leaveFromClass: String,
      leaveActiveClass: String,
      leaveToClass: String
    },
    sa = ye({}, Xo, na),
    ri = ((e) => ((e.displayName = 'Transition'), (e.props = sa), e))((e, { slots: t }) =>
      mp(Zf, ra(e), t)
    ),
    fn = (e, t = []) => {
      K(e) ? e.forEach((n) => n(...t)) : e && e(...t);
    },
    ia = (e) => (e ? (K(e) ? e.some((t) => t.length > 1) : e.length > 1) : !1);
  function ra(e) {
    const t = {};
    for (const E in e) E in na || (t[E] = e[E]);
    if (e.css === !1) return t;
    const {
        name: n = 'v',
        type: s,
        duration: i,
        enterFromClass: r = `${n}-enter-from`,
        enterActiveClass: o = `${n}-enter-active`,
        enterToClass: l = `${n}-enter-to`,
        appearFromClass: a = r,
        appearActiveClass: f = o,
        appearToClass: c = l,
        leaveFromClass: u = `${n}-leave-from`,
        leaveActiveClass: d = `${n}-leave-active`,
        leaveToClass: p = `${n}-leave-to`
      } = e,
      h = yp(i),
      q = h && h[0],
      v = h && h[1],
      {
        onBeforeEnter: y,
        onEnter: z,
        onEnterCancelled: O,
        onLeave: X,
        onLeaveCancelled: N,
        onBeforeAppear: ne = y,
        onAppear: H = z,
        onAppearCancelled: fe = O
      } = t,
      U = (E, Y, de, xe) => {
        ((E._enterCancelled = xe), Kt(E, Y ? c : l), Kt(E, Y ? f : o), de && de());
      },
      w = (E, Y) => {
        ((E._isLeaving = !1), Kt(E, u), Kt(E, p), Kt(E, d), Y && Y());
      },
      x = (E) => (Y, de) => {
        const xe = E ? H : z,
          pe = () => U(Y, E, de);
        (fn(xe, [Y, pe]),
          oa(() => {
            (Kt(Y, E ? a : r), yt(Y, E ? c : l), ia(xe) || la(Y, s, q, pe));
          }));
      };
    return ye(t, {
      onBeforeEnter(E) {
        (fn(y, [E]), yt(E, r), yt(E, o));
      },
      onBeforeAppear(E) {
        (fn(ne, [E]), yt(E, a), yt(E, f));
      },
      onEnter: x(!1),
      onAppear: x(!0),
      onLeave(E, Y) {
        E._isLeaving = !0;
        const de = () => w(E, Y);
        (yt(E, u),
          E._enterCancelled ? (yt(E, d), _r()) : (_r(), yt(E, d)),
          oa(() => {
            E._isLeaving && (Kt(E, u), yt(E, p), ia(X) || la(E, s, v, de));
          }),
          fn(X, [E, de]));
      },
      onEnterCancelled(E) {
        (U(E, !1, void 0, !0), fn(O, [E]));
      },
      onAppearCancelled(E) {
        (U(E, !0, void 0, !0), fn(fe, [E]));
      },
      onLeaveCancelled(E) {
        (w(E), fn(N, [E]));
      }
    });
  }
  function yp(e) {
    if (e == null) return null;
    if (ue(e)) return [gr(e.enter), gr(e.leave)];
    {
      const t = gr(e);
      return [t, t];
    }
  }
  function gr(e) {
    const t = Rc(e);
    return (Bf(t, '<transition> explicit duration'), t);
  }
  function yt(e, t) {
    (t.split(/\s+/).forEach((n) => n && e.classList.add(n)), (e[On] || (e[On] = new Set())).add(t));
  }
  function Kt(e, t) {
    t.split(/\s+/).forEach((s) => s && e.classList.remove(s));
    const n = e[On];
    n && (n.delete(t), n.size || (e[On] = void 0));
  }
  function oa(e) {
    requestAnimationFrame(() => {
      requestAnimationFrame(e);
    });
  }
  let bp = 0;
  function la(e, t, n, s) {
    const i = (e._endId = ++bp),
      r = () => {
        i === e._endId && s();
      };
    if (n != null) return setTimeout(r, n);
    const { type: o, timeout: l, propCount: a } = aa(e, t);
    if (!o) return s();
    const f = o + 'end';
    let c = 0;
    const u = () => {
        (e.removeEventListener(f, d), r());
      },
      d = (p) => {
        p.target === e && ++c >= a && u();
      };
    (setTimeout(() => {
      c < a && u();
    }, l + 1),
      e.addEventListener(f, d));
  }
  function aa(e, t) {
    const n = window.getComputedStyle(e),
      s = (h) => (n[h] || '').split(', '),
      i = s(`${Ht}Delay`),
      r = s(`${Ht}Duration`),
      o = ua(i, r),
      l = s(`${fs}Delay`),
      a = s(`${fs}Duration`),
      f = ua(l, a);
    let c = null,
      u = 0,
      d = 0;
    t === Ht
      ? o > 0 && ((c = Ht), (u = o), (d = r.length))
      : t === fs
        ? f > 0 && ((c = fs), (u = f), (d = a.length))
        : ((u = Math.max(o, f)),
          (c = u > 0 ? (o > f ? Ht : fs) : null),
          (d = c ? (c === Ht ? r.length : a.length) : 0));
    const p = c === Ht && /\b(transform|all)(,|$)/.test(s(`${Ht}Property`).toString());
    return { type: c, timeout: u, propCount: d, hasTransform: p };
  }
  function ua(e, t) {
    for (; e.length < t.length; ) e = e.concat(e);
    return Math.max(...t.map((n, s) => ca(n) + ca(e[s])));
  }
  function ca(e) {
    return e === 'auto' ? 0 : Number(e.slice(0, -1).replace(',', '.')) * 1e3;
  }
  function _r() {
    return document.body.offsetHeight;
  }
  function wp(e, t, n) {
    const s = e[On];
    (s && (t = (t ? [t, ...s] : [...s]).join(' ')),
      t == null ? e.removeAttribute('class') : n ? e.setAttribute('class', t) : (e.className = t));
  }
  const fa = Symbol('_vod'),
    xp = Symbol('_vsh'),
    Ep = Symbol('CSS_VAR_TEXT'),
    Sp = /(^|;)\s*display\s*:/;
  function kp(e, t, n) {
    const s = e.style,
      i = ve(n);
    let r = !1;
    if (n && !i) {
      if (t)
        if (ve(t))
          for (const o of t.split(';')) {
            const l = o.slice(0, o.indexOf(':')).trim();
            n[l] == null && oi(s, l, '');
          }
        else for (const o in t) n[o] == null && oi(s, o, '');
      for (const o in n) (o === 'display' && (r = !0), oi(s, o, n[o]));
    } else if (i) {
      if (t !== n) {
        const o = s[Ep];
        (o && (n += ';' + o), (s.cssText = n), (r = Sp.test(n)));
      }
    } else t && e.removeAttribute('style');
    fa in e && ((e[fa] = r ? s.display : ''), e[xp] && (s.display = 'none'));
  }
  const Cp = /[^\\];\s*$/,
    da = /\s*!important$/;
  function oi(e, t, n) {
    if (K(n)) n.forEach((s) => oi(e, t, s));
    else if (
      (n == null && (n = ''),
      Cp.test(n) && vt(`Unexpected semicolon at the end of '${t}' style value: '${n}'`),
      t.startsWith('--'))
    )
      e.setProperty(t, n);
    else {
      const s = Ap(e, t);
      da.test(n) ? e.setProperty(At(s), n.replace(da, ''), 'important') : (e[s] = n);
    }
  }
  const pa = ['Webkit', 'Moz', 'ms'],
    qr = {};
  function Ap(e, t) {
    const n = qr[t];
    if (n) return n;
    let s = Me(t);
    if (s !== 'filter' && s in e) return (qr[t] = s);
    s = Zt(s);
    for (let i = 0; i < pa.length; i++) {
      const r = pa[i] + s;
      if (r in e) return (qr[t] = r);
    }
    return t;
  }
  const ha = 'http://www.w3.org/1999/xlink';
  function ma(e, t, n, s, i, r = Yc(t)) {
    s && t.startsWith('xlink:')
      ? n == null
        ? e.removeAttributeNS(ha, t.slice(6, t.length))
        : e.setAttributeNS(ha, t, n)
      : n == null || (r && !lo(n))
        ? e.removeAttribute(t)
        : e.setAttribute(t, r ? '' : Ct(n) ? String(n) : n);
  }
  function ga(e, t, n, s, i) {
    if (t === 'innerHTML' || t === 'textContent') {
      n != null && (e[t] = t === 'innerHTML' ? ea(n) : n);
      return;
    }
    const r = e.tagName;
    if (t === 'value' && r !== 'PROGRESS' && !r.includes('-')) {
      const l = r === 'OPTION' ? e.getAttribute('value') || '' : e.value,
        a = n == null ? (e.type === 'checkbox' ? 'on' : '') : String(n);
      ((l !== a || !('_value' in e)) && (e.value = a),
        n == null && e.removeAttribute(t),
        (e._value = n));
      return;
    }
    let o = !1;
    if (n === '' || n == null) {
      const l = typeof e[t];
      l === 'boolean'
        ? (n = lo(n))
        : n == null && l === 'string'
          ? ((n = ''), (o = !0))
          : l === 'number' && ((n = 0), (o = !0));
    }
    try {
      e[t] = n;
    } catch (l) {
      o || vt(`Failed setting prop "${t}" on <${r.toLowerCase()}>: value ${n} is invalid.`, l);
    }
    o && e.removeAttribute(i || t);
  }
  function In(e, t, n, s) {
    e.addEventListener(t, n, s);
  }
  function Tp(e, t, n, s) {
    e.removeEventListener(t, n, s);
  }
  const _a = Symbol('_vei');
  function Op(e, t, n, s, i = null) {
    const r = e[_a] || (e[_a] = {}),
      o = r[t];
    if (s && o) o.value = va(s, t);
    else {
      const [l, a] = Ip(t);
      if (s) {
        const f = (r[t] = Fp(va(s, t), i));
        In(e, l, f, a);
      } else o && (Tp(e, l, o, a), (r[t] = void 0));
    }
  }
  const qa = /(?:Once|Passive|Capture)$/;
  function Ip(e) {
    let t;
    if (qa.test(e)) {
      t = {};
      let s;
      for (; (s = e.match(qa)); )
        ((e = e.slice(0, e.length - s[0].length)), (t[s[0].toLowerCase()] = !0));
    }
    return [e[2] === ':' ? e.slice(3) : At(e.slice(2)), t];
  }
  let vr = 0;
  const $p = Promise.resolve(),
    Bp = () => vr || ($p.then(() => (vr = 0)), (vr = Date.now()));
  function Fp(e, t) {
    const n = (s) => {
      if (!s._vts) s._vts = Date.now();
      else if (s._vts <= n.attached) return;
      ot(Dp(s, n.value), t, 5, [s]);
    };
    return ((n.value = e), (n.attached = Bp()), n);
  }
  function va(e, t) {
    return G(e) || K(e)
      ? e
      : (vt(`Wrong type passed as event handler to ${t} - did you forget @ or : in front of your prop?
Expected function or array of functions, received type ${typeof e}.`),
        Fe);
  }
  function Dp(e, t) {
    if (K(t)) {
      const n = e.stopImmediatePropagation;
      return (
        (e.stopImmediatePropagation = () => {
          (n.call(e), (e._stopped = !0));
        }),
        t.map((s) => (i) => !i._stopped && s && s(i))
      );
    } else return t;
  }
  const ya = (e) =>
      e.charCodeAt(0) === 111 &&
      e.charCodeAt(1) === 110 &&
      e.charCodeAt(2) > 96 &&
      e.charCodeAt(2) < 123,
    zp = (e, t, n, s, i, r) => {
      const o = i === 'svg';
      t === 'class'
        ? wp(e, s, o)
        : t === 'style'
          ? kp(e, n, s)
          : jn(t)
            ? ks(t) || Op(e, t, n, s, r)
            : (
                  t[0] === '.'
                    ? ((t = t.slice(1)), !0)
                    : t[0] === '^'
                      ? ((t = t.slice(1)), !1)
                      : Pp(e, t, s, o)
                )
              ? (ga(e, t, s),
                !e.tagName.includes('-') &&
                  (t === 'value' || t === 'checked' || t === 'selected') &&
                  ma(e, t, s, o, r, t !== 'value'))
              : e._isVueCE && (/[A-Z]/.test(t) || !ve(s))
                ? ga(e, Me(t), s, r, t)
                : (t === 'true-value'
                    ? (e._trueValue = s)
                    : t === 'false-value' && (e._falseValue = s),
                  ma(e, t, s, o));
    };
  function Pp(e, t, n, s) {
    if (s) return !!(t === 'innerHTML' || t === 'textContent' || (t in e && ya(t) && G(n)));
    if (
      t === 'spellcheck' ||
      t === 'draggable' ||
      t === 'translate' ||
      t === 'form' ||
      (t === 'list' && e.tagName === 'INPUT') ||
      (t === 'type' && e.tagName === 'TEXTAREA')
    )
      return !1;
    if (t === 'width' || t === 'height') {
      const i = e.tagName;
      if (i === 'IMG' || i === 'VIDEO' || i === 'CANVAS' || i === 'SOURCE') return !1;
    }
    return ya(t) && ve(n) ? !1 : t in e;
  }
  const ba = new WeakMap(),
    wa = new WeakMap(),
    li = Symbol('_moveCb'),
    xa = Symbol('_enterCb'),
    Mp = ((e) => (delete e.props.mode, e))({
      name: 'TransitionGroup',
      props: ye({}, sa, { tag: String, moveClass: String }),
      setup(e, { slots: t }) {
        const n = ti(),
          s = Jo();
        let i, r;
        return (
          ol(() => {
            if (!i.length) return;
            const o = e.moveClass || `${e.name || 'v'}-move`;
            if (!jp(i[0].el, n.vnode.el, o)) return;
            (i.forEach(Rp), i.forEach(Vp));
            const l = i.filter(Np);
            (_r(),
              l.forEach((a) => {
                const f = a.el,
                  c = f.style;
                (yt(f, o), (c.transform = c.webkitTransform = c.transitionDuration = ''));
                const u = (f[li] = (d) => {
                  (d && d.target !== f) ||
                    ((!d || /transform$/.test(d.propertyName)) &&
                      (f.removeEventListener('transitionend', u), (f[li] = null), Kt(f, o)));
                });
                f.addEventListener('transitionend', u);
              }));
          }),
          () => {
            const o = J(e),
              l = ra(o);
            let a = o.tag || be;
            if (((i = []), r))
              for (let f = 0; f < r.length; f++) {
                const c = r[f];
                c.el &&
                  c.el instanceof Element &&
                  (i.push(c), rn(c, ts(c, l, s, n)), ba.set(c, c.el.getBoundingClientRect()));
              }
            r = t.default ? Ji(t.default()) : [];
            for (let f = 0; f < r.length; f++) {
              const c = r[f];
              c.key != null
                ? rn(c, ts(c, l, s, n))
                : c.type !== An && vt('<TransitionGroup> children must be keyed.');
            }
            return D(a, null, r);
          }
        );
      }
    });
  function Rp(e) {
    const t = e.el;
    (t[li] && t[li](), t[xa] && t[xa]());
  }
  function Vp(e) {
    wa.set(e, e.el.getBoundingClientRect());
  }
  function Np(e) {
    const t = ba.get(e),
      n = wa.get(e),
      s = t.left - n.left,
      i = t.top - n.top;
    if (s || i) {
      const r = e.el.style;
      return (
        (r.transform = r.webkitTransform = `translate(${s}px,${i}px)`),
        (r.transitionDuration = '0s'),
        e
      );
    }
  }
  function jp(e, t, n) {
    const s = e.cloneNode(),
      i = e[On];
    (i &&
      i.forEach((l) => {
        l.split(/\s+/).forEach((a) => a && s.classList.remove(a));
      }),
      n.split(/\s+/).forEach((l) => l && s.classList.add(l)),
      (s.style.display = 'none'));
    const r = t.nodeType === 1 ? t : t.parentNode;
    r.appendChild(s);
    const { hasTransform: o } = aa(s);
    return (r.removeChild(s), o);
  }
  const Ea = (e) => {
    const t = e.props['onUpdate:modelValue'] || !1;
    return K(t) ? (n) => vn(t, n) : t;
  };
  function Lp(e) {
    e.target.composing = !0;
  }
  function Sa(e) {
    const t = e.target;
    t.composing && ((t.composing = !1), t.dispatchEvent(new Event('input')));
  }
  const yr = Symbol('_assign'),
    $n = {
      created(e, { modifiers: { lazy: t, trim: n, number: s } }, i) {
        e[yr] = Ea(i);
        const r = s || (i.props && i.props.type === 'number');
        (In(e, t ? 'change' : 'input', (o) => {
          if (o.target.composing) return;
          let l = e.value;
          (n && (l = l.trim()), r && (l = Oi(l)), e[yr](l));
        }),
          n &&
            In(e, 'change', () => {
              e.value = e.value.trim();
            }),
          t || (In(e, 'compositionstart', Lp), In(e, 'compositionend', Sa), In(e, 'change', Sa)));
      },
      mounted(e, { value: t }) {
        e.value = t ?? '';
      },
      beforeUpdate(e, { value: t, oldValue: n, modifiers: { lazy: s, trim: i, number: r } }, o) {
        if (((e[yr] = Ea(o)), e.composing)) return;
        const l = (r || e.type === 'number') && !/^0\d/.test(e.value) ? Oi(e.value) : e.value,
          a = t ?? '';
        l !== a &&
          ((document.activeElement === e &&
            e.type !== 'range' &&
            ((s && t === n) || (i && e.value.trim() === a))) ||
            (e.value = a));
      }
    },
    Up = ['ctrl', 'shift', 'alt', 'meta'],
    Qp = {
      stop: (e) => e.stopPropagation(),
      prevent: (e) => e.preventDefault(),
      self: (e) => e.target !== e.currentTarget,
      ctrl: (e) => !e.ctrlKey,
      shift: (e) => !e.shiftKey,
      alt: (e) => !e.altKey,
      meta: (e) => !e.metaKey,
      left: (e) => 'button' in e && e.button !== 0,
      middle: (e) => 'button' in e && e.button !== 1,
      right: (e) => 'button' in e && e.button !== 2,
      exact: (e, t) => Up.some((n) => e[`${n}Key`] && !t.includes(n))
    },
    ka = (e, t) => {
      const n = e._withMods || (e._withMods = {}),
        s = t.join('.');
      return (
        n[s] ||
        (n[s] = (i, ...r) => {
          for (let o = 0; o < t.length; o++) {
            const l = Qp[t[o]];
            if (l && l(i, t)) return;
          }
          return e(i, ...r);
        })
      );
    },
    Hp = {
      esc: 'escape',
      space: ' ',
      up: 'arrow-up',
      left: 'arrow-left',
      right: 'arrow-right',
      down: 'arrow-down',
      delete: 'backspace'
    },
    Ca = (e, t) => {
      const n = e._withKeys || (e._withKeys = {}),
        s = t.join('.');
      return (
        n[s] ||
        (n[s] = (i) => {
          if (!('key' in i)) return;
          const r = At(i.key);
          if (t.some((o) => o === r || Hp[o] === r)) return e(i);
        })
      );
    },
    Kp = ye({ patchProp: zp }, vp);
  let Aa;
  function Wp() {
    return Aa || (Aa = Md(Kp));
  }
  const Gp = (...e) => {
    const t = Wp().createApp(...e);
    (Zp(t), Jp(t));
    const { mount: n } = t;
    return (
      (t.mount = (s) => {
        const i = Xp(s);
        if (!i) return;
        const r = t._component;
        (!G(r) && !r.render && !r.template && (r.template = i.innerHTML),
          i.nodeType === 1 && (i.textContent = ''));
        const o = n(i, !1, Yp(i));
        return (
          i instanceof Element && (i.removeAttribute('v-cloak'), i.setAttribute('data-v-app', '')),
          o
        );
      }),
      t
    );
  };
  function Yp(e) {
    if (e instanceof SVGElement) return 'svg';
    if (typeof MathMLElement == 'function' && e instanceof MathMLElement) return 'mathml';
  }
  function Zp(e) {
    Object.defineProperty(e.config, 'isNativeTag', {
      value: (t) => Kc(t) || Wc(t) || Gc(t),
      writable: !1
    });
  }
  function Jp(e) {
    {
      const t = e.config.isCustomElement;
      Object.defineProperty(e.config, 'isCustomElement', {
        get() {
          return t;
        },
        set() {
          vt(
            'The `isCustomElement` config option is deprecated. Use `compilerOptions.isCustomElement` instead.'
          );
        }
      });
      const n = e.config.compilerOptions,
        s =
          'The `compilerOptions` config option is only respected when using a build of Vue.js that includes the runtime compiler (aka "full build"). Since you are using the runtime-only build, `compilerOptions` must be passed to `@vue/compiler-dom` in the build setup instead.\n- For vue-loader: pass it via vue-loader\'s `compilerOptions` loader option.\n- For vue-cli: see https://cli.vuejs.org/guide/webpack.html#modifying-options-of-a-loader\n- For vite: pass it via @vitejs/plugin-vue options. See https://github.com/vitejs/vite-plugin-vue/tree/main/packages/plugin-vue#example-for-passing-options-to-vuecompiler-sfc';
      Object.defineProperty(e.config, 'compilerOptions', {
        get() {
          return (vt(s), n);
        },
        set() {
          vt(s);
        }
      });
    }
  }
  function Xp(e) {
    if (ve(e)) {
      const t = document.querySelector(e);
      return (t || vt(`Failed to mount app: mount target selector "${e}" returned null.`), t);
    }
    return (
      window.ShadowRoot &&
        e instanceof window.ShadowRoot &&
        e.mode === 'closed' &&
        vt('mounting on a ShadowRoot with `{mode: "closed"}` may lead to unpredictable bugs'),
      e
    );
  }
  function eh() {
    gp();
  }
  eh();
  var th = Object.create,
    Ta = Object.defineProperty,
    nh = Object.getOwnPropertyDescriptor,
    br = Object.getOwnPropertyNames,
    sh = Object.getPrototypeOf,
    ih = Object.prototype.hasOwnProperty,
    rh = (e, t) =>
      function () {
        return (e && (t = (0, e[br(e)[0]])((e = 0))), t);
      },
    oh = (e, t) =>
      function () {
        return (t || (0, e[br(e)[0]])((t = { exports: {} }).exports, t), t.exports);
      },
    lh = (e, t, n, s) => {
      if ((t && typeof t == 'object') || typeof t == 'function')
        for (let i of br(t))
          !ih.call(e, i) &&
            i !== n &&
            Ta(e, i, { get: () => t[i], enumerable: !(s = nh(t, i)) || s.enumerable });
      return e;
    },
    ah = (e, t, n) => (
      (n = e != null ? th(sh(e)) : {}),
      lh(Ta(n, 'default', { value: e, enumerable: !0 }), e)
    ),
    ds = rh({
      '../../node_modules/.pnpm/tsup@8.4.0_@microsoft+api-extractor@7.51.1_@types+node@22.13.14__jiti@2.4.2_postcss@8.5_96eb05a9d65343021e53791dd83f3773/node_modules/tsup/assets/esm_shims.js'() {}
    }),
    uh = oh({
      '../../node_modules/.pnpm/rfdc@1.4.1/node_modules/rfdc/index.js'(e, t) {
        (ds(), (t.exports = s));
        function n(r) {
          return r instanceof Buffer
            ? Buffer.from(r)
            : new r.constructor(r.buffer.slice(), r.byteOffset, r.length);
        }
        function s(r) {
          if (((r = r || {}), r.circles)) return i(r);
          const o = new Map();
          if (
            (o.set(Date, (u) => new Date(u)),
            o.set(Map, (u, d) => new Map(a(Array.from(u), d))),
            o.set(Set, (u, d) => new Set(a(Array.from(u), d))),
            r.constructorHandlers)
          )
            for (const u of r.constructorHandlers) o.set(u[0], u[1]);
          let l = null;
          return r.proto ? c : f;
          function a(u, d) {
            const p = Object.keys(u),
              h = new Array(p.length);
            for (let q = 0; q < p.length; q++) {
              const v = p[q],
                y = u[v];
              typeof y != 'object' || y === null
                ? (h[v] = y)
                : y.constructor !== Object && (l = o.get(y.constructor))
                  ? (h[v] = l(y, d))
                  : ArrayBuffer.isView(y)
                    ? (h[v] = n(y))
                    : (h[v] = d(y));
            }
            return h;
          }
          function f(u) {
            if (typeof u != 'object' || u === null) return u;
            if (Array.isArray(u)) return a(u, f);
            if (u.constructor !== Object && (l = o.get(u.constructor))) return l(u, f);
            const d = {};
            for (const p in u) {
              if (Object.hasOwnProperty.call(u, p) === !1) continue;
              const h = u[p];
              typeof h != 'object' || h === null
                ? (d[p] = h)
                : h.constructor !== Object && (l = o.get(h.constructor))
                  ? (d[p] = l(h, f))
                  : ArrayBuffer.isView(h)
                    ? (d[p] = n(h))
                    : (d[p] = f(h));
            }
            return d;
          }
          function c(u) {
            if (typeof u != 'object' || u === null) return u;
            if (Array.isArray(u)) return a(u, c);
            if (u.constructor !== Object && (l = o.get(u.constructor))) return l(u, c);
            const d = {};
            for (const p in u) {
              const h = u[p];
              typeof h != 'object' || h === null
                ? (d[p] = h)
                : h.constructor !== Object && (l = o.get(h.constructor))
                  ? (d[p] = l(h, c))
                  : ArrayBuffer.isView(h)
                    ? (d[p] = n(h))
                    : (d[p] = c(h));
            }
            return d;
          }
        }
        function i(r) {
          const o = [],
            l = [],
            a = new Map();
          if (
            (a.set(Date, (p) => new Date(p)),
            a.set(Map, (p, h) => new Map(c(Array.from(p), h))),
            a.set(Set, (p, h) => new Set(c(Array.from(p), h))),
            r.constructorHandlers)
          )
            for (const p of r.constructorHandlers) a.set(p[0], p[1]);
          let f = null;
          return r.proto ? d : u;
          function c(p, h) {
            const q = Object.keys(p),
              v = new Array(q.length);
            for (let y = 0; y < q.length; y++) {
              const z = q[y],
                O = p[z];
              if (typeof O != 'object' || O === null) v[z] = O;
              else if (O.constructor !== Object && (f = a.get(O.constructor))) v[z] = f(O, h);
              else if (ArrayBuffer.isView(O)) v[z] = n(O);
              else {
                const X = o.indexOf(O);
                X !== -1 ? (v[z] = l[X]) : (v[z] = h(O));
              }
            }
            return v;
          }
          function u(p) {
            if (typeof p != 'object' || p === null) return p;
            if (Array.isArray(p)) return c(p, u);
            if (p.constructor !== Object && (f = a.get(p.constructor))) return f(p, u);
            const h = {};
            (o.push(p), l.push(h));
            for (const q in p) {
              if (Object.hasOwnProperty.call(p, q) === !1) continue;
              const v = p[q];
              if (typeof v != 'object' || v === null) h[q] = v;
              else if (v.constructor !== Object && (f = a.get(v.constructor))) h[q] = f(v, u);
              else if (ArrayBuffer.isView(v)) h[q] = n(v);
              else {
                const y = o.indexOf(v);
                y !== -1 ? (h[q] = l[y]) : (h[q] = u(v));
              }
            }
            return (o.pop(), l.pop(), h);
          }
          function d(p) {
            if (typeof p != 'object' || p === null) return p;
            if (Array.isArray(p)) return c(p, d);
            if (p.constructor !== Object && (f = a.get(p.constructor))) return f(p, d);
            const h = {};
            (o.push(p), l.push(h));
            for (const q in p) {
              const v = p[q];
              if (typeof v != 'object' || v === null) h[q] = v;
              else if (v.constructor !== Object && (f = a.get(v.constructor))) h[q] = f(v, d);
              else if (ArrayBuffer.isView(v)) h[q] = n(v);
              else {
                const y = o.indexOf(v);
                y !== -1 ? (h[q] = l[y]) : (h[q] = d(v));
              }
            }
            return (o.pop(), l.pop(), h);
          }
        }
      }
    });
  (ds(), ds(), ds());
  var Oa = typeof navigator < 'u',
    j =
      typeof window < 'u'
        ? window
        : typeof globalThis < 'u'
          ? globalThis
          : typeof global < 'u'
            ? global
            : {};
  (typeof j.chrome < 'u' && j.chrome.devtools, Oa && (j.self, j.top));
  var Ia;
  (typeof navigator < 'u' &&
    ((Ia = navigator.userAgent) == null || Ia.toLowerCase().includes('electron')),
    ds());
  var ch = ah(uh()),
    fh = /(?:^|[-_/])(\w)/g;
  function dh(e, t) {
    return t ? t.toUpperCase() : '';
  }
  function ph(e) {
    return e && `${e}`.replace(fh, dh);
  }
  function hh(e, t) {
    let n = e.replace(/^[a-z]:/i, '').replace(/\\/g, '/');
    n.endsWith(`index${t}`) && (n = n.replace(`/index${t}`, t));
    const s = n.lastIndexOf('/'),
      i = n.substring(s + 1);
    {
      const r = i.lastIndexOf(t);
      return i.substring(0, r);
    }
  }
  var $a = (0, ch.default)({ circles: !0 });
  const mh = { trailing: !0 };
  function Bn(e, t = 25, n = {}) {
    if (((n = { ...mh, ...n }), !Number.isFinite(t)))
      throw new TypeError('Expected `wait` to be a finite number');
    let s,
      i,
      r = [],
      o,
      l;
    const a = (f, c) => (
      (o = gh(e, f, c)),
      o.finally(() => {
        if (((o = null), n.trailing && l && !i)) {
          const u = a(f, l);
          return ((l = null), u);
        }
      }),
      o
    );
    return function (...f) {
      return o
        ? (n.trailing && (l = f), o)
        : new Promise((c) => {
            const u = !i && n.leading;
            (clearTimeout(i),
              (i = setTimeout(() => {
                i = null;
                const d = n.leading ? s : a(this, f);
                for (const p of r) p(d);
                r = [];
              }, t)),
              u ? ((s = a(this, f)), c(s)) : r.push(c));
          });
    };
  }
  async function gh(e, t, n) {
    return await e.apply(t, n);
  }
  function wr(e, t = {}, n) {
    for (const s in e) {
      const i = e[s],
        r = n ? `${n}:${s}` : s;
      typeof i == 'object' && i !== null ? wr(i, t, r) : typeof i == 'function' && (t[r] = i);
    }
    return t;
  }
  const _h = { run: (e) => e() },
    qh = () => _h,
    Ba = typeof console.createTask < 'u' ? console.createTask : qh;
  function vh(e, t) {
    const n = t.shift(),
      s = Ba(n);
    return e.reduce((i, r) => i.then(() => s.run(() => r(...t))), Promise.resolve());
  }
  function yh(e, t) {
    const n = t.shift(),
      s = Ba(n);
    return Promise.all(e.map((i) => s.run(() => i(...t))));
  }
  function xr(e, t) {
    for (const n of [...e]) n(t);
  }
  class bh {
    constructor() {
      ((this._hooks = {}),
        (this._before = void 0),
        (this._after = void 0),
        (this._deprecatedMessages = void 0),
        (this._deprecatedHooks = {}),
        (this.hook = this.hook.bind(this)),
        (this.callHook = this.callHook.bind(this)),
        (this.callHookWith = this.callHookWith.bind(this)));
    }
    hook(t, n, s = {}) {
      if (!t || typeof n != 'function') return () => {};
      const i = t;
      let r;
      for (; this._deprecatedHooks[t]; ) ((r = this._deprecatedHooks[t]), (t = r.to));
      if (r && !s.allowDeprecated) {
        let o = r.message;
        (o || (o = `${i} hook has been deprecated` + (r.to ? `, please use ${r.to}` : '')),
          this._deprecatedMessages || (this._deprecatedMessages = new Set()),
          this._deprecatedMessages.has(o) || (console.warn(o), this._deprecatedMessages.add(o)));
      }
      if (!n.name)
        try {
          Object.defineProperty(n, 'name', {
            get: () => '_' + t.replace(/\W+/g, '_') + '_hook_cb',
            configurable: !0
          });
        } catch {}
      return (
        (this._hooks[t] = this._hooks[t] || []),
        this._hooks[t].push(n),
        () => {
          n && (this.removeHook(t, n), (n = void 0));
        }
      );
    }
    hookOnce(t, n) {
      let s,
        i = (...r) => (typeof s == 'function' && s(), (s = void 0), (i = void 0), n(...r));
      return ((s = this.hook(t, i)), s);
    }
    removeHook(t, n) {
      if (this._hooks[t]) {
        const s = this._hooks[t].indexOf(n);
        (s !== -1 && this._hooks[t].splice(s, 1),
          this._hooks[t].length === 0 && delete this._hooks[t]);
      }
    }
    deprecateHook(t, n) {
      this._deprecatedHooks[t] = typeof n == 'string' ? { to: n } : n;
      const s = this._hooks[t] || [];
      delete this._hooks[t];
      for (const i of s) this.hook(t, i);
    }
    deprecateHooks(t) {
      Object.assign(this._deprecatedHooks, t);
      for (const n in t) this.deprecateHook(n, t[n]);
    }
    addHooks(t) {
      const n = wr(t),
        s = Object.keys(n).map((i) => this.hook(i, n[i]));
      return () => {
        for (const i of s.splice(0, s.length)) i();
      };
    }
    removeHooks(t) {
      const n = wr(t);
      for (const s in n) this.removeHook(s, n[s]);
    }
    removeAllHooks() {
      for (const t in this._hooks) delete this._hooks[t];
    }
    callHook(t, ...n) {
      return (n.unshift(t), this.callHookWith(vh, t, ...n));
    }
    callHookParallel(t, ...n) {
      return (n.unshift(t), this.callHookWith(yh, t, ...n));
    }
    callHookWith(t, n, ...s) {
      const i = this._before || this._after ? { name: n, args: s, context: {} } : void 0;
      this._before && xr(this._before, i);
      const r = t(n in this._hooks ? [...this._hooks[n]] : [], s);
      return r instanceof Promise
        ? r.finally(() => {
            this._after && i && xr(this._after, i);
          })
        : (this._after && i && xr(this._after, i), r);
    }
    beforeEach(t) {
      return (
        (this._before = this._before || []),
        this._before.push(t),
        () => {
          if (this._before !== void 0) {
            const n = this._before.indexOf(t);
            n !== -1 && this._before.splice(n, 1);
          }
        }
      );
    }
    afterEach(t) {
      return (
        (this._after = this._after || []),
        this._after.push(t),
        () => {
          if (this._after !== void 0) {
            const n = this._after.indexOf(t);
            n !== -1 && this._after.splice(n, 1);
          }
        }
      );
    }
  }
  function Fa() {
    return new bh();
  }
  var wh = Object.create,
    Da = Object.defineProperty,
    xh = Object.getOwnPropertyDescriptor,
    Er = Object.getOwnPropertyNames,
    Eh = Object.getPrototypeOf,
    Sh = Object.prototype.hasOwnProperty,
    kh = (e, t) =>
      function () {
        return (e && (t = (0, e[Er(e)[0]])((e = 0))), t);
      },
    za = (e, t) =>
      function () {
        return (t || (0, e[Er(e)[0]])((t = { exports: {} }).exports, t), t.exports);
      },
    Ch = (e, t, n, s) => {
      if ((t && typeof t == 'object') || typeof t == 'function')
        for (let i of Er(t))
          !Sh.call(e, i) &&
            i !== n &&
            Da(e, i, { get: () => t[i], enumerable: !(s = xh(t, i)) || s.enumerable });
      return e;
    },
    Ah = (e, t, n) => (
      (n = e != null ? wh(Eh(e)) : {}),
      Ch(Da(n, 'default', { value: e, enumerable: !0 }), e)
    ),
    S = kh({
      '../../node_modules/.pnpm/tsup@8.4.0_@microsoft+api-extractor@7.51.1_@types+node@22.13.14__jiti@2.4.2_postcss@8.5_96eb05a9d65343021e53791dd83f3773/node_modules/tsup/assets/esm_shims.js'() {}
    }),
    Th = za({
      '../../node_modules/.pnpm/speakingurl@14.0.1/node_modules/speakingurl/lib/speakingurl.js'(
        e,
        t
      ) {
        (S(),
          (function (n) {
            var s = {
                À: 'A',
                Á: 'A',
                Â: 'A',
                Ã: 'A',
                Ä: 'Ae',
                Å: 'A',
                Æ: 'AE',
                Ç: 'C',
                È: 'E',
                É: 'E',
                Ê: 'E',
                Ë: 'E',
                Ì: 'I',
                Í: 'I',
                Î: 'I',
                Ï: 'I',
                Ð: 'D',
                Ñ: 'N',
                Ò: 'O',
                Ó: 'O',
                Ô: 'O',
                Õ: 'O',
                Ö: 'Oe',
                Ő: 'O',
                Ø: 'O',
                Ù: 'U',
                Ú: 'U',
                Û: 'U',
                Ü: 'Ue',
                Ű: 'U',
                Ý: 'Y',
                Þ: 'TH',
                ß: 'ss',
                à: 'a',
                á: 'a',
                â: 'a',
                ã: 'a',
                ä: 'ae',
                å: 'a',
                æ: 'ae',
                ç: 'c',
                è: 'e',
                é: 'e',
                ê: 'e',
                ë: 'e',
                ì: 'i',
                í: 'i',
                î: 'i',
                ï: 'i',
                ð: 'd',
                ñ: 'n',
                ò: 'o',
                ó: 'o',
                ô: 'o',
                õ: 'o',
                ö: 'oe',
                ő: 'o',
                ø: 'o',
                ù: 'u',
                ú: 'u',
                û: 'u',
                ü: 'ue',
                ű: 'u',
                ý: 'y',
                þ: 'th',
                ÿ: 'y',
                ẞ: 'SS',
                ا: 'a',
                أ: 'a',
                إ: 'i',
                آ: 'aa',
                ؤ: 'u',
                ئ: 'e',
                ء: 'a',
                ب: 'b',
                ت: 't',
                ث: 'th',
                ج: 'j',
                ح: 'h',
                خ: 'kh',
                د: 'd',
                ذ: 'th',
                ر: 'r',
                ز: 'z',
                س: 's',
                ش: 'sh',
                ص: 's',
                ض: 'dh',
                ط: 't',
                ظ: 'z',
                ع: 'a',
                غ: 'gh',
                ف: 'f',
                ق: 'q',
                ك: 'k',
                ل: 'l',
                م: 'm',
                ن: 'n',
                ه: 'h',
                و: 'w',
                ي: 'y',
                ى: 'a',
                ة: 'h',
                ﻻ: 'la',
                ﻷ: 'laa',
                ﻹ: 'lai',
                ﻵ: 'laa',
                گ: 'g',
                چ: 'ch',
                پ: 'p',
                ژ: 'zh',
                ک: 'k',
                ی: 'y',
                'َ': 'a',
                'ً': 'an',
                'ِ': 'e',
                'ٍ': 'en',
                'ُ': 'u',
                'ٌ': 'on',
                'ْ': '',
                '٠': '0',
                '١': '1',
                '٢': '2',
                '٣': '3',
                '٤': '4',
                '٥': '5',
                '٦': '6',
                '٧': '7',
                '٨': '8',
                '٩': '9',
                '۰': '0',
                '۱': '1',
                '۲': '2',
                '۳': '3',
                '۴': '4',
                '۵': '5',
                '۶': '6',
                '۷': '7',
                '۸': '8',
                '۹': '9',
                က: 'k',
                ခ: 'kh',
                ဂ: 'g',
                ဃ: 'ga',
                င: 'ng',
                စ: 's',
                ဆ: 'sa',
                ဇ: 'z',
                စျ: 'za',
                ည: 'ny',
                ဋ: 't',
                ဌ: 'ta',
                ဍ: 'd',
                ဎ: 'da',
                ဏ: 'na',
                တ: 't',
                ထ: 'ta',
                ဒ: 'd',
                ဓ: 'da',
                န: 'n',
                ပ: 'p',
                ဖ: 'pa',
                ဗ: 'b',
                ဘ: 'ba',
                မ: 'm',
                ယ: 'y',
                ရ: 'ya',
                လ: 'l',
                ဝ: 'w',
                သ: 'th',
                ဟ: 'h',
                ဠ: 'la',
                အ: 'a',
                'ြ': 'y',
                'ျ': 'ya',
                'ွ': 'w',
                'ြွ': 'yw',
                'ျွ': 'ywa',
                'ှ': 'h',
                ဧ: 'e',
                '၏': '-e',
                ဣ: 'i',
                ဤ: '-i',
                ဉ: 'u',
                ဦ: '-u',
                ဩ: 'aw',
                သြော: 'aw',
                ဪ: 'aw',
                '၀': '0',
                '၁': '1',
                '၂': '2',
                '၃': '3',
                '၄': '4',
                '၅': '5',
                '၆': '6',
                '၇': '7',
                '၈': '8',
                '၉': '9',
                '္': '',
                '့': '',
                'း': '',
                č: 'c',
                ď: 'd',
                ě: 'e',
                ň: 'n',
                ř: 'r',
                š: 's',
                ť: 't',
                ů: 'u',
                ž: 'z',
                Č: 'C',
                Ď: 'D',
                Ě: 'E',
                Ň: 'N',
                Ř: 'R',
                Š: 'S',
                Ť: 'T',
                Ů: 'U',
                Ž: 'Z',
                ހ: 'h',
                ށ: 'sh',
                ނ: 'n',
                ރ: 'r',
                ބ: 'b',
                ޅ: 'lh',
                ކ: 'k',
                އ: 'a',
                ވ: 'v',
                މ: 'm',
                ފ: 'f',
                ދ: 'dh',
                ތ: 'th',
                ލ: 'l',
                ގ: 'g',
                ޏ: 'gn',
                ސ: 's',
                ޑ: 'd',
                ޒ: 'z',
                ޓ: 't',
                ޔ: 'y',
                ޕ: 'p',
                ޖ: 'j',
                ޗ: 'ch',
                ޘ: 'tt',
                ޙ: 'hh',
                ޚ: 'kh',
                ޛ: 'th',
                ޜ: 'z',
                ޝ: 'sh',
                ޞ: 's',
                ޟ: 'd',
                ޠ: 't',
                ޡ: 'z',
                ޢ: 'a',
                ޣ: 'gh',
                ޤ: 'q',
                ޥ: 'w',
                'ަ': 'a',
                'ާ': 'aa',
                'ި': 'i',
                'ީ': 'ee',
                'ު': 'u',
                'ޫ': 'oo',
                'ެ': 'e',
                'ޭ': 'ey',
                'ޮ': 'o',
                'ޯ': 'oa',
                'ް': '',
                ა: 'a',
                ბ: 'b',
                გ: 'g',
                დ: 'd',
                ე: 'e',
                ვ: 'v',
                ზ: 'z',
                თ: 't',
                ი: 'i',
                კ: 'k',
                ლ: 'l',
                მ: 'm',
                ნ: 'n',
                ო: 'o',
                პ: 'p',
                ჟ: 'zh',
                რ: 'r',
                ს: 's',
                ტ: 't',
                უ: 'u',
                ფ: 'p',
                ქ: 'k',
                ღ: 'gh',
                ყ: 'q',
                შ: 'sh',
                ჩ: 'ch',
                ც: 'ts',
                ძ: 'dz',
                წ: 'ts',
                ჭ: 'ch',
                ხ: 'kh',
                ჯ: 'j',
                ჰ: 'h',
                α: 'a',
                β: 'v',
                γ: 'g',
                δ: 'd',
                ε: 'e',
                ζ: 'z',
                η: 'i',
                θ: 'th',
                ι: 'i',
                κ: 'k',
                λ: 'l',
                μ: 'm',
                ν: 'n',
                ξ: 'ks',
                ο: 'o',
                π: 'p',
                ρ: 'r',
                σ: 's',
                τ: 't',
                υ: 'y',
                φ: 'f',
                χ: 'x',
                ψ: 'ps',
                ω: 'o',
                ά: 'a',
                έ: 'e',
                ί: 'i',
                ό: 'o',
                ύ: 'y',
                ή: 'i',
                ώ: 'o',
                ς: 's',
                ϊ: 'i',
                ΰ: 'y',
                ϋ: 'y',
                ΐ: 'i',
                Α: 'A',
                Β: 'B',
                Γ: 'G',
                Δ: 'D',
                Ε: 'E',
                Ζ: 'Z',
                Η: 'I',
                Θ: 'TH',
                Ι: 'I',
                Κ: 'K',
                Λ: 'L',
                Μ: 'M',
                Ν: 'N',
                Ξ: 'KS',
                Ο: 'O',
                Π: 'P',
                Ρ: 'R',
                Σ: 'S',
                Τ: 'T',
                Υ: 'Y',
                Φ: 'F',
                Χ: 'X',
                Ψ: 'PS',
                Ω: 'O',
                Ά: 'A',
                Έ: 'E',
                Ί: 'I',
                Ό: 'O',
                Ύ: 'Y',
                Ή: 'I',
                Ώ: 'O',
                Ϊ: 'I',
                Ϋ: 'Y',
                ā: 'a',
                ē: 'e',
                ģ: 'g',
                ī: 'i',
                ķ: 'k',
                ļ: 'l',
                ņ: 'n',
                ū: 'u',
                Ā: 'A',
                Ē: 'E',
                Ģ: 'G',
                Ī: 'I',
                Ķ: 'k',
                Ļ: 'L',
                Ņ: 'N',
                Ū: 'U',
                Ќ: 'Kj',
                ќ: 'kj',
                Љ: 'Lj',
                љ: 'lj',
                Њ: 'Nj',
                њ: 'nj',
                Тс: 'Ts',
                тс: 'ts',
                ą: 'a',
                ć: 'c',
                ę: 'e',
                ł: 'l',
                ń: 'n',
                ś: 's',
                ź: 'z',
                ż: 'z',
                Ą: 'A',
                Ć: 'C',
                Ę: 'E',
                Ł: 'L',
                Ń: 'N',
                Ś: 'S',
                Ź: 'Z',
                Ż: 'Z',
                Є: 'Ye',
                І: 'I',
                Ї: 'Yi',
                Ґ: 'G',
                є: 'ye',
                і: 'i',
                ї: 'yi',
                ґ: 'g',
                ă: 'a',
                Ă: 'A',
                ș: 's',
                Ș: 'S',
                ț: 't',
                Ț: 'T',
                ţ: 't',
                Ţ: 'T',
                а: 'a',
                б: 'b',
                в: 'v',
                г: 'g',
                д: 'd',
                е: 'e',
                ё: 'yo',
                ж: 'zh',
                з: 'z',
                и: 'i',
                й: 'i',
                к: 'k',
                л: 'l',
                м: 'm',
                н: 'n',
                о: 'o',
                п: 'p',
                р: 'r',
                с: 's',
                т: 't',
                у: 'u',
                ф: 'f',
                х: 'kh',
                ц: 'c',
                ч: 'ch',
                ш: 'sh',
                щ: 'sh',
                ъ: '',
                ы: 'y',
                ь: '',
                э: 'e',
                ю: 'yu',
                я: 'ya',
                А: 'A',
                Б: 'B',
                В: 'V',
                Г: 'G',
                Д: 'D',
                Е: 'E',
                Ё: 'Yo',
                Ж: 'Zh',
                З: 'Z',
                И: 'I',
                Й: 'I',
                К: 'K',
                Л: 'L',
                М: 'M',
                Н: 'N',
                О: 'O',
                П: 'P',
                Р: 'R',
                С: 'S',
                Т: 'T',
                У: 'U',
                Ф: 'F',
                Х: 'Kh',
                Ц: 'C',
                Ч: 'Ch',
                Ш: 'Sh',
                Щ: 'Sh',
                Ъ: '',
                Ы: 'Y',
                Ь: '',
                Э: 'E',
                Ю: 'Yu',
                Я: 'Ya',
                ђ: 'dj',
                ј: 'j',
                ћ: 'c',
                џ: 'dz',
                Ђ: 'Dj',
                Ј: 'j',
                Ћ: 'C',
                Џ: 'Dz',
                ľ: 'l',
                ĺ: 'l',
                ŕ: 'r',
                Ľ: 'L',
                Ĺ: 'L',
                Ŕ: 'R',
                ş: 's',
                Ş: 'S',
                ı: 'i',
                İ: 'I',
                ğ: 'g',
                Ğ: 'G',
                ả: 'a',
                Ả: 'A',
                ẳ: 'a',
                Ẳ: 'A',
                ẩ: 'a',
                Ẩ: 'A',
                đ: 'd',
                Đ: 'D',
                ẹ: 'e',
                Ẹ: 'E',
                ẽ: 'e',
                Ẽ: 'E',
                ẻ: 'e',
                Ẻ: 'E',
                ế: 'e',
                Ế: 'E',
                ề: 'e',
                Ề: 'E',
                ệ: 'e',
                Ệ: 'E',
                ễ: 'e',
                Ễ: 'E',
                ể: 'e',
                Ể: 'E',
                ỏ: 'o',
                ọ: 'o',
                Ọ: 'o',
                ố: 'o',
                Ố: 'O',
                ồ: 'o',
                Ồ: 'O',
                ổ: 'o',
                Ổ: 'O',
                ộ: 'o',
                Ộ: 'O',
                ỗ: 'o',
                Ỗ: 'O',
                ơ: 'o',
                Ơ: 'O',
                ớ: 'o',
                Ớ: 'O',
                ờ: 'o',
                Ờ: 'O',
                ợ: 'o',
                Ợ: 'O',
                ỡ: 'o',
                Ỡ: 'O',
                Ở: 'o',
                ở: 'o',
                ị: 'i',
                Ị: 'I',
                ĩ: 'i',
                Ĩ: 'I',
                ỉ: 'i',
                Ỉ: 'i',
                ủ: 'u',
                Ủ: 'U',
                ụ: 'u',
                Ụ: 'U',
                ũ: 'u',
                Ũ: 'U',
                ư: 'u',
                Ư: 'U',
                ứ: 'u',
                Ứ: 'U',
                ừ: 'u',
                Ừ: 'U',
                ự: 'u',
                Ự: 'U',
                ữ: 'u',
                Ữ: 'U',
                ử: 'u',
                Ử: 'ư',
                ỷ: 'y',
                Ỷ: 'y',
                ỳ: 'y',
                Ỳ: 'Y',
                ỵ: 'y',
                Ỵ: 'Y',
                ỹ: 'y',
                Ỹ: 'Y',
                ạ: 'a',
                Ạ: 'A',
                ấ: 'a',
                Ấ: 'A',
                ầ: 'a',
                Ầ: 'A',
                ậ: 'a',
                Ậ: 'A',
                ẫ: 'a',
                Ẫ: 'A',
                ắ: 'a',
                Ắ: 'A',
                ằ: 'a',
                Ằ: 'A',
                ặ: 'a',
                Ặ: 'A',
                ẵ: 'a',
                Ẵ: 'A',
                '⓪': '0',
                '①': '1',
                '②': '2',
                '③': '3',
                '④': '4',
                '⑤': '5',
                '⑥': '6',
                '⑦': '7',
                '⑧': '8',
                '⑨': '9',
                '⑩': '10',
                '⑪': '11',
                '⑫': '12',
                '⑬': '13',
                '⑭': '14',
                '⑮': '15',
                '⑯': '16',
                '⑰': '17',
                '⑱': '18',
                '⑲': '18',
                '⑳': '18',
                '⓵': '1',
                '⓶': '2',
                '⓷': '3',
                '⓸': '4',
                '⓹': '5',
                '⓺': '6',
                '⓻': '7',
                '⓼': '8',
                '⓽': '9',
                '⓾': '10',
                '⓿': '0',
                '⓫': '11',
                '⓬': '12',
                '⓭': '13',
                '⓮': '14',
                '⓯': '15',
                '⓰': '16',
                '⓱': '17',
                '⓲': '18',
                '⓳': '19',
                '⓴': '20',
                'Ⓐ': 'A',
                'Ⓑ': 'B',
                'Ⓒ': 'C',
                'Ⓓ': 'D',
                'Ⓔ': 'E',
                'Ⓕ': 'F',
                'Ⓖ': 'G',
                'Ⓗ': 'H',
                'Ⓘ': 'I',
                'Ⓙ': 'J',
                'Ⓚ': 'K',
                'Ⓛ': 'L',
                'Ⓜ': 'M',
                'Ⓝ': 'N',
                'Ⓞ': 'O',
                'Ⓟ': 'P',
                'Ⓠ': 'Q',
                'Ⓡ': 'R',
                'Ⓢ': 'S',
                'Ⓣ': 'T',
                'Ⓤ': 'U',
                'Ⓥ': 'V',
                'Ⓦ': 'W',
                'Ⓧ': 'X',
                'Ⓨ': 'Y',
                'Ⓩ': 'Z',
                'ⓐ': 'a',
                'ⓑ': 'b',
                'ⓒ': 'c',
                'ⓓ': 'd',
                'ⓔ': 'e',
                'ⓕ': 'f',
                'ⓖ': 'g',
                'ⓗ': 'h',
                'ⓘ': 'i',
                'ⓙ': 'j',
                'ⓚ': 'k',
                'ⓛ': 'l',
                'ⓜ': 'm',
                'ⓝ': 'n',
                'ⓞ': 'o',
                'ⓟ': 'p',
                'ⓠ': 'q',
                'ⓡ': 'r',
                'ⓢ': 's',
                'ⓣ': 't',
                'ⓤ': 'u',
                'ⓦ': 'v',
                'ⓥ': 'w',
                'ⓧ': 'x',
                'ⓨ': 'y',
                'ⓩ': 'z',
                '“': '"',
                '”': '"',
                '‘': "'",
                '’': "'",
                '∂': 'd',
                ƒ: 'f',
                '™': '(TM)',
                '©': '(C)',
                œ: 'oe',
                Œ: 'OE',
                '®': '(R)',
                '†': '+',
                '℠': '(SM)',
                '…': '...',
                '˚': 'o',
                º: 'o',
                ª: 'a',
                '•': '*',
                '၊': ',',
                '။': '.',
                $: 'USD',
                '€': 'EUR',
                '₢': 'BRN',
                '₣': 'FRF',
                '£': 'GBP',
                '₤': 'ITL',
                '₦': 'NGN',
                '₧': 'ESP',
                '₩': 'KRW',
                '₪': 'ILS',
                '₫': 'VND',
                '₭': 'LAK',
                '₮': 'MNT',
                '₯': 'GRD',
                '₱': 'ARS',
                '₲': 'PYG',
                '₳': 'ARA',
                '₴': 'UAH',
                '₵': 'GHS',
                '¢': 'cent',
                '¥': 'CNY',
                元: 'CNY',
                円: 'YEN',
                '﷼': 'IRR',
                '₠': 'EWE',
                '฿': 'THB',
                '₨': 'INR',
                '₹': 'INR',
                '₰': 'PF',
                '₺': 'TRY',
                '؋': 'AFN',
                '₼': 'AZN',
                лв: 'BGN',
                '៛': 'KHR',
                '₡': 'CRC',
                '₸': 'KZT',
                ден: 'MKD',
                zł: 'PLN',
                '₽': 'RUB',
                '₾': 'GEL'
              },
              i = ['်', 'ް'],
              r = {
                'ာ': 'a',
                'ါ': 'a',
                'ေ': 'e',
                'ဲ': 'e',
                'ိ': 'i',
                'ီ': 'i',
                'ို': 'o',
                'ု': 'u',
                'ူ': 'u',
                'ေါင်': 'aung',
                'ော': 'aw',
                'ော်': 'aw',
                'ေါ': 'aw',
                'ေါ်': 'aw',
                '်': '်',
                က်: 'et',
                'ိုက်': 'aik',
                'ောက်': 'auk',
                င်: 'in',
                'ိုင်': 'aing',
                'ောင်': 'aung',
                စ်: 'it',
                ည်: 'i',
                တ်: 'at',
                'ိတ်': 'eik',
                'ုတ်': 'ok',
                'ွတ်': 'ut',
                'ေတ်': 'it',
                ဒ်: 'd',
                'ိုဒ်': 'ok',
                'ုဒ်': 'ait',
                န်: 'an',
                'ာန်': 'an',
                'ိန်': 'ein',
                'ုန်': 'on',
                'ွန်': 'un',
                ပ်: 'at',
                'ိပ်': 'eik',
                'ုပ်': 'ok',
                'ွပ်': 'ut',
                န်ုပ်: 'nub',
                မ်: 'an',
                'ိမ်': 'ein',
                'ုမ်': 'on',
                'ွမ်': 'un',
                ယ်: 'e',
                'ိုလ်': 'ol',
                ဉ်: 'in',
                'ံ': 'an',
                'ိံ': 'ein',
                'ုံ': 'on',
                'ައް': 'ah',
                'ަށް': 'ah'
              },
              o = {
                en: {},
                az: {
                  ç: 'c',
                  ə: 'e',
                  ğ: 'g',
                  ı: 'i',
                  ö: 'o',
                  ş: 's',
                  ü: 'u',
                  Ç: 'C',
                  Ə: 'E',
                  Ğ: 'G',
                  İ: 'I',
                  Ö: 'O',
                  Ş: 'S',
                  Ü: 'U'
                },
                cs: {
                  č: 'c',
                  ď: 'd',
                  ě: 'e',
                  ň: 'n',
                  ř: 'r',
                  š: 's',
                  ť: 't',
                  ů: 'u',
                  ž: 'z',
                  Č: 'C',
                  Ď: 'D',
                  Ě: 'E',
                  Ň: 'N',
                  Ř: 'R',
                  Š: 'S',
                  Ť: 'T',
                  Ů: 'U',
                  Ž: 'Z'
                },
                fi: { ä: 'a', Ä: 'A', ö: 'o', Ö: 'O' },
                hu: { ä: 'a', Ä: 'A', ö: 'o', Ö: 'O', ü: 'u', Ü: 'U', ű: 'u', Ű: 'U' },
                lt: {
                  ą: 'a',
                  č: 'c',
                  ę: 'e',
                  ė: 'e',
                  į: 'i',
                  š: 's',
                  ų: 'u',
                  ū: 'u',
                  ž: 'z',
                  Ą: 'A',
                  Č: 'C',
                  Ę: 'E',
                  Ė: 'E',
                  Į: 'I',
                  Š: 'S',
                  Ų: 'U',
                  Ū: 'U'
                },
                lv: {
                  ā: 'a',
                  č: 'c',
                  ē: 'e',
                  ģ: 'g',
                  ī: 'i',
                  ķ: 'k',
                  ļ: 'l',
                  ņ: 'n',
                  š: 's',
                  ū: 'u',
                  ž: 'z',
                  Ā: 'A',
                  Č: 'C',
                  Ē: 'E',
                  Ģ: 'G',
                  Ī: 'i',
                  Ķ: 'k',
                  Ļ: 'L',
                  Ņ: 'N',
                  Š: 'S',
                  Ū: 'u',
                  Ž: 'Z'
                },
                pl: {
                  ą: 'a',
                  ć: 'c',
                  ę: 'e',
                  ł: 'l',
                  ń: 'n',
                  ó: 'o',
                  ś: 's',
                  ź: 'z',
                  ż: 'z',
                  Ą: 'A',
                  Ć: 'C',
                  Ę: 'e',
                  Ł: 'L',
                  Ń: 'N',
                  Ó: 'O',
                  Ś: 'S',
                  Ź: 'Z',
                  Ż: 'Z'
                },
                sv: { ä: 'a', Ä: 'A', ö: 'o', Ö: 'O' },
                sk: { ä: 'a', Ä: 'A' },
                sr: { љ: 'lj', њ: 'nj', Љ: 'Lj', Њ: 'Nj', đ: 'dj', Đ: 'Dj' },
                tr: { Ü: 'U', Ö: 'O', ü: 'u', ö: 'o' }
              },
              l = {
                ar: {
                  '∆': 'delta',
                  '∞': 'la-nihaya',
                  '♥': 'hob',
                  '&': 'wa',
                  '|': 'aw',
                  '<': 'aqal-men',
                  '>': 'akbar-men',
                  '∑': 'majmou',
                  '¤': 'omla'
                },
                az: {},
                ca: {
                  '∆': 'delta',
                  '∞': 'infinit',
                  '♥': 'amor',
                  '&': 'i',
                  '|': 'o',
                  '<': 'menys que',
                  '>': 'mes que',
                  '∑': 'suma dels',
                  '¤': 'moneda'
                },
                cs: {
                  '∆': 'delta',
                  '∞': 'nekonecno',
                  '♥': 'laska',
                  '&': 'a',
                  '|': 'nebo',
                  '<': 'mensi nez',
                  '>': 'vetsi nez',
                  '∑': 'soucet',
                  '¤': 'mena'
                },
                de: {
                  '∆': 'delta',
                  '∞': 'unendlich',
                  '♥': 'Liebe',
                  '&': 'und',
                  '|': 'oder',
                  '<': 'kleiner als',
                  '>': 'groesser als',
                  '∑': 'Summe von',
                  '¤': 'Waehrung'
                },
                dv: {
                  '∆': 'delta',
                  '∞': 'kolunulaa',
                  '♥': 'loabi',
                  '&': 'aai',
                  '|': 'noonee',
                  '<': 'ah vure kuda',
                  '>': 'ah vure bodu',
                  '∑': 'jumula',
                  '¤': 'faisaa'
                },
                en: {
                  '∆': 'delta',
                  '∞': 'infinity',
                  '♥': 'love',
                  '&': 'and',
                  '|': 'or',
                  '<': 'less than',
                  '>': 'greater than',
                  '∑': 'sum',
                  '¤': 'currency'
                },
                es: {
                  '∆': 'delta',
                  '∞': 'infinito',
                  '♥': 'amor',
                  '&': 'y',
                  '|': 'u',
                  '<': 'menos que',
                  '>': 'mas que',
                  '∑': 'suma de los',
                  '¤': 'moneda'
                },
                fa: {
                  '∆': 'delta',
                  '∞': 'bi-nahayat',
                  '♥': 'eshgh',
                  '&': 'va',
                  '|': 'ya',
                  '<': 'kamtar-az',
                  '>': 'bishtar-az',
                  '∑': 'majmooe',
                  '¤': 'vahed'
                },
                fi: {
                  '∆': 'delta',
                  '∞': 'aarettomyys',
                  '♥': 'rakkaus',
                  '&': 'ja',
                  '|': 'tai',
                  '<': 'pienempi kuin',
                  '>': 'suurempi kuin',
                  '∑': 'summa',
                  '¤': 'valuutta'
                },
                fr: {
                  '∆': 'delta',
                  '∞': 'infiniment',
                  '♥': 'Amour',
                  '&': 'et',
                  '|': 'ou',
                  '<': 'moins que',
                  '>': 'superieure a',
                  '∑': 'somme des',
                  '¤': 'monnaie'
                },
                ge: {
                  '∆': 'delta',
                  '∞': 'usasruloba',
                  '♥': 'siqvaruli',
                  '&': 'da',
                  '|': 'an',
                  '<': 'naklebi',
                  '>': 'meti',
                  '∑': 'jami',
                  '¤': 'valuta'
                },
                gr: {},
                hu: {
                  '∆': 'delta',
                  '∞': 'vegtelen',
                  '♥': 'szerelem',
                  '&': 'es',
                  '|': 'vagy',
                  '<': 'kisebb mint',
                  '>': 'nagyobb mint',
                  '∑': 'szumma',
                  '¤': 'penznem'
                },
                it: {
                  '∆': 'delta',
                  '∞': 'infinito',
                  '♥': 'amore',
                  '&': 'e',
                  '|': 'o',
                  '<': 'minore di',
                  '>': 'maggiore di',
                  '∑': 'somma',
                  '¤': 'moneta'
                },
                lt: {
                  '∆': 'delta',
                  '∞': 'begalybe',
                  '♥': 'meile',
                  '&': 'ir',
                  '|': 'ar',
                  '<': 'maziau nei',
                  '>': 'daugiau nei',
                  '∑': 'suma',
                  '¤': 'valiuta'
                },
                lv: {
                  '∆': 'delta',
                  '∞': 'bezgaliba',
                  '♥': 'milestiba',
                  '&': 'un',
                  '|': 'vai',
                  '<': 'mazak neka',
                  '>': 'lielaks neka',
                  '∑': 'summa',
                  '¤': 'valuta'
                },
                my: {
                  '∆': 'kwahkhyaet',
                  '∞': 'asaonasme',
                  '♥': 'akhyait',
                  '&': 'nhin',
                  '|': 'tho',
                  '<': 'ngethaw',
                  '>': 'kyithaw',
                  '∑': 'paungld',
                  '¤': 'ngwekye'
                },
                mk: {},
                nl: {
                  '∆': 'delta',
                  '∞': 'oneindig',
                  '♥': 'liefde',
                  '&': 'en',
                  '|': 'of',
                  '<': 'kleiner dan',
                  '>': 'groter dan',
                  '∑': 'som',
                  '¤': 'valuta'
                },
                pl: {
                  '∆': 'delta',
                  '∞': 'nieskonczonosc',
                  '♥': 'milosc',
                  '&': 'i',
                  '|': 'lub',
                  '<': 'mniejsze niz',
                  '>': 'wieksze niz',
                  '∑': 'suma',
                  '¤': 'waluta'
                },
                pt: {
                  '∆': 'delta',
                  '∞': 'infinito',
                  '♥': 'amor',
                  '&': 'e',
                  '|': 'ou',
                  '<': 'menor que',
                  '>': 'maior que',
                  '∑': 'soma',
                  '¤': 'moeda'
                },
                ro: {
                  '∆': 'delta',
                  '∞': 'infinit',
                  '♥': 'dragoste',
                  '&': 'si',
                  '|': 'sau',
                  '<': 'mai mic ca',
                  '>': 'mai mare ca',
                  '∑': 'suma',
                  '¤': 'valuta'
                },
                ru: {
                  '∆': 'delta',
                  '∞': 'beskonechno',
                  '♥': 'lubov',
                  '&': 'i',
                  '|': 'ili',
                  '<': 'menshe',
                  '>': 'bolshe',
                  '∑': 'summa',
                  '¤': 'valjuta'
                },
                sk: {
                  '∆': 'delta',
                  '∞': 'nekonecno',
                  '♥': 'laska',
                  '&': 'a',
                  '|': 'alebo',
                  '<': 'menej ako',
                  '>': 'viac ako',
                  '∑': 'sucet',
                  '¤': 'mena'
                },
                sr: {},
                tr: {
                  '∆': 'delta',
                  '∞': 'sonsuzluk',
                  '♥': 'ask',
                  '&': 've',
                  '|': 'veya',
                  '<': 'kucuktur',
                  '>': 'buyuktur',
                  '∑': 'toplam',
                  '¤': 'para birimi'
                },
                uk: {
                  '∆': 'delta',
                  '∞': 'bezkinechnist',
                  '♥': 'lubov',
                  '&': 'i',
                  '|': 'abo',
                  '<': 'menshe',
                  '>': 'bilshe',
                  '∑': 'suma',
                  '¤': 'valjuta'
                },
                vn: {
                  '∆': 'delta',
                  '∞': 'vo cuc',
                  '♥': 'yeu',
                  '&': 'va',
                  '|': 'hoac',
                  '<': 'nho hon',
                  '>': 'lon hon',
                  '∑': 'tong',
                  '¤': 'tien te'
                }
              },
              a = [';', '?', ':', '@', '&', '=', '+', '$', ',', '/'].join(''),
              f = [';', '?', ':', '@', '&', '=', '+', '$', ','].join(''),
              c = ['.', '!', '~', '*', "'", '(', ')'].join(''),
              u = function (v, y) {
                var z = '-',
                  O = '',
                  X = '',
                  N = !0,
                  ne = {},
                  H,
                  fe,
                  U,
                  w,
                  x,
                  E,
                  Y,
                  de,
                  xe,
                  pe,
                  V,
                  ee,
                  re,
                  xt,
                  He = '';
                if (typeof v != 'string') return '';
                if (
                  (typeof y == 'string' && (z = y), (Y = l.en), (de = o.en), typeof y == 'object')
                ) {
                  ((H = y.maintainCase || !1),
                    (ne = y.custom && typeof y.custom == 'object' ? y.custom : ne),
                    (U = (+y.truncate > 1 && y.truncate) || !1),
                    (w = y.uric || !1),
                    (x = y.uricNoSlash || !1),
                    (E = y.mark || !1),
                    (N = !(y.symbols === !1 || y.lang === !1)),
                    (z = y.separator || z),
                    w && (He += a),
                    x && (He += f),
                    E && (He += c),
                    (Y = y.lang && l[y.lang] && N ? l[y.lang] : N ? l.en : {}),
                    (de =
                      y.lang && o[y.lang] ? o[y.lang] : y.lang === !1 || y.lang === !0 ? {} : o.en),
                    y.titleCase &&
                    typeof y.titleCase.length == 'number' &&
                    Array.prototype.toString.call(y.titleCase)
                      ? (y.titleCase.forEach(function ($e) {
                          ne[$e + ''] = $e + '';
                        }),
                        (fe = !0))
                      : (fe = !!y.titleCase),
                    y.custom &&
                      typeof y.custom.length == 'number' &&
                      Array.prototype.toString.call(y.custom) &&
                      y.custom.forEach(function ($e) {
                        ne[$e + ''] = $e + '';
                      }),
                    Object.keys(ne).forEach(function ($e) {
                      var Ke;
                      ($e.length > 1
                        ? (Ke = new RegExp('\\b' + p($e) + '\\b', 'gi'))
                        : (Ke = new RegExp(p($e), 'gi')),
                        (v = v.replace(Ke, ne[$e])));
                    }));
                  for (V in ne) He += V;
                }
                for (
                  He += z,
                    He = p(He),
                    v = v.replace(/(^\s+|\s+$)/g, ''),
                    re = !1,
                    xt = !1,
                    pe = 0,
                    ee = v.length;
                  pe < ee;
                  pe++
                )
                  ((V = v[pe]),
                    h(V, ne)
                      ? (re = !1)
                      : de[V]
                        ? ((V = re && de[V].match(/[A-Za-z0-9]/) ? ' ' + de[V] : de[V]), (re = !1))
                        : V in s
                          ? (pe + 1 < ee && i.indexOf(v[pe + 1]) >= 0
                              ? ((X += V), (V = ''))
                              : xt === !0
                                ? ((V = r[X] + s[V]), (X = ''))
                                : (V = re && s[V].match(/[A-Za-z0-9]/) ? ' ' + s[V] : s[V]),
                            (re = !1),
                            (xt = !1))
                          : V in r
                            ? ((X += V), (V = ''), pe === ee - 1 && (V = r[X]), (xt = !0))
                            : Y[V] && !(w && a.indexOf(V) !== -1) && !(x && f.indexOf(V) !== -1)
                              ? ((V = re || O.substr(-1).match(/[A-Za-z0-9]/) ? z + Y[V] : Y[V]),
                                (V +=
                                  v[pe + 1] !== void 0 && v[pe + 1].match(/[A-Za-z0-9]/) ? z : ''),
                                (re = !0))
                              : (xt === !0
                                  ? ((V = r[X] + V), (X = ''), (xt = !1))
                                  : re &&
                                    (/[A-Za-z0-9]/.test(V) || O.substr(-1).match(/A-Za-z0-9]/)) &&
                                    (V = ' ' + V),
                                (re = !1)),
                    (O += V.replace(new RegExp('[^\\w\\s' + He + '_-]', 'g'), z)));
                return (
                  fe &&
                    (O = O.replace(/(\w)(\S*)/g, function ($e, Ke, Nn) {
                      var ws = Ke.toUpperCase() + (Nn !== null ? Nn : '');
                      return Object.keys(ne).indexOf(ws.toLowerCase()) < 0 ? ws : ws.toLowerCase();
                    })),
                  (O = O.replace(/\s+/g, z)
                    .replace(new RegExp('\\' + z + '+', 'g'), z)
                    .replace(new RegExp('(^\\' + z + '+|\\' + z + '+$)', 'g'), '')),
                  U &&
                    O.length > U &&
                    ((xe = O.charAt(U) === z),
                    (O = O.slice(0, U)),
                    xe || (O = O.slice(0, O.lastIndexOf(z)))),
                  !H && !fe && (O = O.toLowerCase()),
                  O
                );
              },
              d = function (v) {
                return function (z) {
                  return u(z, v);
                };
              },
              p = function (v) {
                return v.replace(/[-\\^$*+?.()|[\]{}\/]/g, '\\$&');
              },
              h = function (q, v) {
                for (var y in v) if (v[y] === q) return !0;
              };
            if (typeof t < 'u' && t.exports) ((t.exports = u), (t.exports.createSlug = d));
            else if (typeof define < 'u' && define.amd)
              define([], function () {
                return u;
              });
            else
              try {
                if (n.getSlug || n.createSlug)
                  throw 'speakingurl: globals exists /(getSlug|createSlug)/';
                ((n.getSlug = u), (n.createSlug = d));
              } catch {}
          })(e));
      }
    }),
    Oh = za({
      '../../node_modules/.pnpm/speakingurl@14.0.1/node_modules/speakingurl/index.js'(e, t) {
        (S(), (t.exports = Th()));
      }
    });
  (S(), S(), S(), S(), S(), S(), S(), S());
  function Ih(e) {
    var t;
    const n = e.name || e._componentTag || e.__VUE_DEVTOOLS_COMPONENT_GUSSED_NAME__ || e.__name;
    return n === 'index' && (t = e.__file) != null && t.endsWith('index.vue') ? '' : n;
  }
  function $h(e) {
    const t = e.__file;
    if (t) return ph(hh(t, '.vue'));
  }
  function Pa(e, t) {
    return ((e.type.__VUE_DEVTOOLS_COMPONENT_GUSSED_NAME__ = t), t);
  }
  function Sr(e) {
    if (e.__VUE_DEVTOOLS_NEXT_APP_RECORD__) return e.__VUE_DEVTOOLS_NEXT_APP_RECORD__;
    if (e.root) return e.appContext.app.__VUE_DEVTOOLS_NEXT_APP_RECORD__;
  }
  function Ma(e) {
    var t, n;
    const s = (t = e.subTree) == null ? void 0 : t.type,
      i = Sr(e);
    return i ? ((n = i == null ? void 0 : i.types) == null ? void 0 : n.Fragment) === s : !1;
  }
  function ai(e) {
    var t, n, s;
    const i = Ih((e == null ? void 0 : e.type) || {});
    if (i) return i;
    if ((e == null ? void 0 : e.root) === e) return 'Root';
    for (const o in (n = (t = e.parent) == null ? void 0 : t.type) == null ? void 0 : n.components)
      if (e.parent.type.components[o] === (e == null ? void 0 : e.type)) return Pa(e, o);
    for (const o in (s = e.appContext) == null ? void 0 : s.components)
      if (e.appContext.components[o] === (e == null ? void 0 : e.type)) return Pa(e, o);
    const r = $h((e == null ? void 0 : e.type) || {});
    return r || 'Anonymous Component';
  }
  function Bh(e) {
    var t, n, s;
    const i =
        (s =
          (n = (t = e == null ? void 0 : e.appContext) == null ? void 0 : t.app) == null
            ? void 0
            : n.__VUE_DEVTOOLS_NEXT_APP_RECORD_ID__) != null
          ? s
          : 0,
      r = e === (e == null ? void 0 : e.root) ? 'root' : e.uid;
    return `${i}:${r}`;
  }
  function kr(e, t) {
    return ((t = t || `${e.id}:root`), e.instanceMap.get(t) || e.instanceMap.get(':root'));
  }
  function Fh() {
    const e = {
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      get width() {
        return e.right - e.left;
      },
      get height() {
        return e.bottom - e.top;
      }
    };
    return e;
  }
  var ui;
  function Dh(e) {
    return (ui || (ui = document.createRange()), ui.selectNode(e), ui.getBoundingClientRect());
  }
  function zh(e) {
    const t = Fh();
    if (!e.children) return t;
    for (let n = 0, s = e.children.length; n < s; n++) {
      const i = e.children[n];
      let r;
      if (i.component) r = dn(i.component);
      else if (i.el) {
        const o = i.el;
        o.nodeType === 1 || o.getBoundingClientRect
          ? (r = o.getBoundingClientRect())
          : o.nodeType === 3 && o.data.trim() && (r = Dh(o));
      }
      r && Ph(t, r);
    }
    return t;
  }
  function Ph(e, t) {
    return (
      (!e.top || t.top < e.top) && (e.top = t.top),
      (!e.bottom || t.bottom > e.bottom) && (e.bottom = t.bottom),
      (!e.left || t.left < e.left) && (e.left = t.left),
      (!e.right || t.right > e.right) && (e.right = t.right),
      e
    );
  }
  var Ra = { top: 0, left: 0, right: 0, bottom: 0, width: 0, height: 0 };
  function dn(e) {
    const t = e.subTree.el;
    return typeof window > 'u'
      ? Ra
      : Ma(e)
        ? zh(e.subTree)
        : (t == null ? void 0 : t.nodeType) === 1
          ? t == null
            ? void 0
            : t.getBoundingClientRect()
          : e.subTree.component
            ? dn(e.subTree.component)
            : Ra;
  }
  S();
  function Cr(e) {
    return Ma(e) ? Mh(e.subTree) : e.subTree ? [e.subTree.el] : [];
  }
  function Mh(e) {
    if (!e.children) return [];
    const t = [];
    return (
      e.children.forEach((n) => {
        n.component ? t.push(...Cr(n.component)) : n != null && n.el && t.push(n.el);
      }),
      t
    );
  }
  var Va = '__vue-devtools-component-inspector__',
    Na = '__vue-devtools-component-inspector__card__',
    ja = '__vue-devtools-component-inspector__name__',
    La = '__vue-devtools-component-inspector__indicator__',
    Ua = {
      display: 'block',
      zIndex: 2147483640,
      position: 'fixed',
      backgroundColor: '#42b88325',
      border: '1px solid #42b88350',
      borderRadius: '5px',
      transition: 'all 0.1s ease-in',
      pointerEvents: 'none'
    },
    Rh = {
      fontFamily: 'Arial, Helvetica, sans-serif',
      padding: '5px 8px',
      borderRadius: '4px',
      textAlign: 'left',
      position: 'absolute',
      left: 0,
      color: '#e9e9e9',
      fontSize: '14px',
      fontWeight: 600,
      lineHeight: '24px',
      backgroundColor: '#42b883',
      boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px -1px rgba(0, 0, 0, 0.1)'
    },
    Vh = {
      display: 'inline-block',
      fontWeight: 400,
      fontStyle: 'normal',
      fontSize: '12px',
      opacity: 0.7
    };
  function Fn() {
    return document.getElementById(Va);
  }
  function Nh() {
    return document.getElementById(Na);
  }
  function jh() {
    return document.getElementById(La);
  }
  function Lh() {
    return document.getElementById(ja);
  }
  function Ar(e) {
    return {
      left: `${Math.round(e.left * 100) / 100}px`,
      top: `${Math.round(e.top * 100) / 100}px`,
      width: `${Math.round(e.width * 100) / 100}px`,
      height: `${Math.round(e.height * 100) / 100}px`
    };
  }
  function Tr(e) {
    var t;
    const n = document.createElement('div');
    ((n.id = (t = e.elementId) != null ? t : Va),
      Object.assign(n.style, { ...Ua, ...Ar(e.bounds), ...e.style }));
    const s = document.createElement('span');
    ((s.id = Na), Object.assign(s.style, { ...Rh, top: e.bounds.top < 35 ? 0 : '-35px' }));
    const i = document.createElement('span');
    ((i.id = ja), (i.innerHTML = `&lt;${e.name}&gt;&nbsp;&nbsp;`));
    const r = document.createElement('i');
    return (
      (r.id = La),
      (r.innerHTML = `${Math.round(e.bounds.width * 100) / 100} x ${Math.round(e.bounds.height * 100) / 100}`),
      Object.assign(r.style, Vh),
      s.appendChild(i),
      s.appendChild(r),
      n.appendChild(s),
      document.body.appendChild(n),
      n
    );
  }
  function Or(e) {
    const t = Fn(),
      n = Nh(),
      s = Lh(),
      i = jh();
    t &&
      (Object.assign(t.style, { ...Ua, ...Ar(e.bounds) }),
      Object.assign(n.style, { top: e.bounds.top < 35 ? 0 : '-35px' }),
      (s.innerHTML = `&lt;${e.name}&gt;&nbsp;&nbsp;`),
      (i.innerHTML = `${Math.round(e.bounds.width * 100) / 100} x ${Math.round(e.bounds.height * 100) / 100}`));
  }
  function Uh(e) {
    const t = dn(e);
    if (!t.width && !t.height) return;
    const n = ai(e);
    Fn() ? Or({ bounds: t, name: n }) : Tr({ bounds: t, name: n });
  }
  function Qa() {
    const e = Fn();
    e && (e.style.display = 'none');
  }
  var Ir = null;
  function $r(e) {
    const t = e.target;
    if (t) {
      const n = t.__vueParentComponent;
      if (n && ((Ir = n), n.vnode.el)) {
        const i = dn(n),
          r = ai(n);
        Fn() ? Or({ bounds: i, name: r }) : Tr({ bounds: i, name: r });
      }
    }
  }
  function Qh(e, t) {
    if ((e.preventDefault(), e.stopPropagation(), Ir)) {
      const n = Bh(Ir);
      t(n);
    }
  }
  var ci = null;
  function Hh() {
    (Qa(),
      window.removeEventListener('mouseover', $r),
      window.removeEventListener('click', ci, !0),
      (ci = null));
  }
  function Kh() {
    return (
      window.addEventListener('mouseover', $r),
      new Promise((e) => {
        function t(n) {
          (n.preventDefault(),
            n.stopPropagation(),
            Qh(n, (s) => {
              (window.removeEventListener('click', t, !0),
                (ci = null),
                window.removeEventListener('mouseover', $r));
              const i = Fn();
              (i && (i.style.display = 'none'), e(JSON.stringify({ id: s })));
            }));
        }
        ((ci = t), window.addEventListener('click', t, !0));
      })
    );
  }
  function Wh(e) {
    const t = kr(Le.value, e.id);
    if (t) {
      const [n] = Cr(t);
      if (typeof n.scrollIntoView == 'function') n.scrollIntoView({ behavior: 'smooth' });
      else {
        const s = dn(t),
          i = document.createElement('div'),
          r = { ...Ar(s), position: 'absolute' };
        (Object.assign(i.style, r),
          document.body.appendChild(i),
          i.scrollIntoView({ behavior: 'smooth' }),
          setTimeout(() => {
            document.body.removeChild(i);
          }, 2e3));
      }
      setTimeout(() => {
        const s = dn(t);
        if (s.width || s.height) {
          const i = ai(t),
            r = Fn();
          (r ? Or({ ...e, name: i, bounds: s }) : Tr({ ...e, name: i, bounds: s }),
            setTimeout(() => {
              r && (r.style.display = 'none');
            }, 1500));
        }
      }, 1200);
    }
  }
  S();
  var Ha, Ka;
  (Ka = (Ha = j).__VUE_DEVTOOLS_COMPONENT_INSPECTOR_ENABLED__) != null ||
    (Ha.__VUE_DEVTOOLS_COMPONENT_INSPECTOR_ENABLED__ = !0);
  function Gh(e) {
    let t = 0;
    const n = setInterval(() => {
      (j.__VUE_INSPECTOR__ && (clearInterval(n), (t += 30), e()), t >= 5e3 && clearInterval(n));
    }, 30);
  }
  function Yh() {
    const e = j.__VUE_INSPECTOR__,
      t = e.openInEditor;
    e.openInEditor = async (...n) => {
      (e.disable(), t(...n));
    };
  }
  function Zh() {
    return new Promise((e) => {
      function t() {
        (Yh(), e(j.__VUE_INSPECTOR__));
      }
      j.__VUE_INSPECTOR__
        ? t()
        : Gh(() => {
            t();
          });
    });
  }
  (S(), S());
  function Jh(e) {
    return !!(e && e.__v_isReadonly);
  }
  function Wa(e) {
    return Jh(e) ? Wa(e.__v_raw) : !!(e && e.__v_isReactive);
  }
  function Br(e) {
    return !!(e && e.__v_isRef === !0);
  }
  function ps(e) {
    const t = e && e.__v_raw;
    return t ? ps(t) : e;
  }
  var Xh = class {
      constructor() {
        this.refEditor = new e0();
      }
      set(e, t, n, s) {
        const i = Array.isArray(t) ? t : t.split('.');
        for (; i.length > 1; ) {
          const l = i.shift();
          (e instanceof Map
            ? (e = e.get(l))
            : e instanceof Set
              ? (e = Array.from(e.values())[l])
              : (e = e[l]),
            this.refEditor.isRef(e) && (e = this.refEditor.get(e)));
        }
        const r = i[0],
          o = this.refEditor.get(e)[r];
        s ? s(e, r, n) : this.refEditor.isRef(o) ? this.refEditor.set(o, n) : (e[r] = n);
      }
      get(e, t) {
        const n = Array.isArray(t) ? t : t.split('.');
        for (let s = 0; s < n.length; s++)
          if (
            (e instanceof Map ? (e = e.get(n[s])) : (e = e[n[s]]),
            this.refEditor.isRef(e) && (e = this.refEditor.get(e)),
            !e)
          )
            return;
        return e;
      }
      has(e, t, n = !1) {
        if (typeof e > 'u') return !1;
        const s = Array.isArray(t) ? t.slice() : t.split('.'),
          i = n ? 2 : 1;
        for (; e && s.length > i; ) {
          const r = s.shift();
          ((e = e[r]), this.refEditor.isRef(e) && (e = this.refEditor.get(e)));
        }
        return e != null && Object.prototype.hasOwnProperty.call(e, s[0]);
      }
      createDefaultSetCallback(e) {
        return (t, n, s) => {
          if (
            ((e.remove || e.newKey) &&
              (Array.isArray(t)
                ? t.splice(n, 1)
                : ps(t) instanceof Map
                  ? t.delete(n)
                  : ps(t) instanceof Set
                    ? t.delete(Array.from(t.values())[n])
                    : Reflect.deleteProperty(t, n)),
            !e.remove)
          ) {
            const i = t[e.newKey || n];
            this.refEditor.isRef(i)
              ? this.refEditor.set(i, s)
              : ps(t) instanceof Map
                ? t.set(e.newKey || n, s)
                : ps(t) instanceof Set
                  ? t.add(s)
                  : (t[e.newKey || n] = s);
          }
        };
      }
    },
    e0 = class {
      set(e, t) {
        if (Br(e)) e.value = t;
        else {
          if (e instanceof Set && Array.isArray(t)) {
            (e.clear(), t.forEach((i) => e.add(i)));
            return;
          }
          const n = Object.keys(t);
          if (e instanceof Map) {
            const i = new Set(e.keys());
            (n.forEach((r) => {
              (e.set(r, Reflect.get(t, r)), i.delete(r));
            }),
              i.forEach((r) => e.delete(r)));
            return;
          }
          const s = new Set(Object.keys(e));
          (n.forEach((i) => {
            (Reflect.set(e, i, Reflect.get(t, i)), s.delete(i));
          }),
            s.forEach((i) => Reflect.deleteProperty(e, i)));
        }
      }
      get(e) {
        return Br(e) ? e.value : e;
      }
      isRef(e) {
        return Br(e) || Wa(e);
      }
    };
  (S(), S(), S());
  var t0 = '__VUE_DEVTOOLS_KIT_TIMELINE_LAYERS_STATE__';
  function n0() {
    if (!Oa || typeof localStorage > 'u' || localStorage === null)
      return {
        recordingState: !1,
        mouseEventEnabled: !1,
        keyboardEventEnabled: !1,
        componentEventEnabled: !1,
        performanceEventEnabled: !1,
        selected: ''
      };
    const e = localStorage.getItem(t0);
    return e
      ? JSON.parse(e)
      : {
          recordingState: !1,
          mouseEventEnabled: !1,
          keyboardEventEnabled: !1,
          componentEventEnabled: !1,
          performanceEventEnabled: !1,
          selected: ''
        };
  }
  (S(), S(), S());
  var Ga, Ya;
  (Ya = (Ga = j).__VUE_DEVTOOLS_KIT_TIMELINE_LAYERS) != null ||
    (Ga.__VUE_DEVTOOLS_KIT_TIMELINE_LAYERS = []);
  var s0 = new Proxy(j.__VUE_DEVTOOLS_KIT_TIMELINE_LAYERS, {
    get(e, t, n) {
      return Reflect.get(e, t, n);
    }
  });
  function i0(e, t) {
    ((Te.timelineLayersState[t.id] = !1),
      s0.push({ ...e, descriptorId: t.id, appRecord: Sr(t.app) }));
  }
  var Za, Ja;
  (Ja = (Za = j).__VUE_DEVTOOLS_KIT_INSPECTOR__) != null ||
    (Za.__VUE_DEVTOOLS_KIT_INSPECTOR__ = []);
  var Fr = new Proxy(j.__VUE_DEVTOOLS_KIT_INSPECTOR__, {
      get(e, t, n) {
        return Reflect.get(e, t, n);
      }
    }),
    Xa = Bn(() => {
      zn.hooks.callHook('sendInspectorToClient', eu());
    });
  function r0(e, t) {
    var n, s;
    (Fr.push({
      options: e,
      descriptor: t,
      treeFilterPlaceholder: (n = e.treeFilterPlaceholder) != null ? n : 'Search tree...',
      stateFilterPlaceholder: (s = e.stateFilterPlaceholder) != null ? s : 'Search state...',
      treeFilter: '',
      selectedNodeId: '',
      appRecord: Sr(t.app)
    }),
      Xa());
  }
  function eu() {
    return Fr.filter((e) => e.descriptor.app === Le.value.app)
      .filter((e) => e.descriptor.id !== 'components')
      .map((e) => {
        var t;
        const n = e.descriptor,
          s = e.options;
        return {
          id: s.id,
          label: s.label,
          logo: n.logo,
          icon: `custom-ic-baseline-${(t = s == null ? void 0 : s.icon) == null ? void 0 : t.replace(/_/g, '-')}`,
          packageName: n.packageName,
          homepage: n.homepage,
          pluginId: n.id
        };
      });
  }
  function fi(e, t) {
    return Fr.find((n) => n.options.id === e && (t ? n.descriptor.app === t : !0));
  }
  function o0() {
    const e = Fa();
    e.hook('addInspector', ({ inspector: s, plugin: i }) => {
      r0(s, i.descriptor);
    });
    const t = Bn(async ({ inspectorId: s, plugin: i }) => {
      var r;
      if (
        !s ||
        !((r = i == null ? void 0 : i.descriptor) != null && r.app) ||
        Te.highPerfModeEnabled
      )
        return;
      const o = fi(s, i.descriptor.app),
        l = {
          app: i.descriptor.app,
          inspectorId: s,
          filter: (o == null ? void 0 : o.treeFilter) || '',
          rootNodes: []
        };
      (await new Promise((a) => {
        e.callHookWith(async (f) => {
          (await Promise.all(f.map((c) => c(l))), a());
        }, 'getInspectorTree');
      }),
        e.callHookWith(async (a) => {
          await Promise.all(a.map((f) => f({ inspectorId: s, rootNodes: l.rootNodes })));
        }, 'sendInspectorTreeToClient'));
    }, 120);
    e.hook('sendInspectorTree', t);
    const n = Bn(async ({ inspectorId: s, plugin: i }) => {
      var r;
      if (
        !s ||
        !((r = i == null ? void 0 : i.descriptor) != null && r.app) ||
        Te.highPerfModeEnabled
      )
        return;
      const o = fi(s, i.descriptor.app),
        l = {
          app: i.descriptor.app,
          inspectorId: s,
          nodeId: (o == null ? void 0 : o.selectedNodeId) || '',
          state: null
        },
        a = { currentTab: `custom-inspector:${s}` };
      (l.nodeId &&
        (await new Promise((f) => {
          e.callHookWith(async (c) => {
            (await Promise.all(c.map((u) => u(l, a))), f());
          }, 'getInspectorState');
        })),
        e.callHookWith(async (f) => {
          await Promise.all(f.map((c) => c({ inspectorId: s, nodeId: l.nodeId, state: l.state })));
        }, 'sendInspectorStateToClient'));
    }, 120);
    return (
      e.hook('sendInspectorState', n),
      e.hook('customInspectorSelectNode', ({ inspectorId: s, nodeId: i, plugin: r }) => {
        const o = fi(s, r.descriptor.app);
        o && (o.selectedNodeId = i);
      }),
      e.hook('timelineLayerAdded', ({ options: s, plugin: i }) => {
        i0(s, i.descriptor);
      }),
      e.hook('timelineEventAdded', ({ options: s, plugin: i }) => {
        var r;
        const o = ['performance', 'component-event', 'keyboard', 'mouse'];
        Te.highPerfModeEnabled ||
          (!((r = Te.timelineLayersState) != null && r[i.descriptor.id]) &&
            !o.includes(s.layerId)) ||
          e.callHookWith(async (l) => {
            await Promise.all(l.map((a) => a(s)));
          }, 'sendTimelineEventToClient');
      }),
      e.hook('getComponentInstances', async ({ app: s }) => {
        const i = s.__VUE_DEVTOOLS_NEXT_APP_RECORD__;
        if (!i) return null;
        const r = i.id.toString();
        return [...i.instanceMap].filter(([l]) => l.split(':')[0] === r).map(([, l]) => l);
      }),
      e.hook('getComponentBounds', async ({ instance: s }) => dn(s)),
      e.hook('getComponentName', ({ instance: s }) => ai(s)),
      e.hook('componentHighlight', ({ uid: s }) => {
        const i = Le.value.instanceMap.get(s);
        i && Uh(i);
      }),
      e.hook('componentUnhighlight', () => {
        Qa();
      }),
      e
    );
  }
  var tu, nu;
  (nu = (tu = j).__VUE_DEVTOOLS_KIT_APP_RECORDS__) != null ||
    (tu.__VUE_DEVTOOLS_KIT_APP_RECORDS__ = []);
  var su, iu;
  (iu = (su = j).__VUE_DEVTOOLS_KIT_ACTIVE_APP_RECORD__) != null ||
    (su.__VUE_DEVTOOLS_KIT_ACTIVE_APP_RECORD__ = {});
  var ru, ou;
  (ou = (ru = j).__VUE_DEVTOOLS_KIT_ACTIVE_APP_RECORD_ID__) != null ||
    (ru.__VUE_DEVTOOLS_KIT_ACTIVE_APP_RECORD_ID__ = '');
  var lu, au;
  (au = (lu = j).__VUE_DEVTOOLS_KIT_CUSTOM_TABS__) != null ||
    (lu.__VUE_DEVTOOLS_KIT_CUSTOM_TABS__ = []);
  var uu, cu;
  (cu = (uu = j).__VUE_DEVTOOLS_KIT_CUSTOM_COMMANDS__) != null ||
    (uu.__VUE_DEVTOOLS_KIT_CUSTOM_COMMANDS__ = []);
  var pn = '__VUE_DEVTOOLS_KIT_GLOBAL_STATE__';
  function l0() {
    return {
      connected: !1,
      clientConnected: !1,
      vitePluginDetected: !0,
      appRecords: [],
      activeAppRecordId: '',
      tabs: [],
      commands: [],
      highPerfModeEnabled: !0,
      devtoolsClientDetected: {},
      perfUniqueGroupId: 0,
      timelineLayersState: n0()
    };
  }
  var fu, du;
  (du = (fu = j)[pn]) != null || (fu[pn] = l0());
  var a0 = Bn((e) => {
    zn.hooks.callHook('devtoolsStateUpdated', { state: e });
  });
  Bn((e, t) => {
    zn.hooks.callHook('devtoolsConnectedUpdated', { state: e, oldState: t });
  });
  var di = new Proxy(j.__VUE_DEVTOOLS_KIT_APP_RECORDS__, {
      get(e, t, n) {
        return t === 'value'
          ? j.__VUE_DEVTOOLS_KIT_APP_RECORDS__
          : j.__VUE_DEVTOOLS_KIT_APP_RECORDS__[t];
      }
    }),
    Le = new Proxy(j.__VUE_DEVTOOLS_KIT_ACTIVE_APP_RECORD__, {
      get(e, t, n) {
        return t === 'value'
          ? j.__VUE_DEVTOOLS_KIT_ACTIVE_APP_RECORD__
          : t === 'id'
            ? j.__VUE_DEVTOOLS_KIT_ACTIVE_APP_RECORD_ID__
            : j.__VUE_DEVTOOLS_KIT_ACTIVE_APP_RECORD__[t];
      }
    });
  function pu() {
    a0({
      ...j[pn],
      appRecords: di.value,
      activeAppRecordId: Le.id,
      tabs: j.__VUE_DEVTOOLS_KIT_CUSTOM_TABS__,
      commands: j.__VUE_DEVTOOLS_KIT_CUSTOM_COMMANDS__
    });
  }
  function u0(e) {
    ((j.__VUE_DEVTOOLS_KIT_ACTIVE_APP_RECORD__ = e), pu());
  }
  function c0(e) {
    ((j.__VUE_DEVTOOLS_KIT_ACTIVE_APP_RECORD_ID__ = e), pu());
  }
  var Te = new Proxy(j[pn], {
    get(e, t) {
      return t === 'appRecords'
        ? di
        : t === 'activeAppRecordId'
          ? Le.id
          : t === 'tabs'
            ? j.__VUE_DEVTOOLS_KIT_CUSTOM_TABS__
            : t === 'commands'
              ? j.__VUE_DEVTOOLS_KIT_CUSTOM_COMMANDS__
              : j[pn][t];
    },
    deleteProperty(e, t) {
      return (delete e[t], !0);
    },
    set(e, t, n) {
      return ({ ...j[pn] }, (e[t] = n), (j[pn][t] = n), !0);
    }
  });
  function f0(e = {}) {
    var t, n, s;
    const { file: i, host: r, baseUrl: o = window.location.origin, line: l = 0, column: a = 0 } = e;
    if (i) {
      if (r === 'chrome-extension') {
        const f = i.replace(/\\/g, '\\\\'),
          c =
            (n = (t = window.VUE_DEVTOOLS_CONFIG) == null ? void 0 : t.openInEditorHost) != null
              ? n
              : '/';
        fetch(`${c}__open-in-editor?file=${encodeURI(i)}`).then((u) => {
          if (!u.ok) {
            const d = `Opening component ${f} failed`;
            console.log(`%c${d}`, 'color:red');
          }
        });
      } else if (Te.vitePluginDetected) {
        const f = (s = j.__VUE_DEVTOOLS_OPEN_IN_EDITOR_BASE_URL__) != null ? s : o;
        j.__VUE_INSPECTOR__.openInEditor(f, i, l, a);
      }
    }
  }
  (S(), S(), S(), S(), S());
  var hu, mu;
  (mu = (hu = j).__VUE_DEVTOOLS_KIT_PLUGIN_BUFFER__) != null ||
    (hu.__VUE_DEVTOOLS_KIT_PLUGIN_BUFFER__ = []);
  var Dr = new Proxy(j.__VUE_DEVTOOLS_KIT_PLUGIN_BUFFER__, {
    get(e, t, n) {
      return Reflect.get(e, t, n);
    }
  });
  function zr(e) {
    const t = {};
    return (
      Object.keys(e).forEach((n) => {
        t[n] = e[n].defaultValue;
      }),
      t
    );
  }
  function Pr(e) {
    return `__VUE_DEVTOOLS_NEXT_PLUGIN_SETTINGS__${e}__`;
  }
  function d0(e) {
    var t, n, s;
    const i =
      (n =
        (t = Dr.find((r) => {
          var o;
          return r[0].id === e && !!((o = r[0]) != null && o.settings);
        })) == null
          ? void 0
          : t[0]) != null
        ? n
        : null;
    return (s = i == null ? void 0 : i.settings) != null ? s : null;
  }
  function gu(e, t) {
    var n, s, i;
    const r = Pr(e);
    if (r) {
      const o = localStorage.getItem(r);
      if (o) return JSON.parse(o);
    }
    if (e) {
      const o =
        (s = (n = Dr.find((l) => l[0].id === e)) == null ? void 0 : n[0]) != null ? s : null;
      return zr((i = o == null ? void 0 : o.settings) != null ? i : {});
    }
    return zr(t);
  }
  function p0(e, t) {
    const n = Pr(e);
    localStorage.getItem(n) || localStorage.setItem(n, JSON.stringify(zr(t)));
  }
  function h0(e, t, n) {
    const s = Pr(e),
      i = localStorage.getItem(s),
      r = JSON.parse(i || '{}'),
      o = { ...r, [t]: n };
    (localStorage.setItem(s, JSON.stringify(o)),
      zn.hooks.callHookWith((l) => {
        l.forEach((a) => a({ pluginId: e, key: t, oldValue: r[t], newValue: n, settings: o }));
      }, 'setPluginSettings'));
  }
  (S(), S(), S(), S(), S(), S(), S(), S(), S(), S(), S());
  var _u,
    qu,
    Xe = (qu = (_u = j).__VUE_DEVTOOLS_HOOK) != null ? qu : (_u.__VUE_DEVTOOLS_HOOK = Fa()),
    m0 = {
      vueAppInit(e) {
        Xe.hook('app:init', e);
      },
      vueAppUnmount(e) {
        Xe.hook('app:unmount', e);
      },
      vueAppConnected(e) {
        Xe.hook('app:connected', e);
      },
      componentAdded(e) {
        return Xe.hook('component:added', e);
      },
      componentEmit(e) {
        return Xe.hook('component:emit', e);
      },
      componentUpdated(e) {
        return Xe.hook('component:updated', e);
      },
      componentRemoved(e) {
        return Xe.hook('component:removed', e);
      },
      setupDevtoolsPlugin(e) {
        Xe.hook('devtools-plugin:setup', e);
      },
      perfStart(e) {
        return Xe.hook('perf:start', e);
      },
      perfEnd(e) {
        return Xe.hook('perf:end', e);
      }
    },
    vu = {
      on: m0,
      setupDevToolsPlugin(e, t) {
        return Xe.callHook('devtools-plugin:setup', e, t);
      }
    },
    g0 = class {
      constructor({ plugin: e, ctx: t }) {
        ((this.hooks = t.hooks), (this.plugin = e));
      }
      get on() {
        return {
          visitComponentTree: (e) => {
            this.hooks.hook('visitComponentTree', e);
          },
          inspectComponent: (e) => {
            this.hooks.hook('inspectComponent', e);
          },
          editComponentState: (e) => {
            this.hooks.hook('editComponentState', e);
          },
          getInspectorTree: (e) => {
            this.hooks.hook('getInspectorTree', e);
          },
          getInspectorState: (e) => {
            this.hooks.hook('getInspectorState', e);
          },
          editInspectorState: (e) => {
            this.hooks.hook('editInspectorState', e);
          },
          inspectTimelineEvent: (e) => {
            this.hooks.hook('inspectTimelineEvent', e);
          },
          timelineCleared: (e) => {
            this.hooks.hook('timelineCleared', e);
          },
          setPluginSettings: (e) => {
            this.hooks.hook('setPluginSettings', e);
          }
        };
      }
      notifyComponentUpdate(e) {
        var t;
        if (Te.highPerfModeEnabled) return;
        const n = eu().find((s) => s.packageName === this.plugin.descriptor.packageName);
        if (n != null && n.id) {
          if (e) {
            const s = [e.appContext.app, e.uid, (t = e.parent) == null ? void 0 : t.uid, e];
            Xe.callHook('component:updated', ...s);
          } else Xe.callHook('component:updated');
          this.hooks.callHook('sendInspectorState', { inspectorId: n.id, plugin: this.plugin });
        }
      }
      addInspector(e) {
        (this.hooks.callHook('addInspector', { inspector: e, plugin: this.plugin }),
          this.plugin.descriptor.settings && p0(e.id, this.plugin.descriptor.settings));
      }
      sendInspectorTree(e) {
        Te.highPerfModeEnabled ||
          this.hooks.callHook('sendInspectorTree', { inspectorId: e, plugin: this.plugin });
      }
      sendInspectorState(e) {
        Te.highPerfModeEnabled ||
          this.hooks.callHook('sendInspectorState', { inspectorId: e, plugin: this.plugin });
      }
      selectInspectorNode(e, t) {
        this.hooks.callHook('customInspectorSelectNode', {
          inspectorId: e,
          nodeId: t,
          plugin: this.plugin
        });
      }
      visitComponentTree(e) {
        return this.hooks.callHook('visitComponentTree', e);
      }
      now() {
        return Te.highPerfModeEnabled ? 0 : Date.now();
      }
      addTimelineLayer(e) {
        this.hooks.callHook('timelineLayerAdded', { options: e, plugin: this.plugin });
      }
      addTimelineEvent(e) {
        Te.highPerfModeEnabled ||
          this.hooks.callHook('timelineEventAdded', { options: e, plugin: this.plugin });
      }
      getSettings(e) {
        return gu(e ?? this.plugin.descriptor.id, this.plugin.descriptor.settings);
      }
      getComponentInstances(e) {
        return this.hooks.callHook('getComponentInstances', { app: e });
      }
      getComponentBounds(e) {
        return this.hooks.callHook('getComponentBounds', { instance: e });
      }
      getComponentName(e) {
        return this.hooks.callHook('getComponentName', { instance: e });
      }
      highlightElement(e) {
        const t = e.__VUE_DEVTOOLS_NEXT_UID__;
        return this.hooks.callHook('componentHighlight', { uid: t });
      }
      unhighlightElement() {
        return this.hooks.callHook('componentUnhighlight');
      }
    },
    _0 = g0;
  (S(), S(), S(), S());
  var q0 = '__vue_devtool_undefined__',
    v0 = '__vue_devtool_infinity__',
    y0 = '__vue_devtool_negative_infinity__',
    b0 = '__vue_devtool_nan__';
  (S(), S());
  var w0 = { [q0]: 'undefined', [b0]: 'NaN', [v0]: 'Infinity', [y0]: '-Infinity' };
  (Object.entries(w0).reduce((e, [t, n]) => ((e[n] = t), e), {}), S(), S(), S(), S(), S());
  var yu, bu;
  (bu = (yu = j).__VUE_DEVTOOLS_KIT__REGISTERED_PLUGIN_APPS__) != null ||
    (yu.__VUE_DEVTOOLS_KIT__REGISTERED_PLUGIN_APPS__ = new Set());
  function wu(e, t) {
    return vu.setupDevToolsPlugin(e, t);
  }
  function x0(e, t) {
    const [n, s] = e;
    if (n.app !== t) return;
    const i = new _0({ plugin: { setupFn: s, descriptor: n }, ctx: zn });
    (n.packageName === 'vuex' &&
      i.on.editInspectorState((r) => {
        i.sendInspectorState(r.inspectorId);
      }),
      s(i));
  }
  function xu(e, t) {
    j.__VUE_DEVTOOLS_KIT__REGISTERED_PLUGIN_APPS__.has(e) ||
      (Te.highPerfModeEnabled && !(t != null && t.inspectingComponent)) ||
      (j.__VUE_DEVTOOLS_KIT__REGISTERED_PLUGIN_APPS__.add(e),
      Dr.forEach((n) => {
        x0(n, e);
      }));
  }
  (S(), S());
  var hs = '__VUE_DEVTOOLS_ROUTER__',
    Dn = '__VUE_DEVTOOLS_ROUTER_INFO__',
    Eu,
    Su;
  (Su = (Eu = j)[Dn]) != null || (Eu[Dn] = { currentRoute: null, routes: [] });
  var ku, Cu;
  ((Cu = (ku = j)[hs]) != null || (ku[hs] = {}),
    new Proxy(j[Dn], {
      get(e, t) {
        return j[Dn][t];
      }
    }),
    new Proxy(j[hs], {
      get(e, t) {
        if (t === 'value') return j[hs];
      }
    }));
  function E0(e) {
    const t = new Map();
    return ((e == null ? void 0 : e.getRoutes()) || []).filter(
      (n) => !t.has(n.path) && t.set(n.path, 1)
    );
  }
  function Mr(e) {
    return e.map((t) => {
      let { path: n, name: s, children: i, meta: r } = t;
      return (i != null && i.length && (i = Mr(i)), { path: n, name: s, children: i, meta: r });
    });
  }
  function S0(e) {
    if (e) {
      const {
        fullPath: t,
        hash: n,
        href: s,
        path: i,
        name: r,
        matched: o,
        params: l,
        query: a
      } = e;
      return {
        fullPath: t,
        hash: n,
        href: s,
        path: i,
        name: r,
        params: l,
        query: a,
        matched: Mr(o)
      };
    }
    return e;
  }
  function k0(e, t) {
    function n() {
      var s;
      const i = (s = e.app) == null ? void 0 : s.config.globalProperties.$router,
        r = S0(i == null ? void 0 : i.currentRoute.value),
        o = Mr(E0(i)),
        l = console.warn;
      ((console.warn = () => {}),
        (j[Dn] = { currentRoute: r ? $a(r) : {}, routes: $a(o) }),
        (j[hs] = i),
        (console.warn = l));
    }
    (n(),
      vu.on.componentUpdated(
        Bn(() => {
          var s;
          ((s = t.value) == null ? void 0 : s.app) === e.app &&
            (n(),
            !Te.highPerfModeEnabled && zn.hooks.callHook('routerInfoUpdated', { state: j[Dn] }));
        }, 200)
      ));
  }
  function C0(e) {
    return {
      async getInspectorTree(t) {
        const n = { ...t, app: Le.value.app, rootNodes: [] };
        return (
          await new Promise((s) => {
            e.callHookWith(async (i) => {
              (await Promise.all(i.map((r) => r(n))), s());
            }, 'getInspectorTree');
          }),
          n.rootNodes
        );
      },
      async getInspectorState(t) {
        const n = { ...t, app: Le.value.app, state: null },
          s = { currentTab: `custom-inspector:${t.inspectorId}` };
        return (
          await new Promise((i) => {
            e.callHookWith(async (r) => {
              (await Promise.all(r.map((o) => o(n, s))), i());
            }, 'getInspectorState');
          }),
          n.state
        );
      },
      editInspectorState(t) {
        const n = new Xh(),
          s = {
            ...t,
            app: Le.value.app,
            set: (i, r = t.path, o = t.state.value, l) => {
              n.set(i, r, o, l || n.createDefaultSetCallback(t.state));
            }
          };
        e.callHookWith((i) => {
          i.forEach((r) => r(s));
        }, 'editInspectorState');
      },
      sendInspectorState(t) {
        const n = fi(t);
        e.callHook('sendInspectorState', {
          inspectorId: t,
          plugin: { descriptor: n.descriptor, setupFn: () => ({}) }
        });
      },
      inspectComponentInspector() {
        return Kh();
      },
      cancelInspectComponentInspector() {
        return Hh();
      },
      getComponentRenderCode(t) {
        const n = kr(Le.value, t);
        if (n)
          return typeof (n == null ? void 0 : n.type) != 'function'
            ? n.render.toString()
            : n.type.toString();
      },
      scrollToComponent(t) {
        return Wh({ id: t });
      },
      openInEditor: f0,
      getVueInspector: Zh,
      toggleApp(t, n) {
        const s = di.value.find((i) => i.id === t);
        s && (c0(t), u0(s), k0(s, Le), Xa(), xu(s.app, n));
      },
      inspectDOM(t) {
        const n = kr(Le.value, t);
        if (n) {
          const [s] = Cr(n);
          s && (j.__VUE_DEVTOOLS_INSPECT_DOM_TARGET__ = s);
        }
      },
      updatePluginSettings(t, n, s) {
        h0(t, n, s);
      },
      getPluginSettings(t) {
        return { options: d0(t), values: gu(t) };
      }
    };
  }
  S();
  var Au, Tu;
  (Tu = (Au = j).__VUE_DEVTOOLS_ENV__) != null ||
    (Au.__VUE_DEVTOOLS_ENV__ = { vitePluginDetected: !1 });
  var Ou = o0(),
    Iu,
    $u;
  ($u = (Iu = j).__VUE_DEVTOOLS_KIT_CONTEXT__) != null ||
    (Iu.__VUE_DEVTOOLS_KIT_CONTEXT__ = {
      hooks: Ou,
      get state() {
        return { ...Te, activeAppRecordId: Le.id, activeAppRecord: Le.value, appRecords: di.value };
      },
      api: C0(Ou)
    });
  var zn = j.__VUE_DEVTOOLS_KIT_CONTEXT__;
  (S(), Ah(Oh()));
  var Bu, Fu;
  ((Fu = (Bu = j).__VUE_DEVTOOLS_NEXT_APP_RECORD_INFO__) != null ||
    (Bu.__VUE_DEVTOOLS_NEXT_APP_RECORD_INFO__ = { id: 0, appIds: new Set() }),
    S());
  function A0(e) {
    ((Te.highPerfModeEnabled = e ?? !Te.highPerfModeEnabled), !e && Le.value && xu(Le.value.app));
  }
  (S(), S(), S());
  function T0(e) {
    Te.devtoolsClientDetected = { ...Te.devtoolsClientDetected, ...e };
    const t = Object.values(Te.devtoolsClientDetected).some(Boolean);
    A0(!t);
  }
  var Du, zu;
  ((zu = (Du = j).__VUE_DEVTOOLS_UPDATE_CLIENT_DETECTED__) != null ||
    (Du.__VUE_DEVTOOLS_UPDATE_CLIENT_DETECTED__ = T0),
    S(),
    S(),
    S(),
    S(),
    S(),
    S(),
    S());
  var O0 = class {
      constructor() {
        ((this.keyToValue = new Map()), (this.valueToKey = new Map()));
      }
      set(e, t) {
        (this.keyToValue.set(e, t), this.valueToKey.set(t, e));
      }
      getByKey(e) {
        return this.keyToValue.get(e);
      }
      getByValue(e) {
        return this.valueToKey.get(e);
      }
      clear() {
        (this.keyToValue.clear(), this.valueToKey.clear());
      }
    },
    Pu = class {
      constructor(e) {
        ((this.generateIdentifier = e), (this.kv = new O0()));
      }
      register(e, t) {
        this.kv.getByValue(e) || (t || (t = this.generateIdentifier(e)), this.kv.set(t, e));
      }
      clear() {
        this.kv.clear();
      }
      getIdentifier(e) {
        return this.kv.getByValue(e);
      }
      getValue(e) {
        return this.kv.getByKey(e);
      }
    },
    I0 = class extends Pu {
      constructor() {
        (super((e) => e.name), (this.classToAllowedProps = new Map()));
      }
      register(e, t) {
        typeof t == 'object'
          ? (t.allowProps && this.classToAllowedProps.set(e, t.allowProps),
            super.register(e, t.identifier))
          : super.register(e, t);
      }
      getAllowedProps(e) {
        return this.classToAllowedProps.get(e);
      }
    };
  (S(), S());
  function $0(e) {
    if ('values' in Object) return Object.values(e);
    const t = [];
    for (const n in e) e.hasOwnProperty(n) && t.push(e[n]);
    return t;
  }
  function B0(e, t) {
    const n = $0(e);
    if ('find' in n) return n.find(t);
    const s = n;
    for (let i = 0; i < s.length; i++) {
      const r = s[i];
      if (t(r)) return r;
    }
  }
  function Pn(e, t) {
    Object.entries(e).forEach(([n, s]) => t(s, n));
  }
  function pi(e, t) {
    return e.indexOf(t) !== -1;
  }
  function Mu(e, t) {
    for (let n = 0; n < e.length; n++) {
      const s = e[n];
      if (t(s)) return s;
    }
  }
  var F0 = class {
    constructor() {
      this.transfomers = {};
    }
    register(e) {
      this.transfomers[e.name] = e;
    }
    findApplicable(e) {
      return B0(this.transfomers, (t) => t.isApplicable(e));
    }
    findByName(e) {
      return this.transfomers[e];
    }
  };
  (S(), S());
  var D0 = (e) => Object.prototype.toString.call(e).slice(8, -1),
    Ru = (e) => typeof e > 'u',
    z0 = (e) => e === null,
    ms = (e) =>
      typeof e != 'object' || e === null || e === Object.prototype
        ? !1
        : Object.getPrototypeOf(e) === null
          ? !0
          : Object.getPrototypeOf(e) === Object.prototype,
    Rr = (e) => ms(e) && Object.keys(e).length === 0,
    Wt = (e) => Array.isArray(e),
    P0 = (e) => typeof e == 'string',
    M0 = (e) => typeof e == 'number' && !isNaN(e),
    R0 = (e) => typeof e == 'boolean',
    V0 = (e) => e instanceof RegExp,
    gs = (e) => e instanceof Map,
    _s = (e) => e instanceof Set,
    Vu = (e) => D0(e) === 'Symbol',
    N0 = (e) => e instanceof Date && !isNaN(e.valueOf()),
    j0 = (e) => e instanceof Error,
    Nu = (e) => typeof e == 'number' && isNaN(e),
    L0 = (e) => R0(e) || z0(e) || Ru(e) || M0(e) || P0(e) || Vu(e),
    U0 = (e) => typeof e == 'bigint',
    Q0 = (e) => e === 1 / 0 || e === -1 / 0,
    H0 = (e) => ArrayBuffer.isView(e) && !(e instanceof DataView),
    K0 = (e) => e instanceof URL;
  S();
  var ju = (e) => e.replace(/\./g, '\\.'),
    Vr = (e) => e.map(String).map(ju).join('.'),
    qs = (e) => {
      const t = [];
      let n = '';
      for (let i = 0; i < e.length; i++) {
        let r = e.charAt(i);
        if (r === '\\' && e.charAt(i + 1) === '.') {
          ((n += '.'), i++);
          continue;
        }
        if (r === '.') {
          (t.push(n), (n = ''));
          continue;
        }
        n += r;
      }
      const s = n;
      return (t.push(s), t);
    };
  S();
  function bt(e, t, n, s) {
    return { isApplicable: e, annotation: t, transform: n, untransform: s };
  }
  var Lu = [
    bt(
      Ru,
      'undefined',
      () => null,
      () => {}
    ),
    bt(
      U0,
      'bigint',
      (e) => e.toString(),
      (e) => (typeof BigInt < 'u' ? BigInt(e) : (console.error('Please add a BigInt polyfill.'), e))
    ),
    bt(
      N0,
      'Date',
      (e) => e.toISOString(),
      (e) => new Date(e)
    ),
    bt(
      j0,
      'Error',
      (e, t) => {
        const n = { name: e.name, message: e.message };
        return (
          t.allowedErrorProps.forEach((s) => {
            n[s] = e[s];
          }),
          n
        );
      },
      (e, t) => {
        const n = new Error(e.message);
        return (
          (n.name = e.name),
          (n.stack = e.stack),
          t.allowedErrorProps.forEach((s) => {
            n[s] = e[s];
          }),
          n
        );
      }
    ),
    bt(
      V0,
      'regexp',
      (e) => '' + e,
      (e) => {
        const t = e.slice(1, e.lastIndexOf('/')),
          n = e.slice(e.lastIndexOf('/') + 1);
        return new RegExp(t, n);
      }
    ),
    bt(
      _s,
      'set',
      (e) => [...e.values()],
      (e) => new Set(e)
    ),
    bt(
      gs,
      'map',
      (e) => [...e.entries()],
      (e) => new Map(e)
    ),
    bt(
      (e) => Nu(e) || Q0(e),
      'number',
      (e) => (Nu(e) ? 'NaN' : e > 0 ? 'Infinity' : '-Infinity'),
      Number
    ),
    bt(
      (e) => e === 0 && 1 / e === -1 / 0,
      'number',
      () => '-0',
      Number
    ),
    bt(
      K0,
      'URL',
      (e) => e.toString(),
      (e) => new URL(e)
    )
  ];
  function hi(e, t, n, s) {
    return { isApplicable: e, annotation: t, transform: n, untransform: s };
  }
  var Uu = hi(
      (e, t) => (Vu(e) ? !!t.symbolRegistry.getIdentifier(e) : !1),
      (e, t) => ['symbol', t.symbolRegistry.getIdentifier(e)],
      (e) => e.description,
      (e, t, n) => {
        const s = n.symbolRegistry.getValue(t[1]);
        if (!s) throw new Error('Trying to deserialize unknown symbol');
        return s;
      }
    ),
    W0 = [
      Int8Array,
      Uint8Array,
      Int16Array,
      Uint16Array,
      Int32Array,
      Uint32Array,
      Float32Array,
      Float64Array,
      Uint8ClampedArray
    ].reduce((e, t) => ((e[t.name] = t), e), {}),
    Qu = hi(
      H0,
      (e) => ['typed-array', e.constructor.name],
      (e) => [...e],
      (e, t) => {
        const n = W0[t[1]];
        if (!n) throw new Error('Trying to deserialize unknown typed array');
        return new n(e);
      }
    );
  function Hu(e, t) {
    return e != null && e.constructor ? !!t.classRegistry.getIdentifier(e.constructor) : !1;
  }
  var Ku = hi(
      Hu,
      (e, t) => ['class', t.classRegistry.getIdentifier(e.constructor)],
      (e, t) => {
        const n = t.classRegistry.getAllowedProps(e.constructor);
        if (!n) return { ...e };
        const s = {};
        return (
          n.forEach((i) => {
            s[i] = e[i];
          }),
          s
        );
      },
      (e, t, n) => {
        const s = n.classRegistry.getValue(t[1]);
        if (!s)
          throw new Error(
            `Trying to deserialize unknown class '${t[1]}' - check https://github.com/blitz-js/superjson/issues/116#issuecomment-773996564`
          );
        return Object.assign(Object.create(s.prototype), e);
      }
    ),
    Wu = hi(
      (e, t) => !!t.customTransformerRegistry.findApplicable(e),
      (e, t) => ['custom', t.customTransformerRegistry.findApplicable(e).name],
      (e, t) => t.customTransformerRegistry.findApplicable(e).serialize(e),
      (e, t, n) => {
        const s = n.customTransformerRegistry.findByName(t[1]);
        if (!s) throw new Error('Trying to deserialize unknown custom value');
        return s.deserialize(e);
      }
    ),
    G0 = [Ku, Uu, Wu, Qu],
    Gu = (e, t) => {
      const n = Mu(G0, (i) => i.isApplicable(e, t));
      if (n) return { value: n.transform(e, t), type: n.annotation(e, t) };
      const s = Mu(Lu, (i) => i.isApplicable(e, t));
      if (s) return { value: s.transform(e, t), type: s.annotation };
    },
    Yu = {};
  Lu.forEach((e) => {
    Yu[e.annotation] = e;
  });
  var Y0 = (e, t, n) => {
    if (Wt(t))
      switch (t[0]) {
        case 'symbol':
          return Uu.untransform(e, t, n);
        case 'class':
          return Ku.untransform(e, t, n);
        case 'custom':
          return Wu.untransform(e, t, n);
        case 'typed-array':
          return Qu.untransform(e, t, n);
        default:
          throw new Error('Unknown transformation: ' + t);
      }
    else {
      const s = Yu[t];
      if (!s) throw new Error('Unknown transformation: ' + t);
      return s.untransform(e, n);
    }
  };
  S();
  var Mn = (e, t) => {
    if (t > e.size) throw new Error('index out of bounds');
    const n = e.keys();
    for (; t > 0; ) (n.next(), t--);
    return n.next().value;
  };
  function Zu(e) {
    if (pi(e, '__proto__')) throw new Error('__proto__ is not allowed as a property');
    if (pi(e, 'prototype')) throw new Error('prototype is not allowed as a property');
    if (pi(e, 'constructor')) throw new Error('constructor is not allowed as a property');
  }
  var Z0 = (e, t) => {
      Zu(t);
      for (let n = 0; n < t.length; n++) {
        const s = t[n];
        if (_s(e)) e = Mn(e, +s);
        else if (gs(e)) {
          const i = +s,
            r = +t[++n] == 0 ? 'key' : 'value',
            o = Mn(e, i);
          switch (r) {
            case 'key':
              e = o;
              break;
            case 'value':
              e = e.get(o);
              break;
          }
        } else e = e[s];
      }
      return e;
    },
    Nr = (e, t, n) => {
      if ((Zu(t), t.length === 0)) return n(e);
      let s = e;
      for (let r = 0; r < t.length - 1; r++) {
        const o = t[r];
        if (Wt(s)) {
          const l = +o;
          s = s[l];
        } else if (ms(s)) s = s[o];
        else if (_s(s)) {
          const l = +o;
          s = Mn(s, l);
        } else if (gs(s)) {
          if (r === t.length - 2) break;
          const a = +o,
            f = +t[++r] == 0 ? 'key' : 'value',
            c = Mn(s, a);
          switch (f) {
            case 'key':
              s = c;
              break;
            case 'value':
              s = s.get(c);
              break;
          }
        }
      }
      const i = t[t.length - 1];
      if ((Wt(s) ? (s[+i] = n(s[+i])) : ms(s) && (s[i] = n(s[i])), _s(s))) {
        const r = Mn(s, +i),
          o = n(r);
        r !== o && (s.delete(r), s.add(o));
      }
      if (gs(s)) {
        const r = +t[t.length - 2],
          o = Mn(s, r);
        switch (+i == 0 ? 'key' : 'value') {
          case 'key': {
            const a = n(o);
            (s.set(a, s.get(o)), a !== o && s.delete(o));
            break;
          }
          case 'value': {
            s.set(o, n(s.get(o)));
            break;
          }
        }
      }
      return e;
    };
  function jr(e, t, n = []) {
    if (!e) return;
    if (!Wt(e)) {
      Pn(e, (r, o) => jr(r, t, [...n, ...qs(o)]));
      return;
    }
    const [s, i] = e;
    (i &&
      Pn(i, (r, o) => {
        jr(r, t, [...n, ...qs(o)]);
      }),
      t(s, n));
  }
  function J0(e, t, n) {
    return (
      jr(t, (s, i) => {
        e = Nr(e, i, (r) => Y0(r, s, n));
      }),
      e
    );
  }
  function X0(e, t) {
    function n(s, i) {
      const r = Z0(e, qs(i));
      s.map(qs).forEach((o) => {
        e = Nr(e, o, () => r);
      });
    }
    if (Wt(t)) {
      const [s, i] = t;
      (s.forEach((r) => {
        e = Nr(e, qs(r), () => e);
      }),
        i && Pn(i, n));
    } else Pn(t, n);
    return e;
  }
  var em = (e, t) => ms(e) || Wt(e) || gs(e) || _s(e) || Hu(e, t);
  function tm(e, t, n) {
    const s = n.get(e);
    s ? s.push(t) : n.set(e, [t]);
  }
  function nm(e, t) {
    const n = {};
    let s;
    return (
      e.forEach((i) => {
        if (i.length <= 1) return;
        t || (i = i.map((l) => l.map(String)).sort((l, a) => l.length - a.length));
        const [r, ...o] = i;
        r.length === 0 ? (s = o.map(Vr)) : (n[Vr(r)] = o.map(Vr));
      }),
      s ? (Rr(n) ? [s] : [s, n]) : Rr(n) ? void 0 : n
    );
  }
  var Ju = (e, t, n, s, i = [], r = [], o = new Map()) => {
    var l;
    const a = L0(e);
    if (!a) {
      tm(e, i, t);
      const h = o.get(e);
      if (h) return s ? { transformedValue: null } : h;
    }
    if (!em(e, n)) {
      const h = Gu(e, n),
        q = h ? { transformedValue: h.value, annotations: [h.type] } : { transformedValue: e };
      return (a || o.set(e, q), q);
    }
    if (pi(r, e)) return { transformedValue: null };
    const f = Gu(e, n),
      c = (l = f == null ? void 0 : f.value) != null ? l : e,
      u = Wt(c) ? [] : {},
      d = {};
    Pn(c, (h, q) => {
      if (q === '__proto__' || q === 'constructor' || q === 'prototype')
        throw new Error(
          `Detected property ${q}. This is a prototype pollution risk, please remove it from your object.`
        );
      const v = Ju(h, t, n, s, [...i, q], [...r, e], o);
      ((u[q] = v.transformedValue),
        Wt(v.annotations)
          ? (d[q] = v.annotations)
          : ms(v.annotations) &&
            Pn(v.annotations, (y, z) => {
              d[ju(q) + '.' + z] = y;
            }));
    });
    const p = Rr(d)
      ? { transformedValue: u, annotations: f ? [f.type] : void 0 }
      : { transformedValue: u, annotations: f ? [f.type, d] : d };
    return (a || o.set(e, p), p);
  };
  (S(), S());
  function Xu(e) {
    return Object.prototype.toString.call(e).slice(8, -1);
  }
  function ec(e) {
    return Xu(e) === 'Array';
  }
  function sm(e) {
    if (Xu(e) !== 'Object') return !1;
    const t = Object.getPrototypeOf(e);
    return !!t && t.constructor === Object && t === Object.prototype;
  }
  function im(e, t, n, s, i) {
    const r = {}.propertyIsEnumerable.call(s, t) ? 'enumerable' : 'nonenumerable';
    (r === 'enumerable' && (e[t] = n),
      i &&
        r === 'nonenumerable' &&
        Object.defineProperty(e, t, { value: n, enumerable: !1, writable: !0, configurable: !0 }));
  }
  function Lr(e, t = {}) {
    if (ec(e)) return e.map((i) => Lr(i, t));
    if (!sm(e)) return e;
    const n = Object.getOwnPropertyNames(e),
      s = Object.getOwnPropertySymbols(e);
    return [...n, ...s].reduce((i, r) => {
      if (ec(t.props) && !t.props.includes(r)) return i;
      const o = e[r],
        l = Lr(o, t);
      return (im(i, r, l, e, t.nonenumerable), i);
    }, {});
  }
  var qe = class {
    constructor({ dedupe: e = !1 } = {}) {
      ((this.classRegistry = new I0()),
        (this.symbolRegistry = new Pu((t) => {
          var n;
          return (n = t.description) != null ? n : '';
        })),
        (this.customTransformerRegistry = new F0()),
        (this.allowedErrorProps = []),
        (this.dedupe = e));
    }
    serialize(e) {
      const t = new Map(),
        n = Ju(e, t, this, this.dedupe),
        s = { json: n.transformedValue };
      n.annotations && (s.meta = { ...s.meta, values: n.annotations });
      const i = nm(t, this.dedupe);
      return (i && (s.meta = { ...s.meta, referentialEqualities: i }), s);
    }
    deserialize(e) {
      const { json: t, meta: n } = e;
      let s = Lr(t);
      return (
        n != null && n.values && (s = J0(s, n.values, this)),
        n != null && n.referentialEqualities && (s = X0(s, n.referentialEqualities)),
        s
      );
    }
    stringify(e) {
      return JSON.stringify(this.serialize(e));
    }
    parse(e) {
      return this.deserialize(JSON.parse(e));
    }
    registerClass(e, t) {
      this.classRegistry.register(e, t);
    }
    registerSymbol(e, t) {
      this.symbolRegistry.register(e, t);
    }
    registerCustom(e, t) {
      this.customTransformerRegistry.register({ name: t, ...e });
    }
    allowErrorProps(...e) {
      this.allowedErrorProps.push(...e);
    }
  };
  ((qe.defaultInstance = new qe()),
    (qe.serialize = qe.defaultInstance.serialize.bind(qe.defaultInstance)),
    (qe.deserialize = qe.defaultInstance.deserialize.bind(qe.defaultInstance)),
    (qe.stringify = qe.defaultInstance.stringify.bind(qe.defaultInstance)),
    (qe.parse = qe.defaultInstance.parse.bind(qe.defaultInstance)),
    (qe.registerClass = qe.defaultInstance.registerClass.bind(qe.defaultInstance)),
    (qe.registerSymbol = qe.defaultInstance.registerSymbol.bind(qe.defaultInstance)),
    (qe.registerCustom = qe.defaultInstance.registerCustom.bind(qe.defaultInstance)),
    (qe.allowErrorProps = qe.defaultInstance.allowErrorProps.bind(qe.defaultInstance)),
    S(),
    S(),
    S(),
    S(),
    S(),
    S(),
    S(),
    S(),
    S(),
    S(),
    S(),
    S(),
    S(),
    S(),
    S(),
    S(),
    S(),
    S(),
    S(),
    S(),
    S(),
    S(),
    S());
  var tc, nc;
  (nc = (tc = j).__VUE_DEVTOOLS_KIT_MESSAGE_CHANNELS__) != null ||
    (tc.__VUE_DEVTOOLS_KIT_MESSAGE_CHANNELS__ = []);
  var sc, ic;
  (ic = (sc = j).__VUE_DEVTOOLS_KIT_RPC_CLIENT__) != null ||
    (sc.__VUE_DEVTOOLS_KIT_RPC_CLIENT__ = null);
  var rc, oc;
  (oc = (rc = j).__VUE_DEVTOOLS_KIT_RPC_SERVER__) != null ||
    (rc.__VUE_DEVTOOLS_KIT_RPC_SERVER__ = null);
  var lc, ac;
  (ac = (lc = j).__VUE_DEVTOOLS_KIT_VITE_RPC_CLIENT__) != null ||
    (lc.__VUE_DEVTOOLS_KIT_VITE_RPC_CLIENT__ = null);
  var uc, cc;
  (cc = (uc = j).__VUE_DEVTOOLS_KIT_VITE_RPC_SERVER__) != null ||
    (uc.__VUE_DEVTOOLS_KIT_VITE_RPC_SERVER__ = null);
  var fc, dc;
  ((dc = (fc = j).__VUE_DEVTOOLS_KIT_BROADCAST_RPC_SERVER__) != null ||
    (fc.__VUE_DEVTOOLS_KIT_BROADCAST_RPC_SERVER__ = null),
    S(),
    S(),
    S(),
    S(),
    S(),
    S(),
    S());
  let Ur;
  const vs = (e) => (Ur = e),
    pc = Symbol('pinia');
  function hn(e) {
    return (
      e &&
      typeof e == 'object' &&
      Object.prototype.toString.call(e) === '[object Object]' &&
      typeof e.toJSON != 'function'
    );
  }
  var wt;
  (function (e) {
    ((e.direct = 'direct'), (e.patchObject = 'patch object'), (e.patchFunction = 'patch function'));
  })(wt || (wt = {}));
  const mn = typeof window < 'u',
    hc =
      typeof window == 'object' && window.window === window
        ? window
        : typeof self == 'object' && self.self === self
          ? self
          : typeof global == 'object' && global.global === global
            ? global
            : typeof globalThis == 'object'
              ? globalThis
              : { HTMLElement: null };
  function rm(e, { autoBom: t = !1 } = {}) {
    return t &&
      /^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(e.type)
      ? new Blob(['\uFEFF', e], { type: e.type })
      : e;
  }
  function Qr(e, t, n) {
    const s = new XMLHttpRequest();
    (s.open('GET', e),
      (s.responseType = 'blob'),
      (s.onload = function () {
        _c(s.response, t, n);
      }),
      (s.onerror = function () {
        console.error('could not download file');
      }),
      s.send());
  }
  function mc(e) {
    const t = new XMLHttpRequest();
    t.open('HEAD', e, !1);
    try {
      t.send();
    } catch {}
    return t.status >= 200 && t.status <= 299;
  }
  function mi(e) {
    try {
      e.dispatchEvent(new MouseEvent('click'));
    } catch {
      const n = new MouseEvent('click', {
        bubbles: !0,
        cancelable: !0,
        view: window,
        detail: 0,
        screenX: 80,
        screenY: 20,
        clientX: 80,
        clientY: 20,
        ctrlKey: !1,
        altKey: !1,
        shiftKey: !1,
        metaKey: !1,
        button: 0,
        relatedTarget: null
      });
      e.dispatchEvent(n);
    }
  }
  const gi = typeof navigator == 'object' ? navigator : { userAgent: '' },
    gc =
      /Macintosh/.test(gi.userAgent) &&
      /AppleWebKit/.test(gi.userAgent) &&
      !/Safari/.test(gi.userAgent),
    _c = mn
      ? typeof HTMLAnchorElement < 'u' && 'download' in HTMLAnchorElement.prototype && !gc
        ? om
        : 'msSaveOrOpenBlob' in gi
          ? lm
          : am
      : () => {};
  function om(e, t = 'download', n) {
    const s = document.createElement('a');
    ((s.download = t),
      (s.rel = 'noopener'),
      typeof e == 'string'
        ? ((s.href = e),
          s.origin !== location.origin
            ? mc(s.href)
              ? Qr(e, t, n)
              : ((s.target = '_blank'), mi(s))
            : mi(s))
        : ((s.href = URL.createObjectURL(e)),
          setTimeout(function () {
            URL.revokeObjectURL(s.href);
          }, 4e4),
          setTimeout(function () {
            mi(s);
          }, 0)));
  }
  function lm(e, t = 'download', n) {
    if (typeof e == 'string')
      if (mc(e)) Qr(e, t, n);
      else {
        const s = document.createElement('a');
        ((s.href = e),
          (s.target = '_blank'),
          setTimeout(function () {
            mi(s);
          }));
      }
    else navigator.msSaveOrOpenBlob(rm(e, n), t);
  }
  function am(e, t, n, s) {
    if (
      ((s = s || open('', '_blank')),
      s && (s.document.title = s.document.body.innerText = 'downloading...'),
      typeof e == 'string')
    )
      return Qr(e, t, n);
    const i = e.type === 'application/octet-stream',
      r = /constructor/i.test(String(hc.HTMLElement)) || 'safari' in hc,
      o = /CriOS\/[\d]+/.test(navigator.userAgent);
    if ((o || (i && r) || gc) && typeof FileReader < 'u') {
      const l = new FileReader();
      ((l.onloadend = function () {
        let a = l.result;
        if (typeof a != 'string') throw ((s = null), new Error('Wrong reader.result type'));
        ((a = o ? a : a.replace(/^data:[^;]*;/, 'data:attachment/file;')),
          s ? (s.location.href = a) : location.assign(a),
          (s = null));
      }),
        l.readAsDataURL(e));
    } else {
      const l = URL.createObjectURL(e);
      (s ? s.location.assign(l) : (location.href = l),
        (s = null),
        setTimeout(function () {
          URL.revokeObjectURL(l);
        }, 4e4));
    }
  }
  function Ie(e, t) {
    const n = '🍍 ' + e;
    typeof __VUE_DEVTOOLS_TOAST__ == 'function'
      ? __VUE_DEVTOOLS_TOAST__(n, t)
      : t === 'error'
        ? console.error(n)
        : t === 'warn'
          ? console.warn(n)
          : console.log(n);
  }
  function Hr(e) {
    return '_a' in e && 'install' in e;
  }
  function qc() {
    if (!('clipboard' in navigator))
      return (Ie("Your browser doesn't support the Clipboard API", 'error'), !0);
  }
  function vc(e) {
    return e instanceof Error && e.message.toLowerCase().includes('document is not focused')
      ? (Ie(
          'You need to activate the "Emulate a focused page" setting in the "Rendering" panel of devtools.',
          'warn'
        ),
        !0)
      : !1;
  }
  async function um(e) {
    if (!qc())
      try {
        (await navigator.clipboard.writeText(JSON.stringify(e.state.value)),
          Ie('Global state copied to clipboard.'));
      } catch (t) {
        if (vc(t)) return;
        (Ie('Failed to serialize the state. Check the console for more details.', 'error'),
          console.error(t));
      }
  }
  async function cm(e) {
    if (!qc())
      try {
        (yc(e, JSON.parse(await navigator.clipboard.readText())),
          Ie('Global state pasted from clipboard.'));
      } catch (t) {
        if (vc(t)) return;
        (Ie(
          'Failed to deserialize the state from clipboard. Check the console for more details.',
          'error'
        ),
          console.error(t));
      }
  }
  async function fm(e) {
    try {
      _c(
        new Blob([JSON.stringify(e.state.value)], { type: 'text/plain;charset=utf-8' }),
        'pinia-state.json'
      );
    } catch (t) {
      (Ie('Failed to export the state as JSON. Check the console for more details.', 'error'),
        console.error(t));
    }
  }
  let zt;
  function dm() {
    zt || ((zt = document.createElement('input')), (zt.type = 'file'), (zt.accept = '.json'));
    function e() {
      return new Promise((t, n) => {
        ((zt.onchange = async () => {
          const s = zt.files;
          if (!s) return t(null);
          const i = s.item(0);
          return t(i ? { text: await i.text(), file: i } : null);
        }),
          (zt.oncancel = () => t(null)),
          (zt.onerror = n),
          zt.click());
      });
    }
    return e;
  }
  async function pm(e) {
    try {
      const n = await dm()();
      if (!n) return;
      const { text: s, file: i } = n;
      (yc(e, JSON.parse(s)), Ie(`Global state imported from "${i.name}".`));
    } catch (t) {
      (Ie('Failed to import the state from JSON. Check the console for more details.', 'error'),
        console.error(t));
    }
  }
  function yc(e, t) {
    for (const n in t) {
      const s = e.state.value[n];
      s ? Object.assign(s, t[n]) : (e.state.value[n] = t[n]);
    }
  }
  function ct(e) {
    return { _custom: { display: e } };
  }
  const bc = '🍍 Pinia (root)',
    _i = '_root';
  function hm(e) {
    return Hr(e) ? { id: _i, label: bc } : { id: e.$id, label: e.$id };
  }
  function mm(e) {
    if (Hr(e)) {
      const n = Array.from(e._s.keys()),
        s = e._s;
      return {
        state: n.map((r) => ({ editable: !0, key: r, value: e.state.value[r] })),
        getters: n
          .filter((r) => s.get(r)._getters)
          .map((r) => {
            const o = s.get(r);
            return {
              editable: !1,
              key: r,
              value: o._getters.reduce((l, a) => ((l[a] = o[a]), l), {})
            };
          })
      };
    }
    const t = {
      state: Object.keys(e.$state).map((n) => ({ editable: !0, key: n, value: e.$state[n] }))
    };
    return (
      e._getters &&
        e._getters.length &&
        (t.getters = e._getters.map((n) => ({ editable: !1, key: n, value: e[n] }))),
      e._customProperties.size &&
        (t.customProperties = Array.from(e._customProperties).map((n) => ({
          editable: !0,
          key: n,
          value: e[n]
        }))),
      t
    );
  }
  function gm(e) {
    return e
      ? Array.isArray(e)
        ? e.reduce(
            (t, n) => (
              t.keys.push(n.key),
              t.operations.push(n.type),
              (t.oldValue[n.key] = n.oldValue),
              (t.newValue[n.key] = n.newValue),
              t
            ),
            { oldValue: {}, keys: [], operations: [], newValue: {} }
          )
        : { operation: ct(e.type), key: ct(e.key), oldValue: e.oldValue, newValue: e.newValue }
      : {};
  }
  function _m(e) {
    switch (e) {
      case wt.direct:
        return 'mutation';
      case wt.patchFunction:
        return '$patch';
      case wt.patchObject:
        return '$patch';
      default:
        return 'unknown';
    }
  }
  let Rn = !0;
  const qi = [],
    gn = 'pinia:mutations',
    Pe = 'pinia',
    { assign: qm } = Object,
    vi = (e) => '🍍 ' + e;
  function vm(e, t) {
    wu(
      {
        id: 'dev.esm.pinia',
        label: 'Pinia 🍍',
        logo: 'https://pinia.vuejs.org/logo.svg',
        packageName: 'pinia',
        homepage: 'https://pinia.vuejs.org',
        componentStateTypes: qi,
        app: e
      },
      (n) => {
        (typeof n.now != 'function' &&
          Ie(
            'You seem to be using an outdated version of Vue Devtools. Are you still using the Beta release instead of the stable one? You can find the links at https://devtools.vuejs.org/guide/installation.html.'
          ),
          n.addTimelineLayer({ id: gn, label: 'Pinia 🍍', color: 15064968 }),
          n.addInspector({
            id: Pe,
            label: 'Pinia 🍍',
            icon: 'storage',
            treeFilterPlaceholder: 'Search stores',
            actions: [
              {
                icon: 'content_copy',
                action: () => {
                  um(t);
                },
                tooltip: 'Serialize and copy the state'
              },
              {
                icon: 'content_paste',
                action: async () => {
                  (await cm(t), n.sendInspectorTree(Pe), n.sendInspectorState(Pe));
                },
                tooltip: 'Replace the state with the content of your clipboard'
              },
              {
                icon: 'save',
                action: () => {
                  fm(t);
                },
                tooltip: 'Save the state as a JSON file'
              },
              {
                icon: 'folder_open',
                action: async () => {
                  (await pm(t), n.sendInspectorTree(Pe), n.sendInspectorState(Pe));
                },
                tooltip: 'Import the state from a JSON file'
              }
            ],
            nodeActions: [
              {
                icon: 'restore',
                tooltip: 'Reset the state (with "$reset")',
                action: (s) => {
                  const i = t._s.get(s);
                  i
                    ? typeof i.$reset != 'function'
                      ? Ie(
                          `Cannot reset "${s}" store because it doesn't have a "$reset" method implemented.`,
                          'warn'
                        )
                      : (i.$reset(), Ie(`Store "${s}" reset.`))
                    : Ie(`Cannot reset "${s}" store because it wasn't found.`, 'warn');
                }
              }
            ]
          }),
          n.on.inspectComponent((s) => {
            const i = s.componentInstance && s.componentInstance.proxy;
            if (i && i._pStores) {
              const r = s.componentInstance.proxy._pStores;
              Object.values(r).forEach((o) => {
                (s.instanceData.state.push({
                  type: vi(o.$id),
                  key: 'state',
                  editable: !0,
                  value: o._isOptionsAPI
                    ? {
                        _custom: {
                          value: J(o.$state),
                          actions: [
                            {
                              icon: 'restore',
                              tooltip: 'Reset the state of this store',
                              action: () => o.$reset()
                            }
                          ]
                        }
                      }
                    : Object.keys(o.$state).reduce((l, a) => ((l[a] = o.$state[a]), l), {})
                }),
                  o._getters &&
                    o._getters.length &&
                    s.instanceData.state.push({
                      type: vi(o.$id),
                      key: 'getters',
                      editable: !1,
                      value: o._getters.reduce((l, a) => {
                        try {
                          l[a] = o[a];
                        } catch (f) {
                          l[a] = f;
                        }
                        return l;
                      }, {})
                    }));
              });
            }
          }),
          n.on.getInspectorTree((s) => {
            if (s.app === e && s.inspectorId === Pe) {
              let i = [t];
              ((i = i.concat(Array.from(t._s.values()))),
                (s.rootNodes = (
                  s.filter
                    ? i.filter((r) =>
                        '$id' in r
                          ? r.$id.toLowerCase().includes(s.filter.toLowerCase())
                          : bc.toLowerCase().includes(s.filter.toLowerCase())
                      )
                    : i
                ).map(hm)));
            }
          }),
          (globalThis.$pinia = t),
          n.on.getInspectorState((s) => {
            if (s.app === e && s.inspectorId === Pe) {
              const i = s.nodeId === _i ? t : t._s.get(s.nodeId);
              if (!i) return;
              i && (s.nodeId !== _i && (globalThis.$store = J(i)), (s.state = mm(i)));
            }
          }),
          n.on.editInspectorState((s) => {
            if (s.app === e && s.inspectorId === Pe) {
              const i = s.nodeId === _i ? t : t._s.get(s.nodeId);
              if (!i) return Ie(`store "${s.nodeId}" not found`, 'error');
              const { path: r } = s;
              (Hr(i)
                ? r.unshift('state')
                : (r.length !== 1 || !i._customProperties.has(r[0]) || r[0] in i.$state) &&
                  r.unshift('$state'),
                (Rn = !1),
                s.set(i, r, s.state.value),
                (Rn = !0));
            }
          }),
          n.on.editComponentState((s) => {
            if (s.type.startsWith('🍍')) {
              const i = s.type.replace(/^🍍\s*/, ''),
                r = t._s.get(i);
              if (!r) return Ie(`store "${i}" not found`, 'error');
              const { path: o } = s;
              if (o[0] !== 'state')
                return Ie(`Invalid path for store "${i}":
${o}
Only state can be modified.`);
              ((o[0] = '$state'), (Rn = !1), s.set(r, o, s.state.value), (Rn = !0));
            }
          }));
      }
    );
  }
  function ym(e, t) {
    (qi.includes(vi(t.$id)) || qi.push(vi(t.$id)),
      wu(
        {
          id: 'dev.esm.pinia',
          label: 'Pinia 🍍',
          logo: 'https://pinia.vuejs.org/logo.svg',
          packageName: 'pinia',
          homepage: 'https://pinia.vuejs.org',
          componentStateTypes: qi,
          app: e,
          settings: {
            logStoreChanges: {
              label: 'Notify about new/deleted stores',
              type: 'boolean',
              defaultValue: !0
            }
          }
        },
        (n) => {
          const s = typeof n.now == 'function' ? n.now.bind(n) : Date.now;
          (t.$onAction(({ after: o, onError: l, name: a, args: f }) => {
            const c = wc++;
            (n.addTimelineEvent({
              layerId: gn,
              event: {
                time: s(),
                title: '🛫 ' + a,
                subtitle: 'start',
                data: { store: ct(t.$id), action: ct(a), args: f },
                groupId: c
              }
            }),
              o((u) => {
                ((Gt = void 0),
                  n.addTimelineEvent({
                    layerId: gn,
                    event: {
                      time: s(),
                      title: '🛬 ' + a,
                      subtitle: 'end',
                      data: { store: ct(t.$id), action: ct(a), args: f, result: u },
                      groupId: c
                    }
                  }));
              }),
              l((u) => {
                ((Gt = void 0),
                  n.addTimelineEvent({
                    layerId: gn,
                    event: {
                      time: s(),
                      logType: 'error',
                      title: '💥 ' + a,
                      subtitle: 'end',
                      data: { store: ct(t.$id), action: ct(a), args: f, error: u },
                      groupId: c
                    }
                  }));
              }));
          }, !0),
            t._customProperties.forEach((o) => {
              ze(
                () => rt(t[o]),
                (l, a) => {
                  (n.notifyComponentUpdate(),
                    n.sendInspectorState(Pe),
                    Rn &&
                      n.addTimelineEvent({
                        layerId: gn,
                        event: {
                          time: s(),
                          title: 'Change',
                          subtitle: o,
                          data: { newValue: l, oldValue: a },
                          groupId: Gt
                        }
                      }));
                },
                { deep: !0 }
              );
            }),
            t.$subscribe(
              ({ events: o, type: l }, a) => {
                if ((n.notifyComponentUpdate(), n.sendInspectorState(Pe), !Rn)) return;
                const f = {
                  time: s(),
                  title: _m(l),
                  data: qm({ store: ct(t.$id) }, gm(o)),
                  groupId: Gt
                };
                (l === wt.patchFunction
                  ? (f.subtitle = '⤵️')
                  : l === wt.patchObject
                    ? (f.subtitle = '🧩')
                    : o && !Array.isArray(o) && (f.subtitle = o.type),
                  o &&
                    (f.data['rawEvent(s)'] = {
                      _custom: {
                        display: 'DebuggerEvent',
                        type: 'object',
                        tooltip: 'raw DebuggerEvent[]',
                        value: o
                      }
                    }),
                  n.addTimelineEvent({ layerId: gn, event: f }));
              },
              { detached: !0, flush: 'sync' }
            ));
          const i = t._hotUpdate;
          t._hotUpdate = Mt((o) => {
            (i(o),
              n.addTimelineEvent({
                layerId: gn,
                event: {
                  time: s(),
                  title: '🔥 ' + t.$id,
                  subtitle: 'HMR update',
                  data: { store: ct(t.$id), info: ct('HMR update') }
                }
              }),
              n.notifyComponentUpdate(),
              n.sendInspectorTree(Pe),
              n.sendInspectorState(Pe));
          });
          const { $dispose: r } = t;
          ((t.$dispose = () => {
            (r(),
              n.notifyComponentUpdate(),
              n.sendInspectorTree(Pe),
              n.sendInspectorState(Pe),
              n.getSettings().logStoreChanges && Ie(`Disposed "${t.$id}" store 🗑`));
          }),
            n.notifyComponentUpdate(),
            n.sendInspectorTree(Pe),
            n.sendInspectorState(Pe),
            n.getSettings().logStoreChanges && Ie(`"${t.$id}" store installed 🆕`));
        }
      ));
  }
  let wc = 0,
    Gt;
  function xc(e, t, n) {
    const s = t.reduce((i, r) => ((i[r] = J(e)[r]), i), {});
    for (const i in s)
      e[i] = function () {
        const r = wc,
          o = n
            ? new Proxy(e, {
                get(...a) {
                  return ((Gt = r), Reflect.get(...a));
                },
                set(...a) {
                  return ((Gt = r), Reflect.set(...a));
                }
              })
            : e;
        Gt = r;
        const l = s[i].apply(o, arguments);
        return ((Gt = void 0), l);
      };
  }
  function bm({ app: e, store: t, options: n }) {
    if (!t.$id.startsWith('__hot:')) {
      if (((t._isOptionsAPI = !!n.state), !t._p._testing)) {
        xc(t, Object.keys(n.actions), t._isOptionsAPI);
        const s = t._hotUpdate;
        J(t)._hotUpdate = function (i) {
          (s.apply(this, arguments), xc(t, Object.keys(i._hmrPayload.actions), !!t._isOptionsAPI));
        };
      }
      ym(e, t);
    }
  }
  function wm() {
    const e = fo(!0),
      t = e.run(() => Q({}));
    let n = [],
      s = [];
    const i = Mt({
      install(r) {
        (vs(i),
          (i._a = r),
          r.provide(pc, i),
          (r.config.globalProperties.$pinia = i),
          mn && vm(r, i),
          s.forEach((o) => n.push(o)),
          (s = []));
      },
      use(r) {
        return (this._a ? n.push(r) : s.push(r), this);
      },
      _p: n,
      _a: null,
      _e: e,
      _s: new Map(),
      state: t
    });
    return (mn && typeof Proxy < 'u' && i.use(bm), i);
  }
  function Ec(e, t) {
    for (const n in t) {
      const s = t[n];
      if (!(n in e)) continue;
      const i = e[n];
      hn(i) && hn(s) && !ge(s) && !pt(s) ? (e[n] = Ec(i, s)) : (e[n] = s);
    }
    return e;
  }
  const xm = () => {};
  function Sc(e, t, n, s = xm) {
    e.push(t);
    const i = () => {
      const r = e.indexOf(t);
      r > -1 && (e.splice(r, 1), s());
    };
    return (!n && po() && Jc(i), i);
  }
  function Vn(e, ...t) {
    e.slice().forEach((n) => {
      n(...t);
    });
  }
  const Em = (e) => e(),
    kc = Symbol(),
    Kr = Symbol();
  function Wr(e, t) {
    e instanceof Map && t instanceof Map
      ? t.forEach((n, s) => e.set(s, n))
      : e instanceof Set && t instanceof Set && t.forEach(e.add, e);
    for (const n in t) {
      if (!t.hasOwnProperty(n)) continue;
      const s = t[n],
        i = e[n];
      hn(i) && hn(s) && e.hasOwnProperty(n) && !ge(s) && !pt(s) ? (e[n] = Wr(i, s)) : (e[n] = s);
    }
    return e;
  }
  const Sm = Symbol('pinia:skipHydration');
  function km(e) {
    return !hn(e) || !Object.prototype.hasOwnProperty.call(e, Sm);
  }
  const { assign: st } = Object;
  function Cc(e) {
    return !!(ge(e) && e.effect);
  }
  function Ac(e, t, n, s) {
    const { state: i, actions: r, getters: o } = t,
      l = n.state.value[e];
    let a;
    function f() {
      !l && !s && (n.state.value[e] = i ? i() : {});
      const c = Do(s ? Q(i ? i() : {}).value : n.state.value[e]);
      return st(
        c,
        r,
        Object.keys(o || {}).reduce(
          (u, d) => (
            d in c &&
              console.warn(
                `[🍍]: A getter cannot have the same name as another state property. Rename one of them. Found with "${d}" in store "${e}".`
              ),
            (u[d] = Mt(
              L(() => {
                vs(n);
                const p = n._s.get(e);
                return o[d].call(p, p);
              })
            )),
            u
          ),
          {}
        )
      );
    }
    return ((a = Gr(e, f, t, n, s, !0)), a);
  }
  function Gr(e, t, n = {}, s, i, r) {
    let o;
    const l = st({ actions: {} }, n);
    if (!s._e.active) throw new Error('Pinia destroyed');
    const a = { deep: !0 };
    a.onTrigger = (w) => {
      f
        ? (p = w)
        : f == !1 &&
          !H._hotUpdating &&
          (Array.isArray(p)
            ? p.push(w)
            : console.error(
                '🍍 debuggerEvents should be an array. This is most likely an internal Pinia bug.'
              ));
    };
    let f,
      c,
      u = [],
      d = [],
      p;
    const h = s.state.value[e];
    !r && !h && !i && (s.state.value[e] = {});
    const q = Q({});
    let v;
    function y(w) {
      let x;
      ((f = c = !1),
        (p = []),
        typeof w == 'function'
          ? (w(s.state.value[e]), (x = { type: wt.patchFunction, storeId: e, events: p }))
          : (Wr(s.state.value[e], w),
            (x = { type: wt.patchObject, payload: w, storeId: e, events: p })));
      const E = (v = Symbol());
      (Hi().then(() => {
        v === E && (f = !0);
      }),
        (c = !0),
        Vn(u, x, s.state.value[e]));
    }
    const z = r
      ? function () {
          const { state: x } = n,
            E = x ? x() : {};
          this.$patch((Y) => {
            st(Y, E);
          });
        }
      : () => {
          throw new Error(
            `🍍: Store "${e}" is built using the setup syntax and does not implement $reset().`
          );
        };
    function O() {
      (o.stop(), (u = []), (d = []), s._s.delete(e));
    }
    const X = (w, x = '') => {
        if (kc in w) return ((w[Kr] = x), w);
        const E = function () {
          vs(s);
          const Y = Array.from(arguments),
            de = [],
            xe = [];
          function pe(re) {
            de.push(re);
          }
          function V(re) {
            xe.push(re);
          }
          Vn(d, { args: Y, name: E[Kr], store: H, after: pe, onError: V });
          let ee;
          try {
            ee = w.apply(this && this.$id === e ? this : H, Y);
          } catch (re) {
            throw (Vn(xe, re), re);
          }
          return ee instanceof Promise
            ? ee.then((re) => (Vn(de, re), re)).catch((re) => (Vn(xe, re), Promise.reject(re)))
            : (Vn(de, ee), ee);
        };
        return ((E[kc] = !0), (E[Kr] = x), E);
      },
      N = Mt({ actions: {}, getters: {}, state: [], hotState: q }),
      ne = {
        _p: s,
        $id: e,
        $onAction: Sc.bind(null, d),
        $patch: y,
        $reset: z,
        $subscribe(w, x = {}) {
          const E = Sc(u, w, x.detached, () => Y()),
            Y = o.run(() =>
              ze(
                () => s.state.value[e],
                (de) => {
                  (x.flush === 'sync' ? c : f) && w({ storeId: e, type: wt.direct, events: p }, de);
                },
                st({}, a, x)
              )
            );
          return E;
        },
        $dispose: O
      },
      H = Ds(st({ _hmrPayload: N, _customProperties: Mt(new Set()) }, ne));
    s._s.set(e, H);
    const U = ((s._a && s._a.runWithContext) || Em)(() =>
      s._e.run(() => (o = fo()).run(() => t({ action: X })))
    );
    for (const w in U) {
      const x = U[w];
      if ((ge(x) && !Cc(x)) || pt(x))
        (i
          ? (q.value[w] = Li(U, w))
          : r ||
            (h && km(x) && (ge(x) ? (x.value = h[w]) : Wr(x, h[w])), (s.state.value[e][w] = x)),
          N.state.push(w));
      else if (typeof x == 'function') {
        const E = i ? x : X(x, w);
        ((U[w] = E), (N.actions[w] = x), (l.actions[w] = x));
      } else
        Cc(x) &&
          ((N.getters[w] = r ? n.getters[w] : x),
          mn && (U._getters || (U._getters = Mt([]))).push(w));
    }
    if (
      (st(H, U),
      st(J(H), U),
      Object.defineProperty(H, '$state', {
        get: () => (i ? q.value : s.state.value[e]),
        set: (w) => {
          if (i) throw new Error('cannot set hotState');
          y((x) => {
            st(x, w);
          });
        }
      }),
      (H._hotUpdate = Mt((w) => {
        ((H._hotUpdating = !0),
          w._hmrPayload.state.forEach((x) => {
            if (x in H.$state) {
              const E = w.$state[x],
                Y = H.$state[x];
              typeof E == 'object' && hn(E) && hn(Y) ? Ec(E, Y) : (w.$state[x] = Y);
            }
            H[x] = Li(w.$state, x);
          }),
          Object.keys(H.$state).forEach((x) => {
            x in w.$state || delete H[x];
          }),
          (f = !1),
          (c = !1),
          (s.state.value[e] = Li(w._hmrPayload, 'hotState')),
          (c = !0),
          Hi().then(() => {
            f = !0;
          }));
        for (const x in w._hmrPayload.actions) {
          const E = w[x];
          H[x] = X(E, x);
        }
        for (const x in w._hmrPayload.getters) {
          const E = w._hmrPayload.getters[x],
            Y = r ? L(() => (vs(s), E.call(H, H))) : E;
          H[x] = Y;
        }
        (Object.keys(H._hmrPayload.getters).forEach((x) => {
          x in w._hmrPayload.getters || delete H[x];
        }),
          Object.keys(H._hmrPayload.actions).forEach((x) => {
            x in w._hmrPayload.actions || delete H[x];
          }),
          (H._hmrPayload = w._hmrPayload),
          (H._getters = w._getters),
          (H._hotUpdating = !1));
      })),
      mn)
    ) {
      const w = { writable: !0, configurable: !0, enumerable: !1 };
      ['_p', '_hmrPayload', '_getters', '_customProperties'].forEach((x) => {
        Object.defineProperty(H, x, st({ value: H[x] }, w));
      });
    }
    return (
      s._p.forEach((w) => {
        if (mn) {
          const x = o.run(() => w({ store: H, app: s._a, pinia: s, options: l }));
          (Object.keys(x || {}).forEach((E) => H._customProperties.add(E)), st(H, x));
        } else
          st(
            H,
            o.run(() => w({ store: H, app: s._a, pinia: s, options: l }))
          );
      }),
      H.$state &&
        typeof H.$state == 'object' &&
        typeof H.$state.constructor == 'function' &&
        !H.$state.constructor.toString().includes('[native code]') &&
        console.warn(`[🍍]: The "state" must be a plain object. It cannot be
	state: () => new MyClass()
Found in store "${H.$id}".`),
      h && r && n.hydrate && n.hydrate(H.$state, h),
      (f = !0),
      (c = !0),
      H
    );
  }
  /*! #__NO_SIDE_EFFECTS__ */ function Cm(e, t, n) {
    let s;
    const i = typeof t == 'function';
    s = i ? n : t;
    function r(o, l) {
      const a = xd();
      if (((o = o || (a ? is(pc, null) : null)), o && vs(o), !Ur))
        throw new Error(`[🍍]: "getActivePinia()" was called but there was no active Pinia. Are you trying to use a store before calling "app.use(pinia)"?
See https://pinia.vuejs.org/core-concepts/outside-component-usage.html for help.
This will fail in production.`);
      ((o = Ur), o._s.has(e) || (i ? Gr(e, t, s, o) : Ac(e, s, o), (r._pinia = o)));
      const f = o._s.get(e);
      if (l) {
        const c = '__hot:' + e,
          u = i ? Gr(c, t, s, o, !0) : Ac(c, st({}, s), o, !0);
        (l._hotUpdate(u), delete o.state.value[c], o._s.delete(c));
      }
      if (mn) {
        const c = ti();
        if (c && c.proxy && !l) {
          const u = c.proxy,
            d = '_pStores' in u ? u._pStores : (u._pStores = {});
          d[e] = f;
        }
      }
      return f;
    }
    return ((r.$id = e), r);
  }
  const Am = () => {
      const e = (s) => {
        let i = s.replace('https:', ''),
          r = [],
          o = i.lastIndexOf('.'),
          l = i.substring(0, o),
          a = i.substring(o + 1);
        return (
          [250, 375, 420, 600, 782].forEach((c) => {
            r.push(`${l}_${c}x_crop_center.${a}`);
          }),
          r
        );
      };
      return {
        generateSrcSetImages: (s) => {
          const i = e(s),
            r = [250, 375, 420, 600, 782];
          return i.map((o, l) => `${o} ${r[l]}w`).join(', ');
        },
        convertImageUrlTo150: (s) => {
          let i = s.lastIndexOf('.'),
            r = s.substring(0, i),
            o = s.substring(i + 1);
          return `${r}_150x_crop_center.${o}`;
        }
      };
    },
    Tm = [
      'src',
      'data-srcset',
      'alt',
      'sizes',
      'srcset',
      'aria-hidden',
      'loading',
      'decoding',
      'fetchpriority'
    ],
    ke = {
      __name: 'Image',
      props: {
        src: { type: String, required: !0 },
        alt: { type: String, default: '' },
        sizes: { type: String, default: '(max-width: 640px) 50vw, 400px' },
        loading: { type: String, default: 'lazy' },
        decoding: { type: String, default: 'async' },
        fetchpriority: { type: String, default: 'auto' },
        class: { type: [String, Array, Object], default: 'qlfqa:!w-full qlfqa:!h-auto' }
      },
      setup(e) {
        const { generateSrcSetImages: t } = Am(),
          n = e,
          s = L(() => n.class);
        return (i, r) =>
          e.src
            ? (F(),
              R(
                'img',
                {
                  key: 0,
                  'data-sizes': 'auto',
                  src: e.src,
                  'data-srcset': rt(t)(e.src),
                  alt: e.alt,
                  sizes: e.sizes,
                  srcset: rt(t)(e.src),
                  class: Be(s.value),
                  'aria-hidden': e.alt === '',
                  loading: e.loading,
                  decoding: e.decoding,
                  fetchpriority: e.fetchpriority,
                  role: 'img'
                },
                null,
                10,
                Tm
              ))
            : we('', !0);
      }
    },
    Om = { class: 'qlfqa:!flex qlfqa:!min-h-[100dvh] qlfqa:!flex-col qlfqa:!bg-[#F6F4F2]' },
    Im = {
      class:
        'qlfqa:!mx-auto qlfqa:!flex qlfqa:!w-full qlfqa:!flex-1 qlfqa:!flex-col qlfqa:sm:!max-w-md qlfqa:!bg-[#F6F4F2] qlfqa:!px-6 qlfqa:!pt-4'
    },
    $m = { class: 'qlfqa:!flex-1' },
    Bm = {
      __name: 'GuestLayout',
      setup(e) {
        return (t, n) => (
          F(),
          R('div', Om, [
            _('div', Im, [
              D(ke, {
                src: 'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/logo.png?v=1753083867',
                'image-width': 100,
                'srcset-widths': [50, 100],
                sizes: '50px',
                alt: 'Logo',
                loading: 'eager',
                decoding: 'async',
                width: '50',
                height: '50',
                style: { width: '50px !important', height: '50px !important' }
              }),
              _('div', $m, [cl(t.$slots, 'default')])
            ]),
            n[0] ||
              (n[0] = _(
                'footer',
                {
                  class:
                    'qlfqa:!mx-auto qlfqa:!w-full qlfqa:sm:!max-w-md qlfqa:!px-6 qlfqa:!pt-6 qlfqa:!pb-5 qlfqa:!text-center qlfqa:!text-xs qlfqa:!text-gray-400'
                },
                [
                  _(
                    'a',
                    {
                      href: '/pages/impressum',
                      target: '_blank',
                      class: 'qlfqa:!text-gray-400 qlfqa:hover:!text-gray-500'
                    },
                    'Impressum'
                  ),
                  _('span', { class: 'qlfqa:!mx-2' }, '|'),
                  _(
                    'a',
                    {
                      href: '/pages/datenschutz',
                      target: '_blank',
                      class: 'qlfqa:!text-gray-400 qlfqa:hover:!text-gray-500'
                    },
                    'Datenschutz'
                  )
                ],
                -1
              ))
          ])
        );
      }
    },
    ae = Cm('quiz', {
      state: () => ({
        age: '',
        gender: 'm',
        q03: '',
        q04: '',
        q05: '',
        q06: ['Bauch', 'Beine', 'Po'],
        q07: 'Moderat',
        q08: '',
        q09: '45',
        q10: '70',
        q11: '188',
        q12: '',
        q13: '',
        q14: '',
        q15: '',
        q16: '',
        q17: '',
        q18: '1.55,Moderat',
        q19: '',
        q20: '',
        q21: '',
        q22: '',
        q23: '',
        q24: '',
        q25: '',
        q26: '',
        q27: '',
        q28: '',
        q29: '',
        q30: '',
        q31: '',
        q32: '',
        currentScreen: 'QuizScreen01',
        screenHistory: [],
        quizCompleted: !1,
        results: null
      }),
      getters: {
        currentQuestion() {
          if (!this.gender) return null;
          const e = this.gender === 'male' ? this.maleQuestions : this.femaleQuestions;
          if (this.currentQuestionIndex < e.length) return e[this.currentQuestionIndex];
          {
            const t = this.currentQuestionIndex - e.length;
            return t < this.commonQuestions.length ? this.commonQuestions[t] : null;
          }
        },
        isFinished() {
          if (!this.gender) return !1;
          const e = this.gender === 'male' ? this.maleQuestions : this.femaleQuestions;
          return this.currentQuestionIndex >= e.length + this.commonQuestions.length;
        }
      },
      actions: {
        goToNextScreen(e = null) {
          (e && (this[this.getDataPropertyForScreen(this.currentScreen)] = e),
            this.screenHistory.push(this.currentScreen),
            (this.currentScreen = this.getNextScreen()));
        },
        goBack() {
          this.screenHistory.length > 0 && (this.currentScreen = this.screenHistory.pop());
        },
        getNextScreen() {
          const t = {
            QuizScreen01: 'QuizScreen02',
            QuizScreen02: 'QuizScreen03',
            QuizScreen03: 'QuizScreen04',
            QuizScreen04: 'QuizScreen05',
            QuizScreen05: 'QuizScreen06',
            QuizScreen06: 'QuizScreen07',
            QuizScreen07: 'QuizScreen08',
            QuizScreen08: 'QuizScreen09',
            QuizScreen09: 'QuizScreen10',
            QuizScreen10: 'QuizScreen11',
            QuizScreen11: 'QuizScreen12',
            QuizScreen12: 'QuizScreen13',
            QuizScreen13: 'QuizScreen14',
            QuizScreen14: 'QuizScreen15',
            QuizScreen15: 'QuizScreen16',
            QuizScreen16: 'QuizScreen17',
            QuizScreen17: 'QuizScreen18',
            QuizScreen18: 'QuizScreen19',
            QuizScreen19: 'QuizScreen20',
            QuizScreen20: 'QuizScreen21',
            QuizScreen21: 'QuizScreen22',
            QuizScreen22: 'QuizScreen23',
            QuizScreen23: 'QuizScreen24',
            QuizScreen24: 'QuizScreen25',
            QuizScreen25: 'QuizScreen26',
            QuizScreen26: 'QuizScreen27',
            QuizScreen27: 'QuizScreen28',
            QuizScreen28: 'QuizScreen29',
            QuizScreen29: 'QuizScreen30',
            QuizScreen30: 'QuizScreen31',
            QuizScreen31: 'QuizScreen32'
          }[this.currentScreen];
          return typeof t == 'function' ? t() : t;
        },
        getDataPropertyForScreen(e) {
          return (
            {
              QuizScreen01: 'age',
              QuizScreen02: 'gender',
              QuizScreen03: 'q03',
              QuizScreen04: 'q04',
              QuizScreen05: 'q05',
              QuizScreen06: 'q06',
              QuizScreen07: 'q07',
              QuizScreen08: 'q08',
              QuizScreen09: 'q09',
              QuizScreen10: 'q10',
              QuizScreen11: 'q11',
              QuizScreen12: 'q12',
              QuizScreen13: 'q13',
              QuizScreen14: 'q14',
              QuizScreen15: 'q15',
              QuizScreen16: 'q16',
              QuizScreen17: 'q17',
              QuizScreen18: 'q18',
              QuizScreen19: 'q19',
              QuizScreen20: 'q20',
              QuizScreen21: 'q21',
              QuizScreen22: 'q22',
              QuizScreen23: 'q23',
              QuizScreen24: 'q24',
              QuizScreen25: 'q25',
              QuizScreen26: 'q26',
              QuizScreen27: 'q27',
              QuizScreen28: 'q28',
              QuizScreen29: 'q29',
              QuizScreen30: 'q30',
              QuizScreen31: 'q31',
              QuizScreen32: 'q32'
            }[e] || null
          );
        },
        resetQuiz() {
          this.$reset();
        },
        completeQuiz() {
          ((this.quizCompleted = !0), this.calculateResults());
        },
        calculateResults() {
          const e = (n) => Math.round(n * 100) / 100,
            t = this.gender;
          if (t === 'm') {
            const s =
                (88.362 +
                  13.397 * parseInt(this.q10) +
                  4.799 * parseInt(this.q11) -
                  5.677 * parseInt(this.q09)) *
                parseFloat(this.q18.split(',')[0]),
              i = e(s) - 200,
              r = (parseInt(this.q11) - 80) * 2,
              o = (i * 0.25) / 9,
              l = (i - 50 - r * 4 - o * 9) / 4;
            this.results = {
              gender: t,
              calorieIntake: e(s),
              calorieIntakeRange: [e(s) - 500, e(i)],
              proteinIntake: e(r),
              fatIntake: e(o),
              carbohydrates: e(l),
              caloriesMax: e(i)
            };
          } else {
            const s =
                (444.593 +
                  9.247 * parseInt(this.q10) +
                  3.098 * parseInt(this.q11) -
                  4.33 * parseInt(this.q09)) *
                parseFloat(this.q18.split(',')[0]),
              i = e(s) - 200,
              r = (parseInt(this.q11) - 105) * 2,
              o = (i * 0.3) / 9,
              l = (i - 50 - r * 4 - o * 9) / 4;
            this.results = {
              gender: t,
              calorieIntake: e(s),
              calorieIntakeRange: [e(s) - 500, e(i)],
              proteinIntake: e(r),
              fatIntake: e(o),
              carbohydrates: e(l),
              caloriesMax: e(i)
            };
          }
        }
      }
    }),
    Fm = ['disabled'],
    yi = {
      __name: 'ImageButton',
      props: {
        text: { type: String, default: 'Weiter' },
        disabled: { type: Boolean, default: !1 },
        variant: { type: String, default: 'primary' },
        customClass: { type: String, default: '' }
      },
      emits: ['click'],
      setup(e, { emit: t }) {
        const n = e,
          s = t,
          i = L(() => {
            const o = 'qlfqa:!px-2 qlfqa:!py-2',
              l = { primary: 'qlfqa:hover:!cursor-pointer qlfqa:!text-white' };
            return `${o} ${l[n.variant] || l.primary} ${n.customClass}`;
          }),
          r = (o) => {
            s('click', o);
          };
        return (o, l) => (
          F(),
          R(
            'button',
            { onClick: r, disabled: e.disabled, class: Be(i.value) },
            [cl(o.$slots, 'default', {}, () => [Tn(me(e.text), 1)])],
            10,
            Fm
          )
        );
      }
    },
    Tc = new Set();
  function Dm(e) {
    if (!e || Tc.has(e)) return;
    Tc.add(e);
    const t = new window.Image();
    ((t.decoding = 'async'), (t.src = e));
  }
  function Ue(e) {
    for (const t of e) Dm(t || void 0);
  }
  const zm = { class: 'qlfqa:!py-2', role: 'form', 'aria-labelledby': 'age-title' },
    Pm = {
      class: 'qlfqa:!mt-8 qlfqa:!flex qlfqa:!flex-wrap',
      role: 'radiogroup',
      'aria-label': 'Wähle deine Altersgruppe'
    },
    Mm = { class: 'qlfqa:!w-full qlfqa:!flex qlfqa:!flex-col qlfqa:!items-center' },
    Rm = se({
      __name: 'QuizScreen01',
      emits: ['next'],
      setup(e, { emit: t }) {
        const n = t,
          s = Q([]),
          i = [
            {
              id: 1,
              text: '18-29',
              val: '5',
              image:
                'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Quiz-Frage1-18bis29.jpg',
              altText: ''
            },
            {
              id: 2,
              text: '30-44',
              val: '0',
              image:
                'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Quiz-Frage1-30bis44.jpg',
              altText: ''
            },
            {
              id: 3,
              text: '45-59',
              val: '0',
              image:
                'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Quiz-Frage1-45bis59.jpg',
              altText: ''
            },
            {
              id: 4,
              text: '60+',
              val: '10',
              image: 'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Quiz-Frage1-ab60.jpg',
              altText: ''
            }
          ],
          r = {
            '18-29': [
              'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Quiz-Frage2-Frau-18bis29.jpg',
              'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Quiz-Frage2-Mann-18bis29.jpg'
            ],
            '30-44': [
              'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Quiz-Frage2-Frau-30bis44.jpg',
              'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Quiz-Frage2-Mann-30bis44.jpg'
            ],
            '45-59': [
              'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Quiz-Frage2-Frau-45bis59.jpg',
              'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Quiz-Frage2-Mann-45bis59.jpg'
            ],
            '60+': [
              'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Quiz-Frage2-Frau-ab60.jpg',
              'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Quiz-Frage2-Mann-ab60.jpg'
            ]
          };
        function o(f) {
          const u = (r[f] ?? []).flatMap((d) => [
            `${d}?width=320`,
            `${d}?width=400`,
            `${d}?width=800`
          ]);
          Ue(u);
        }
        function l() {
          const c = Object.values(r)
            .flat()
            .flatMap((u) => [`${u}?width=320`, `${u}?width=400`]);
          Ue(c);
        }
        jt(() => {
          l();
        });
        function a(f, c) {
          ((s.value = [f, c]), o(f), n('next', s.value));
        }
        return (f, c) => (
          F(),
          R('div', zm, [
            c[0] ||
              (c[0] = _(
                'h1',
                {
                  id: 'age-title',
                  class: 'qlfqa:!text-2xl qlfqa:!font-medium qlfqa:!mb-4 qlfqa:!text-center'
                },
                'Protein-Test zum Abnehmen',
                -1
              )),
            c[1] ||
              (c[1] = _(
                'p',
                { class: 'qlfqa:!mb-4 qlfqa:!text-center qlfqa:!text-gray-700' },
                ' Erfahre den einfachsten Weg zum Abnehmen für deinen Körpertypen und deine Voraussetzung. ',
                -1
              )),
            _('div', Pm, [
              (F(),
              R(
                be,
                null,
                Lt(i, (u) =>
                  D(
                    yi,
                    {
                      class: Be([
                        'qlfqa:!w-6/12 qlfqa:!flex',
                        { 'qlfqa:!border-2 qlfqa:!border-[#FED43CFF]': s.value[1] === u.val }
                      ]),
                      key: u.id,
                      onPointerenter: (d) => o(u.text),
                      onPointerdown: (d) => o(u.text),
                      onClick: (d) => a(u.text, u.val),
                      role: 'radio',
                      'aria-checked': s.value[1] === u.val,
                      'aria-label': 'Altersgruppe ' + u.text
                    },
                    {
                      default: lt(() => [
                        _('span', Mm, [
                          D(
                            ke,
                            {
                              src: `${u.image}?width=400`,
                              srcset: `
                            ${u.image}?width=320 320w,
                            ${u.image}?width=400 400w,
                            ${u.image}?width=800 800w
                          `,
                              alt: 'Person in Altersgruppe ' + u.text,
                              sizes: '(max-width: 640px) 50vw, 400px',
                              loading: u.id <= 2 ? 'eager' : 'lazy',
                              decoding: 'async',
                              fetchpriority: u.id === 1 ? 'high' : 'auto',
                              class: 'qlfqa:!w-full qlfqa:!h-auto'
                            },
                            null,
                            8,
                            ['src', 'srcset', 'alt', 'loading', 'fetchpriority']
                          )
                        ])
                      ]),
                      _: 2
                    },
                    1032,
                    [
                      'class',
                      'onPointerenter',
                      'onPointerdown',
                      'onClick',
                      'aria-checked',
                      'aria-label'
                    ]
                  )
                ),
                64
              ))
            ])
          ])
        );
      }
    }),
    Vm = { class: 'qlfqa:!py-6', role: 'form', 'aria-labelledby': 'gender-title' },
    Nm = {
      class: 'qlfqa:!mt-8 qlfqa:!flex qlfqa:!flex-wrap',
      role: 'radiogroup',
      'aria-labelledby': 'gender-title'
    },
    jm = { class: 'qlfqa:!w-full qlfqa:!flex qlfqa:!flex-col qlfqa:!items-center' },
    Lm = se({
      __name: 'QuizScreen02',
      emits: ['next'],
      setup(e, { emit: t }) {
        const n = t,
          s = Q(null),
          i = ae(),
          r = [
            {
              id: 1,
              text: 'Weiblich',
              age: '18-29',
              val: 'w',
              image:
                'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Quiz-Frage2-Frau-18bis29.jpg'
            },
            {
              id: 2,
              text: 'Weiblich',
              age: '30-44',
              val: 'w',
              image:
                'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Quiz-Frage2-Frau-30bis44.jpg'
            },
            {
              id: 3,
              text: 'Weiblich',
              age: '45-59',
              val: 'w',
              image:
                'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Quiz-Frage2-Frau-45bis59.jpg'
            },
            {
              id: 4,
              text: 'Weiblich',
              age: '60+',
              val: 'w',
              image:
                'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Quiz-Frage2-Frau-ab60.jpg'
            },
            {
              id: 5,
              text: 'Männlich',
              age: '18-29',
              val: 'm',
              image:
                'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Quiz-Frage2-Mann-18bis29.jpg'
            },
            {
              id: 6,
              text: 'Männlich',
              age: '30-44',
              val: 'm',
              image:
                'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Quiz-Frage2-Mann-30bis44.jpg'
            },
            {
              id: 7,
              text: 'Männlich',
              age: '45-59',
              val: 'm',
              image:
                'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Quiz-Frage2-Mann-45bis59.jpg'
            },
            {
              id: 8,
              text: 'Männlich',
              age: '60+',
              val: 'm',
              image:
                'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Quiz-Frage2-Mann-ab60.jpg'
            }
          ],
          o = L(() => {
            const u = i.age[0];
            return u ? r.filter((d) => d.age === u) : r;
          }),
          l = {
            w: [
              'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Quiz-Frage4-Frau-Schlank.jpg',
              'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Quiz-Frage4-Frau_Skinny-fat.jpg',
              'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Quiz-Frage4-Frau-uebergewichtig.jpg',
              'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Quiz-Frage4-Frau-adipoes.jpg'
            ],
            m: [
              'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Quiz-Frage4-Mann-schlank.jpg',
              'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Quiz-Frage4-Mann-skinnyfat.jpg',
              'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Quiz-Frage4-Mann-uebergewicht.jpg',
              'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Quiz-Frage4-Mann-adipoes.jpg'
            ]
          },
          a = new Set();
        function f(u) {
          if (!u || a.has(u)) return;
          a.add(u);
          const p = (l[u] ?? []).flatMap((h) => {
            const q = h.lastIndexOf('.'),
              v = h.substring(0, q),
              y = h.substring(q + 1);
            return [`${v}_375x_crop_center.${y}`, `${v}_600x_crop_center.${y}`];
          });
          Ue(p);
        }
        function c(u) {
          ((s.value = u), f(u), n('next', s.value));
        }
        return (u, d) => (
          F(),
          R('div', Vm, [
            d[0] ||
              (d[0] = _(
                'h1',
                {
                  id: 'gender-title',
                  class: 'qlfqa:!text-2xl qlfqa:!font-medium qlfqa:!mb-4 qlfqa:!text-center'
                },
                'Wähle dein Geschlecht',
                -1
              )),
            d[1] ||
              (d[1] = _(
                'p',
                { class: 'qlfqa:!mb-4 qlfqa:!text-center qlfqa:!text-gray-700' },
                'Wir nutzen diese Angaben, um deinen Abnehmen-Plan zu personalisieren.',
                -1
              )),
            _('div', Nm, [
              (F(!0),
              R(
                be,
                null,
                Lt(
                  o.value,
                  (p) => (
                    F(),
                    at(
                      yi,
                      {
                        class: 'qlfqa:!w-6/12 qlfqa:!flex',
                        key: p.id,
                        onPointerenter: (h) => f(p.val),
                        onPointerdown: (h) => f(p.val),
                        onClick: (h) => c(p.val),
                        role: 'radio',
                        'aria-checked': s.value === p.val,
                        'aria-label': p.text
                      },
                      {
                        default: lt(() => [
                          _('span', jm, [
                            p.image
                              ? (F(),
                                at(
                                  ke,
                                  {
                                    key: 0,
                                    src: `${p.image}?width=400`,
                                    srcset: `
                            ${p.image}?width=320 320w,
                            ${p.image}?width=400 400w,
                            ${p.image}?width=800 800w
                          `,
                                    alt: p.text,
                                    sizes: '(max-width: 640px) 50vw, 400px',
                                    loading: 'eager',
                                    decoding: 'async',
                                    fetchpriority: 'high',
                                    class: 'qlfqa:!w-full qlfqa:!h-auto'
                                  },
                                  null,
                                  8,
                                  ['src', 'srcset', 'alt']
                                ))
                              : we('', !0)
                          ])
                        ]),
                        _: 2
                      },
                      1032,
                      ['onPointerenter', 'onPointerdown', 'onClick', 'aria-checked', 'aria-label']
                    )
                  )
                ),
                128
              ))
            ])
          ])
        );
      }
    }),
    Um = {
      class:
        'qlfqa:!mt-2 qlfqa:!grid qlfqa:!grid-cols-1 qlfqa:!gap-y-3 qlfqa:sm:!gap-x-4 qlfqa:!w-full'
    },
    Qm = ['onClick', 'onKeydown', 'aria-checked', 'aria-label', 'aria-description'],
    Hm = ['onMouseenter'],
    Km = { class: 'qlfqa:!flex qlfqa:!flex-1' },
    Wm = { class: 'qlfqa:!flex qlfqa:!items-center' },
    Gm = { class: 'qlfqa:!block qlfqa:!text-sm qlfqa:!font-medium qlfqa:!text-gray-900' },
    Ym = {
      key: 0,
      class: 'qlfqa:!flex qlfqa:!items-center qlfqa:!justify-center qlfqa:!text-yellow-300'
    },
    ys = {
      __name: 'SelectionGroup',
      props: {
        modelValue: { type: [String, Number], default: null },
        options: { type: Array, default: null }
      },
      emits: ['update:modelValue'],
      setup(e, { emit: t }) {
        const n = e,
          s = t,
          i = Q(n.modelValue),
          r = Q(null);
        (ze(
          () => n.modelValue,
          (l) => {
            i.value = l;
          }
        ),
          ze(i, (l) => {
            s('update:modelValue', l);
          }));
        function o(l) {
          i.value = l;
        }
        return (l, a) => (
          F(),
          R('div', Um, [
            (F(!0),
            R(
              be,
              null,
              Lt(
                e.options,
                (f) => (
                  F(),
                  R(
                    'div',
                    {
                      key: f.id,
                      class: 'qlfqa:!flex-1',
                      onClick: (c) => o(f.val),
                      onKeydown: Ca(
                        ka((c) => o(f.val), ['prevent']),
                        ['space']
                      ),
                      tabindex: '0',
                      role: 'radio',
                      'aria-checked': i.value === f.val,
                      'aria-label': f.text,
                      'aria-description': `Select ${f.text}`
                    },
                    [
                      _(
                        'div',
                        {
                          class: Be([
                            i.value === f.val
                              ? 'qlfqa:!border-yellow-300 qlfqa:!ring-1 qlfqa:!ring-yellow-300'
                              : 'qlfqa:!border-gray-300',
                            r.value === f.val
                              ? 'qlfqa:!border-yellow-300 qlfqa:!ring-1 qlfqa:!ring-yellow-300'
                              : '',
                            'qlfqa:!relative qlfqa:!flex qlfqa:!cursor-pointer qlfqa:!rounded-lg qlfqa:!h-14 qlfqa:!border qlfqa:!bg-white qlfqa:!p-4 qlfqa:!shadow-md qlfqa:focus:!outline-none'
                          ]),
                          onMouseenter: (c) => (r.value = f.val),
                          onMouseleave: a[0] || (a[0] = (c) => (r.value = null))
                        },
                        [
                          _('span', Km, [_('span', Wm, [_('span', Gm, me(f.text), 1)])]),
                          i.value === f.val
                            ? (F(),
                              R(
                                'span',
                                Ym,
                                a[1] ||
                                  (a[1] = [
                                    _(
                                      'svg',
                                      {
                                        xmlns: 'http://www.w3.org/2000/svg',
                                        viewBox: '0 0 24 24',
                                        fill: 'currentColor',
                                        class: 'qlfqa:!size-5'
                                      },
                                      [
                                        _('path', {
                                          'fill-rule': 'evenodd',
                                          d: 'M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12zm13.36-1.814a.75.75 0 10-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 00-1.06 1.06l2.25 2.25a.75.75 0 001.14-.094l3.75-5.25z',
                                          'clip-rule': 'evenodd'
                                        })
                                      ],
                                      -1
                                    )
                                  ])
                              ))
                            : we('', !0),
                          _(
                            'span',
                            {
                              class: Be([
                                r.value === f.val ? 'qlfqa:!border' : 'qlfqa:!border-2',
                                i.value === f.val
                                  ? 'qlfqa:!border-yellow-300'
                                  : 'qlfqa:!border-transparent',
                                'qlfqa:!pointer-events-none qlfqa:!absolute qlfqa:!-inset-px qlfqa:!rounded-lg'
                              ]),
                              'aria-hidden': 'true'
                            },
                            null,
                            2
                          )
                        ],
                        42,
                        Hm
                      )
                    ],
                    40,
                    Qm
                  )
                )
              ),
              128
            ))
          ])
        );
      }
    },
    Zm = { class: 'qlfqa:!mt-5 qlfqa:!flex qlfqa:!gap-4' },
    Jm = ['disabled'],
    Xm = ['disabled'],
    Ce = se({
      __name: 'NavigationButtons',
      props: {
        showBackButton: { type: Boolean, default: !0 },
        disableContinue: { type: Boolean, default: !1 },
        hideContinue: { type: Boolean, default: !1 },
        backText: { type: String, default: 'Zurück' },
        continueText: { type: String, default: 'Weiter' }
      },
      emits: ['back', 'continue'],
      setup(e, { emit: t }) {
        const n = e,
          s = t,
          i = (r) => {
            r.key === 'Enter' && !n.disableContinue && !n.hideContinue && s('continue');
          };
        return (
          jt(() => {
            window.addEventListener('keydown', i);
          }),
          Gs(() => {
            window.removeEventListener('keydown', i);
          }),
          (r, o) => (
            F(),
            R('div', Zm, [
              e.hideContinue
                ? we('', !0)
                : (F(),
                  R(
                    'button',
                    {
                      key: 0,
                      onClick: o[0] || (o[0] = (l) => r.$emit('back')),
                      disabled: !e.showBackButton,
                      class:
                        'qlfqa:!border qlfqa:!border-solid qlfqa:!border-[#CECDCA] qlfqa:!text-[#808080] qlfqa:!px-6 qlfqa:!py-3 qlfqa:!rounded-md qlfqa:disabled:!opacity-50 qlfqa:hover:!opacity-80 qlfqa:!cursor-pointer qlfqa:!w-1/2'
                    },
                    me(e.backText),
                    9,
                    Jm
                  )),
              e.hideContinue
                ? we('', !0)
                : (F(),
                  R(
                    'button',
                    {
                      key: 1,
                      onClick: o[1] || (o[1] = (l) => r.$emit('continue')),
                      disabled: e.disableContinue,
                      class:
                        'qlfqa:!bg-custom-yellow qlfqa:!text-[#131313] qlfqa:!px-6 qlfqa:!py-3 qlfqa:!rounded-md qlfqa:disabled:!opacity-50 qlfqa:hover:!bg-yellow-400 qlfqa:!cursor-pointer qlfqa:!w-1/2 qlfqa:!font-medium'
                    },
                    me(e.continueText),
                    9,
                    Xm
                  ))
            ])
          )
        );
      }
    }),
    eg = { class: 'qlfqa:!py-2' },
    tg = { class: 'qlfqa:!flex' },
    ng = se({
      __name: 'QuizScreen03',
      emits: ['next'],
      setup(e, { emit: t }) {
        const n = t,
          s = ae(),
          i = Q(''),
          r = [
            { id: 1, text: 'Langfristig 1-10 kg abnehmen', val: '0' },
            { id: 2, text: 'Langfristig 11-20 kg abnehmen', val: '30' },
            { id: 3, text: 'Langfristig mehr als 20 kg abnehmen', val: '40' },
            { id: 4, text: 'Mein Gewicht halten und gesünder leben', val: '-5' }
          ],
          o = L(() => s.screenHistory.length > 0);
        function l() {
          n('next', i.value);
        }
        function a() {
          s.goBack();
        }
        return (f, c) => (
          F(),
          R('div', eg, [
            c[1] ||
              (c[1] = _(
                'h2',
                { class: 'qlfqa:!text-l qlfqa:!font-medium qlfqa:!mb-4' },
                'Erste Frage: Was ist dein aktuelles Ziel?',
                -1
              )),
            _('div', tg, [
              D(
                ys,
                {
                  class: 'qlfqa:!flex',
                  options: r,
                  modelValue: i.value,
                  'onUpdate:modelValue': c[0] || (c[0] = (u) => (i.value = u))
                },
                null,
                8,
                ['modelValue']
              )
            ]),
            D(
              Ce,
              { showBackButton: o.value, disableContinue: !i.value, onBack: a, onContinue: l },
              null,
              8,
              ['showBackButton', 'disableContinue']
            )
          ])
        );
      }
    }),
    sg = { class: 'qlfqa:!py-2', role: 'form', 'aria-labelledby': 'age-title' },
    ig = {
      class: 'qlfqa:!mt-8 qlfqa:!flex qlfqa:!flex-wrap',
      role: 'radiogroup',
      'aria-label': 'Wähle deine Altersgruppe'
    },
    rg = { class: 'qlfqa:!w-full qlfqa:!flex qlfqa:!flex-col qlfqa:!items-center' },
    og = se({
      __name: 'QuizScreen04',
      emits: ['next'],
      setup(e, { emit: t }) {
        const n = t,
          s = ae(),
          i = Q(''),
          r = {
            w: [
              'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Quiz-Frage5-Frau-schlank.jpg',
              'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Quiz-Frage5-Frau-definiert.jpg',
              'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Quiz-Frage5-Fra-kurvig-sportlich.jpg',
              'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Quiz-Frage5-Frau-normal.jpg'
            ],
            m: [
              'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Quiz-Frage5-Mann-schlank.jpg',
              'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Quiz-Frage5-Mann-definiert.jpg',
              'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Quiz-Frage5-Mann-sportlich.jpg',
              'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Quiz-Frage5-Mann-normal.jpg'
            ]
          };
        let o = !1;
        function l() {
          if (o) return;
          o = !0;
          const u = s.gender;
          if (!u) return;
          const p = (r[u] ?? []).flatMap((h) => {
            const q = h.lastIndexOf('.'),
              v = h.substring(0, q),
              y = h.substring(q + 1);
            return [`${v}_375x_crop_center.${y}`, `${v}_600x_crop_center.${y}`];
          });
          Ue(p);
        }
        const a = [
            {
              id: 1,
              text: 'schlank',
              gender: 'w',
              val: '1',
              image:
                'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Quiz-Frage4-Frau-Schlank.jpg',
              altText: ''
            },
            {
              id: 2,
              text: 'skinnyfat',
              gender: 'w',
              val: '2',
              image:
                'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Quiz-Frage4-Frau_Skinny-fat.jpg',
              altText: ''
            },
            {
              id: 3,
              text: 'uebergewichtig',
              gender: 'w',
              val: '3',
              image:
                'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Quiz-Frage4-Frau-uebergewichtig.jpg',
              altText: ''
            },
            {
              id: 4,
              text: 'adipoes',
              gender: 'w',
              val: '4',
              image:
                'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Quiz-Frage4-Frau-adipoes.jpg',
              altText: ''
            },
            {
              id: 5,
              text: 'schlank',
              gender: 'm',
              val: '1',
              image:
                'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Quiz-Frage4-Mann-schlank.jpg',
              altText: ''
            },
            {
              id: 6,
              text: 'skinnyfat',
              gender: 'm',
              val: '2',
              image:
                'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Quiz-Frage4-Mann-skinnyfat.jpg',
              altText: ''
            },
            {
              id: 7,
              text: 'uebergewichtig',
              gender: 'm',
              val: '3',
              image:
                'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Quiz-Frage4-Mann-uebergewicht.jpg',
              altText: ''
            },
            {
              id: 8,
              text: 'adipoes',
              gender: 'm',
              val: '4',
              image:
                'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Quiz-Frage4-Mann-adipoes.jpg',
              altText: ''
            }
          ],
          f = L(() => {
            const u = s.gender;
            return u ? a.filter((d) => d.gender === u) : a;
          });
        function c(u) {
          ((i.value = u), l(), i.value && n('next', i.value));
        }
        return (u, d) => (
          F(),
          R('div', sg, [
            d[2] ||
              (d[2] = _(
                'h2',
                { class: 'qlfqa:!text-l qlfqa:!font-medium qlfqa:!mb-4' },
                'Welcher Körpertyp trifft auf dich zu?',
                -1
              )),
            _('div', ig, [
              (F(!0),
              R(
                be,
                null,
                Lt(
                  f.value,
                  (p) => (
                    F(),
                    at(
                      yi,
                      {
                        class: 'qlfqa:!w-6/12 qlfqa:!flex',
                        key: p.id,
                        onPointerenter: d[0] || (d[0] = (h) => l()),
                        onPointerdown: d[1] || (d[1] = (h) => l()),
                        onClick: (h) => c(p.val),
                        role: 'radio',
                        'aria-checked': i.value === p.val,
                        alt: 'Körpertyp ' + p.text
                      },
                      {
                        default: lt(() => [
                          _('span', rg, [
                            D(
                              ke,
                              {
                                src: p.image,
                                srcset: `${p.image}?width=300 300w, ${p.image}?width=600 600w`,
                                alt: 'Person in Altersgruppe ' + p.text,
                                class: 'qlfqa:!w-full qlfqa:!h-auto',
                                sizes: '(max-width: 640px) 50vw, 400px',
                                loading: f.value.indexOf(p) < 2 ? 'eager' : 'lazy',
                                decoding: 'async',
                                fetchpriority: f.value.indexOf(p) === 0 ? 'high' : 'auto'
                              },
                              null,
                              8,
                              ['src', 'srcset', 'alt', 'loading', 'fetchpriority']
                            )
                          ])
                        ]),
                        _: 2
                      },
                      1032,
                      ['onClick', 'aria-checked', 'alt']
                    )
                  )
                ),
                128
              ))
            ])
          ])
        );
      }
    }),
    lg = { class: 'qlfqa:!py-2', role: 'form', 'aria-labelledby': 'age-title' },
    ag = {
      class: 'qlfqa:!mt-8 qlfqa:!flex qlfqa:!flex-wrap',
      role: 'radiogroup',
      'aria-label': 'Was ist deine Wunschfigur?'
    },
    ug = { class: 'qlfqa:!w-full qlfqa:!flex qlfqa:!flex-col qlfqa:!items-center' },
    cg = se({
      __name: 'QuizScreen05',
      emits: ['next'],
      setup(e, { emit: t }) {
        const n = t,
          s = ae(),
          i = Q(''),
          r = [
            {
              id: 1,
              text: 'schlank',
              gender: 'w',
              val: '1',
              image:
                'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Quiz-Frage5-Frau-schlank.jpg',
              altText: ''
            },
            {
              id: 2,
              text: 'definiert',
              gender: 'w',
              val: '2',
              image:
                'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Quiz-Frage5-Frau-definiert.jpg',
              altText: ''
            },
            {
              id: 3,
              text: 'sportlich',
              gender: 'w',
              val: '3',
              image:
                'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Quiz-Frage5-Fra-kurvig-sportlich.jpg',
              altText: ''
            },
            {
              id: 4,
              text: 'normal',
              gender: 'w',
              val: '4',
              image:
                'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Quiz-Frage5-Frau-normal.jpg',
              altText: ''
            },
            {
              id: 5,
              text: 'schlank',
              gender: 'm',
              val: '5',
              image:
                'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Quiz-Frage5-Mann-schlank.jpg',
              altText: ''
            },
            {
              id: 6,
              text: 'definiert',
              gender: 'm',
              val: '6',
              image:
                'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Quiz-Frage5-Mann-definiert.jpg',
              altText: ''
            },
            {
              id: 7,
              text: 'sportlich',
              gender: 'm',
              val: '7',
              image:
                'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Quiz-Frage5-Mann-sportlich.jpg',
              altText: ''
            },
            {
              id: 8,
              text: 'normal',
              gender: 'm',
              val: '8',
              image:
                'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Quiz-Frage5-Mann-normal.jpg',
              altText: ''
            }
          ],
          o = L(() => {
            const u = s.gender;
            return u ? r.filter((d) => d.gender === u) : r;
          });
        function l(u) {
          ((i.value = u), i.value && n('next', i.value));
        }
        const a = {
          m: [
            'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Frage6-Mann-Bauch.jpg',
            'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Frage6-Mann-Po.jpg',
            'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Frage6-Mann-Huefte.jpg',
            'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Frage6-Mann-Beine.jpg',
            'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Frage6-Mann-Gesicht.jpg'
          ],
          w: [
            'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Frage6-Frau-Bauch.jpg',
            'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Frage6-Frau-Po1.jpg',
            'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Frage6-Frau-Huefte.jpg',
            'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Frage6-Frau-Beine.jpg',
            'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Frage6-Frau-Gesicht.jpg'
          ]
        };
        let f = !1;
        function c() {
          if (f) return;
          f = !0;
          const u = s.gender;
          if (!u) return;
          const p = (a[u] ?? []).flatMap((h) => {
            const q = h.lastIndexOf('.'),
              v = h.substring(0, q),
              y = h.substring(q + 1);
            return [`${v}_375x_crop_center.${y}`, `${v}_600x_crop_center.${y}`];
          });
          Ue(p);
        }
        return (u, d) => (
          F(),
          R('div', lg, [
            d[2] ||
              (d[2] = _(
                'h2',
                { class: 'qlfqa:!text-l qlfqa:!font-medium qlfqa:!mb-4' },
                'Was ist deine Wunschfigur?',
                -1
              )),
            _('div', ag, [
              (F(!0),
              R(
                be,
                null,
                Lt(
                  o.value,
                  (p) => (
                    F(),
                    at(
                      yi,
                      {
                        class: Be([
                          'qlfqa:!w-6/12 qlfqa:!flex',
                          { 'qlfqa:!border-2 qlfqa:!border-[#FED43CFF]': i.value === p.val }
                        ]),
                        key: p.id,
                        onPointerenter: d[0] || (d[0] = (h) => c()),
                        onPointerdown: d[1] || (d[1] = (h) => c()),
                        onClick: (h) => l(p.val),
                        role: 'radio',
                        'aria-checked': i.value === p.val,
                        'aria-label': 'Wunschfigur ' + p.text
                      },
                      {
                        default: lt(() => [
                          _('span', ug, [
                            D(
                              ke,
                              {
                                src: `${p.image}?width=400`,
                                srcset: `
                            ${p.image}?width=320 320w,
                            ${p.image}?width=400 400w,
                            ${p.image}?width=800 800w
                          `,
                                alt: '',
                                class: 'qlfqa:!w-full qlfqa:!h-auto',
                                sizes: '(max-width: 640px) 50vw, 400px',
                                loading: o.value.indexOf(p) < 2 ? 'eager' : 'lazy',
                                decoding: 'async',
                                fetchpriority: o.value.indexOf(p) === 0 ? 'high' : 'auto'
                              },
                              null,
                              8,
                              ['src', 'srcset', 'loading', 'fetchpriority']
                            )
                          ])
                        ]),
                        _: 2
                      },
                      1032,
                      ['class', 'onClick', 'aria-checked', 'aria-label']
                    )
                  )
                ),
                128
              ))
            ])
          ])
        );
      }
    }),
    fg = {
      class:
        'qlfqa:!grid qlfqa:!grid-cols-1 qlfqa:!gap-y-3 qlfqa:sm:!gap-x-4 qlfqa:!w-full qlfqa:!flex'
    },
    dg = ['onClick'],
    pg = { class: 'qlfqa:!flex qlfqa:!flex-1 qlfqa:!items-center qlfqa:!p-4' },
    hg = { class: 'qlfqa:!block qlfqa:!text-sm qlfqa:!font-medium qlfqa:!text-gray-900' },
    mg = {
      key: 0,
      class:
        'qlfqa:!flex qlfqa:!items-center qlfqa:!justify-center qlfqa:!text-yellow-300 qlfqa:!mx-3'
    },
    gg = { class: 'qlfqa:!flex qlfqa:!flex-1 qlfqa:!p-4' },
    _g = { class: 'qlfqa:!flex qlfqa:!items-center' },
    qg = { class: 'qlfqa:!block qlfqa:!text-sm qlfqa:!font-medium qlfqa:!text-gray-900' },
    vg = {
      key: 0,
      class:
        'qlfqa:!flex qlfqa:!items-center qlfqa:!justify-center qlfqa:!text-yellow-300 qlfqa:!mx-3'
    },
    _n = se({
      __name: 'MultiSelectionGroup',
      props: {
        modelValue: { type: Array, default: () => [] },
        checkboxOptions: { type: Array, default: () => [] },
        exclusiveOption: { type: Object, default: null }
      },
      emits: ['update:modelValue'],
      setup(e, { emit: t }) {
        const n = e,
          s = t,
          i = Q(!1);
        ze(
          () => n.modelValue,
          (l) => {
            n.exclusiveOption && l.includes(n.exclusiveOption.val)
              ? (i.value = !0)
              : (i.value = !1);
          },
          { immediate: !0 }
        );
        function r(l) {
          if (i.value) {
            ((i.value = !1), s('update:modelValue', [l.val]));
            return;
          }
          const a = [...n.modelValue],
            f = a.indexOf(l.val);
          (f === -1 ? a.push(l.val) : a.splice(f, 1), s('update:modelValue', a));
        }
        function o() {
          ((i.value = !i.value),
            i.value ? s('update:modelValue', [n.exclusiveOption.val]) : s('update:modelValue', []));
        }
        return (l, a) => (
          F(),
          R('div', fg, [
            (F(!0),
            R(
              be,
              null,
              Lt(
                e.checkboxOptions,
                (f) => (
                  F(),
                  R(
                    'div',
                    {
                      key: f.id,
                      onClick: (c) => r(f),
                      class: Be([
                        'qlfqa:!h-14 qlfqa:!flex qlfqa:!cursor-pointer qlfqa:!rounded-lg qlfqa:!border qlfqa:!bg-white qlfqa:!shadow-md qlfqa:focus:!outline-none qlfqa:!overflow-hidden',
                        [
                          e.modelValue.includes(f.val)
                            ? 'qlfqa:!border-yellow-300 qlfqa:!ring-1 qlfqa:!ring-yellow-300'
                            : 'qlfqa:!border-gray-300'
                        ]
                      ])
                    },
                    [
                      _('span', pg, [_('span', hg, me(f.text), 1)]),
                      e.modelValue.includes(f.val)
                        ? (F(),
                          R(
                            'span',
                            mg,
                            a[0] ||
                              (a[0] = [
                                _(
                                  'svg',
                                  {
                                    xmlns: 'http://www.w3.org/2000/svg',
                                    viewBox: '0 0 24 24',
                                    fill: 'currentColor',
                                    class: 'qlfqa:!size-6'
                                  },
                                  [
                                    _('path', {
                                      'fill-rule': 'evenodd',
                                      d: 'M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12zm13.36-1.814a.75.75 0 10-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 00-1.06 1.06l2.25 2.25a.75.75 0 001.14-.094l3.75-5.25z',
                                      'clip-rule': 'evenodd'
                                    })
                                  ],
                                  -1
                                )
                              ])
                          ))
                        : we('', !0),
                      f.image
                        ? (F(),
                          at(
                            ke,
                            {
                              key: 1,
                              src: f.image,
                              alt: f.text,
                              fetchpriority: f.id === 1 ? 'high' : 'auto',
                              class:
                                'qlfqa:!ml-3 qlfqa:!h-full qlfqa:!object-contain qlfqa:!shrink-0'
                            },
                            null,
                            8,
                            ['src', 'alt', 'fetchpriority']
                          ))
                        : we('', !0)
                    ],
                    10,
                    dg
                  )
                )
              ),
              128
            )),
            e.exclusiveOption
              ? (F(),
                R(
                  'div',
                  {
                    key: 0,
                    onClick: o,
                    class: Be([
                      'qlfqa:!h-14 qlfqa:!flex qlfqa:!cursor-pointer qlfqa:!rounded-lg qlfqa:!border qlfqa:!bg-white qlfqa:!shadow-md qlfqa:focus:!outline-none',
                      [
                        i.value
                          ? 'qlfqa:!border-yellow-300 qlfqa:!ring-1 qlfqa:!ring-yellow-300'
                          : 'qlfqa:!border-gray-300'
                      ]
                    ])
                  },
                  [
                    _('span', gg, [_('span', _g, [_('span', qg, me(e.exclusiveOption.text), 1)])]),
                    i.value
                      ? (F(),
                        R(
                          'span',
                          vg,
                          a[1] ||
                            (a[1] = [
                              _(
                                'svg',
                                {
                                  xmlns: 'http://www.w3.org/2000/svg',
                                  viewBox: '0 0 24 24',
                                  fill: 'currentColor',
                                  class: 'qlfqa:!size-6'
                                },
                                [
                                  _('path', {
                                    'fill-rule': 'evenodd',
                                    d: 'M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12zm13.36-1.814a.75.75 0 10-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 00-1.06 1.06l2.25 2.25a.75.75 0 001.14-.094l3.75-5.25z',
                                    'clip-rule': 'evenodd'
                                  })
                                ],
                                -1
                              )
                            ])
                        ))
                      : we('', !0)
                  ],
                  2
                ))
              : we('', !0)
          ])
        );
      }
    }),
    yg = { class: 'qlfqa:!py-2' },
    Yr =
      'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Frage15-Grafik-rot-gruen.jpg?v=1766150507',
    Zr = 'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/University-Colorado.jpg',
    Jr = 'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Universitaet-Freiburg.jpg',
    bg = se({
      __name: 'QuizScreen06',
      emits: ['next'],
      setup(e, { emit: t }) {
        const n = t,
          s = ae(),
          i = Q([]),
          r = Q(!1),
          o = [
            {
              id: 1,
              text: 'Bauch',
              val: 'Bauch',
              image: 'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Frage6-Mann-Bauch.jpg'
            },
            {
              id: 2,
              text: 'Po',
              val: 'Po',
              image: 'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Frage6-Mann-Po.jpg'
            },
            {
              id: 3,
              text: 'Hüfte',
              val: 'Hüfte',
              image: 'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Frage6-Mann-Huefte.jpg'
            },
            {
              id: 4,
              text: 'Beine',
              val: 'Beine',
              image: 'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Frage6-Mann-Beine.jpg'
            },
            {
              id: 5,
              text: 'Gesicht',
              val: 'Gesicht',
              image:
                'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Frage6-Mann-Gesicht.jpg'
            }
          ],
          l = [
            {
              id: 1,
              text: 'Bauch',
              val: 'Bauch',
              image: 'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Frage6-Frau-Bauch.jpg'
            },
            {
              id: 2,
              text: 'Po',
              val: 'Po',
              image: 'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Frage6-Frau-Po1.jpg'
            },
            {
              id: 3,
              text: 'Hüfte',
              val: 'Hüfte',
              image: 'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Frage6-Frau-Huefte.jpg'
            },
            {
              id: 4,
              text: 'Beine',
              val: 'Beine',
              image: 'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Frage6-Frau-Beine.jpg'
            },
            {
              id: 5,
              text: 'Gesicht',
              val: 'Gesicht',
              image:
                'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Frage6-Frau-Gesicht.jpg'
            }
          ],
          a = L(() => (s.gender === 'm' ? o : l)),
          f = void 0,
          c = L(() => s.screenHistory.length > 0),
          u = L(() => i.value.length > 0 || r.value);
        let d = !1;
        function p() {
          d ||
            ((d = !0),
            Ue([
              `${Yr}?width=320`,
              `${Yr}?width=400`,
              `${Yr}?width=800`,
              `${Zr}?width=120`,
              `${Zr}?width=150`,
              `${Zr}?width=300`,
              `${Jr}?width=120`,
              `${Jr}?width=150`,
              `${Jr}?width=300`
            ]));
        }
        ze(u, (v) => {
          v && p();
        });
        function h() {
          let v;
          ((r.value && f) || (v = i.value), n('next', v));
        }
        function q() {
          s.goBack();
        }
        return (v, y) => (
          F(),
          R('div', yg, [
            y[1] ||
              (y[1] = _(
                'h2',
                { class: 'qlfqa:!text-l qlfqa:!font-medium qlfqa:!mb-4' },
                'Welche sind deine Problemzonen?',
                -1
              )),
            y[2] ||
              (y[2] = _('p', { class: 'qlfqa:!text-gray-700' }, 'Mehrfach-Auswahl möglich', -1)),
            D(
              _n,
              {
                modelValue: i.value,
                'onUpdate:modelValue': y[0] || (y[0] = (z) => (i.value = z)),
                class: 'qlfqa:!mt-4',
                checkboxOptions: a.value,
                exclusiveOption: rt(f)
              },
              null,
              8,
              ['modelValue', 'checkboxOptions', 'exclusiveOption']
            ),
            D(
              Ce,
              { showBackButton: c.value, disableContinue: !u.value, onBack: q, onContinue: h },
              null,
              8,
              ['showBackButton', 'disableContinue']
            )
          ])
        );
      }
    }),
    wg = { class: 'qlfqa:!py-2' },
    xg = { class: 'qlfqa:!flex' },
    Eg = se({
      __name: 'QuizScreen07',
      emits: ['next'],
      setup(e, { emit: t }) {
        const n = t,
          s = ae(),
          i = Q(''),
          r = [
            { id: 1, text: 'Ich nehme schnell zu, aber nur langsam ab', val: 'Langsam' },
            { id: 2, text: 'Ich nehme einfach zu und ab', val: 'Moderat' },
            { id: 3, text: 'Ich habe Probleme Gewicht zuzunehmen', val: 'Moderat 2' }
          ],
          o = L(() => s.screenHistory.length > 0);
        function l() {
          n('next', i.value);
        }
        function a() {
          s.goBack();
        }
        return (f, c) => (
          F(),
          R('div', wg, [
            c[1] ||
              (c[1] = _(
                'h2',
                { class: 'qlfqa:!text-l qlfqa:!font-medium qlfqa:!mb-4' },
                'Wie ändert sich dein Gewicht normalerweise?',
                -1
              )),
            _('div', xg, [
              D(
                ys,
                {
                  class: 'qlfqa:!flex',
                  options: r,
                  modelValue: i.value,
                  'onUpdate:modelValue': c[0] || (c[0] = (u) => (i.value = u))
                },
                null,
                8,
                ['modelValue']
              )
            ]),
            D(
              Ce,
              { showBackButton: o.value, disableContinue: !i.value, onBack: a, onContinue: l },
              null,
              8,
              ['showBackButton', 'disableContinue']
            )
          ])
        );
      }
    }),
    Sg = { class: 'qlfqa:!py-2' },
    kg = { class: 'qlfqa:!flex' },
    Cg = se({
      __name: 'QuizScreen08',
      emits: ['next'],
      setup(e, { emit: t }) {
        const n = t,
          s = ae(),
          i = Q(''),
          r = [
            { id: 1, text: 'Vor weniger als 1 Jahr', val: '0' },
            { id: 2, text: '1 bis 2 Jahre her', val: '30' },
            { id: 3, text: 'Mehr als 3 Jahre her', val: '40' },
            { id: 4, text: 'Noch nie', val: '50' }
          ],
          o = L(() => s.screenHistory.length > 0);
        function l() {
          n('next', i.value);
        }
        function a() {
          s.goBack();
        }
        return (f, c) => (
          F(),
          R('div', Sg, [
            c[1] ||
              (c[1] = _(
                'h2',
                { class: 'qlfqa:!text-l qlfqa:!font-medium qlfqa:!mb-4' },
                'Wann hast du dich das letzte mal so richtig wohl und stolz in deinem Körper gefühlt?',
                -1
              )),
            _('div', kg, [
              D(
                ys,
                {
                  class: 'qlfqa:!flex',
                  options: r,
                  modelValue: i.value,
                  'onUpdate:modelValue': c[0] || (c[0] = (u) => (i.value = u))
                },
                null,
                8,
                ['modelValue']
              )
            ]),
            D(
              Ce,
              { showBackButton: o.value, disableContinue: !i.value, onBack: a, onContinue: l },
              null,
              8,
              ['showBackButton', 'disableContinue']
            )
          ])
        );
      }
    }),
    Ag = { class: 'qlfqa:!py-2' },
    Tg = {
      class:
        'qlfqa:!mt-8 qlfqa:!flex qlfqa:!items-center qlfqa:!bg-transparent qlfqa:!border-b qlfqa:!pr-3 qlfqa:!border-yellow-300 qlfqa:focus:!border-yellow-400 qlfqa:focus:!border-b qlfqa:focus:!ring-yellow-300 qlfqa:!rounded-t-md'
    },
    Og = { key: 0, class: 'qlfqa:!text-red-500 qlfqa:!mt-2 qlfqa:!text-sm' },
    Ig = se({
      __name: 'QuizScreen09',
      emits: ['next'],
      setup(e, { emit: t }) {
        const n = t,
          s = ae(),
          i = Q(''),
          r = Q(''),
          o = L(() => s.screenHistory.length > 0);
        function l() {
          f(i.value) && n('next', i.value);
        }
        function a() {
          s.goBack();
        }
        function f(c) {
          if (c === '') return ((r.value = ''), !0);
          const u = Number(c);
          return u < 18
            ? ((r.value = 'Alter muss mindestens 18 Jahre betragen.'), !1)
            : u > 99
              ? ((r.value = 'Alter darf maximal 99 Jahre betragen.'), !1)
              : ((r.value = ''), !0);
        }
        return (c, u) => (
          F(),
          R('div', Ag, [
            u[2] ||
              (u[2] = _(
                'h2',
                { class: 'qlfqa:!text-l qlfqa:!font-medium qlfqa:!mb-4' },
                'Wie alt bist du aktuell ganz genau?',
                -1
              )),
            _('div', Tg, [
              En(
                _(
                  'input',
                  {
                    type: 'tel',
                    inputmode: 'numeric',
                    pattern: '[0-9]*',
                    autocomplete: 'off',
                    enterkeyhint: 'done',
                    'onUpdate:modelValue': u[0] || (u[0] = (d) => (i.value = d)),
                    'aria-label': 'Gebe dein Alter ein',
                    min: '18',
                    max: '99',
                    class:
                      'qlfqa:!border-none qlfqa:!block qlfqa:!min-w-0 qlfqa:!grow qlfqa:!px-4 qlfqa:!py-2 qlfqa:focus:!outline-0 qlfqa:!text-[3em] qlfqa:!font-semibold qlfqa:!text-center qlfqa:!w-full qlfqa:!box-border'
                  },
                  null,
                  512
                ),
                [[$n, i.value]]
              ),
              u[1] ||
                (u[1] = _(
                  'div',
                  {
                    class: 'qlfqa:!text-lg qlfqa:!text-gray-500 qlfqa:!relative qlfqa:!top-[10px]'
                  },
                  'Jahre',
                  -1
                ))
            ]),
            r.value ? (F(), R('div', Og, me(r.value), 1)) : we('', !0),
            D(
              Ce,
              { showBackButton: o.value, disableContinue: !i.value, onBack: a, onContinue: l },
              null,
              8,
              ['showBackButton', 'disableContinue']
            )
          ])
        );
      }
    }),
    $g = { class: 'qlfqa:!py-2' },
    Bg = {
      class:
        'qlfqa:!mt-8 qlfqa:!flex qlfqa:!items-center qlfqa:!bg-transparent qlfqa:!border-b qlfqa:!pr-3 qlfqa:!border-yellow-300 qlfqa:focus:!border-yellow-400 qlfqa:focus:!border-b qlfqa:focus:!ring-yellow-300 qlfqa:!rounded-t-md'
    },
    Fg = { key: 0, class: 'qlfqa:!text-red-500 qlfqa:!mt-2 qlfqa:!text-sm' },
    Dg = se({
      __name: 'QuizScreen10',
      emits: ['next'],
      setup(e, { emit: t }) {
        const n = t,
          s = ae(),
          i = Q(''),
          r = Q(''),
          o = L(() => s.screenHistory.length > 0);
        function l() {
          f(i.value) && n('next', i.value);
        }
        function a() {
          s.goBack();
        }
        function f(c) {
          if (c === '') return ((r.value = ''), !0);
          const u = Number(c);
          return u < 30
            ? ((r.value = 'Gewicht muss mindestens 30 kg betragen.'), !1)
            : u > 250
              ? ((r.value = 'Gewicht darf 250 kg nicht überschreiten.'), !1)
              : ((r.value = ''), !0);
        }
        return (c, u) => (
          F(),
          R('div', $g, [
            u[2] ||
              (u[2] = _(
                'h2',
                { class: 'qlfqa:!text-l qlfqa:!font-medium qlfqa:!mb-4' },
                'Was ist dein aktuelles Gewicht?',
                -1
              )),
            _('div', Bg, [
              En(
                _(
                  'input',
                  {
                    type: 'tel',
                    inputmode: 'numeric',
                    pattern: '[0-9]*',
                    autocomplete: 'off',
                    enterkeyhint: 'done',
                    'onUpdate:modelValue': u[0] || (u[0] = (d) => (i.value = d)),
                    'aria-label': 'Enter your weight',
                    min: '30',
                    max: '250',
                    class:
                      'qlfqa:!border-none qlfqa:!font-semibold qlfqa:!block qlfqa:!min-w-0 qlfqa:!grow qlfqa:!px-4 qlfqa:!py-3 qlfqa:focus:!outline-0 qlfqa:!text-[3em] qlfqa:!text-center'
                  },
                  null,
                  512
                ),
                [[$n, i.value]]
              ),
              u[1] ||
                (u[1] = _(
                  'div',
                  {
                    class: 'qlfqa:!text-lg qlfqa:!text-gray-500 qlfqa:!relative qlfqa:!top-[10px]'
                  },
                  'kg',
                  -1
                ))
            ]),
            r.value ? (F(), R('div', Fg, me(r.value), 1)) : we('', !0),
            D(
              Ce,
              { showBackButton: o.value, disableContinue: !i.value, onBack: a, onContinue: l },
              null,
              8,
              ['showBackButton', 'disableContinue']
            )
          ])
        );
      }
    }),
    zg = { class: 'qlfqa:!py-2' },
    Pg = {
      class:
        'qlfqa:!mt-8 qlfqa:!flex qlfqa:!items-center qlfqa:!bg-transparent qlfqa:!border-b qlfqa:!pr-3 qlfqa:!border-yellow-300 qlfqa:focus:!border-yellow-400 qlfqa:focus:!border-b qlfqa:focus:!ring-yellow-300 qlfqa:!rounded-t-md'
    },
    Mg = {
      key: 0,
      class:
        'qlfqa:!mt-4 qlfqa:!border qlfqa:!border-[#e0a959] qlfqa:!rounded-2xl qlfqa:!p-5 qlfqa:!bg-[#faf3e9]'
    },
    Rg = { class: 'qlfqa:!flex qlfqa:!items-center qlfqa:!gap-2' },
    Vg = { class: 'qlfqa:!font-semibold qlfqa:!text-xs' },
    Ng = { class: 'qlfqa:!mt-2 qlfqa:!text-xs' },
    jg = { key: 0, class: 'qlfqa:!text-red-500 qlfqa:!mt-2 qlfqa:!text-sm' },
    Lg = se({
      __name: 'QuizScreen11',
      emits: ['next'],
      setup(e, { emit: t }) {
        const n = t,
          s = ae(),
          i = Q(''),
          r = Q(''),
          o = [
            {
              bmi_range: [0, 16],
              headline1: 'Dein BMI beträgt',
              headline2: ', womit du stark untergewichtig bist',
              text: 'Ein BMI-Wert unter 16 ist bedenklich und gilt bei Männern wie Frauen als anorektisch. Um deine Gesundheit nicht zu gefährden, raten wir dir stark von einer weiteren Abnahme ab. Bitte beende dieses Quiz daher.'
            },
            {
              bmi_range: [16, 18.5],
              headline1: 'Dein BMI beträgt',
              headline2: ', womit du untergewichtig bist',
              text: 'Dein BMI-Wert ist bereits sehr niedrig, weshalb wir dir an der Stelle nur raten können, nicht weitere Maßnahmen zur Gewichtsreduktion zu unternehmen. Bitte beende daher dieses Quiz jetzt.'
            },
            {
              bmi_range: [18.5, 25],
              headline1: 'Dein BMI beträgt',
              headline2: ', womit du Normalgewicht hast',
              text: 'Klasse, dein BMI-Wert ist im grünen Bereich. Das ist eine gute Ausgangslage, deine Gesundheit und dein Wohlbefinden zu optimieren, gezielt Fett zu verlieren, den Körper zu straffen und schöne Muskulatur aufzubauen.'
            },
            {
              bmi_range: [25, 30],
              headline1: 'Dein BMI beträgt',
              headline2: ', womit du Übergewicht hast',
              text: 'Dein BMI-Wert ist bereits erhöht und das Risiko diverser Krankheiten beginnt zu steigen (Herz-Kreislauf, Diabetes Typ-2, Krebs). Mit den richtigen Strategien kannst du jedoch schnell beeindruckende Resultate erzielen.'
            },
            {
              bmi_range: [30, 999],
              headline1: 'Dein BMI beträgt',
              headline2: ', womit du starkes Übergewicht hast',
              text: 'Du leidest somit an einem stark erhöhten Risiko für diverse Krankheiten, wie Diabetes Typ-2, Krebs & Herz-Kreislauf-Erkrankungen. Zusammen können wir aber schnelle und wichtige Verbesserungen erzielen.'
            }
          ],
          l = L(() => s.screenHistory.length > 0),
          a = L(() => (!i.value || !s.q10 ? !1 : parseFloat(u()) < 18.5));
        function f() {
          p(i.value) && n('next', i.value);
        }
        function c() {
          s.goBack();
        }
        function u() {
          const h = parseInt(s.q10),
            q = parseInt(i.value);
          return (h / (q / 100) ** 2).toFixed(2);
        }
        function d() {
          const h = parseFloat(u());
          return o.find((v) => h >= v.bmi_range[0] && h < v.bmi_range[1]) || null;
        }
        function p(h) {
          if (h === '') return ((r.value = ''), !0);
          const q = Number(h);
          return q < 60
            ? ((r.value = 'Größe muss mindestens 60 cm betragen.'), !1)
            : q > 250
              ? ((r.value = 'Größe darf maximal 250 cm betragen.'), !1)
              : ((r.value = ''), !0);
        }
        return (h, q) => (
          F(),
          R('div', zg, [
            q[3] ||
              (q[3] = _(
                'h2',
                { class: 'qlfqa:!text-l qlfqa:!font-medium qlfqa:!mb-4' },
                'Wie groß bist du?',
                -1
              )),
            _('div', Pg, [
              En(
                _(
                  'input',
                  {
                    type: 'tel',
                    inputmode: 'numeric',
                    pattern: '[0-9]*',
                    autocomplete: 'off',
                    enterkeyhint: 'done',
                    'onUpdate:modelValue': q[0] || (q[0] = (v) => (i.value = v)),
                    'aria-label': 'Gebe deine Größe ein',
                    class:
                      'qlfqa:!border-none qlfqa:!block qlfqa:!min-w-0 qlfqa:!grow qlfqa:!px-4 qlfqa:!py-2 qlfqa:focus:!outline-0 qlfqa:!text-[3em] qlfqa:!font-semibold qlfqa:!text-center qlfqa:!w-full qlfqa:!box-border'
                  },
                  null,
                  512
                ),
                [[$n, i.value]]
              ),
              q[1] ||
                (q[1] = _(
                  'div',
                  {
                    class: 'qlfqa:!text-lg qlfqa:!text-gray-500 qlfqa:!relative qlfqa:!top-[10px]'
                  },
                  'cm',
                  -1
                ))
            ]),
            D(
              ri,
              { name: 'fade' },
              {
                default: lt(() => {
                  var v, y, z;
                  return [
                    i.value && rt(s).q10 && d()
                      ? (F(),
                        R('div', Mg, [
                          _('div', Rg, [
                            q[2] ||
                              (q[2] = _(
                                'div',
                                {
                                  class:
                                    'qlfqa:!text-sm qlfqa:!border qlfqa:!border-[#e0a959] qlfqa:!text-[#e0a959] qlfqa:!rounded-full qlfqa:!flex qlfqa:!w-[20px] qlfqa:!h-[20px] qlfqa:!justify-center qlfqa:!items-center qlfqa:!font-bold'
                                },
                                ' ! ',
                                -1
                              )),
                            _(
                              'h3',
                              Vg,
                              me((v = d()) == null ? void 0 : v.headline1) +
                                ' ' +
                                me(u()) +
                                me((y = d()) == null ? void 0 : y.headline2),
                              1
                            )
                          ]),
                          _('p', Ng, me((z = d()) == null ? void 0 : z.text), 1)
                        ]))
                      : we('', !0)
                  ];
                }),
                _: 1
              }
            ),
            r.value ? (F(), R('div', jg, me(r.value), 1)) : we('', !0),
            D(
              Ce,
              {
                showBackButton: l.value,
                disableContinue: !i.value,
                hideContinue: a.value,
                onBack: c,
                onContinue: f
              },
              null,
              8,
              ['showBackButton', 'disableContinue', 'hideContinue']
            )
          ])
        );
      }
    }),
    Ug = { class: 'qlfqa:!py-2' },
    Qg = {
      class:
        'qlfqa:!mt-8 qlfqa:!flex qlfqa:!items-center qlfqa:!bg-transparent qlfqa:!border-b qlfqa:!pr-3 qlfqa:!border-yellow-300 qlfqa:focus:!border-yellow-400 qlfqa:focus:!border-b qlfqa:focus:!ring-yellow-300 qlfqa:!rounded-t-md'
    },
    Hg = { key: 0, class: 'qlfqa:!text-red-500 qlfqa:!mt-2 qlfqa:!text-sm' },
    Kg = se({
      __name: 'QuizScreen12',
      emits: ['next'],
      setup(e, { emit: t }) {
        const n = t,
          s = ae(),
          i = Q(''),
          r = Q(''),
          o = L(() => s.screenHistory.length > 0);
        function l() {
          f(i.value) && n('next', i.value);
        }
        function a() {
          s.goBack();
        }
        function f(c) {
          if (c === '') return ((r.value = ''), !0);
          const u = Number(c);
          return u < 30
            ? ((r.value = 'Gewicht muss mindestens 30 kg betragen.'), !1)
            : u > 250
              ? ((r.value = 'Gewicht darf 250 kg nicht überschreiten.'), !1)
              : ((r.value = ''), !0);
        }
        return (c, u) => (
          F(),
          R('div', Ug, [
            u[2] ||
              (u[2] = _(
                'h2',
                { class: 'qlfqa:!text-l qlfqa:!font-medium qlfqa:!mb-4' },
                'Was ist dein Zielgewicht?',
                -1
              )),
            _('div', Qg, [
              En(
                _(
                  'input',
                  {
                    type: 'tel',
                    inputmode: 'numeric',
                    pattern: '[0-9]*',
                    autocomplete: 'off',
                    enterkeyhint: 'done',
                    'onUpdate:modelValue': u[0] || (u[0] = (d) => (i.value = d)),
                    'aria-label': 'Enter your weight',
                    min: '30',
                    max: '250',
                    class:
                      'qlfqa:!border-none qlfqa:!font-semibold qlfqa:!block qlfqa:!min-w-0 qlfqa:!grow qlfqa:!px-4 qlfqa:!py-3 qlfqa:focus:!outline-0 qlfqa:!text-[3em] qlfqa:!text-center'
                  },
                  null,
                  512
                ),
                [[$n, i.value]]
              ),
              u[1] || (u[1] = _('div', null, 'kg', -1))
            ]),
            r.value ? (F(), R('div', Hg, me(r.value), 1)) : we('', !0),
            D(
              Ce,
              { showBackButton: o.value, disableContinue: !i.value, onBack: a, onContinue: l },
              null,
              8,
              ['showBackButton', 'disableContinue']
            )
          ])
        );
      }
    }),
    Wg = { class: 'qlfqa:!py-2' },
    Gg = { class: 'qlfqa:!flex' },
    Yg = se({
      __name: 'QuizScreen13',
      emits: ['next'],
      setup(e, { emit: t }) {
        const n = t,
          s = ae(),
          i = Q(''),
          r = [
            { id: 1, text: 'Gesünder leben', val: '0' },
            { id: 2, text: 'Mein Aussehen verändern', val: '30' },
            { id: 3, text: 'Mich glücklicher und wohler fühlen', val: '40' },
            { id: 4, text: 'Andere Gründe', val: '-5' }
          ],
          o = L(() => s.screenHistory.length > 0);
        function l() {
          n('next', i.value);
        }
        function a() {
          s.goBack();
        }
        return (f, c) => (
          F(),
          R('div', Wg, [
            c[1] ||
              (c[1] = _(
                'h2',
                { class: 'qlfqa:!text-l qlfqa:!font-medium qlfqa:!mb-4' },
                'Was motiviert dich am meisten abzunehmen?',
                -1
              )),
            c[2] ||
              (c[2] = _(
                'p',
                { class: 'qlfqa:!mb-4 qlfqa:!text-gray-700' },
                'Wähle aus, was dir aktuell am wichtigsten ist.',
                -1
              )),
            _('div', Gg, [
              D(
                ys,
                {
                  class: 'qlfqa:!flex',
                  options: r,
                  modelValue: i.value,
                  'onUpdate:modelValue': c[0] || (c[0] = (u) => (i.value = u))
                },
                null,
                8,
                ['modelValue']
              )
            ]),
            D(
              Ce,
              { showBackButton: o.value, disableContinue: !i.value, onBack: a, onContinue: l },
              null,
              8,
              ['showBackButton', 'disableContinue']
            )
          ])
        );
      }
    }),
    Zg = { class: 'qlfqa:!py-2' },
    Jg = { class: 'qlfqa:!flex' },
    Xg = se({
      __name: 'QuizScreen14',
      emits: ['next'],
      setup(e, { emit: t }) {
        const n = t,
          s = ae(),
          i = Q(''),
          r = [
            { id: 1, text: 'Urlaub', val: '0' },
            { id: 2, text: 'Hochzeit', val: '30' },
            { id: 3, text: 'Sommer', val: '40' },
            { id: 4, text: 'Abnehmen nach Schwangerschaft', val: '-5' },
            { id: 5, text: 'Geburtstagsfeier', val: '50' },
            { id: 6, text: 'Nein, ich will mich einfach wieder wohler fühlen!', val: '60' }
          ],
          o = L(() => (s.gender === 'm' ? r.filter((c) => c.id !== 4) : r)),
          l = L(() => s.screenHistory.length > 0);
        function a() {
          n('next', i.value);
        }
        function f() {
          s.goBack();
        }
        return (c, u) => (
          F(),
          R('div', Zg, [
            u[1] ||
              (u[1] = _(
                'h2',
                { class: 'qlfqa:!text-l qlfqa:!font-medium qlfqa:!mb-4' },
                'Gibt es ein bestimmtes Ziel, um abzunehmen?',
                -1
              )),
            _('div', Jg, [
              D(
                ys,
                {
                  class: 'qlfqa:!flex',
                  options: o.value,
                  modelValue: i.value,
                  'onUpdate:modelValue': u[0] || (u[0] = (d) => (i.value = d))
                },
                null,
                8,
                ['options', 'modelValue']
              )
            ]),
            D(
              Ce,
              { showBackButton: l.value, disableContinue: !i.value, onBack: f, onContinue: a },
              null,
              8,
              ['showBackButton', 'disableContinue']
            )
          ])
        );
      }
    }),
    e1 = { class: 'qlfqa:!py-2', role: 'article' },
    t1 = { class: 'qlfqa:!mb-6' },
    n1 = { class: 'qlfqa:!mb-4' },
    s1 = { class: 'qlfqa:!flex qlfqa:!items-center qlfqa:!gap-2' },
    i1 = { class: 'qlfqa:!mb-4' },
    r1 = { class: 'qlfqa:!flex qlfqa:!items-center qlfqa:!gap-2' },
    o1 = {
      class: 'qlfqa:!mt-8 qlfqa:!flex qlfqa:!justify-center qlfqa:!gap-4',
      role: 'group',
      'aria-label': 'Navigation'
    },
    l1 = ['disabled', 'aria-disabled'],
    bi =
      'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Frage15-Grafik-rot-gruen.jpg?v=1766150507',
    wi = 'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/University-Colorado.jpg',
    xi = 'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Universitaet-Freiburg.jpg',
    a1 = 'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Frau_Schlaf.jpg',
    u1 = 'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Mann_Schlaf.jpg',
    c1 = se({
      __name: 'QuizScreen15',
      emits: ['next'],
      setup(e, { emit: t }) {
        const n = t,
          s = ae(),
          i = L(() => s.screenHistory.length > 0);
        function r() {
          (a(), n('next', 'checked'));
        }
        function o() {
          s.goBack();
        }
        let l = !1;
        function a() {
          if (l) return;
          l = !0;
          const f = s.gender === 'm' ? u1 : a1;
          Ue([`${f}?width=320`, `${f}?width=400`, `${f}?width=800`]);
        }
        return (f, c) => (
          F(),
          R('div', e1, [
            c[4] ||
              (c[4] = _(
                'h2',
                { class: 'qlfqa:!text-xl qlfqa:!font-medium qlfqa:!mb-4 qlfqa:!text-center' },
                'Sehr gut, fast geschafft 🎉',
                -1
              )),
            c[5] ||
              (c[5] = _(
                'p',
                { class: 'qlfqa:!text-gray-700 qlfqa:!text-center' },
                ' Danke für deine Angaben. Wir können damit deinen Fahrplan berechnen. Jetzt noch einige letzte Fragen, damit deine Resultate dauerhaft sein werden! ',
                -1
              )),
            _('div', t1, [
              D(
                ke,
                {
                  src: `${bi}?width=400`,
                  srcset: `
          ${bi}?width=320 320w,
          ${bi}?width=400 400w,
          ${bi}?width=800 800w
        `,
                  sizes: '400px',
                  alt: 'Grafik zu Diätstatistiken',
                  loading: 'eager',
                  fetchpriority: 'high',
                  decoding: 'async',
                  width: '400',
                  height: '300',
                  class: 'qlfqa:!w-full qlfqa:!h-auto'
                },
                null,
                8,
                ['src', 'srcset']
              )
            ]),
            _('div', n1, [
              _('p', s1, [
                D(
                  ke,
                  {
                    src: `${wi}?width=150`,
                    srcset: `
            ${wi}?width=120 120w,
            ${wi}?width=150 150w,
            ${wi}?width=300 300w
          `,
                    sizes: '100px',
                    alt: 'Colorado University',
                    loading: 'lazy',
                    fetchpriority: 'low',
                    decoding: 'async',
                    width: '150',
                    height: '40',
                    class: 'qlfqa:!w-[70px] qlfqa:!h-auto qlfqa:!shrink-0'
                  },
                  null,
                  8,
                  ['src', 'srcset']
                ),
                c[2] ||
                  (c[2] = _(
                    'span',
                    { class: 'qlfqa:!text-gray-500 qlfqa:!text-sm qlfqa:!pl-4' },
                    ' Forscher der Universität Colorado belegen, dass unglaubliche 95% aller Diäten nach nur 3 Jahren komplett gescheitert sind. ',
                    -1
                  ))
              ])
            ]),
            _('div', i1, [
              _('p', r1, [
                D(
                  ke,
                  {
                    src: `${xi}?width=150`,
                    srcset: `
            ${xi}?width=120 120w,
            ${xi}?width=150 150w,
            ${xi}?width=300 300w
          `,
                    sizes: '100px',
                    alt: 'Universität Freiburg',
                    loading: 'lazy',
                    fetchpriority: 'low',
                    decoding: 'async',
                    width: '100',
                    height: '40',
                    class: 'qlfqa:!w-[70px] qlfqa:!h-auto qlfqa:!shrink-0'
                  },
                  null,
                  8,
                  ['src', 'srcset']
                ),
                c[3] ||
                  (c[3] = _(
                    'span',
                    { class: 'qlfqa:!text-gray-500 qlfqa:!text-sm qlfqa:!pl-4' },
                    ' Forschungen der Uni Freiburg beweisen, dass bis zu 70% aller Diätenden im Nachhinein mehr Gewicht zunehmen als vorher. ',
                    -1
                  ))
              ])
            ]),
            _('div', o1, [
              _(
                'button',
                {
                  onClick: o,
                  disabled: !i.value,
                  'aria-disabled': !i.value,
                  'aria-label': 'Zurück zum vorherigen Schritt',
                  class:
                    'qlfqa:!border qlfqa:!border-solid qlfqa:!border-[#CECDCA] qlfqa:!text-[#808080] qlfqa:!px-6 qlfqa:!py-3 qlfqa:!rounded-md qlfqa:disabled:!opacity-50 qlfqa:hover:!opacity-80 qlfqa:!cursor-pointer qlfqa:!w-1/2'
                },
                ' Zurück ',
                8,
                l1
              ),
              _(
                'button',
                {
                  onPointerenter: c[0] || (c[0] = (u) => a()),
                  onPointerdown: c[1] || (c[1] = (u) => a()),
                  onClick: r,
                  'aria-label': 'Alles klar und weiter',
                  class:
                    'qlfqa:!bg-yellow-500 qlfqa:!text-black qlfqa:!px-6 qlfqa:!py-3 qlfqa:!rounded-md qlfqa:hover:!bg-yellow-400 qlfqa:!cursor-pointer qlfqa:!w-1/2'
                },
                ' Weiter ',
                32
              )
            ])
          ])
        );
      }
    }),
    f1 = {
      class:
        'qlfqa:!mt-2 qlfqa:!grid qlfqa:!grid-cols-2 qlfqa:!gap-3 qlfqa:sm:!gap-x-4 qlfqa:!w-full'
    },
    d1 = ['onClick', 'onKeydown', 'aria-checked', 'aria-label', 'aria-description'],
    p1 = ['onMouseenter'],
    h1 = { class: 'qlfqa:!flex qlfqa:!flex-1 qlfqa:!justify-center' },
    m1 = { class: 'qlfqa:!flex qlfqa:!items-center' },
    g1 = { class: 'qlfqa:!block qlfqa:!text-sm qlfqa:!font-medium qlfqa:!text-gray-900' },
    _1 = {
      key: 0,
      class: 'qlfqa:!flex qlfqa:!items-center qlfqa:!justify-center qlfqa:!text-yellow-300'
    },
    bs = {
      __name: 'SelectionGroupGrid',
      props: {
        modelValue: { type: [String, Number], default: null },
        options: { type: Array, default: null }
      },
      emits: ['update:modelValue'],
      setup(e, { emit: t }) {
        const n = e,
          s = t,
          i = Q(n.modelValue),
          r = Q(null);
        (ze(
          () => n.modelValue,
          (l) => {
            i.value = l;
          }
        ),
          ze(i, (l) => {
            s('update:modelValue', l);
          }));
        function o(l) {
          i.value = l;
        }
        return (l, a) => (
          F(),
          R('div', f1, [
            (F(!0),
            R(
              be,
              null,
              Lt(
                e.options,
                (f) => (
                  F(),
                  R(
                    'div',
                    {
                      key: f.id,
                      class: 'qlfqa:!flex-1',
                      onClick: (c) => o(f.val),
                      onKeydown: Ca(
                        ka((c) => o(f.val), ['prevent']),
                        ['space']
                      ),
                      tabindex: '0',
                      role: 'radio',
                      'aria-checked': i.value === f.val,
                      'aria-label': f.text,
                      'aria-description': `Select ${f.text}`
                    },
                    [
                      _(
                        'div',
                        {
                          class: Be([
                            i.value === f.val
                              ? 'qlfqa:!border-yellow-300 qlfqa:!ring-1 qlfqa:!ring-yellow-300'
                              : 'qlfqa:!border-gray-300',
                            r.value === f.val
                              ? 'qlfqa:!border-yellow-300 qlfqa:!ring-1 qlfqa:!ring-yellow-300'
                              : '',
                            'qlfqa:!relative qlfqa:!flex qlfqa:!cursor-pointer qlfqa:!rounded-lg qlfqa:!h-14 qlfqa:!border qlfqa:!bg-white qlfqa:!p-4 qlfqa:!shadow-md qlfqa:focus:!outline-none'
                          ]),
                          onMouseenter: (c) => (r.value = f.val),
                          onMouseleave: a[0] || (a[0] = (c) => (r.value = null))
                        },
                        [
                          _('span', h1, [_('span', m1, [_('span', g1, me(f.text), 1)])]),
                          i.value === f.val
                            ? (F(),
                              R(
                                'span',
                                _1,
                                a[1] ||
                                  (a[1] = [
                                    _(
                                      'svg',
                                      {
                                        xmlns: 'http://www.w3.org/2000/svg',
                                        viewBox: '0 0 24 24',
                                        fill: 'currentColor',
                                        class: 'qlfqa:!size-5'
                                      },
                                      [
                                        _('path', {
                                          'fill-rule': 'evenodd',
                                          d: 'M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12zm13.36-1.814a.75.75 0 10-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 00-1.06 1.06l2.25 2.25a.75.75 0 001.14-.094l3.75-5.25z',
                                          'clip-rule': 'evenodd'
                                        })
                                      ],
                                      -1
                                    )
                                  ])
                              ))
                            : we('', !0),
                          _(
                            'span',
                            {
                              class: Be([
                                r.value === f.val ? 'qlfqa:!border' : 'qlfqa:!border-2',
                                i.value === f.val
                                  ? 'qlfqa:!border-yellow-300'
                                  : 'qlfqa:!border-transparent',
                                'qlfqa:!pointer-events-none qlfqa:!absolute qlfqa:!-inset-px qlfqa:!rounded-lg'
                              ]),
                              'aria-hidden': 'true'
                            },
                            null,
                            2
                          )
                        ],
                        42,
                        p1
                      )
                    ],
                    40,
                    d1
                  )
                )
              ),
              128
            ))
          ])
        );
      }
    },
    q1 = { class: 'qlfqa:!py-2' },
    v1 = { class: 'qlfqa:!mb-4' },
    y1 = { class: 'qlfqa:!flex' },
    b1 = se({
      __name: 'QuizScreen16',
      emits: ['next'],
      setup(e, { emit: t }) {
        const n = t,
          s = ae(),
          i = Q(''),
          r = [
            { id: 1, text: 'Weniger als 5h', val: '0' },
            { id: 2, text: '5 - 6 Stunden', val: '30' },
            { id: 3, text: '7 - 8 Stunden', val: '40' },
            { id: 4, text: 'Mehr als 8 Stunden', val: '-5' }
          ],
          o = [
            {
              id: 1,
              gender: 'w',
              image: 'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Frau_Schlaf.jpg',
              alt: ''
            },
            {
              id: 2,
              gender: 'm',
              image: 'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Mann_Schlaf.jpg',
              alt: ''
            }
          ],
          l = L(() => o.find((h) => h.gender === s.gender) || o[0]),
          a = L(() => s.screenHistory.length > 0);
        function f() {
          (p(), n('next', i.value));
        }
        function c() {
          s.goBack();
        }
        const u = {
          w: 'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Frau_trinken.jpg',
          m: 'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Mann_trinken.jpg'
        };
        let d = !1;
        function p() {
          if (d) return;
          d = !0;
          const h = s.gender === 'm' ? 'm' : 'w',
            q = u[h];
          Ue([`${q}?width=320`, `${q}?width=400`, `${q}?width=800`]);
        }
        return (
          ze(i, (h) => {
            h && p();
          }),
          (h, q) => (
            F(),
            R('div', q1, [
              q[1] ||
                (q[1] = _(
                  'h2',
                  { class: 'qlfqa:!text-xl qlfqa:!font-medium qlfqa:!mb-6 qlfqa:!text-center' },
                  'Wie viel schläfst du?',
                  -1
                )),
              _('div', v1, [
                D(
                  ke,
                  {
                    src: `${l.value.image}?width=400`,
                    srcset: `
                        ${l.value.image}?width=320 320w,
                        ${l.value.image}?width=400 400w,
                        ${l.value.image}?width=800 800w
                      `,
                    sizes: '400px',
                    alt: l.value.alt || 'Person schläft',
                    loading: 'eager',
                    fetchpriority: 'high',
                    decoding: 'async',
                    width: '400',
                    height: '300',
                    class: 'qlfqa:!rounded-md qlfqa:!w-full qlfqa:!h-auto'
                  },
                  null,
                  8,
                  ['src', 'srcset', 'alt']
                )
              ]),
              _('div', y1, [
                D(
                  bs,
                  {
                    class: 'qlfqa:!flex',
                    options: r,
                    modelValue: i.value,
                    'onUpdate:modelValue': q[0] || (q[0] = (v) => (i.value = v))
                  },
                  null,
                  8,
                  ['modelValue']
                )
              ]),
              D(
                Ce,
                {
                  class: 'qlfqa:!mt-6',
                  showBackButton: a.value,
                  disableContinue: !i.value,
                  onBack: c,
                  onContinue: f
                },
                null,
                8,
                ['showBackButton', 'disableContinue']
              )
            ])
          )
        );
      }
    }),
    w1 = { class: 'qlfqa:!py-2' },
    x1 = { class: 'qlfqa:!mb-4' },
    E1 = { class: 'qlfqa:!flex' },
    S1 = se({
      __name: 'QuizScreen17',
      emits: ['next'],
      setup(e, { emit: t }) {
        const n = t,
          s = ae(),
          i = Q(''),
          r = [
            { id: 1, text: 'Weniger als 1 Liter', val: '0' },
            { id: 2, text: '1 - 2 Liter', val: '30' },
            { id: 3, text: '2 - 3 Liter', val: '40' },
            { id: 4, text: 'Mehr als 3 Liter', val: '-5' }
          ],
          o = [
            {
              id: 1,
              gender: 'w',
              image: 'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Frau_trinken.jpg',
              alt: ''
            },
            {
              id: 2,
              gender: 'm',
              image: 'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Mann_trinken.jpg',
              alt: ''
            }
          ],
          l = L(() => o.find((h) => h.gender === s.gender) || o[0]),
          a = L(() => s.screenHistory.length > 0);
        function f() {
          (p(), n('next', i.value));
        }
        function c() {
          s.goBack();
        }
        const u = {
          w: 'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Bewegung_Frau.jpg',
          m: 'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Bewegung_Mann.jpg'
        };
        let d = !1;
        function p() {
          if (d) return;
          d = !0;
          const h = s.gender === 'm' ? 'm' : 'w',
            q = u[h];
          Ue([`${q}?width=320`, `${q}?width=400`, `${q}?width=800`]);
        }
        return (
          ze(i, (h) => {
            h && p();
          }),
          (h, q) => (
            F(),
            R('div', w1, [
              q[1] ||
                (q[1] = _(
                  'h2',
                  { class: 'qlfqa:!text-xl qlfqa:!font-medium qlfqa:!mb-6 qlfqa:!text-center' },
                  'Wie viel Wasser trinkst du?',
                  -1
                )),
              _('div', x1, [
                D(
                  ke,
                  {
                    src: `${l.value.image}?width=400`,
                    srcset: `
                    ${l.value.image}?width=320 320w,
                    ${l.value.image}?width=400 400w,
                    ${l.value.image}?width=800 800w
                  `,
                    sizes: '400px',
                    alt: l.value.alt || 'Person trinkt Wasser',
                    loading: 'eager',
                    fetchpriority: 'high',
                    decoding: 'async',
                    width: '400',
                    height: '300',
                    class: 'qlfqa:!rounded-md qlfqa:!w-full qlfqa:!h-auto'
                  },
                  null,
                  8,
                  ['src', 'srcset', 'alt']
                )
              ]),
              _('div', E1, [
                D(
                  bs,
                  {
                    class: 'qlfqa:!flex',
                    options: r,
                    modelValue: i.value,
                    'onUpdate:modelValue': q[0] || (q[0] = (v) => (i.value = v))
                  },
                  null,
                  8,
                  ['modelValue']
                )
              ]),
              D(
                Ce,
                {
                  class: 'qlfqa:!mt-6',
                  showBackButton: a.value,
                  disableContinue: !i.value,
                  onBack: c,
                  onContinue: f
                },
                null,
                8,
                ['showBackButton', 'disableContinue']
              )
            ])
          )
        );
      }
    }),
    k1 = { class: 'qlfqa:!py-2' },
    C1 = { class: 'qlfqa:!mb-4' },
    A1 = { class: 'qlfqa:!flex' },
    T1 = se({
      __name: 'QuizScreen18',
      emits: ['next'],
      setup(e, { emit: t }) {
        const n = t,
          s = ae(),
          i = Q(''),
          r = [
            { id: 1, text: 'Kaum bis gar nicht', val: '1.2,Inaktiv' },
            { id: 2, text: 'Kleiner Spaziergang', val: '1.375,Gering' },
            { id: 3, text: 'Großer Spaziergang', val: '1.55,Moderat' },
            { id: 4, text: 'Viel Bewegung', val: '1.725,Aktiv' }
          ],
          o = [
            {
              id: 1,
              gender: 'w',
              image: 'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Bewegung_Frau.jpg',
              alt: ''
            },
            {
              id: 2,
              gender: 'm',
              image: 'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Bewegung_Mann.jpg',
              alt: ''
            }
          ],
          l = L(() => o.find((h) => h.gender === s.gender) || o[0]),
          a = L(() => s.screenHistory.length > 0);
        function f() {
          (p(), n('next', i.value));
        }
        function c() {
          s.goBack();
        }
        const u = {
          w: 'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Frau_Sport.jpg',
          m: 'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Mann_Sport.jpg'
        };
        let d = !1;
        function p() {
          if (d) return;
          d = !0;
          const h = s.gender === 'm' ? 'm' : 'w',
            q = u[h];
          Ue([`${q}?width=320`, `${q}?width=400`, `${q}?width=800`]);
        }
        return (
          ze(i, (h) => {
            h && p();
          }),
          (h, q) => (
            F(),
            R('div', k1, [
              q[1] ||
                (q[1] = _(
                  'h2',
                  { class: 'qlfqa:!text-xl qlfqa:!font-medium qlfqa:!mb-6 qlfqa:!text-center' },
                  'Bewegst du dich täglich?',
                  -1
                )),
              _('div', C1, [
                D(
                  ke,
                  {
                    src: `${l.value.image}?width=400`,
                    srcset: `
                    ${l.value.image}?width=320 320w,
                    ${l.value.image}?width=400 400w,
                    ${l.value.image}?width=800 800w
                  `,
                    sizes: '400px',
                    alt: l.value.alt || 'Person bewegt sich',
                    loading: 'eager',
                    fetchpriority: 'high',
                    decoding: 'async',
                    width: '400',
                    height: '300',
                    class: 'qlfqa:!rounded-md qlfqa:!w-full qlfqa:!h-auto'
                  },
                  null,
                  8,
                  ['src', 'srcset', 'alt']
                )
              ]),
              _('div', A1, [
                D(
                  bs,
                  {
                    class: 'qlfqa:!flex',
                    options: r,
                    modelValue: i.value,
                    'onUpdate:modelValue': q[0] || (q[0] = (v) => (i.value = v))
                  },
                  null,
                  8,
                  ['modelValue']
                )
              ]),
              D(
                Ce,
                {
                  class: 'qlfqa:!mt-6',
                  showBackButton: a.value,
                  disableContinue: !i.value,
                  onBack: c,
                  onContinue: f
                },
                null,
                8,
                ['showBackButton', 'disableContinue']
              )
            ])
          )
        );
      }
    }),
    O1 = { class: 'qlfqa:!py-2' },
    I1 = { class: 'qlfqa:!mb-4' },
    $1 = { class: 'qlfqa:!flex' },
    B1 = se({
      __name: 'QuizScreen19',
      emits: ['next'],
      setup(e, { emit: t }) {
        const n = t,
          s = ae(),
          i = Q(''),
          r = [
            { id: 1, text: 'Nein, aktuell nicht', val: '0' },
            { id: 2, text: '1 bis 2 x / Woche', val: '30' },
            { id: 3, text: '2 bis 3 x / Woche', val: '40' },
            { id: 4, text: 'Mehr als 3 x / Woche', val: '-5' }
          ],
          o = [
            {
              id: 1,
              gender: 'w',
              image: 'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Frau_Sport.jpg',
              alt: ''
            },
            {
              id: 2,
              gender: 'm',
              image: 'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Mann_Sport.jpg',
              alt: ''
            }
          ],
          l = L(() => o.find((h) => h.gender === s.gender) || o[0]),
          a = L(() => s.screenHistory.length > 0),
          f = {
            w: 'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Frauen_Treppen.jpg',
            m: 'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Mann_Treppen.jpg'
          };
        let c = !1;
        function u() {
          if (c) return;
          c = !0;
          const h = s.gender === 'm' ? 'm' : 'w',
            q = f[h];
          Ue([`${q}?width=320`, `${q}?width=400`, `${q}?width=800`]);
        }
        ze(i, (h) => {
          h && u();
        });
        function d() {
          (u(), n('next', i.value));
        }
        function p() {
          s.goBack();
        }
        return (h, q) => (
          F(),
          R('div', O1, [
            q[1] ||
              (q[1] = _(
                'h2',
                { class: 'qlfqa:!text-xl qlfqa:!font-medium qlfqa:!mb-6 qlfqa:!text-center' },
                'Machst du regelmäßig Sport?',
                -1
              )),
            _('div', I1, [
              D(
                ke,
                {
                  src: `${l.value.image}?width=400`,
                  srcset: `
    ${l.value.image}?width=320 320w,
    ${l.value.image}?width=400 400w,
    ${l.value.image}?width=800 800w
  `,
                  sizes: '400px',
                  alt: l.value.alt || 'Person macht Sport',
                  loading: 'eager',
                  fetchpriority: 'high',
                  decoding: 'async',
                  width: '400',
                  height: '300',
                  class: 'qlfqa:!rounded-md qlfqa:!w-full qlfqa:!h-auto'
                },
                null,
                8,
                ['src', 'srcset', 'alt']
              )
            ]),
            _('div', $1, [
              D(
                bs,
                {
                  class: 'qlfqa:!flex',
                  options: r,
                  modelValue: i.value,
                  'onUpdate:modelValue': q[0] || (q[0] = (v) => (i.value = v))
                },
                null,
                8,
                ['modelValue']
              )
            ]),
            D(
              Ce,
              {
                class: 'qlfqa:!mt-6',
                showBackButton: a.value,
                disableContinue: !i.value,
                onBack: p,
                onContinue: d
              },
              null,
              8,
              ['showBackButton', 'disableContinue']
            )
          ])
        );
      }
    }),
    F1 = { class: 'qlfqa:!py-2' },
    D1 = { class: 'qlfqa:!mb-4' },
    z1 = { class: 'qlfqa:!flex' },
    Xr = 'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Diaeten-Scheitern.jpg',
    P1 = se({
      __name: 'QuizScreen20',
      emits: ['next'],
      setup(e, { emit: t }) {
        const n = t,
          s = ae(),
          i = Q(''),
          r = [
            { id: 1, text: 'Nein, eher nicht', val: '0' },
            { id: 2, text: 'Ja, eher schon', val: '30' }
          ],
          o = [
            {
              id: 1,
              gender: 'w',
              image: 'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Frauen_Treppen.jpg',
              alt: ''
            },
            {
              id: 2,
              gender: 'm',
              image: 'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Mann_Treppen.jpg',
              alt: ''
            }
          ],
          l = L(() => o.find((h) => h.gender === s.gender) || o[0]),
          a = L(() => s.screenHistory.length > 0),
          f = {
            m: 'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Jojo-Effekt-Mann.jpg',
            w: 'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Jojo-Effekt-Frau.jpg'
          };
        let c = !1;
        function u() {
          if (c) return;
          c = !0;
          const h = s.gender === 'm' ? 'm' : 'w',
            q = f[h];
          Ue([
            `${Xr}?width=320`,
            `${Xr}?width=400`,
            `${Xr}?width=800`,
            `${q}?width=320`,
            `${q}?width=400`,
            `${q}?width=800`
          ]);
        }
        ze(i, (h) => {
          h && u();
        });
        function d() {
          (u(), n('next', i.value));
        }
        function p() {
          s.goBack();
        }
        return (h, q) => (
          F(),
          R('div', F1, [
            q[1] ||
              (q[1] = _(
                'h2',
                { class: 'qlfqa:!text-xl qlfqa:!font-medium qlfqa:!mb-6 qlfqa:!text-center' },
                'Außer Atem bei Treppen?',
                -1
              )),
            _('div', D1, [
              D(
                ke,
                {
                  src: `${l.value.image}?width=400`,
                  srcset: `
    ${l.value.image}?width=320 320w,
    ${l.value.image}?width=400 400w,
    ${l.value.image}?width=800 800w
  `,
                  sizes: '400px',
                  alt: l.value.alt || 'Person geht Treppen',
                  loading: 'eager',
                  fetchpriority: 'high',
                  decoding: 'async',
                  width: '400',
                  height: '300',
                  class: 'qlfqa:!rounded-md qlfqa:!w-full qlfqa:!h-auto'
                },
                null,
                8,
                ['src', 'srcset', 'alt']
              )
            ]),
            _('div', z1, [
              D(
                bs,
                {
                  class: 'qlfqa:!flex',
                  options: r,
                  modelValue: i.value,
                  'onUpdate:modelValue': q[0] || (q[0] = (v) => (i.value = v))
                },
                null,
                8,
                ['modelValue']
              )
            ]),
            D(
              Ce,
              {
                class: 'qlfqa:!mt-6',
                showBackButton: a.value,
                disableContinue: !i.value,
                onBack: p,
                onContinue: d
              },
              null,
              8,
              ['showBackButton', 'disableContinue']
            )
          ])
        );
      }
    }),
    M1 = { class: 'qlfqa:!py-2' },
    R1 = se({
      __name: 'QuizScreen21',
      emits: ['next'],
      setup(e, { emit: t }) {
        const n = t,
          s = ae(),
          i = Q([]),
          r = Q(!1),
          o = [
            { id: 1, text: 'Emotionales essen oder aus Langeweile', val: '0' },
            { id: 2, text: 'Zu viel essen', val: '1' },
            { id: 3, text: 'Oft Snacks essen', val: '2' },
            { id: 4, text: 'Mahlzeiten häufiger komplett auslassen', val: '3' }
          ],
          l = { id: 5, text: 'Keine der Aufgezählten', val: 'nichts' },
          a = L(() => s.screenHistory.length > 0),
          f = L(() => i.value.length > 0 || r.value);
        function c() {
          let d;
          (r.value && l ? (d = [l.val]) : (d = i.value), n('next', d));
        }
        function u() {
          s.goBack();
        }
        return (d, p) => (
          F(),
          R('div', M1, [
            p[1] ||
              (p[1] = _(
                'h2',
                { class: 'qlfqa:!text-l qlfqa:!font-medium qlfqa:!mb-4' },
                'Hast du einige dieser Angewohnheiten?',
                -1
              )),
            p[2] ||
              (p[2] = _('p', { class: 'qlfqa:!text-gray-700' }, 'Mehrfach-Auswahl möglich', -1)),
            D(
              _n,
              {
                modelValue: i.value,
                'onUpdate:modelValue': p[0] || (p[0] = (h) => (i.value = h)),
                class: 'qlfqa:!mt-4',
                checkboxOptions: o,
                exclusiveOption: l
              },
              null,
              8,
              ['modelValue']
            ),
            D(
              Ce,
              { showBackButton: a.value, disableContinue: !f.value, onBack: u, onContinue: c },
              null,
              8,
              ['showBackButton', 'disableContinue']
            )
          ])
        );
      }
    }),
    V1 = { class: 'qlfqa:!py-2' },
    N1 = se({
      __name: 'QuizScreen22',
      emits: ['next'],
      setup(e, { emit: t }) {
        const n = t,
          s = ae(),
          i = Q([]),
          r = Q(!1),
          o = [
            { id: 1, text: 'Low Carb oder Keto', val: '0' },
            { id: 2, text: 'Intermittierendes Fasten', val: '1' },
            { id: 3, text: 'Kalorien zählen', val: '2' },
            { id: 4, text: 'Weight Watchers (oder ähnliches)', val: '3' }
          ],
          l = { id: 5, text: 'Keine der Aufgezählten', val: 'nichts' },
          a = L(() => s.screenHistory.length > 0),
          f = L(() => i.value.length > 0 || r.value);
        function c() {
          let d;
          (r.value && l ? (d = [l.val]) : (d = i.value), n('next', d));
        }
        function u() {
          s.goBack();
        }
        return (d, p) => (
          F(),
          R('div', V1, [
            p[1] ||
              (p[1] = _(
                'h2',
                { class: 'qlfqa:!text-l qlfqa:!font-medium qlfqa:!mb-4' },
                'Hast du schon solche Diäten ausprobiert?',
                -1
              )),
            p[2] ||
              (p[2] = _('p', { class: 'qlfqa:!text-gray-700' }, 'Mehrfach-Auswahl möglich', -1)),
            D(
              _n,
              {
                modelValue: i.value,
                'onUpdate:modelValue': p[0] || (p[0] = (h) => (i.value = h)),
                class: 'qlfqa:!mt-4',
                checkboxOptions: o,
                exclusiveOption: l
              },
              null,
              8,
              ['modelValue']
            ),
            D(
              Ce,
              { showBackButton: a.value, disableContinue: !f.value, onBack: u, onContinue: c },
              null,
              8,
              ['showBackButton', 'disableContinue']
            )
          ])
        );
      }
    }),
    j1 = { class: 'qlfqa:!py-2', role: 'article' },
    L1 = { class: 'qlfqa:!mb-4' },
    U1 = {
      class: 'qlfqa:!mt-8 qlfqa:!flex qlfqa:!justify-center qlfqa:!gap-4',
      role: 'group',
      'aria-label': 'Navigation'
    },
    Q1 = ['disabled', 'aria-disabled'],
    eo = 'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/testis.jpg',
    H1 = se({
      __name: 'QuizScreen23',
      emits: ['next'],
      setup(e, { emit: t }) {
        const n = t,
          s = ae(),
          i = Q('checked'),
          r = L(() => s.screenHistory.length > 0),
          o = L(() =>
            s.gender === 'm'
              ? 'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Jojo-Effekt-Mann.jpg'
              : 'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Jojo-Effekt-Frau.jpg'
          ),
          l = L(() =>
            s.gender === 'm'
              ? 'Grafik, die zeigt, dass Diäten langfristig nicht funktionieren bei Männern'
              : 'Grafik, die zeigt, dass Diäten langfristig nicht funktionieren bei Frauen'
          );
        function a() {
          (d(), n('next', i.value));
        }
        function f() {
          s.goBack();
        }
        const c = {
          w: 'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Trafo_Frau_Stoffwechsel_Quiz.jpg',
          m: 'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Trafo_Mann_Stoffwechsel_Quiz.jpg'
        };
        let u = !1;
        function d() {
          if (u) return;
          u = !0;
          const p = s.gender === 'm' ? 'm' : 'w',
            h = c[p];
          Ue([
            `${eo}?width=80`,
            `${eo}?width=120`,
            `${eo}?width=240`,
            `${h}?width=320`,
            `${h}?width=400`,
            `${h}?width=800`
          ]);
        }
        return (p, h) => (
          F(),
          R('div', j1, [
            h[2] ||
              (h[2] = _(
                'h2',
                { class: 'qlfqa:!text-xl qlfqa:!font-medium qlfqa:!mb-6 qlfqa:!text-center' },
                'Schluss mit der Diät-Falle 😣',
                -1
              )),
            h[3] ||
              (h[3] = _(
                'p',
                { class: 'qlfqa:!text-gray-700 qlfqa:!text-center' },
                ' Die Statistik beweist - Klassische Diäten scheitern nicht nur, sondern machen es jedes Mal leichter mehr an ungesunden Fett zuzunehmen. ',
                -1
              )),
            _('div', L1, [
              D(ke, {
                src: 'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Diaeten-Scheitern.jpg?width=400',
                srcset: `
                    https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Diaeten-Scheitern.jpg?width=320 320w,
                    https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Diaeten-Scheitern.jpg?width=400 400w,
                    https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Diaeten-Scheitern.jpg?width=800 800w
                  `,
                sizes: '400px',
                alt: 'Diagramm das zeigt, dass Diäten langfristig nicht funktionieren',
                loading: 'eager',
                fetchpriority: 'high',
                decoding: 'async',
                width: '400',
                height: '300',
                class: 'qlfqa:!w-full qlfqa:!h-auto'
              }),
              D(
                ke,
                {
                  src: `${o.value}?width=400`,
                  srcset: `
                    ${o.value}?width=320 320w,
                    ${o.value}?width=400 400w,
                    ${o.value}?width=800 800w
                  `,
                  sizes: '400px',
                  alt: l.value,
                  loading: 'lazy',
                  fetchpriority: 'low',
                  decoding: 'async',
                  width: '400',
                  height: '300',
                  class: 'qlfqa:!w-full qlfqa:!h-auto'
                },
                null,
                8,
                ['src', 'srcset', 'alt']
              )
            ]),
            _('div', U1, [
              _(
                'button',
                {
                  onClick: f,
                  disabled: !r.value,
                  'aria-disabled': !r.value,
                  'aria-label': 'Zurück zum vorherigen Schritt',
                  class:
                    'qlfqa:!border qlfqa:!border-solid qlfqa:!border-[#CECDCA] qlfqa:!text-[#808080] qlfqa:!px-6 qlfqa:!py-3 qlfqa:!rounded-md qlfqa:disabled:!opacity-50 qlfqa:hover:!opacity-80 qlfqa:!cursor-pointer qlfqa:!w-1/2'
                },
                ' Zurück ',
                8,
                Q1
              ),
              _(
                'button',
                {
                  onPointerenter: h[0] || (h[0] = (q) => d()),
                  onPointerdown: h[1] || (h[1] = (q) => d()),
                  onClick: a,
                  'aria-label': 'Alles klar und weiter',
                  class:
                    'qlfqa:!bg-yellow-500 qlfqa:!text-black qlfqa:!px-6 qlfqa:!py-3 qlfqa:!rounded-md qlfqa:disabled:!opacity-50 qlfqa:hover:!bg-yellow-400 qlfqa:!cursor-pointer qlfqa:!w-1/2'
                },
                ' Weiter ',
                32
              )
            ])
          ])
        );
      }
    }),
    K1 = { class: 'qlfqa:!py-2' },
    W1 = se({
      __name: 'QuizScreen24',
      emits: ['next'],
      setup(e, { emit: t }) {
        const n = t,
          s = ae(),
          i = Q([]),
          r = Q(!1),
          o = [
            { id: 1, text: 'Süßigkeiten', val: '0' },
            { id: 2, text: 'Salzige Snacks', val: '1' },
            { id: 3, text: 'Fast Food', val: '2' },
            { id: 4, text: 'Zuckerhaltige Getränke', val: '3' }
          ],
          l = { id: 5, text: 'Keine der Aufgezählten', val: 'nichts' },
          a = L(() => s.screenHistory.length > 0),
          f = L(() => i.value.length > 0 || r.value);
        function c() {
          let d;
          (r.value && l ? (d = [l.val]) : (d = i.value), n('next', d));
        }
        function u() {
          s.goBack();
        }
        return (d, p) => (
          F(),
          R('div', K1, [
            p[1] ||
              (p[1] = _(
                'h2',
                { class: 'qlfqa:!text-l qlfqa:!font-medium qlfqa:!mb-4' },
                'Welche sind deine häufigsten Cravings?',
                -1
              )),
            p[2] ||
              (p[2] = _('p', { class: 'qlfqa:!text-gray-700' }, 'Mehrfach-Auswahl möglich', -1)),
            D(
              _n,
              {
                modelValue: i.value,
                'onUpdate:modelValue': p[0] || (p[0] = (h) => (i.value = h)),
                class: 'qlfqa:!mt-4',
                checkboxOptions: o,
                exclusiveOption: l
              },
              null,
              8,
              ['modelValue']
            ),
            D(
              Ce,
              { showBackButton: a.value, disableContinue: !f.value, onBack: u, onContinue: c },
              null,
              8,
              ['showBackButton', 'disableContinue']
            )
          ])
        );
      }
    }),
    G1 = { class: 'loading-bar-container' },
    Y1 = { key: 0, class: 'qlfqa:!flex qlfqa:!justify-between qlfqa:!items-center qlfqa:!mb-2' },
    Z1 = { class: 'qlfqa:!flex qlfqa:!items-center qlfqa:!gap-2' },
    J1 = {
      key: 0,
      width: '16',
      height: '16',
      viewBox: '0 0 24 24',
      xmlns: 'http://www.w3.org/2000/svg'
    },
    X1 = { key: 1, class: 'qlfqa:!text-xs qlfqa:!font-medium qlfqa:!w-[35px]' },
    e_ = { class: 'loading-bar-wrapper' },
    t_ = { class: 'loading-bar-track' },
    n_ = { key: 0, class: 'loading-bar-percentage' },
    Ei = se({
      __name: 'LoadingBarConfigurable',
      props: {
        duration: { default: 4e3 },
        showPercentage: { type: Boolean, default: !0 },
        easingFunction: { default: 'linear' },
        autoStart: { type: Boolean, default: !0 },
        label: { default: '' }
      },
      emits: ['complete', 'progress'],
      setup(e, { expose: t, emit: n }) {
        const s = e,
          i = n,
          r = Q(0),
          o = Q(!1);
        let l = null,
          a = null;
        const f = {
          linear: (h) => h,
          easeIn: (h) => h * h,
          easeOut: (h) => h * (2 - h),
          easeInOut: (h) => (h < 0.5 ? 2 * h * h : -1 + (4 - 2 * h) * h)
        };
        function c(h) {
          a || (a = h);
          const q = h - a,
            v = Math.min(q / s.duration, 1),
            y = f[s.easingFunction](v);
          ((r.value = y * 100),
            i('progress', r.value),
            v < 1
              ? (l = requestAnimationFrame(c))
              : ((r.value = 100), (o.value = !1), i('complete')));
        }
        function u() {
          (d(), (o.value = !0), (l = requestAnimationFrame(c)));
        }
        function d() {
          (l !== null && (cancelAnimationFrame(l), (l = null)),
            (a = null),
            (r.value = 0),
            (o.value = !1));
        }
        function p() {
          (l !== null && (cancelAnimationFrame(l), (l = null)), (o.value = !1));
        }
        return (
          jt(() => {
            s.autoStart && u();
          }),
          Gs(() => {
            l !== null && cancelAnimationFrame(l);
          }),
          t({ start: u, reset: d, pause: p, progress: r }),
          (h, q) => (
            F(),
            R('div', G1, [
              h.label
                ? (F(),
                  R('div', Y1, [
                    _(
                      'span',
                      {
                        class: Be([
                          'qlfqa:!text-xs',
                          { 'qlfqa:font-bold': o.value, 'qlfqa:opacity-75': !o.value }
                        ])
                      },
                      me(h.label),
                      3
                    ),
                    _('span', Z1, [
                      o.value
                        ? (F(),
                          R(
                            'svg',
                            J1,
                            q[0] ||
                              (q[0] = [
                                _(
                                  'path',
                                  {
                                    d: 'M10.72,19.9a8,8,0,0,1-6.5-9.79A7.77,7.77,0,0,1,10.4,4.16a8,8,0,0,1,9.49,6.52A1.54,1.54,0,0,0,21.38,12h.13a1.37,1.37,0,0,0,1.38-1.54,11,11,0,1,0-12.7,12.39A1.54,1.54,0,0,0,12,21.34h0A1.47,1.47,0,0,0,10.72,19.9Z',
                                    class: 'spinner_6kVp'
                                  },
                                  null,
                                  -1
                                )
                              ])
                          ))
                        : we('', !0),
                      h.showPercentage
                        ? (F(), R('span', X1, me(Math.round(r.value)) + '% ', 1))
                        : we('', !0)
                    ])
                  ]))
                : we('', !0),
              _('div', e_, [
                _('div', t_, [
                  _(
                    'div',
                    { class: 'loading-bar-fill', style: Ye({ width: `${r.value}%` }) },
                    null,
                    4
                  )
                ]),
                h.showPercentage && !h.label
                  ? (F(), R('div', n_, me(Math.round(r.value)) + '% ', 1))
                  : we('', !0)
              ])
            ])
          )
        );
      }
    }),
    s_ = { class: 'qlfqa:!py-2', role: 'article' },
    i_ = { class: 'qlfqa:!mt-8' },
    r_ = {
      class:
        'qlfqa:!text-center qlfqa:!text-sm qlfqa:!mt-6 qlfqa:!flex qlfqa:!items-center qlfqa:!justify-center qlfqa:!gap-2 qlfqa:!font-bold qlfqa:!text-black'
    },
    o_ = { class: 'qlfqa:!mb-4 qlfqa:!mt-8' },
    to = 300,
    l_ = se({
      __name: 'QuizScreen25',
      emits: ['next'],
      setup(e, { emit: t }) {
        const n = t,
          s = ae(),
          i = Q('checked'),
          r = Q(),
          o = Q(),
          l = Q(),
          a = Q(),
          f = Q(0);
        function c() {
          setTimeout(() => {
            var O;
            ((f.value = 2), (O = o.value) == null || O.start());
          }, to);
        }
        function u() {
          setTimeout(() => {
            var O;
            ((f.value = 3), (O = l.value) == null || O.start());
          }, to);
        }
        function d() {
          setTimeout(() => {
            var O;
            ((f.value = 4), (O = a.value) == null || O.start());
          }, to);
        }
        function p() {
          ((f.value = 0),
            setTimeout(() => {
              n('next', i.value);
            }, 1e3));
        }
        const h = [
            {
              id: 1,
              gender: 'w',
              image:
                'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Trafo_Frau_Stoffwechsel_Quiz.jpg',
              alt: ''
            },
            {
              id: 2,
              gender: 'm',
              image:
                'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Trafo_Mann_Stoffwechsel_Quiz.jpg',
              alt: ''
            }
          ],
          q = L(() => h.find((O) => O.gender === s.gender) || h[0]),
          v = {
            w: 'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Nicole-Trafo.jpg?v=1769996540',
            m: 'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Trafo_Mann_Stoffwechsel_Quiz_3d36a4c1-5986-4743-80a2-5bad9319d814.jpg'
          };
        let y = !1;
        function z() {
          if (y) return;
          y = !0;
          const O = s.gender === 'm' ? 'm' : 'w',
            X = v[O];
          Ue([`${X}?width=320`, `${X}?width=400`, `${X}?width=800`]);
        }
        return (
          jt(() => {
            var O;
            (z(), s.calculateResults(), (f.value = 1), (O = r.value) == null || O.start());
          }),
          (O, X) => (
            F(),
            R('div', s_, [
              X[2] ||
                (X[2] = _(
                  'h2',
                  { class: 'qlfqa:!text-l qlfqa:!font-medium qlfqa:!mb-4 qlfqa:!text-center' },
                  'Deine Daten werden jetzt analysiert',
                  -1
                )),
              _('div', i_, [
                D(
                  Ei,
                  {
                    ref_key: 'loadingBar1',
                    ref: r,
                    label: 'Persönliche Angaben werden ausgewertet',
                    duration: 2e3,
                    autoStart: !1,
                    class: 'qlfqa:!mb-4',
                    easingFunction: 'easeOut',
                    onComplete: c
                  },
                  null,
                  512
                ),
                D(
                  Ei,
                  {
                    ref_key: 'loadingBar2',
                    ref: o,
                    label: 'Individuelle Umstände werden abgeglichen',
                    duration: 2200,
                    autoStart: !1,
                    class: 'qlfqa:!mb-4',
                    easingFunction: 'easeOut',
                    onComplete: u
                  },
                  null,
                  512
                ),
                D(
                  Ei,
                  {
                    ref_key: 'loadingBar3',
                    ref: l,
                    label: 'Gesundheit & Langfristiger Erfolg berechnet',
                    duration: 2500,
                    autoStart: !1,
                    class: 'qlfqa:!mb-4',
                    easingFunction: 'easeOut',
                    onComplete: d
                  },
                  null,
                  512
                ),
                D(
                  Ei,
                  {
                    ref_key: 'loadingBar4',
                    ref: a,
                    label: 'Abgleich mit der wissenschaftlichen Datenbank',
                    duration: 1e4,
                    autoStart: !1,
                    easingFunction: 'easeInOut',
                    onComplete: p
                  },
                  null,
                  512
                )
              ]),
              _('p', r_, [
                D(ke, {
                  src: 'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/testis.jpg?width=120',
                  srcset: `
                    https://cdn.shopify.com/s/files/1/0794/9097/4033/files/testis.jpg?width=80 80w,
                    https://cdn.shopify.com/s/files/1/0794/9097/4033/files/testis.jpg?width=120 120w,
                    https://cdn.shopify.com/s/files/1/0794/9097/4033/files/testis.jpg?width=240 240w
                  `,
                  sizes: '120px',
                  alt: 'Testimonials',
                  loading: 'lazy',
                  fetchpriority: 'low',
                  decoding: 'async',
                  width: '120',
                  height: '28',
                  class: 'qlfqa:!w-auto qlfqa:!h-7'
                }),
                X[0] ||
                  (X[0] = _(
                    'svg',
                    {
                      width: '25px',
                      height: '25px',
                      viewBox: '0 0 24 24',
                      fill: 'none',
                      xmlns: 'http://www.w3.org/2000/svg'
                    },
                    [
                      _('rect', { width: '24', height: '24' }),
                      _('path', {
                        'fill-rule': 'evenodd',
                        'clip-rule': 'evenodd',
                        d: 'M9.55879 3.6972C10.7552 2.02216 13.2447 2.02216 14.4412 3.6972L14.6317 3.96387C14.8422 4.25867 15.1958 4.41652 15.5558 4.37652L16.4048 4.28218C18.3156 4.06988 19.9301 5.68439 19.7178 7.59513L19.6235 8.44415C19.5835 8.8042 19.7413 9.15774 20.0361 9.36831L20.3028 9.55879C21.9778 10.7552 21.9778 13.2447 20.3028 14.4412L20.0361 14.6317C19.7413 14.8422 19.5835 15.1958 19.6235 15.5558L19.7178 16.4048C19.9301 18.3156 18.3156 19.9301 16.4048 19.7178L15.5558 19.6235C15.1958 19.5835 14.8422 19.7413 14.6317 20.0361L14.4412 20.3028C13.2447 21.9778 10.7553 21.9778 9.55879 20.3028L9.36831 20.0361C9.15774 19.7413 8.8042 19.5835 8.44414 19.6235L7.59513 19.7178C5.68439 19.9301 4.06988 18.3156 4.28218 16.4048L4.37652 15.5558C4.41652 15.1958 4.25867 14.8422 3.96387 14.6317L3.6972 14.4412C2.02216 13.2447 2.02216 10.7553 3.6972 9.55879L3.96387 9.36831C4.25867 9.15774 4.41652 8.8042 4.37652 8.44414L4.28218 7.59513C4.06988 5.68439 5.68439 4.06988 7.59513 4.28218L8.44415 4.37652C8.8042 4.41652 9.15774 4.25867 9.36831 3.96387L9.55879 3.6972ZM15.7071 9.29289C16.0976 9.68342 16.0976 10.3166 15.7071 10.7071L11.8882 14.526C11.3977 15.0166 10.6023 15.0166 10.1118 14.526L8.29289 12.7071C7.90237 12.3166 7.90237 11.6834 8.29289 11.2929C8.68342 10.9024 9.31658 10.9024 9.70711 11.2929L11 12.5858L14.2929 9.29289C14.6834 8.90237 15.3166 8.90237 15.7071 9.29289Z',
                        fill: '#3D7FDE'
                      })
                    ],
                    -1
                  )),
                X[1] ||
                  (X[1] = _(
                    'span',
                    { class: 'qlfqa:!text-[0.7rem]' },
                    'über 500.000 Kunden vertrauen QLF',
                    -1
                  ))
              ]),
              _('div', o_, [
                D(
                  ke,
                  {
                    src: `${q.value.image}?width=400`,
                    srcset: `
                    ${q.value.image}?width=320 320w,
                    ${q.value.image}?width=400 400w,
                    ${q.value.image}?width=800 800w
                  `,
                    sizes: '400px',
                    alt: q.value.alt || 'Analyse wird durchgeführt',
                    loading: 'lazy',
                    fetchpriority: 'low',
                    decoding: 'async',
                    width: '400',
                    height: '300',
                    class: 'qlfqa:!w-full qlfqa:!h-auto qlfqa:!rounded-md'
                  },
                  null,
                  8,
                  ['src', 'srcset', 'alt']
                )
              ])
            ])
          )
        );
      }
    }),
    a_ = { class: 'qlfqa:!py-2', role: 'article' },
    u_ = { class: 'bmi-chart-wrapper' },
    c_ = { class: 'bmi-chart' },
    f_ = { class: 'bmi-chart-track' },
    d_ = { class: 'bmi-chart-bottom' },
    p_ = {
      key: 0,
      class:
        'qlfqa:!mt-4 qlfqa:!border qlfqa:!border-[#e0a959] qlfqa:!rounded-2xl qlfqa:!p-5 qlfqa:!bg-[#faf3e9]'
    },
    h_ = { class: 'qlfqa:!flex qlfqa:!items-center qlfqa:!gap-2' },
    m_ = { class: 'qlfqa:!font-semibold qlfqa:!text-xs' },
    g_ = { class: 'qlfqa:!mt-2 qlfqa:!text-xs' },
    __ = { class: 'qlfqa:!text-gray-700 qlfqa:!text-xs qlfqa:!m-0' },
    q_ = { class: 'qlfqa:!text-sm qlfqa:!font-bold' },
    v_ = {
      class: 'qlfqa:!mt-8 qlfqa:!flex qlfqa:!justify-center qlfqa:!gap-4',
      role: 'group',
      'aria-label': 'Navigation'
    },
    y_ = ['disabled', 'aria-disabled'],
    b_ = se({
      __name: 'QuizScreen26',
      emits: ['next'],
      setup(e, { emit: t }) {
        const n = t,
          s = ae(),
          i = Q('checked'),
          r = Q([]),
          o = Q(0),
          l = Q(!1),
          a = L(() => '20%'),
          f = L(() => '21%'),
          c = L(() => '22%'),
          u = L(() => '37%'),
          d = [
            {
              id: 1,
              headline: 'STOFFWECHSEL-TYP',
              text: s.q07.replace(' 2', ''),
              imageM:
                'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Stoffwechsel-Typ_Mann.png',
              imageW:
                'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Stoffwechsel-Typ_Frau.png'
            },
            {
              id: 2,
              headline: 'LEBENSSTIL',
              text: s.q18.split(',')[1],
              image: 'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/sofa.png'
            },
            {
              id: 3,
              headline: 'ZIEL-ZONEN',
              text: s.q06.toString().replaceAll(',', ', '),
              image: 'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/ziel.png'
            },
            {
              id: 4,
              headline: 'ERFOLGS-CHANCE',
              text: 'Sehr hoch',
              image: 'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/blitz.png'
            }
          ],
          p = [
            {
              bmi_range: [0, 18.5],
              headline: 'Risiken eines ungesunden BMI',
              text: 'Bluthochdruck, erhöhtes Risiko für Herzinfarkt, Schlaganfall, Typ-2 Diabetes sowie chronische Rücken- und Gelenkschmerzen. Mit den richtigen Maßnahmen kannst du jedoch schnell, sicher und effektiv abnehmen.'
            },
            {
              bmi_range: [25, 999],
              headline: 'Risiken eines ungesunden BMI',
              text: 'Bluthochdruck, erhöhtes Risiko für Herzinfarkt, Schlaganfall, Typ-2 Diabetes sowie chronische Rücken- und Gelenkschmerzen. Mit den richtigen Maßnahmen kannst du jedoch schnell, sicher und effektiv abnehmen.'
            }
          ];
        function h() {
          const w = parseInt(s.q10),
            x = parseInt(s.q11);
          return (w / (x / 100) ** 2).toFixed(2);
        }
        function q() {
          const w = parseFloat(h());
          return p.find((E) => w >= E.bmi_range[0] && w < E.bmi_range[1]) || null;
        }
        function v(w) {
          const de = ((Math.max(15, Math.min(40, w)) - 15) / 25) * 100;
          return Math.min(de, 100);
        }
        const y = L(() => {
          const w = parseFloat(h());
          return w <= 35
            ? 'calc(.5rem + 2px)'
            : w >= 40
              ? '-19px'
              : `calc(.5rem + 2px + ${((w - 35) / 5) * -19}px)`;
        });
        function z() {
          const w = parseFloat(h()),
            x = v(w);
          setTimeout(() => {
            ((o.value = x),
              setTimeout(() => {
                l.value = !0;
              }, 1500));
          }, 300);
        }
        const O = (w) =>
            'imageM' in w && 'imageW' in w ? (s.gender === 'm' ? w.imageM : w.imageW) : w.image,
          X = L(() => {
            const w = parseFloat(h());
            return isNaN(w) || w < 18.5
              ? 'lt20'
              : w < 25
                ? 'gte20_lt25'
                : w < 30
                  ? 'gte25_lt30'
                  : w < 35
                    ? 'gte30_lt35'
                    : 'gte35';
          }),
          N = {
            m: {
              lt20: 'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Quiz-Frage26-Mann-BMI-unter20.jpg',
              gte20_lt25:
                'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Quiz-Frage26-Mann-BMI-ueber20.jpg',
              gte25_lt30:
                'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Quiz-Frage26-Mann-BMI-25.jpg',
              gte30_lt35:
                'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Quiz-Frage26-Mann-BMI-30.jpg',
              gte35:
                'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Quiz-Frage26-Mann-BMI-35Plus.jpg'
            },
            w: {
              lt20: 'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Quiz-Frage26-Frau-BMI-ueber20.jpg',
              gte20_lt25:
                'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Quiz-Frage26-Frau-BMI-25.jpg',
              gte25_lt30:
                'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Quiz-Frage26-Frau-BMI-25.jpg',
              gte30_lt35:
                'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Quiz-Frage26-Frau-BMI-30.jpg',
              gte35:
                'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Quiz-Frage26-Frau-BMI-35Plus.jpg'
            }
          },
          ne = L(() => {
            const w = s.gender === 'm' ? 'm' : 'w',
              x = N[w][X.value];
            return x
              ? {
                  backgroundImage: `image-set(
      url(${x}?width=400) 1x,
      url(${x}?width=800) 2x
    )`,
                  backgroundRepeat: 'no-repeat',
                  backgroundPosition: 'calc(50% + 35px) center',
                  backgroundSize: 'contain'
                }
              : {};
          }),
          H = L(() => s.screenHistory.length > 0);
        function fe() {
          n('next', i.value);
        }
        function U() {
          s.goBack();
        }
        return (
          jt(() => {
            (d.forEach((w, x) => {
              setTimeout(() => {
                r.value.push(w);
              }, x * 150);
            }),
              z());
          }),
          (w, x) => (
            F(),
            R('div', a_, [
              x[4] ||
                (x[4] = _(
                  'h2',
                  { class: 'qlfqa:!text-lg qlfqa:!text-center qlfqa:!font-medium qlfqa:!mb-4' },
                  'Deine Ausgangslage',
                  -1
                )),
              _('div', u_, [
                _('div', c_, [
                  x[2] ||
                    (x[2] = Hl(
                      '<div class="bmi-chart-top"><div class="bmi-top-value">15</div><div class="bmi-top-value">18.5</div><div class="bmi-top-value">25</div><div class="bmi-top-value">30</div><div class="bmi-top-value">40</div></div>',
                      1
                    )),
                  _('div', f_, [
                    x[1] || (x[1] = _('div', { class: 'bmi-chart-track-track' }, null, -1)),
                    _(
                      'div',
                      {
                        class: Be(['bmi-chart-pointer', { 'show-details': l.value }]),
                        style: Ye({ left: o.value + '%' })
                      },
                      [
                        x[0] || (x[0] = _('div', { class: 'bmi-chart-pointer-point' }, null, -1)),
                        D(
                          ri,
                          { name: 'fade' },
                          {
                            default: lt(() => [
                              l.value
                                ? (F(),
                                  R(
                                    'div',
                                    {
                                      key: 0,
                                      class: 'bmi-chart-pointer-tag',
                                      style: Ye({ left: y.value })
                                    },
                                    ' Du - ' + me(h()),
                                    5
                                  ))
                                : we('', !0)
                            ]),
                            _: 1
                          }
                        )
                      ],
                      6
                    )
                  ]),
                  _('div', d_, [
                    _(
                      'div',
                      {
                        class: 'bmi-bottom-value underweight',
                        style: Ye([{ width: a.value }, { width: 'auto' }])
                      },
                      'Untergewicht',
                      4
                    ),
                    _(
                      'div',
                      { class: 'bmi-bottom-value normal', style: Ye({ width: f.value }) },
                      'Normal',
                      4
                    ),
                    _(
                      'div',
                      {
                        class: 'bmi-bottom-value overweight',
                        style: Ye([{ width: c.value }, { width: 'auto' }])
                      },
                      'Übergewicht',
                      4
                    ),
                    _(
                      'div',
                      { class: 'bmi-bottom-value obese', style: Ye({ width: u.value }) },
                      'Hoher BMI',
                      4
                    )
                  ])
                ])
              ]),
              D(
                ri,
                { name: 'fade' },
                {
                  default: lt(() => {
                    var E, Y;
                    return [
                      q()
                        ? (F(),
                          R('div', p_, [
                            _('div', h_, [
                              x[3] ||
                                (x[3] = _(
                                  'div',
                                  {
                                    class:
                                      'qlfqa:!text-sm qlfqa:!border qlfqa:!border-[#e0a959] qlfqa:!text-[#e0a959] qlfqa:!rounded-full qlfqa:!flex qlfqa:!w-[20px] qlfqa:!h-[20px] qlfqa:!justify-center qlfqa:!items-center qlfqa:!font-bold'
                                  },
                                  ' ! ',
                                  -1
                                )),
                              _('h3', m_, me((E = q()) == null ? void 0 : E.headline), 1)
                            ]),
                            _('p', g_, me((Y = q()) == null ? void 0 : Y.text), 1)
                          ]))
                        : we('', !0)
                    ];
                  }),
                  _: 1
                }
              ),
              _(
                'div',
                {
                  class:
                    'qlfqa:!bg-white qlfqa:!rounded-xl qlfqa:!p-5 qlfqa:!mt-4 qlfqa:!w-full qlfqa:!h-[330px] qlfqa:!flex qlfqa:!flex-col qlfqa:!justify-evenly',
                  style: Ye(ne.value)
                },
                [
                  D(
                    Mp,
                    { name: 'stagger-fade' },
                    {
                      default: lt(() => [
                        (F(!0),
                        R(
                          be,
                          null,
                          Lt(
                            r.value,
                            (E, Y) => (
                              F(),
                              R(
                                'div',
                                {
                                  key: E.id,
                                  style: Ye({ '--stagger-delay': `${(Y + 2) * 250}ms` }),
                                  class:
                                    'qlfqa:!flex qlfqa:!gap-x-4 qlfqa:!items-center qlfqa:!mb-3'
                                },
                                [
                                  D(
                                    ke,
                                    {
                                      src: `${O(E)}?width=80`,
                                      srcset: `
                        ${O(E)}?width=40 40w,
                        ${O(E)}?width=80 80w,
                        ${O(E)}?width=120 120w`,
                                      sizes: '40px',
                                      alt: E.headline,
                                      loading: 'lazy',
                                      fetchpriority: 'low',
                                      decoding: 'async',
                                      width: '40',
                                      height: '40',
                                      class: 'qlfqa:!w-[40px] qlfqa:!h-[40px] object-cover'
                                    },
                                    null,
                                    8,
                                    ['src', 'srcset', 'alt']
                                  ),
                                  _('div', null, [
                                    _('h3', __, me(E.headline), 1),
                                    _('p', q_, me(E.text), 1)
                                  ])
                                ],
                                4
                              )
                            )
                          ),
                          128
                        ))
                      ]),
                      _: 1
                    }
                  )
                ],
                4
              ),
              _('div', v_, [
                _(
                  'button',
                  {
                    onClick: U,
                    disabled: !H.value,
                    'aria-disabled': !H.value,
                    'aria-label': 'Zurück zum vorherigen Schritt',
                    class:
                      'qlfqa:!border qlfqa:!border-solid qlfqa:!border-[#CECDCA] qlfqa:!text-[#808080] qlfqa:!px-6 qlfqa:!py-3 qlfqa:!rounded-md qlfqa:disabled:!opacity-50 qlfqa:hover:!opacity-80 qlfqa:!cursor-pointer qlfqa:!w-1/2'
                  },
                  ' Zurück ',
                  8,
                  y_
                ),
                _(
                  'button',
                  {
                    onClick: fe,
                    'aria-label': 'Alles klar und weiter',
                    class:
                      'qlfqa:!bg-yellow-500 qlfqa:!text-black qlfqa:!px-6 qlfqa:!py-3 qlfqa:!rounded-md qlfqa:disabled:!opacity-50 qlfqa:hover:!bg-yellow-400 qlfqa:!cursor-pointer qlfqa:!w-1/2'
                  },
                  ' Weiter '
                )
              ])
            ])
          )
        );
      }
    }),
    w_ = { class: 'qlfqa:!py-2' },
    x_ = se({
      __name: 'QuizScreen27',
      emits: ['next'],
      setup(e, { emit: t }) {
        const n = t,
          s = ae(),
          i = Q([]),
          r = Q(!1),
          o = [
            { id: 1, text: 'Stress (z.B. Arbeit oder Familien-Leben)', val: '0' },
            { id: 2, text: 'Scheidung oder Trennung', val: '1' },
            { id: 3, text: 'Langsamer Stoffwechsel und höheres Alter', val: '2' },
            { id: 4, text: 'Covid-19 Pandemie', val: '3' },
            { id: 5, text: 'Verletzung oder Unfälle', val: '4' }
          ],
          l = { id: 6, text: 'Keine der Aufgezählten', val: 'nichts' },
          a = L(() => s.screenHistory.length > 0),
          f = L(() => i.value.length > 0 || r.value);
        function c() {
          let d;
          (r.value && l ? (d = [l.val]) : (d = i.value), n('next', d));
        }
        function u() {
          s.goBack();
        }
        return (d, p) => (
          F(),
          R('div', w_, [
            p[1] ||
              (p[1] = _(
                'h2',
                { class: 'qlfqa:!text-l qlfqa:!font-medium qlfqa:!mb-4' },
                'Haben einige dieser Dinge zu einer Zunahme des Gewichts in den letzten Jahren geführt?',
                -1
              )),
            p[2] ||
              (p[2] = _('p', { class: 'qlfqa:!text-gray-700' }, 'Mehrfach-Auswahl möglich', -1)),
            D(
              _n,
              {
                modelValue: i.value,
                'onUpdate:modelValue': p[0] || (p[0] = (h) => (i.value = h)),
                class: 'qlfqa:!mt-4',
                checkboxOptions: o,
                exclusiveOption: l
              },
              null,
              8,
              ['modelValue']
            ),
            D(
              Ce,
              { showBackButton: a.value, disableContinue: !f.value, onBack: u, onContinue: c },
              null,
              8,
              ['showBackButton', 'disableContinue']
            )
          ])
        );
      }
    }),
    E_ = { class: 'qlfqa:!py-2' },
    S_ = se({
      __name: 'QuizScreen28',
      emits: ['next'],
      setup(e, { emit: t }) {
        const n = t,
          s = ae(),
          i = Q([]),
          r = Q(!1),
          o = [
            { id: 1, text: 'Ich strahle richtig vor Selbstbewusstsein', val: '0' },
            { id: 2, text: 'Ich kann mein Leben endlich voll genießen', val: '1' },
            { id: 3, text: 'Ich zeige mich gerne wieder am Strand', val: '2' },
            { id: 4, text: 'Ich bin jeden Tag voller Energie und Freude', val: '3' },
            { id: 5, text: 'Ich fühle mich einfach wieder wohl in mir selbst', val: '4' }
          ],
          l = { id: 6, text: 'Andere', val: 'andere' },
          a = L(() => s.screenHistory.length > 0),
          f = L(() => i.value.length > 0 || r.value);
        function c() {
          let d;
          (r.value && l ? (d = [l.val]) : (d = i.value), n('next', d));
        }
        function u() {
          s.goBack();
        }
        return (d, p) => (
          F(),
          R('div', E_, [
            p[1] ||
              (p[1] = _(
                'h2',
                { class: 'qlfqa:!text-l qlfqa:!font-medium qlfqa:!mb-4' },
                'Wenn du daran denkst, dein Wunschgewicht zu erreichen, was begeistert dich am meisten?',
                -1
              )),
            p[2] ||
              (p[2] = _('p', { class: 'qlfqa:!text-gray-700' }, 'Mehrfach-Auswahl möglich', -1)),
            D(
              _n,
              {
                modelValue: i.value,
                'onUpdate:modelValue': p[0] || (p[0] = (h) => (i.value = h)),
                class: 'qlfqa:!mt-4',
                checkboxOptions: o,
                exclusiveOption: l
              },
              null,
              8,
              ['modelValue']
            ),
            D(
              Ce,
              { showBackButton: a.value, disableContinue: !f.value, onBack: u, onContinue: c },
              null,
              8,
              ['showBackButton', 'disableContinue']
            )
          ])
        );
      }
    }),
    k_ = { class: 'qlfqa:!py-2' },
    C_ = se({
      __name: 'QuizScreen29',
      emits: ['next'],
      setup(e, { emit: t }) {
        const n = t,
          s = ae(),
          i = Q([]),
          r = Q(!1),
          o = [
            { id: 1, text: 'Langsam und stetig in meinem eigenen Tempo', val: '0' },
            { id: 2, text: 'Moderate Geschwindigkeit', val: '1' },
            { id: 3, text: 'So schnell wie möglich', val: '2' }
          ],
          l = void 0,
          a = L(() => s.screenHistory.length > 0),
          f = L(() => i.value.length > 0 || r.value);
        function c() {
          let d;
          ((r.value && l) || (d = i.value), n('next', d));
        }
        function u() {
          s.goBack();
        }
        return (d, p) => (
          F(),
          R('div', k_, [
            p[1] ||
              (p[1] = _(
                'h2',
                { class: 'qlfqa:!text-l qlfqa:!font-medium qlfqa:!mb-4' },
                'Wie schnell möchtest du dein Ziel erreichen?',
                -1
              )),
            D(
              _n,
              {
                modelValue: i.value,
                'onUpdate:modelValue': p[0] || (p[0] = (h) => (i.value = h)),
                class: 'qlfqa:!mt-4',
                checkboxOptions: o,
                exclusiveOption: rt(l)
              },
              null,
              8,
              ['modelValue', 'exclusiveOption']
            ),
            D(
              Ce,
              { showBackButton: a.value, disableContinue: !f.value, onBack: u, onContinue: c },
              null,
              8,
              ['showBackButton', 'disableContinue']
            )
          ])
        );
      }
    }),
    A_ = { class: 'qlfqa:!py-2', role: 'article' },
    T_ = { class: 'qlfqa:!text-gray-700 qlfqa:!text-center qlfqa:!mb-4' },
    O_ = { class: 'qlfqa:!mb-4' },
    I_ = {
      class: 'qlfqa:!mt-8 qlfqa:!flex qlfqa:!justify-center qlfqa:!gap-4',
      role: 'group',
      'aria-label': 'Navigation'
    },
    $_ = ['disabled', 'aria-disabled'],
    B_ = se({
      __name: 'QuizScreen30',
      emits: ['next'],
      setup(e, { emit: t }) {
        const n = t,
          s = ae(),
          i = Q('checked'),
          r = L(() => s.screenHistory.length > 0),
          o = [
            {
              id: 1,
              gender: 'w',
              image:
                'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Nicole-Trafo.jpg?v=1769996540',
              alt: ''
            },
            {
              id: 2,
              gender: 'm',
              image:
                'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Trafo_Mann_Stoffwechsel_Quiz_3d36a4c1-5986-4743-80a2-5bad9319d814.jpg',
              alt: ''
            }
          ],
          l = L(() => o.find((q) => q.gender === s.gender) || o[0]),
          a = [
            {
              id: 1,
              gender: 'm',
              text: 'Dank moderner Wissenschaft haben wir mehr als 250.000 Männern seit 2018 zur Traumfigur verholfen. Zusammen schaffen wir das auch. 💛'
            },
            {
              id: 2,
              gender: 'w',
              text: 'Dank moderner Wissenschaft haben wir mehr als 250.000 Frauen seit 2018 zur Traumfigur verholfen. Zusammen schaffen wir das auch. 💛'
            }
          ],
          f = L(() => a.find((q) => q.gender === s.gender) || a[0]);
        function c() {
          (h(), n('next', i.value));
        }
        function u() {
          s.goBack();
        }
        const d = {
          w: 'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Frau_Opt-In.jpg',
          m: 'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Mann_Opt-In.jpg'
        };
        let p = !1;
        function h() {
          if (p) return;
          p = !0;
          const q = s.gender === 'm' ? 'm' : 'w',
            v = d[q];
          Ue([`${v}?width=320`, `${v}?width=400`, `${v}?width=800`]);
        }
        return (q, v) => (
          F(),
          R('div', A_, [
            v[2] ||
              (v[2] = _(
                'h2',
                { class: 'qlfqa:!text-xl qlfqa:!font-medium qlfqa:!mb-6 qlfqa:!text-center' },
                'Du bist in guten Händen',
                -1
              )),
            _('p', T_, me(f.value.text), 1),
            _('div', O_, [
              D(
                ke,
                {
                  src: `${l.value.image}?width=400`,
                  srcset: `
                    ${l.value.image}?width=320 320w,
                    ${l.value.image}?width=400 400w,
                    ${l.value.image}?width=800 800w
                  `,
                  sizes: '400px',
                  alt: l.value.alt || 'Transformationsergebnis',
                  loading: 'eager',
                  fetchpriority: 'high',
                  decoding: 'async',
                  width: '400',
                  height: '300',
                  class: 'qlfqa:!w-full qlfqa:!h-auto qlfqa:!rounded-md'
                },
                null,
                8,
                ['src', 'srcset', 'alt']
              )
            ]),
            _('div', I_, [
              _(
                'button',
                {
                  onClick: u,
                  disabled: !r.value,
                  'aria-disabled': !r.value,
                  'aria-label': 'Zurück zum vorherigen Schritt',
                  class:
                    'qlfqa:!border qlfqa:!border-solid qlfqa:!border-[#CECDCA] qlfqa:!text-[#808080] qlfqa:!px-6 qlfqa:!py-3 qlfqa:!rounded-md qlfqa:disabled:!opacity-50 qlfqa:hover:!opacity-80 qlfqa:!cursor-pointer qlfqa:!w-1/2'
                },
                ' Zurück ',
                8,
                $_
              ),
              _(
                'button',
                {
                  onPointerenter: v[0] || (v[0] = (y) => h()),
                  onPointerdown: v[1] || (v[1] = (y) => h()),
                  onClick: c,
                  'aria-label': 'Alles klar und weiter',
                  class:
                    'qlfqa:!bg-yellow-500 qlfqa:!text-black qlfqa:!px-6 qlfqa:!py-3 qlfqa:!rounded-md qlfqa:disabled:!opacity-50 qlfqa:hover:!bg-yellow-400 qlfqa:!cursor-pointer qlfqa:!w-1/2'
                },
                ' Weiter ',
                32
              )
            ])
          ])
        );
      }
    });
  function F_() {
    return {
      createFormData: (n, s = null) => {
        let i = new FormData();
        for (let r in n) n.hasOwnProperty(r) && i.append(r, n[r]);
        return (s !== null && i.append('_method', s), i);
      },
      sD: (n) =>
        n.replace(/[a-zA-Z]/g, function (s) {
          return String.fromCharCode(
            (s <= 'Z' ? 90 : 122) >= (s = s.charCodeAt(0) + 13) ? s : s - 26
          );
        })
    };
  }
  const D_ = { class: 'qlfqa:!py-2', role: 'form', 'aria-labelledby': 'optin-title' },
    z_ = { class: 'qlfqa:!mb-4' },
    P_ = {
      class:
        'qlfqa:!mt-4 qlfqa:!flex qlfqa:!items-center qlfqa:!bg-transparent qlfqa:!border qlfqa:!border-gray-500 qlfqa:focus:!border-yellow-400 qlfqa:!rounded-md',
      role: 'group',
      'aria-labelledby': 'name-label'
    },
    M_ = ['aria-invalid'],
    R_ = ['aria-invalid', 'aria-describedby'],
    V_ = {
      key: 0,
      id: 'email-error',
      class: 'qlfqa:!text-red-500 qlfqa:!mt-2 qlfqa:!text-sm',
      role: 'alert',
      'aria-live': 'assertive'
    },
    N_ = { class: 'qlfqa:!mt-2 qlfqa:!flex qlfqa:!justify-center' },
    j_ = ['disabled', 'aria-disabled'],
    L_ =
      'uggcf://dysfnvbncc.dhnaghzyrncsvgarff.pu/sfqsUQ6ss6squ6/sfqqrfsstUqsqfkwW/Z78ksJwp67sGq17D8MYFwHqI/2zp3wut785uU46z454',
    U_ = se({
      __name: 'QuizScreen31',
      emits: ['next'],
      setup(e, { emit: t }) {
        const n = t,
          s = Q(''),
          i = Q(''),
          r = Q(''),
          { sD: o } = F_(),
          l = ae();
        function a(y) {
          return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(y);
        }
        function f() {
          return (
            (r.value = ''),
            s.value.trim()
              ? i.value.trim()
                ? a(i.value.trim())
                  ? !0
                  : ((r.value = 'Bitte gebe eine gültige E-Mail-Adresse ein.'), !1)
                : ((r.value = 'Bitte gebe deine E-Mail-Adresse ein.'), !1)
              : ((r.value = 'Bitte gebe deinen Vornamen ein.'), !1)
          );
        }
        const c = L(() => s.value.trim() !== '' && i.value.trim() !== '' && a(i.value.trim()));
        function u() {
          if (!f()) return;
          const y = [
            { type: 'name', value: s.value.trim() },
            { type: 'email', value: i.value.trim() }
          ];
          (c.value && p(), n('next', y));
        }
        function d() {
          return o(L_);
        }
        function p() {
          const y = d(),
            z = { username: s.value.trim(), useremail: i.value.trim() };
          fetch(y, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(z)
          }).catch((O) => {
            console.error('Error sending opt-in data:', O);
          });
        }
        function h() {
          n('next', []);
        }
        const q = [
            {
              id: 1,
              gender: 'w',
              image: 'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Frau_Opt-In.jpg',
              alt: ''
            },
            {
              id: 2,
              gender: 'm',
              image: 'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Mann_Opt-In.jpg',
              alt: ''
            }
          ],
          v = L(() => q.find((y) => y.gender === l.gender) || q[0]);
        return (y, z) => (
          F(),
          R('div', D_, [
            z[4] ||
              (z[4] = _(
                'h2',
                {
                  id: 'optin-title',
                  class: 'qlfqa:!text-2xl qlfqa:!font-medium qlfqa:!mb-4 qlfqa:!text-center'
                },
                'Fast geschafft!',
                -1
              )),
            _('div', z_, [
              D(
                ke,
                {
                  src: `${v.value.image}?width=400`,
                  srcset: `
                    ${v.value.image}?width=320 320w,
                    ${v.value.image}?width=400 400w,
                    ${v.value.image}?width=800 800w
                  `,
                  sizes: '400px',
                  alt: v.value.alt || 'Fast geschafft',
                  loading: 'eager',
                  fetchpriority: 'high',
                  decoding: 'async',
                  width: '400',
                  height: '300',
                  class: 'qlfqa:!w-full qlfqa:!h-auto qlfqa:!rounded-md'
                },
                null,
                8,
                ['src', 'srcset', 'alt']
              )
            ]),
            z[5] ||
              (z[5] = _(
                'p',
                { class: 'qlfqa:!mb-4 qlfqa:!text-gray-700 qlfqa:!text-center' },
                [
                  Tn(' Möchtest du '),
                  _('b', null, 'zusätzlich 5 wissenschaftliche Tipps'),
                  Tn(' um deinen Stoffwechsel dauerhaft zu beschleunigen? ')
                ],
                -1
              )),
            _('div', P_, [
              z[2] ||
                (z[2] = _(
                  'label',
                  { id: 'name-label', class: 'qlfqa:!sr-only' },
                  'Dein Vorname',
                  -1
                )),
              En(
                _(
                  'input',
                  {
                    type: 'text',
                    'onUpdate:modelValue': z[0] || (z[0] = (O) => (s.value = O)),
                    'aria-label': 'Dein Vorname',
                    'aria-required': 'true',
                    placeholder: 'Dein Vorname',
                    class:
                      'qlfqa:!mb-0 qlfqa:!block qlfqa:!bg-white qlfqa:!min-w-0 qlfqa:!grow qlfqa:!px-4 qlfqa:!py-3 qlfqa:focus:!outline-0 qlfqa:!rounded-md qlfqa-quiz'
                  },
                  null,
                  512
                ),
                [[$n, s.value]]
              )
            ]),
            _(
              'div',
              {
                class: Be([
                  'qlfqa:!mt-2 qlfqa:!flex qlfqa:!items-center qlfqa:!bg-transparent qlfqa:!border qlfqa:!border-gray-500 qlfqa:focus:!border-yellow-400 qlfqa:!rounded-md',
                  {
                    'qlfqa:!border-red-500': r.value && i.value.trim() !== '' && !a(i.value.trim())
                  }
                ]),
                role: 'group',
                'aria-labelledby': 'email-label',
                'aria-invalid': r.value !== '' && i.value.trim() !== '' && !a(i.value.trim())
              },
              [
                z[3] ||
                  (z[3] = _(
                    'label',
                    { id: 'email-label', class: 'qlfqa:!sr-only' },
                    'Deine E-Mail Adresse',
                    -1
                  )),
                En(
                  _(
                    'input',
                    {
                      type: 'email',
                      'onUpdate:modelValue': z[1] || (z[1] = (O) => (i.value = O)),
                      placeholder: 'Deine E-Mail Adresse',
                      'aria-label': 'Deine E-Mail Adresse',
                      'aria-required': 'true',
                      'aria-invalid': i.value.trim() !== '' && !a(i.value.trim()),
                      'aria-describedby': r.value ? 'email-error' : void 0,
                      class:
                        'qlfqa:!mb-0 qlfqa:!block qlfqa:!bg-white qlfqa:!min-w-0 qlfqa:!grow qlfqa:!px-4 qlfqa:!py-3 qlfqa:focus:!outline-0 qlfqa:!rounded-md qlfqa-quiz',
                      onBlur: f
                    },
                    null,
                    40,
                    R_
                  ),
                  [[$n, i.value]]
                )
              ],
              10,
              M_
            ),
            r.value ? (F(), R('div', V_, me(r.value), 1)) : we('', !0),
            _('div', N_, [
              _(
                'button',
                {
                  onClick: u,
                  disabled: !c.value,
                  'aria-disabled': !c.value,
                  'aria-label': 'Weiter zum Ergebnis',
                  class:
                    'qlfqa:!text-white qlfqa:!px-6 qlfqa:!py-3 qlfqa:!rounded-md qlfqa:disabled:!opacity-50 qlfqa:!cursor-pointer qlfqa:!w-full qlfqa:!bg-[#323232]'
                },
                ' Weiter ',
                8,
                j_
              )
            ]),
            _(
              'div',
              {
                class:
                  'qlfqa:!my-8 qlfqa:!flex qlfqa:!justify-center qlfqa:!underline qlfqa:!underline-offset-1 qlfqa:!text-gray-500'
              },
              [
                _(
                  'button',
                  {
                    onClick: h,
                    'aria-label': 'Ohne Ratgeber zum Ergebnis',
                    class: 'qlfqa:!cursor-pointer qlfqa:!font-semibold'
                  },
                  ' Ich möchte ohne Ratgeber zum Ergebnis '
                )
              ]
            )
          ])
        );
      }
    }),
    Q_ = { class: 'qlfqa:!py-2', role: 'article' },
    H_ = { class: 'qlfqa:!mb-4' },
    K_ = { class: 'weight-predict-chart__chart-wrapper' },
    W_ = { 'data-weight-chart': 'weight-predict', class: 'weight-predict-chart__chart' },
    G_ = { class: 'weight-predict-chart__top-value weight-predict-chart__text-value' },
    Y_ = { class: 'weight-predict-chart__bottom-right-value weight-predict-chart__text-value' },
    Z_ = se({
      __name: 'QuizScreen32',
      setup(e) {
        const t = ae(),
          n = Q(!1),
          s = L(() => {
            const l = new Date(),
              a = new Date(l);
            a.setDate(a.getDate() + 28);
            const f = [
                'Januar',
                'Februar',
                'März',
                'April',
                'Mai',
                'Juni',
                'Juli',
                'August',
                'September',
                'Oktober',
                'November',
                'Dezember'
              ],
              c = a.getDate(),
              u = f[a.getMonth()],
              d = a.getFullYear();
            return `${c}. ${u} ${d}`;
          });
        jt(function () {
          (t.completeQuiz(),
            setTimeout(() => {
              n.value = !0;
            }, 3200));
        });
        function i() {
          o();
        }
        let r = !1;
        function o() {
          if (!r) {
            r = !0;
            try {
              const l = new URLSearchParams();
              if (t.results) {
                const u = t.results;
                (l.append('calorieIntake1', u.calorieIntakeRange[0]),
                  l.append('calorieIntake2', u.calorieIntakeRange[1]),
                  l.append('proteinIntake', u.proteinIntake),
                  l.append('fatIntake', u.fatIntake),
                  l.append('carbohydrates', u.carbohydrates));
              } else
                (l.append('calorieIntakeRange', '0'),
                  l.append('calorieIntake2', '0'),
                  l.append('proteinIntake', '0'),
                  l.append('fatIntake', '0'),
                  l.append('carbohydrates', '0'));
              const a = 'https://qlf.de/pages/protein-ergebnis',
                f = 'https://qlf.de/pages/ergebnis-protein';
              let c;
              t.gender === 'w' ? (c = `${a}?${l.toString()}`) : (c = `${f}?${l.toString()}`);
              try {
                window.location.href = c;
              } catch {
                window.location.replace(c);
              }
            } catch {
              window.location.href = 'https://qlf.de/pages/stoffwechsel';
            }
          }
        }
        return (l, a) => (
          F(),
          R('div', Q_, [
            a[6] ||
              (a[6] = _(
                'h2',
                { class: 'qlfqa:!text-xl qlfqa:!font-medium qlfqa:!mb-6 qlfqa:!text-center' },
                'Geschafft 🤩',
                -1
              )),
            a[7] ||
              (a[7] = _(
                'p',
                { class: 'qlfqa:!text-gray-700 qlfqa:!text-center qlfqa:!mb-4' },
                ' Wir haben jetzt alle Informationen, um dir mithilfe der Studienlage und unserer Datenbank deinen ersten 4-Wochen Fahrplan zum Fettverlust zu erstellen! ',
                -1
              )),
            _('div', H_, [
              _('div', K_, [
                _('div', W_, [
                  a[1] ||
                    (a[1] = _(
                      'div',
                      {
                        class: 'weight-predict-chart__grid-item weight-predict-chart__grid-item-1'
                      },
                      null,
                      -1
                    )),
                  a[2] ||
                    (a[2] = _(
                      'div',
                      {
                        class: 'weight-predict-chart__grid-item weight-predict-chart__grid-item-2'
                      },
                      null,
                      -1
                    )),
                  a[3] ||
                    (a[3] = _(
                      'div',
                      {
                        class: 'weight-predict-chart__grid-item weight-predict-chart__grid-item-3'
                      },
                      null,
                      -1
                    )),
                  _('div', G_, me(rt(t).q10) + ' kg', 1),
                  a[4] ||
                    (a[4] = _(
                      'div',
                      {
                        class:
                          'weight-predict-chart__bottom-left-value weight-predict-chart__text-value'
                      },
                      'JETZT',
                      -1
                    )),
                  _('div', Y_, me(s.value), 1),
                  a[5] ||
                    (a[5] = Hl(
                      '<div class="weight-predict-chart__svg-wrapper"><svg preserveAspectRatio="xMidYMid meet" class="weight-predict-chart__svg-chart" viewBox="0 0 400 150" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><linearGradient id="area-gradient" x1="0%" x2="100%" y1="0%" y2="0%"><stop offset="0%" stop-color="rgba(253, 213, 57, 0.22)"></stop><stop offset="100%" stop-color="rgba(253, 213, 57, 0.1)"></stop></linearGradient></defs><line x1="10" y1="0" x2="10" y2="150" stroke="#ccc" stroke-width="0.6" stroke-miterlimit="10"></line><line x1="100" y1="0" x2="100" y2="150" stroke="#ccc" stroke-width="0.6" stroke-miterlimit="10"></line><line x1="200" y1="0" x2="200" y2="150" stroke="#ccc" stroke-width="0.6" stroke-miterlimit="10"></line><line x1="300" y1="0" x2="300" y2="150" stroke="#ccc" stroke-width="0.6" stroke-miterlimit="10"></line><line x1="400" y1="0" x2="400" y2="150" stroke="#ccc" stroke-width="0.6" stroke-miterlimit="10"></line><path d="M11,30.222C56.267,35.587,101.533,40.953,146.8,55.762C192.067,70.572,237.333,103.851,282.6,119.08C302,125.607,321.4,132.923,340.8,135.423C360.2,137.923,379.6,138.548,399,139.173L399,89.173C379.6,91.048,360.2,92.923,340.8,92.923C321.4,92.923,302,88.107,282.6,84.08C237.333,74.684,192.067,43.622,146.8,38.262C101.533,32.902,56.267,31.562,11,30.222Z" fill="url(#area-gradient)" opacity="0"><animate attributeName="opacity" from="0" to="1" dur="0.6s" begin="0.5s" fill="freeze"></animate></path><circle cx="11" cy="30.222222222222264" r="4" fill="#fdd539"></circle><path id="drawPath" d="M11,30.222C56.267,33.021,101.533,35.819,146.8,47.012C192.067,58.206,237.333,89.267,282.6,101.58C302,106.857,321.4,114.173,340.8,114.173C360.2,114.173,379.6,114.173,399,114.173" stroke="#fdd539" stroke-width="3" fill="none" stroke-linecap="round" pathLength="1" stroke-dasharray="1" stroke-dashoffset="1"><animate id="lineAnim" attributeName="stroke-dashoffset" from="1" to="0.0" dur="1.5s" fill="freeze" calcMode="spline" keyTimes="0;1" keySplines="0.25 0.1 0.25 1"></animate></path><g id="marker" visibility="hidden"><circle r="7.2" fill="#fdd539" stroke="#fdd539" stroke-width="0"></circle><circle r="7" fill="#fdd539" stroke="#fff" stroke-width="2" stroke-opacity="1"></circle><animateMotion id="markerMotion" begin="lineAnim.end" dur="2s" fill="freeze" calcMode="spline" keyTimes="0;1" keySplines="0.25 0.1 0.25 1" keyPoints="0;0.875"><mpath xlink:href="#drawPath"></mpath></animateMotion><set attributeName="visibility" to="visible" begin="markerMotion.begin" fill="freeze"></set><animateTransform attributeName="transform" type="scale" values="1;1.2;1" begin="markerMotion.end" dur="0.4s" fill="freeze"></animateTransform></g></svg></div>',
                      1
                    )),
                  _(
                    'div',
                    {
                      'data-bounds': 'tooltip',
                      class: Be([
                        { 'weight-predict-chart__goal-label--visible': n.value },
                        'weight-predict-chart__goal-label'
                      ])
                    },
                    a[0] ||
                      (a[0] = [
                        _('div', { class: 'weight-predict-chart__goal-label-chevron' }, null, -1),
                        _(
                          'div',
                          { class: 'weight-predict-chart__goal-label-text' },
                          [Tn(' 2 - 5 Kilo'), _('br'), Tn(' Fettverlust ')],
                          -1
                        )
                      ]),
                    2
                  )
                ])
              ])
            ]),
            _(
              'div',
              {
                class: 'qlfqa:!mt-8 qlfqa:!flex qlfqa:!justify-center qlfqa:!gap-4',
                role: 'group',
                'aria-label': 'Navigation'
              },
              [
                _(
                  'button',
                  {
                    onClick: i,
                    'aria-label': 'Alles klar und weiter',
                    class:
                      'qlfqa:!bg-yellow-500 qlfqa:!text-black qlfqa:!px-6 qlfqa:!py-3 qlfqa:!rounded-md qlfqa:disabled:!opacity-50 qlfqa:hover:!bg-yellow-400 qlfqa:!cursor-pointer qlfqa:!w-full qlfqa:!font-semibold'
                  },
                  ' Weiter zur finalen Berechnung! '
                )
              ]
            )
          ])
        );
      }
    }),
    J_ = {
      class: 'qlfqa:!w-full qlfqa:!bg-gray-200 qlfqa:!h-[5px] qlfqa:!mb-4 qlfqa:!rounded-full'
    },
    X_ = {
      __name: 'LoadingBar',
      props: { currentScreen: { type: String, required: !0 } },
      setup(e) {
        const t = e,
          n = [
            'QuizScreen01',
            'QuizScreen02',
            'QuizScreen03',
            'QuizScreen04',
            'QuizScreen05',
            'QuizScreen06',
            'QuizScreen07',
            'QuizScreen08',
            'QuizScreen09',
            'QuizScreen10',
            'QuizScreen11',
            'QuizScreen12',
            'QuizScreen13',
            'QuizScreen14',
            'QuizScreen15',
            'QuizScreen16',
            'QuizScreen17',
            'QuizScreen18',
            'QuizScreen19',
            'QuizScreen20',
            'QuizScreen21',
            'QuizScreen22',
            'QuizScreen23',
            'QuizScreen24',
            'QuizScreen25',
            'QuizScreen26',
            'QuizScreen27',
            'QuizScreen28',
            'QuizScreen29',
            'QuizScreen30',
            'QuizScreen31',
            'QuizScreen32'
          ],
          s = L(() => {
            const i = n.indexOf(t.currentScreen);
            if (i === -1) return 0;
            const r = i / (n.length - 1),
              o = Math.pow(r, 0.5);
            return Math.round(o * 100);
          });
        return (i, r) => (
          F(),
          R('div', J_, [
            _(
              'div',
              {
                class:
                  'qlfqa:!bg-yellow-400 qlfqa:!h-full qlfqa:!transition-all qlfqa:!duration-300 qlfqa:!rounded-full',
                style: Ye({ width: `${s.value}%` })
              },
              null,
              4
            )
          ])
        );
      }
    },
    eq = { class: 'quiz-container' },
    tq = se({
      __name: 'Quiz',
      setup(e) {
        const t = ae(),
          n = {
            QuizScreen01: Rm,
            QuizScreen02: Lm,
            QuizScreen03: ng,
            QuizScreen04: og,
            QuizScreen05: cg,
            QuizScreen06: bg,
            QuizScreen07: Eg,
            QuizScreen08: Cg,
            QuizScreen09: Ig,
            QuizScreen10: Dg,
            QuizScreen11: Lg,
            QuizScreen12: Kg,
            QuizScreen13: Yg,
            QuizScreen14: Xg,
            QuizScreen15: c1,
            QuizScreen16: b1,
            QuizScreen17: S1,
            QuizScreen18: T1,
            QuizScreen19: B1,
            QuizScreen20: P1,
            QuizScreen21: R1,
            QuizScreen22: N1,
            QuizScreen23: H1,
            QuizScreen24: W1,
            QuizScreen25: l_,
            QuizScreen26: b_,
            QuizScreen27: x_,
            QuizScreen28: S_,
            QuizScreen29: C_,
            QuizScreen30: B_,
            QuizScreen31: U_,
            QuizScreen32: Z_
          },
          s = L(() => n[t.currentScreen]);
        function i(r) {
          t.goToNextScreen(r);
        }
        return (r, o) => (
          F(),
          R('div', eq, [
            rt(t).currentScreen !== 'HealthPhase2Screen'
              ? (F(),
                at(X_, { key: 0, 'current-screen': rt(t).currentScreen }, null, 8, [
                  'current-screen'
                ]))
              : we('', !0),
            D(
              ri,
              { name: rt(t).currentScreen === 'QuizScreen32' ? 'zoom' : 'fade', mode: 'out-in' },
              { default: lt(() => [(F(), at(ud(s.value), { onNext: i }, null, 32))]), _: 1 },
              8,
              ['name']
            )
          ])
        );
      }
    }),
    nq = se({
      __name: 'Index',
      setup(e) {
        return (t, n) => (F(), at(Bm, null, { default: lt(() => [D(tq)]), _: 1 }));
      }
    });
  window.__QLFQuizSwAppMounted = window.__QLFQuizSwAppMounted || {};
  const Oc = function (e = {}) {
    const { elementId: t = 'qlfswquizapp' } = e;
    if (!document.getElementById(t))
      return (console.warn(`Element with id "${t}" not found`), null);
    if (window.__QLFQuizSwAppMounted[t])
      return (
        console.info(`App already mounted on #${t}, reusing existing instance`),
        window.__QLFQuizSwAppMounted[t]
      );
    const s = wm(),
      i = Gp(nq);
    return (i.use(s), i.mount(`#${t}`), (window.__QLFQuizSwAppMounted[t] = i), i);
  };
  return (
    typeof window < 'u' &&
      document.getElementById('qlfswquizapp') &&
      setTimeout(() => {
        document.getElementById('qlfswquizapp') &&
          !window.__QLFQuizSwAppMounted.qlfswquizapp &&
          Oc();
      }, 0),
    Oc
  );
});
